(function () {
  'use strict';
  var commonjsGlobal =
    typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }
  function createCommonjsModule(fn, module) {
    return (module = { exports: {} }), fn(module, module.exports), module.exports;
  }
  (function ($) {
    // check for trend event (make sure jquery.trend is included)
    if (typeof $.event.special.trend !== 'object') {
      console.warn("Please make sure jquery.trend is included! Otherwise revealer won't work.");
    }
    // Simple requestAnimationFrame polyfill
    var raf =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      function (fn) {
        window.setTimeout(fn, 1000 / 60);
      };
    // Public API
    var methods = {
      isVisible: function (el) {
        return !!el.data('revealer-visible');
      },
      show: function (el, force) {
        // Check state
        if (methods.isVisible(el)) {
          el.removeClass('animating animating-in');
          el.off('revealer-animating revealer-show');
          return;
        }
        // Remove previous event listeners
        el.data('revealer-visible', true);
        el.off('trend');
        if (force) {
          el.addClass('visible');
          raf(function () {
            el.trigger('revealer-animating');
            el.trigger('revealer-show');
          });
          return;
        }
        raf(function () {
          // Start animation state transition
          el.addClass('animating animating-in');
          el.trigger('revealer-animating');
          raf(function () {
            el.addClass('visible');
            el.one('trend', function () {
              el.removeClass('animating animating-in');
              el.trigger('revealer-show');
            });
          });
        });
      },
      hide: function (el, force) {
        // Check state
        if (!methods.isVisible(el)) {
          el.removeClass('animating animating-out visible');
          el.off('revealer-animating revealer-hide');
          return;
        }
        // Remove previous event listeners
        el.data('revealer-visible', false);
        el.off('trend');
        if (force) {
          el.removeClass('visible');
          raf(function () {
            el.trigger('revealer-animating');
            el.trigger('revealer-hide');
          });
          return;
        }
        raf(function () {
          el.addClass('animating animating-out');
          el.trigger('revealer-animating');
          raf(function () {
            el.removeClass('visible');
            el.one('trend', function () {
              el.removeClass('animating animating-in animating-out');
              el.trigger('revealer-hide');
            });
          });
        });
      },
      toggle: function (el, force) {
        if (methods.isVisible(el)) {
          methods.hide(el, force);
        } else {
          methods.show(el, force);
        }
      },
    };
    // jQuery plugin
    $.fn.revealer = function (method, force) {
      // Get action
      var action = methods[method || 'toggle'];
      if (!action) return this;
      // Run action
      if (method === 'isVisible') {
        return action(this);
      }
      return this.each(function () {
        action($(this), force);
      });
    };
  })(jQuery);
  var evEmitter = createCommonjsModule(function (module) {
    /**
     * EvEmitter v1.1.0
     * Lil' event emitter
     * MIT License
     */
    /* jshint unused: true, undef: true, strict: true */
    (function (global, factory) {
      // universal module definition
      /* jshint strict: false */ /* globals define, module, window */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD - RequireJS
        undefined(factory);
      } else if ('object' == 'object' && module.exports) {
        // CommonJS - Browserify, Webpack
        module.exports = factory();
      } else {
        // Browser globals
        global.EvEmitter = factory();
      }
    })(typeof window != 'undefined' ? window : commonjsGlobal, function () {
      'use strict';
      function EvEmitter() { }
      var proto = EvEmitter.prototype;
      proto.on = function (eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        // set events hash
        var events = (this._events = this._events || {});
        // set listeners array
        var listeners = (events[eventName] = events[eventName] || []);
        // only add once
        if (listeners.indexOf(listener) == -1) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function (eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = (this._onceEvents = this._onceEvents || {});
        // set onceListeners object
        var onceListeners = (onceEvents[eventName] = onceEvents[eventName] || {});
        // set flag
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function (eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        var index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function (eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (var i = 0; i < listeners.length; i++) {
          var listener = listeners[i];
          var isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            // remove listener
            // remove before trigger to prevent recursion
            this.off(eventName, listener);
            // unset once flag
            delete onceListeners[listener];
          }
          // trigger listener
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function () {
        delete this._events;
        delete this._onceEvents;
      };
      return EvEmitter;
    });
  });
  var getSize = createCommonjsModule(function (module) {
    /**
     * getSize v2.0.3
     * measure size of elements
     * MIT license
     */
    /* jshint browser: true, strict: true, undef: true, unused: true */
    /* globals console: false */
    (function (window, factory) {
      /* jshint strict: false */ /* globals define, module */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(factory);
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
      } else {
        // browser global
        window.getSize = factory();
      }
    })(window, function factory() {
      'use strict';
      // -------------------------- helpers -------------------------- //
      // get a number from a string, not a percentage
      function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
      }
      function noop() { }
      var logError =
        typeof console == 'undefined'
          ? noop
          : function (message) {
            console.error(message);
          };
      // -------------------------- measurements -------------------------- //
      var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth',
      ];
      var measurementsLength = measurements.length;
      function getZeroSize() {
        var size = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0,
        };
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          size[measurement] = 0;
        }
        return size;
      }
      // -------------------------- getStyle -------------------------- //
      /**
       * getStyle, get style of element, check for Firefox bug
       * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
       */
      function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) {
          logError(
            'Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1'
          );
        }
        return style;
      }
      // -------------------------- setup -------------------------- //
      var isSetup = false;
      var isBoxSizeOuter;
      /**
       * setup
       * check isBoxSizerOuter
       * do on first getSize() rather than on page load for Firefox bug
       */
      function setup() {
        // setup once
        if (isSetup) {
          return;
        }
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
         * Chrome & Safari measure the outer-width on style.width on border-box elems
         * IE11 & Firefox<29 measures the inner-width
         */
        var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
      }
      // -------------------------- getSize -------------------------- //
      function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == 'string') {
          elem = document.querySelector(elem);
        }
        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) {
          return;
        }
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') {
          return getZeroSize();
        }
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = (size.isBorderBox = style.boxSizing == 'border-box');
        // get all measurements
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          var value = style[measurement];
          var num = parseFloat(value);
          // any 'auto', 'medium' value will be 0
          size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
          size.width =
            styleWidth +
            // add padding and border unless it's already including it
            (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
          size.height =
            styleHeight +
            // add padding and border unless it's already including it
            (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
      }
      return getSize;
    });
  });
  var matchesSelector = createCommonjsModule(function (module) {
    /**
     * matchesSelector v2.0.2
     * matchesSelector( element, '.selector' )
     * MIT license
     */
    /*jshint browser: true, strict: true, undef: true, unused: true */
    (function (window, factory) {
      /*global define: false, module: false */
      'use strict';
      // universal module definition
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(factory);
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
      } else {
        // browser global
        window.matchesSelector = factory();
      }
    })(window, function factory() {
      'use strict';
      var matchesMethod = (function () {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) {
          return 'matches';
        }
        // check un-prefixed
        if (ElemProto.matchesSelector) {
          return 'matchesSelector';
        }
        // check vendor prefixes
        var prefixes = ['webkit', 'moz', 'ms', 'o'];
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          var method = prefix + 'MatchesSelector';
          if (ElemProto[method]) {
            return method;
          }
        }
      })();
      return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
      };
    });
  });
  var utils = createCommonjsModule(function (module) {
    /**
     * Fizzy UI utils v2.0.7
     * MIT license
     */
    /*jshint browser: true, undef: true, unused: true, strict: true */
    (function (window, factory) {
      // universal module definition
      /*jshint strict: false */ /*globals define, module, require */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['desandro-matches-selector/matches-selector'], function (matchesSelector$$1) {
          return factory(window, matchesSelector$$1);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, matchesSelector);
      } else {
        // browser global
        window.fizzyUIUtils = factory(window, window.matchesSelector);
      }
    })(window, function factory(window, matchesSelector$$1) {
      'use strict';
      var utils = {};
      // ----- extend ----- //
      // extends objects
      utils.extend = function (a, b) {
        for (var prop in b) {
          a[prop] = b[prop];
        }
        return a;
      };
      // ----- modulo ----- //
      utils.modulo = function (num, div) {
        return ((num % div) + div) % div;
      };
      // ----- makeArray ----- //
      var arraySlice = Array.prototype.slice;
      // turn element or nodeList into an array
      utils.makeArray = function (obj) {
        if (Array.isArray(obj)) {
          // use object if already an array
          return obj;
        }
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) {
          return [];
        }
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) {
          // convert nodeList to array
          return arraySlice.call(obj);
        }
        // array of single index
        return [obj];
      };
      // ----- removeFrom ----- //
      utils.removeFrom = function (ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) {
          ary.splice(index, 1);
        }
      };
      // ----- getParent ----- //
      utils.getParent = function (elem, selector) {
        while (elem.parentNode && elem != document.body) {
          elem = elem.parentNode;
          if (matchesSelector$$1(elem, selector)) {
            return elem;
          }
        }
      };
      // ----- getQueryElement ----- //
      // use element as selector string
      utils.getQueryElement = function (elem) {
        if (typeof elem == 'string') {
          return document.querySelector(elem);
        }
        return elem;
      };
      // ----- handleEvent ----- //
      // enable .ontype to trigger from .addEventListener( elem, 'type' )
      utils.handleEvent = function (event) {
        var method = 'on' + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      // ----- filterFindElements ----- //
      utils.filterFindElements = function (elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function (elem) {
          // check that elem is an actual element
          if (!(elem instanceof HTMLElement)) {
            return;
          }
          // add elem if no selector
          if (!selector) {
            ffElems.push(elem);
            return;
          }
          // filter & find items if we have a selector
          // filter
          if (matchesSelector$$1(elem, selector)) {
            ffElems.push(elem);
          }
          // find children
          var childElems = elem.querySelectorAll(selector);
          // concat childElems to filterFound array
          for (var i = 0; i < childElems.length; i++) {
            ffElems.push(childElems[i]);
          }
        });
        return ffElems;
      };
      // ----- debounceMethod ----- //
      utils.debounceMethod = function (_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function () {
          var timeout = this[timeoutName];
          clearTimeout(timeout);
          var args = arguments;
          var _this = this;
          this[timeoutName] = setTimeout(function () {
            method.apply(_this, args);
            delete _this[timeoutName];
          }, threshold);
        };
      };
      // ----- docReady ----- //
      utils.docReady = function (callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') {
          // do async to allow for other scripts to run. metafizzy/flickity#441
          setTimeout(callback);
        } else {
          document.addEventListener('DOMContentLoaded', callback);
        }
      };
      // ----- htmlInit ----- //
      // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
      utils.toDashed = function (str) {
        return str
          .replace(/(.)([A-Z])/g, function (match, $1, $2) {
            return $1 + '-' + $2;
          })
          .toLowerCase();
      };
      var console = window.console;
      /**
       * allow user to initialize classes via [data-namespace] or .js-namespace class
       * htmlInit( Widget, 'widgetName' )
       * options are parsed from data-namespace-options
       */
      utils.htmlInit = function (WidgetClass, namespace) {
        utils.docReady(function () {
          var dashedNamespace = utils.toDashed(namespace);
          var dataAttr = 'data-' + dashedNamespace;
          var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
          var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
          var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
          var dataOptionsAttr = dataAttr + '-options';
          var jQuery = window.jQuery;
          elems.forEach(function (elem) {
            var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
            var options;
            try {
              options = attr && JSON.parse(attr);
            } catch (error) {
              // log error, do not initialize
              if (console) {
                console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
              }
              return;
            }
            // initialize
            var instance = new WidgetClass(elem, options);
            // make available via $().data('namespace')
            if (jQuery) {
              jQuery.data(elem, namespace, instance);
            }
          });
        });
      };
      // -----  ----- //
      return utils;
    });
  });
  var cell = createCommonjsModule(function (module) {
    // Flickity.Cell
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['get-size/get-size'], function (getSize$$1) {
          return factory(window, getSize$$1);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, getSize);
      } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.Cell = factory(window, window.getSize);
      }
    })(window, function factory(window, getSize$$1) {
      'use strict';
      function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
      }
      var proto = Cell.prototype;
      proto.create = function () {
        this.element.style.position = 'absolute';
        this.element.setAttribute('aria-selected', 'false');
        this.x = 0;
        this.shift = 0;
      };
      proto.destroy = function () {
        // reset style
        this.element.style.position = '';
        var side = this.parent.originSide;
        this.element.removeAttribute('aria-selected');
        this.element.style[side] = '';
      };
      proto.getSize = function () {
        this.size = getSize$$1(this.element);
      };
      proto.setPosition = function (x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
      };
      // setDefaultTarget v1 method, backwards compatibility, remove in v3
      proto.updateTarget = proto.setDefaultTarget = function () {
        var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
      };
      proto.renderPosition = function (x) {
        // render position of cell with in slider
        var side = this.parent.originSide;
        this.element.style[side] = this.parent.getPositionValue(x);
      };
      /**
       * @param {Integer} factor - 0, 1, or -1
       **/
      proto.wrapShift = function (shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
      };
      proto.remove = function () {
        this.element.parentNode.removeChild(this.element);
      };
      return Cell;
    });
  });
  var slide = createCommonjsModule(function (module) {
    // slide
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(factory);
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
      } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.Slide = factory();
      }
    })(window, function factory() {
      'use strict';
      function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == 'left';
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
      }
      var proto = Slide.prototype;
      proto.addCell = function (cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
          this.x = cell.x; // x comes from first cell
          var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
          this.firstMargin = cell.size[beginMargin];
        }
      };
      proto.updateTarget = function () {
        var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
      };
      proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      };
      proto.select = function () {
        this.changeSelected(true);
      };
      proto.unselect = function () {
        this.changeSelected(false);
      };
      proto.changeSelected = function (isSelected) {
        var classMethod = isSelected ? 'add' : 'remove';
        this.cells.forEach(function (cell) {
          cell.element.classList[classMethod]('is-selected');
          cell.element.setAttribute('aria-selected', isSelected.toString());
        });
      };
      proto.getCellElements = function () {
        return this.cells.map(function (cell) {
          return cell.element;
        });
      };
      return Slide;
    });
  });
  var animate = createCommonjsModule(function (module) {
    // animate
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['fizzy-ui-utils/utils'], function (utils$$1) {
          return factory(window, utils$$1);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, utils);
      } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
      }
    })(window, function factory(window, utils$$1) {
      'use strict';
      // -------------------------- animate -------------------------- //
      var proto = {};
      proto.startAnimation = function () {
        if (this.isAnimating) {
          return;
        }
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
      };
      proto.animate = function () {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
          var _this = this;
          requestAnimationFrame(function animateFrame() {
            _this.animate();
          });
        }
      };
      proto.positionSlider = function () {
        var x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
          x = utils$$1.modulo(x, this.slideableWidth);
          x = x - this.slideableWidth;
          this.shiftWrapCells(x);
        }
        x = x + this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var value = this.getPositionValue(x);
        // use 3D tranforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = this.isAnimating ? 'translate3d(' + value + ',0,0)' : 'translateX(' + value + ')';
        // scroll event
        var firstSlide = this.slides[0];
        if (firstSlide) {
          var positionX = -this.x - firstSlide.target;
          var progress = positionX / this.slidesWidth;
          this.dispatchEvent('scroll', null, [progress, positionX]);
        }
      };
      proto.positionSliderAtSelected = function () {
        if (!this.cells.length) {
          return;
        }
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
      };
      proto.getPositionValue = function (position) {
        if (this.options.percentPosition) {
          // percent position, round to 2 digits, like 12.34%
          return Math.round((position / this.size.innerWidth) * 10000) * 0.01 + '%';
        } else {
          // pixel positioning
          return Math.round(position) + 'px';
        }
      };
      proto.settle = function (previousX) {
        // keep track of frames where x hasn't moved
        if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
          this.restingFrames++;
        }
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
          this.isAnimating = false;
          delete this.isFreeScrolling;
          // render position with translateX when settled
          this.positionSlider();
          this.dispatchEvent('settle', null, [this.selectedIndex]);
        }
      };
      proto.shiftWrapCells = function (x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
      };
      proto._shiftCells = function (cells, gap, shift) {
        for (var i = 0; i < cells.length; i++) {
          var cell = cells[i];
          var cellShift = gap > 0 ? shift : 0;
          cell.wrapShift(cellShift);
          gap -= cell.size.outerWidth;
        }
      };
      proto._unshiftCells = function (cells) {
        if (!cells || !cells.length) {
          return;
        }
        for (var i = 0; i < cells.length; i++) {
          cells[i].wrapShift(0);
        }
      };
      // -------------------------- physics -------------------------- //
      proto.integratePhysics = function () {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
      };
      proto.applyForce = function (force) {
        this.velocity += force;
      };
      proto.getFrictionFactor = function () {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
      };
      proto.getRestingPosition = function () {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      };
      proto.applyDragForce = function () {
        if (!this.isDraggable || !this.isPointerDown) {
          return;
        }
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
      };
      proto.applySelectedAttraction = function () {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) {
          return;
        }
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
      };
      return proto;
    });
  });
  var flickity = createCommonjsModule(function (module) {
    // Flickity main
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(
          ['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './cell', './slide', './animate'],
          function (EvEmitter, getSize$$1, utils$$1, Cell, Slide, animatePrototype) {
            return factory(window, EvEmitter, getSize$$1, utils$$1, Cell, Slide, animatePrototype);
          }
        );
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, evEmitter, getSize, utils, cell, slide, animate);
      } else {
        // browser global
        var _Flickity = window.Flickity;
        window.Flickity = factory(
          window,
          window.EvEmitter,
          window.getSize,
          window.fizzyUIUtils,
          _Flickity.Cell,
          _Flickity.Slide,
          _Flickity.animatePrototype
        );
      }
    })(window, function factory(window, EvEmitter, getSize$$1, utils$$1, Cell, Slide, animatePrototype) {
      'use strict';
      // vars
      var jQuery = window.jQuery;
      var getComputedStyle = window.getComputedStyle;
      var console = window.console;
      function moveElements(elems, toElem) {
        elems = utils$$1.makeArray(elems);
        while (elems.length) {
          toElem.appendChild(elems.shift());
        }
      }
      // -------------------------- Flickity -------------------------- //
      // globally unique identifiers
      var GUID = 0;
      // internal store of all Flickity intances
      var instances = {};
      function Flickity(element, options) {
        var queryElement = utils$$1.getQueryElement(element);
        if (!queryElement) {
          if (console) {
            console.error('Bad element for Flickity: ' + (queryElement || element));
          }
          return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
          var instance = instances[this.element.flickityGUID];
          instance.option(options);
          return instance;
        }
        // add jQuery
        if (jQuery) {
          this.$element = jQuery(this.element);
        }
        // options
        this.options = utils$$1.extend({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
      }
      Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075, // friction when free-scrolling
        friction: 0.28, // friction when selecting
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true,
        // watchCSS: false,
        // wrapAround: false
      };
      // hash of methods triggered on _create()
      Flickity.createMethods = [];
      var proto = Flickity.prototype;
      // inherit EventEmitter
      utils$$1.extend(proto, EvEmitter.prototype);
      proto._create = function () {
        // add id for Flickity.data
        var id = (this.guid = ++GUID);
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? 'right' : 'left';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) {
          window.addEventListener('resize', this);
        }
        // add listeners from on option
        for (var eventName in this.options.on) {
          var listener = this.options.on[eventName];
          this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function (method) {
          this[method]();
        }, this);
        if (this.options.watchCSS) {
          this.watchCSS();
        } else {
          this.activate();
        }
      };
      /**
       * set options
       * @param {Object} opts
       */
      proto.option = function (opts) {
        utils$$1.extend(this.options, opts);
      };
      proto.activate = function () {
        if (this.isActive) {
          return;
        }
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) {
          this.element.classList.add('flickity-rtl');
        }
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
          // allow element to focusable
          this.element.tabIndex = 0;
          // listen for key presses
          this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        var index;
        var initialIndex = this.options.initialIndex;
        if (this.isInitActivated) {
          index = this.selectedIndex;
        } else if (initialIndex !== undefined) {
          index = this.cells[initialIndex] ? initialIndex : 0;
        } else {
          index = 0;
        }
        // select instantly
        this.select(index, false, true);
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
      };
      // slider positions the cells
      proto._createSlider = function () {
        // slider element does all the positioning
        var slider = document.createElement('div');
        slider.className = 'flickity-slider';
        slider.style[this.originSide] = 0;
        this.slider = slider;
      };
      proto._filterFindCellElements = function (elems) {
        return utils$$1.filterFindElements(elems, this.options.cellSelector);
      };
      // goes through all children
      proto.reloadCells = function () {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
      };
      /**
       * turn elements into Flickity.Cells
       * @param {Array or NodeList or HTMLElement} elems
       * @returns {Array} items - collection of new Flickity Cells
       */
      proto._makeCells = function (elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Flickity for collection
        var cells = cellElems.map(function (cellElem) {
          return new Cell(cellElem, this);
        }, this);
        return cells;
      };
      proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      };
      proto.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      };
      // positions all cells
      proto.positionCells = function () {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
      };
      /**
       * position certain cells
       * @param {Integer} index - which cell to start with
       */
      proto._positionCells = function (index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
          var startCell = this.cells[index - 1];
          cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for (var i = index; i < len; i++) {
          var cell$$1 = this.cells[i];
          cell$$1.setPosition(cellX);
          cellX += cell$$1.size.outerWidth;
          this.maxCellHeight = Math.max(cell$$1.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
      };
      /**
       * cell.getSize() on multiple cells
       * @param {Array} cells
       */
      proto._sizeCells = function (cells) {
        cells.forEach(function (cell$$1) {
          cell$$1.getSize();
        });
      };
      // --------------------------  -------------------------- //
      proto.updateSlides = function () {
        this.slides = [];
        if (!this.cells.length) {
          return;
        }
        var slide$$1 = new Slide(this);
        this.slides.push(slide$$1);
        var isOriginLeft = this.originSide == 'left';
        var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function (cell$$1, i) {
          // just add cell if first cell in slide
          if (!slide$$1.cells.length) {
            slide$$1.addCell(cell$$1);
            return;
          }
          var slideWidth = slide$$1.outerWidth - slide$$1.firstMargin + (cell$$1.size.outerWidth - cell$$1.size[nextMargin]);
          if (canCellFit.call(this, i, slideWidth)) {
            slide$$1.addCell(cell$$1);
          } else {
            // doesn't fit, new slide
            slide$$1.updateTarget();
            slide$$1 = new Slide(this);
            this.slides.push(slide$$1);
            slide$$1.addCell(cell$$1);
          }
        }, this);
        // last slide
        slide$$1.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
      };
      proto._getCanCellFit = function () {
        var groupCells = this.options.groupCells;
        if (!groupCells) {
          return function () {
            return false;
          };
        } else if (typeof groupCells == 'number') {
          // group by number. 3 -> [0,1,2], [3,4,5], ...
          var number = parseInt(groupCells, 10);
          return function (i) {
            return i % number !== 0;
          };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function (i, slideWidth) {
          return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
      };
      // alias _init for jQuery plugin .flickity()
      proto._init = proto.reposition = function () {
        this.positionCells();
        this.positionSliderAtSelected();
      };
      proto.getSize = function () {
        this.size = getSize$$1(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
      };
      var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
          left: 0.5,
          right: 0.5,
        },
        left: {
          left: 0,
          right: 1,
        },
        right: {
          right: 0,
          left: 1,
        },
      };
      proto.setCellAlign = function () {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
      };
      proto.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = height + 'px';
        }
      };
      proto._getWrapShiftCells = function () {
        // only for wrap-around
        if (!this.options.wrapAround) {
          return;
        }
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
      };
      proto._getGapCells = function (gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while (gapX > 0) {
          var cell$$1 = this.cells[cellIndex];
          if (!cell$$1) {
            break;
          }
          cells.push(cell$$1);
          cellIndex += increment;
          gapX -= cell$$1.size.outerWidth;
        }
        return cells;
      };
      // ----- contain ----- //
      // contain cell targets so no excess sliding
      proto._containSlides = function () {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
          return;
        }
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
        var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function (slide$$1) {
          if (isContentSmaller) {
            // all cells fit inside gallery
            slide$$1.target = contentWidth * this.cellAlign;
          } else {
            // contain to bounds
            slide$$1.target = Math.max(slide$$1.target, beginBound);
            slide$$1.target = Math.min(slide$$1.target, endBound);
          }
        }, this);
      };
      // -----  ----- //
      /**
       * emits events via eventEmitter and jQuery events
       * @param {String} type - name of event
       * @param {Event} event - original event
       * @param {Array} args - extra arguments
       */
      proto.dispatchEvent = function (type, event, args) {
        var emitArgs = event ? [event].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
          // default trigger with type if no event
          type += this.options.namespaceJQueryEvents ? '.flickity' : '';
          var $event = type;
          if (event) {
            // create jQuery event
            var jQEvent = jQuery.Event(event);
            jQEvent.type = type;
            $event = jQEvent;
          }
          this.$element.trigger($event, args);
        }
      };
      // -------------------------- select -------------------------- //
      /**
       * @param {Integer} index - index of the slide
       * @param {Boolean} isWrap - will wrap-around to last/first if at the end
       * @param {Boolean} isInstant - will immediately set position at selected cell
       */
      proto.select = function (index, isWrap, isInstant) {
        if (!this.isActive) {
          return;
        }
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) {
          index = utils$$1.modulo(index, this.slides.length);
        }
        // bail if invalid index
        if (!this.slides[index]) {
          return;
        }
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) {
          this.positionSliderAtSelected();
        } else {
          this.startAnimation();
        }
        if (this.options.adaptiveHeight) {
          this.setGallerySize();
        }
        // events
        this.dispatchEvent('select', null, [index]);
        // change event if new index
        if (index != prevIndex) {
          this.dispatchEvent('change', null, [index]);
        }
        // old v1 event name, remove in v3
        this.dispatchEvent('cellSelect');
      };
      // wraps position for wrapAround, to move to closest slide. #113
      proto._wrapSelect = function (index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) {
          return index;
        }
        var wrapIndex = utils$$1.modulo(index, len);
        // go to shortest
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) {
          index += len;
        } else if (!this.isDragSelect && forewardWrapDelta < delta) {
          index -= len;
        }
        // wrap position so slider is within normal area
        if (index < 0) {
          this.x -= this.slideableWidth;
        } else if (index >= len) {
          this.x += this.slideableWidth;
        }
      };
      proto.previous = function (isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
      };
      proto.next = function (isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
      };
      proto.updateSelectedSlide = function () {
        var slide$$1 = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide$$1) {
          return;
        }
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide$$1;
        slide$$1.select();
        this.selectedCells = slide$$1.cells;
        this.selectedElements = slide$$1.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide$$1.cells[0];
        this.selectedElement = this.selectedElements[0];
      };
      proto.unselectSelectedSlide = function () {
        if (this.selectedSlide) {
          this.selectedSlide.unselect();
        }
      };
      /**
       * select slide from number or cell element
       * @param {Element or Number} elem
       */
      proto.selectCell = function (value, isWrap, isInstant) {
        // get cell
        var cell$$1 = this.queryCell(value);
        if (!cell$$1) {
          return;
        }
        var index = this.getCellSlideIndex(cell$$1);
        this.select(index, isWrap, isInstant);
      };
      proto.getCellSlideIndex = function (cell$$1) {
        // get index of slides that has cell
        for (var i = 0; i < this.slides.length; i++) {
          var slide$$1 = this.slides[i];
          var index = slide$$1.cells.indexOf(cell$$1);
          if (index != -1) {
            return i;
          }
        }
      };
      // -------------------------- get cells -------------------------- //
      /**
       * get Flickity.Cell, given an Element
       * @param {Element} elem
       * @returns {Flickity.Cell} item
       */
      proto.getCell = function (elem) {
        // loop through cells to get the one that matches
        for (var i = 0; i < this.cells.length; i++) {
          var cell$$1 = this.cells[i];
          if (cell$$1.element == elem) {
            return cell$$1;
          }
        }
      };
      /**
       * get collection of Flickity.Cells, given Elements
       * @param {Element, Array, NodeList} elems
       * @returns {Array} cells - Flickity.Cells
       */
      proto.getCells = function (elems) {
        elems = utils$$1.makeArray(elems);
        var cells = [];
        elems.forEach(function (elem) {
          var cell$$1 = this.getCell(elem);
          if (cell$$1) {
            cells.push(cell$$1);
          }
        }, this);
        return cells;
      };
      /**
       * get cell elements
       * @returns {Array} cellElems
       */
      proto.getCellElements = function () {
        return this.cells.map(function (cell$$1) {
          return cell$$1.element;
        });
      };
      /**
       * get parent cell from an element
       * @param {Element} elem
       * @returns {Flickit.Cell} cell
       */
      proto.getParentCell = function (elem) {
        // first check if elem is cell
        var cell$$1 = this.getCell(elem);
        if (cell$$1) {
          return cell$$1;
        }
        // try to get parent cell elem
        elem = utils$$1.getParent(elem, '.flickity-slider > *');
        return this.getCell(elem);
      };
      /**
       * get cells adjacent to a slide
       * @param {Integer} adjCount - number of adjacent slides
       * @param {Integer} index - index of slide to start
       * @returns {Array} cells - array of Flickity.Cells
       */
      proto.getAdjacentCellElements = function (adjCount, index) {
        if (!adjCount) {
          return this.selectedSlide.getCellElements();
        }
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) {
          return this.getCellElements();
        }
        var cellElems = [];
        for (var i = index - adjCount; i <= index + adjCount; i++) {
          var slideIndex = this.options.wrapAround ? utils$$1.modulo(i, len) : i;
          var slide$$1 = this.slides[slideIndex];
          if (slide$$1) {
            cellElems = cellElems.concat(slide$$1.getCellElements());
          }
        }
        return cellElems;
      };
      /**
       * select slide from number or cell element
       * @param {Element, Selector String, or Number} selector
       */
      proto.queryCell = function (selector) {
        if (typeof selector == 'number') {
          // use number as index
          return this.cells[selector];
        }
        if (typeof selector == 'string') {
          // use string as selector, get element
          selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
      };
      // -------------------------- events -------------------------- //
      proto.uiChange = function () {
        this.emitEvent('uiChange');
      };
      proto.childUIPointerDown = function (event) {
        this.emitEvent('childUIPointerDown', [event]);
      };
      // ----- resize ----- //
      proto.onresize = function () {
        this.watchCSS();
        this.resize();
      };
      utils$$1.debounceMethod(Flickity, 'onresize', 150);
      proto.resize = function () {
        if (!this.isActive) {
          return;
        }
        this.getSize();
        // wrap values
        if (this.options.wrapAround) {
          this.x = utils$$1.modulo(this.x, this.slideableWidth);
        }
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
      };
      // watches the :after property, activates/deactivates
      proto.watchCSS = function () {
        var watchOption = this.options.watchCSS;
        if (!watchOption) {
          return;
        }
        var afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.indexOf('flickity') != -1) {
          this.activate();
        } else {
          this.deactivate();
        }
      };
      // ----- keydown ----- //
      // go previous/next if left/right keys pressed
      proto.onkeydown = function (event) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) {
          return;
        }
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) {
          handler.call(this);
        }
      };
      Flickity.keyboardHandlers = {
        // left arrow
        37: function () {
          var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
          this.uiChange();
          this[leftMethod]();
        },
        // right arrow
        39: function () {
          var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
          this.uiChange();
          this[rightMethod]();
        },
      };
      // ----- focus ----- //
      proto.focus = function () {
        var prevScrollY = window.pageYOffset;
        this.element.focus();
        // hack to fix scroll jump after focus, #76
        if (window.pageYOffset != prevScrollY) {
          window.scrollTo(window.pageXOffset, prevScrollY);
        }
      };
      // -------------------------- destroy -------------------------- //
      // deactivate all Flickity functionality, but keep stuff available
      proto.deactivate = function () {
        if (!this.isActive) {
          return;
        }
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function (cell$$1) {
          cell$$1.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
          this.element.removeAttribute('tabIndex');
          this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
      };
      proto.destroy = function () {
        this.deactivate();
        window.removeEventListener('resize', this);
        this.emitEvent('destroy');
        if (jQuery && this.$element) {
          jQuery.removeData(this.element, 'flickity');
        }
        delete this.element.flickityGUID;
        delete instances[this.guid];
      };
      // -------------------------- prototype -------------------------- //
      utils$$1.extend(proto, animatePrototype);
      // -------------------------- extras -------------------------- //
      /**
       * get Flickity instance from element
       * @param {Element} elem
       * @returns {Flickity}
       */
      Flickity.data = function (elem) {
        elem = utils$$1.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
      };
      utils$$1.htmlInit(Flickity, 'flickity');
      if (jQuery && jQuery.bridget) {
        jQuery.bridget('flickity', Flickity);
      }
      // set internal jQuery, for Webpack + jQuery v3, #478
      Flickity.setJQuery = function (jq) {
        jQuery = jq;
      };
      Flickity.Cell = Cell;
      return Flickity;
    });
  });
  var unipointer = createCommonjsModule(function (module) {
    /**
     * Unipointer v2.3.0
     * base class for doing one thing with pointer event
     * MIT license
     */
    /*jshint browser: true, undef: true, unused: true, strict: true */
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */ /*global define, module, require */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['ev-emitter/ev-emitter'], function (EvEmitter) {
          return factory(window, EvEmitter);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, evEmitter);
      } else {
        // browser global
        window.Unipointer = factory(window, window.EvEmitter);
      }
    })(window, function factory(window, EvEmitter) {
      'use strict';
      function noop() { }
      function Unipointer() { }
      // inherit EvEmitter
      var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));
      proto.bindStartEvent = function (elem) {
        this._bindStartEvent(elem, true);
      };
      proto.unbindStartEvent = function (elem) {
        this._bindStartEvent(elem, false);
      };
      /**
       * Add or remove start event
       * @param {Boolean} isAdd - remove if falsey
       */
      proto._bindStartEvent = function (elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        // default to mouse events
        var startEvent = 'mousedown';
        if (window.PointerEvent) {
          // Pointer Events
          startEvent = 'pointerdown';
        } else if ('ontouchstart' in window) {
          // Touch Events. iOS Safari
          startEvent = 'touchstart';
        }
        elem[bindMethod](startEvent, this);
      };
      // trigger handler methods for events
      proto.handleEvent = function (event) {
        var method = 'on' + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      // returns the touch that we're keeping track of
      proto.getTouch = function (touches) {
        for (var i = 0; i < touches.length; i++) {
          var touch = touches[i];
          if (touch.identifier == this.pointerIdentifier) {
            return touch;
          }
        }
      };
      // ----- start event ----- //
      proto.onmousedown = function (event) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if (button && button !== 0 && button !== 1) {
          return;
        }
        this._pointerDown(event, event);
      };
      proto.ontouchstart = function (event) {
        this._pointerDown(event, event.changedTouches[0]);
      };
      proto.onpointerdown = function (event) {
        this._pointerDown(event, event);
      };
      /**
       * pointer start
       * @param {Event} event
       * @param {Event or Touch} pointer
       */
      proto._pointerDown = function (event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) {
          return;
        }
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier =
          pointer.pointerId !== undefined
            ? // pointerId for pointer events, touch.indentifier for touch events
            pointer.pointerId
            : pointer.identifier;
        this.pointerDown(event, pointer);
      };
      proto.pointerDown = function (event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [event, pointer]);
      };
      // hash of events to be bound after start event
      var postStartEvents = {
        mousedown: ['mousemove', 'mouseup'],
        touchstart: ['touchmove', 'touchend', 'touchcancel'],
        pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
      };
      proto._bindPostStartEvents = function (event) {
        if (!event) {
          return;
        }
        // get proper events to match start event
        var events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function (eventName) {
          window.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
      };
      proto._unbindPostStartEvents = function () {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) {
          return;
        }
        this._boundPointerEvents.forEach(function (eventName) {
          window.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
      };
      // ----- move event ----- //
      proto.onmousemove = function (event) {
        this._pointerMove(event, event);
      };
      proto.onpointermove = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
          this._pointerMove(event, event);
        }
      };
      proto.ontouchmove = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
          this._pointerMove(event, touch);
        }
      };
      /**
       * pointer move
       * @param {Event} event
       * @param {Event or Touch} pointer
       * @private
       */
      proto._pointerMove = function (event, pointer) {
        this.pointerMove(event, pointer);
      };
      // public
      proto.pointerMove = function (event, pointer) {
        this.emitEvent('pointerMove', [event, pointer]);
      };
      // ----- end event ----- //
      proto.onmouseup = function (event) {
        this._pointerUp(event, event);
      };
      proto.onpointerup = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
          this._pointerUp(event, event);
        }
      };
      proto.ontouchend = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
          this._pointerUp(event, touch);
        }
      };
      /**
       * pointer up
       * @param {Event} event
       * @param {Event or Touch} pointer
       * @private
       */
      proto._pointerUp = function (event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
      };
      // public
      proto.pointerUp = function (event, pointer) {
        this.emitEvent('pointerUp', [event, pointer]);
      };
      // ----- pointer done ----- //
      // triggered on pointer up & pointer cancel
      proto._pointerDone = function () {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
      };
      proto._pointerReset = function () {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
      };
      proto.pointerDone = noop;
      // ----- pointer cancel ----- //
      proto.onpointercancel = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
          this._pointerCancel(event, event);
        }
      };
      proto.ontouchcancel = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
          this._pointerCancel(event, touch);
        }
      };
      /**
       * pointer cancel
       * @param {Event} event
       * @param {Event or Touch} pointer
       * @private
       */
      proto._pointerCancel = function (event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
      };
      // public
      proto.pointerCancel = function (event, pointer) {
        this.emitEvent('pointerCancel', [event, pointer]);
      };
      // -----  ----- //
      // utility function for getting x/y coords from event
      Unipointer.getPointerPoint = function (pointer) {
        return {
          x: pointer.pageX,
          y: pointer.pageY,
        };
      };
      // -----  ----- //
      return Unipointer;
    });
  });
  var unidragger = createCommonjsModule(function (module) {
    /**
     * Unidragger v2.3.0
     * Draggable base class
     * MIT license
     */
    /*jshint browser: true, unused: true, undef: true, strict: true */
    (function (window, factory) {
      // universal module definition
      /*jshint strict: false */ /*globals define, module, require */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['unipointer/unipointer'], function (Unipointer) {
          return factory(window, Unipointer);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, unipointer);
      } else {
        // browser global
        window.Unidragger = factory(window, window.Unipointer);
      }
    })(window, function factory(window, Unipointer) {
      'use strict';
      // -------------------------- Unidragger -------------------------- //
      function Unidragger() { }
      // inherit Unipointer & EvEmitter
      var proto = (Unidragger.prototype = Object.create(Unipointer.prototype));
      // ----- bind start ----- //
      proto.bindHandles = function () {
        this._bindHandles(true);
      };
      proto.unbindHandles = function () {
        this._bindHandles(false);
      };
      /**
       * Add or remove start event
       * @param {Boolean} isAdd
       */
      proto._bindHandles = function (isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        var touchAction = isAdd ? this._touchActionValue : '';
        for (var i = 0; i < this.handles.length; i++) {
          var handle = this.handles[i];
          this._bindStartEvent(handle, isAdd);
          handle[bindMethod]('click', this);
          // touch-action: none to override browser touch gestures. metafizzy/flickity#540
          if (window.PointerEvent) {
            handle.style.touchAction = touchAction;
          }
        }
      };
      // prototype so it can be overwriteable by Flickity
      proto._touchActionValue = 'none';
      // ----- start event ----- //
      /**
       * pointer start
       * @param {Event} event
       * @param {Event or Touch} pointer
       */
      proto.pointerDown = function (event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) {
          return;
        }
        // track start event position
        this.pointerDownPointer = pointer;
        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [event, pointer]);
      };
      // nodes that have text fields
      var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true,
      };
      // input types that do not have text fields
      var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true,
      };
      // dismiss inputs with text fields. flickity#403, flickity#404
      proto.okayPointerDown = function (event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) {
          this._pointerReset();
        }
        return isOkay;
      };
      // kludge to blur previously focused input
      proto.pointerDownBlur = function () {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) {
          focused.blur();
        }
      };
      // ----- move event ----- //
      /**
       * drag move
       * @param {Event} event
       * @param {Event or Touch} pointer
       */
      proto.pointerMove = function (event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent('pointerMove', [event, pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
      };
      // base pointer move logic
      proto._dragPointerMove = function (event, pointer) {
        var moveVector = {
          x: pointer.pageX - this.pointerDownPointer.pageX,
          y: pointer.pageY - this.pointerDownPointer.pageY,
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) {
          this._dragStart(event, pointer);
        }
        return moveVector;
      };
      // condition if pointer has moved far enough to start drag
      proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
      };
      // ----- end event ----- //
      /**
       * pointer up
       * @param {Event} event
       * @param {Event or Touch} pointer
       */
      proto.pointerUp = function (event, pointer) {
        this.emitEvent('pointerUp', [event, pointer]);
        this._dragPointerUp(event, pointer);
      };
      proto._dragPointerUp = function (event, pointer) {
        if (this.isDragging) {
          this._dragEnd(event, pointer);
        } else {
          // pointer didn't move enough for drag to start
          this._staticClick(event, pointer);
        }
      };
      // -------------------------- drag -------------------------- //
      // dragStart
      proto._dragStart = function (event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
      };
      proto.dragStart = function (event, pointer) {
        this.emitEvent('dragStart', [event, pointer]);
      };
      // dragMove
      proto._dragMove = function (event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) {
          return;
        }
        this.dragMove(event, pointer, moveVector);
      };
      proto.dragMove = function (event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent('dragMove', [event, pointer, moveVector]);
      };
      // dragEnd
      proto._dragEnd = function (event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout(
          function () {
            delete this.isPreventingClicks;
          }.bind(this)
        );
        this.dragEnd(event, pointer);
      };
      proto.dragEnd = function (event, pointer) {
        this.emitEvent('dragEnd', [event, pointer]);
      };
      // ----- onclick ----- //
      // handle all clicks and prevent clicks when dragging
      proto.onclick = function (event) {
        if (this.isPreventingClicks) {
          event.preventDefault();
        }
      };
      // ----- staticClick ----- //
      // triggered after pointer down & up with no/tiny movement
      proto._staticClick = function (event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == 'mouseup') {
          return;
        }
        this.staticClick(event, pointer);
        // set flag for emulated clicks 300ms after touchend
        if (event.type != 'mouseup') {
          this.isIgnoringMouseUp = true;
          // reset flag after 300ms
          setTimeout(
            function () {
              delete this.isIgnoringMouseUp;
            }.bind(this),
            400
          );
        }
      };
      proto.staticClick = function (event, pointer) {
        this.emitEvent('staticClick', [event, pointer]);
      };
      // ----- utils ----- //
      Unidragger.getPointerPoint = Unipointer.getPointerPoint;
      // -----  ----- //
      return Unidragger;
    });
  });
  var drag = createCommonjsModule(function (module) {
    // drag
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', 'unidragger/unidragger', 'fizzy-ui-utils/utils'], function (Flickity, Unidragger, utils$$2) {
          return factory(window, Flickity, Unidragger, utils$$2);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, flickity, unidragger, utils);
      } else {
        // browser global
        window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
      }
    })(window, function factory(window, Flickity, Unidragger, utils$$2) {
      'use strict';
      // ----- defaults ----- //
      utils$$2.extend(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3,
      });
      // ----- create ----- //
      Flickity.createMethods.push('_createDrag');
      // -------------------------- drag prototype -------------------------- //
      var proto = Flickity.prototype;
      utils$$2.extend(proto, Unidragger.prototype);
      proto._touchActionValue = 'pan-y';
      // --------------------------  -------------------------- //
      var isTouch = 'createTouch' in document;
      var isTouchmoveScrollCanceled = false;
      proto._createDrag = function () {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('childUIPointerDown', this._childUIPointerDownDrag);
        this.on('deactivate', this.unbindDrag);
        this.on('cellChange', this.updateDraggable);
        // TODO updateDraggable on resize? if groupCells & slides change
        // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
        // #457, RubaXa/Sortable#973
        if (isTouch && !isTouchmoveScrollCanceled) {
          window.addEventListener('touchmove', function () { });
          isTouchmoveScrollCanceled = true;
        }
      };
      proto.onActivateDrag = function () {
        this.handles = [this.viewport];
        this.bindHandles();
        this.updateDraggable();
      };
      proto.onDeactivateDrag = function () {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
      };
      proto.updateDraggable = function () {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == '>1') {
          this.isDraggable = this.slides.length > 1;
        } else {
          this.isDraggable = this.options.draggable;
        }
        if (this.isDraggable) {
          this.element.classList.add('is-draggable');
        } else {
          this.element.classList.remove('is-draggable');
        }
      };
      // backwards compatibility
      proto.bindDrag = function () {
        this.options.draggable = true;
        this.updateDraggable();
      };
      proto.unbindDrag = function () {
        this.options.draggable = false;
        this.updateDraggable();
      };
      proto._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      };
      proto._childUIPointerDownDrag = function (event) {
        // allow focus & preventDefault even when not draggable
        // so child UI elements keep focus on carousel. #721
        event.preventDefault();
        this.pointerDownFocus(event);
      };
      // -------------------------- pointer events -------------------------- //
      proto.pointerDown = function (event, pointer) {
        if (!this.isDraggable) {
          this._pointerDownDefault(event, pointer);
          return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) {
          return;
        }
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) {
          // do not blur if already focused
          this.pointerDownBlur();
        }
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window.addEventListener('scroll', this);
        this._pointerDownDefault(event, pointer);
      };
      // default pointerDown logic, used for staticClick
      proto._pointerDownDefault = function (event, pointer) {
        // track start event position
        this.pointerDownPointer = pointer;
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent('pointerDown', event, [pointer]);
      };
      var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true,
      };
      proto.pointerDownFocus = function (event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) {
          this.focus();
        }
      };
      proto._pointerDownPreventDefault = function (event) {
        var isTouchStart = event.type == 'touchstart';
        var isTouchPointer = event.pointerType == 'touch';
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) {
          event.preventDefault();
        }
      };
      // ----- move ----- //
      proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
      };
      // ----- up ----- //
      proto.pointerUp = function (event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
        this.dispatchEvent('pointerUp', event, [pointer]);
        this._dragPointerUp(event, pointer);
      };
      proto.pointerDone = function () {
        window.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
      };
      // -------------------------- dragging -------------------------- //
      proto.dragStart = function (event, pointer) {
        if (!this.isDraggable) {
          return;
        }
        this.dragStartPosition = this.x;
        this.startAnimation();
        window.removeEventListener('scroll', this);
        this.dispatchEvent('dragStart', event, [pointer]);
      };
      proto.pointerMove = function (event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
      };
      proto.dragMove = function (event, pointer, moveVector) {
        if (!this.isDraggable) {
          return;
        }
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) {
          // wrap around move. #589
          moveVector.x = moveVector.x % this.slideableWidth;
        }
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
          // slow drag
          var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
          dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
          var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
          dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent('dragMove', event, [pointer, moveVector]);
      };
      proto.dragEnd = function (event, pointer) {
        if (!this.isDraggable) {
          return;
        }
        if (this.options.freeScroll) {
          this.isFreeScrolling = true;
        }
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
          // if free-scroll & not wrap around
          // do not free-scroll if going outside of bounding slides
          // so bounding slides can attract slider, and keep it in bounds
          var restingX = this.getRestingPosition();
          this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) {
          // boost selection if selected index has not changed
          index += this.dragEndBoostSelect();
        }
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent('dragEnd', event, [pointer]);
      };
      proto.dragEndRestingSelect = function () {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
      };
      /**
       * given resting X and distance to selected cell
       * get the distance and index of the closest cell
       * @param {Number} restingX - estimated post-flick resting position
       * @param {Number} distance - distance to selected cell
       * @param {Integer} increment - +1 or -1, going up or down
       * @returns {Object} - { distance: {Number}, index: {Integer} }
       */
      proto._getClosestResting = function (restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition =
          this.options.contain && !this.options.wrapAround
            ? // if contain, keep going if distance is equal to minDistance
            function (d, md) {
              return d <= md;
            }
            : function (d, md) {
              return d < md;
            };
        while (condition(distance, minDistance)) {
          // measure distance to next cell
          index += increment;
          minDistance = distance;
          distance = this.getSlideDistance(-restingX, index);
          if (distance === null) {
            break;
          }
          distance = Math.abs(distance);
        }
        return {
          distance: minDistance,
          // selected was previous index
          index: index - increment,
        };
      };
      /**
       * measure distance between x and a slide target
       * @param {Number} x
       * @param {Integer} index - slide index
       */
      proto.getSlideDistance = function (x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils$$2.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) {
          return null;
        }
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
      };
      proto.dragEndBoostSelect = function () {
        // do not boost if no previousDragX or dragMoveTime
        if (
          this.previousDragX === undefined ||
          !this.dragMoveTime ||
          // or if drag was held for 100 ms
          new Date() - this.dragMoveTime > 100
        ) {
          return 0;
        }
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) {
          // boost to next if moving towards the right, and positive velocity
          return 1;
        } else if (distance < 0 && delta < 0) {
          // boost to previous if moving towards the left, and negative velocity
          return -1;
        }
        return 0;
      };
      // ----- staticClick ----- //
      proto.staticClick = function (event, pointer) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
      };
      // ----- scroll ----- //
      proto.onscroll = function () {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
          this._pointerDone();
        }
      };
      // ----- utils ----- //
      function getScrollPosition() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset,
        };
      }
      // -----  ----- //
      return Flickity;
    });
  });
  var tapListener = createCommonjsModule(function (module) {
    /**
     * Tap listener v2.0.0
     * listens to taps
     * MIT license
     */
    /*jshint browser: true, unused: true, undef: true, strict: true */
    (function (window, factory) {
      // universal module definition
      /*jshint strict: false*/ /*globals define, module, require */ if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['unipointer/unipointer'], function (Unipointer) {
          return factory(window, Unipointer);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, unipointer);
      } else {
        // browser global
        window.TapListener = factory(window, window.Unipointer);
      }
    })(window, function factory(window, Unipointer) {
      'use strict';
      // --------------------------  TapListener -------------------------- //
      function TapListener(elem) {
        this.bindTap(elem);
      }
      // inherit Unipointer & EventEmitter
      var proto = (TapListener.prototype = Object.create(Unipointer.prototype));
      /**
       * bind tap event to element
       * @param {Element} elem
       */
      proto.bindTap = function (elem) {
        if (!elem) {
          return;
        }
        this.unbindTap();
        this.tapElement = elem;
        this._bindStartEvent(elem, true);
      };
      proto.unbindTap = function () {
        if (!this.tapElement) {
          return;
        }
        this._bindStartEvent(this.tapElement, true);
        delete this.tapElement;
      };
      /**
       * pointer up
       * @param {Event} event
       * @param {Event or Touch} pointer
       */
      proto.pointerUp = function (event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == 'mouseup') {
          return;
        }
        var pointerPoint = Unipointer.getPointerPoint(pointer);
        var boundingRect = this.tapElement.getBoundingClientRect();
        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;
        // calculate if pointer is inside tapElement
        var isInside =
          pointerPoint.x >= boundingRect.left + scrollX &&
          pointerPoint.x <= boundingRect.right + scrollX &&
          pointerPoint.y >= boundingRect.top + scrollY &&
          pointerPoint.y <= boundingRect.bottom + scrollY;
        // trigger callback if pointer is inside element
        if (isInside) {
          this.emitEvent('tap', [event, pointer]);
        }
        // set flag for emulated clicks 300ms after touchend
        if (event.type != 'mouseup') {
          this.isIgnoringMouseUp = true;
          // reset flag after 300ms
          var _this = this;
          setTimeout(function () {
            delete _this.isIgnoringMouseUp;
          }, 400);
        }
      };
      proto.destroy = function () {
        this.pointerDone();
        this.unbindTap();
      };
      // -----  ----- //
      return TapListener;
    });
  });
  var prevNextButton = createCommonjsModule(function (module) {
    // prev/next buttons
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', 'tap-listener/tap-listener', 'fizzy-ui-utils/utils'], function (Flickity, TapListener, utils$$2) {
          return factory(window, Flickity, TapListener, utils$$2);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, flickity, tapListener, utils);
      } else {
        // browser global
        factory(window, window.Flickity, window.TapListener, window.fizzyUIUtils);
      }
    })(window, function factory(window, Flickity, TapListener, utils$$2) {
      'use strict';
      var svgURI = 'http://www.w3.org/2000/svg';
      // -------------------------- PrevNextButton -------------------------- //
      function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
      }
      PrevNextButton.prototype = Object.create(TapListener.prototype);
      PrevNextButton.prototype._create = function () {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = (this.element = document.createElement('button'));
        element.className = 'flickity-button flickity-prev-next-button';
        element.className += this.isPrevious ? ' previous' : ' next';
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        // init as disabled
        this.disable();
        element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
        // create arrow
        var svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.on('tap', this.onTap);
        this.parent.on('select', this.update.bind(this));
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
      };
      PrevNextButton.prototype.activate = function () {
        this.bindTap(this.element);
        // click events from keyboard
        this.element.addEventListener('click', this);
        // add to DOM
        this.parent.element.appendChild(this.element);
      };
      PrevNextButton.prototype.deactivate = function () {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // do regular TapListener destroy
        TapListener.prototype.destroy.call(this);
        // click events from keyboard
        this.element.removeEventListener('click', this);
      };
      PrevNextButton.prototype.createSVG = function () {
        var svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        var path = document.createElementNS(svgURI, 'path');
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) {
          path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
        }
        svg.appendChild(path);
        return svg;
      };
      // get SVG path movmement
      function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') {
          return shape;
        }
        // create movement string
        return (
          'M ' +
          shape.x0 +
          ',50' +
          ' L ' +
          shape.x1 +
          ',' +
          (shape.y1 + 50) +
          ' L ' +
          shape.x2 +
          ',' +
          (shape.y2 + 50) +
          ' L ' +
          shape.x3 +
          ',50 ' +
          ' L ' +
          shape.x2 +
          ',' +
          (50 - shape.y2) +
          ' L ' +
          shape.x1 +
          ',' +
          (50 - shape.y1) +
          ' Z'
        );
      }
      PrevNextButton.prototype.onTap = function () {
        if (!this.isEnabled) {
          return;
        }
        this.parent.uiChange();
        var method = this.isPrevious ? 'previous' : 'next';
        this.parent[method]();
      };
      PrevNextButton.prototype.handleEvent = utils$$2.handleEvent;
      PrevNextButton.prototype.onclick = function (event) {
        // only allow clicks from keyboard
        var focused = document.activeElement;
        if (focused && focused == this.element) {
          this.onTap(event, event);
        }
      };
      // -----  ----- //
      PrevNextButton.prototype.enable = function () {
        if (this.isEnabled) {
          return;
        }
        this.element.disabled = false;
        this.isEnabled = true;
      };
      PrevNextButton.prototype.disable = function () {
        if (!this.isEnabled) {
          return;
        }
        this.element.disabled = true;
        this.isEnabled = false;
      };
      PrevNextButton.prototype.update = function () {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
          this.enable();
          return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
        this[method]();
      };
      PrevNextButton.prototype.destroy = function () {
        this.deactivate();
      };
      // -------------------------- Flickity prototype -------------------------- //
      utils$$2.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30,
        },
      });
      Flickity.createMethods.push('_createPrevNextButtons');
      var proto = Flickity.prototype;
      proto._createPrevNextButtons = function () {
        if (!this.options.prevNextButtons) {
          return;
        }
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on('activate', this.activatePrevNextButtons);
      };
      proto.activatePrevNextButtons = function () {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on('deactivate', this.deactivatePrevNextButtons);
      };
      proto.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off('deactivate', this.deactivatePrevNextButtons);
      };
      // --------------------------  -------------------------- //
      Flickity.PrevNextButton = PrevNextButton;
      return Flickity;
    });
  });
  var pageDots = createCommonjsModule(function (module) {
    // page dots
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', 'tap-listener/tap-listener', 'fizzy-ui-utils/utils'], function (Flickity, TapListener, utils$$2) {
          return factory(window, Flickity, TapListener, utils$$2);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, flickity, tapListener, utils);
      } else {
        // browser global
        factory(window, window.Flickity, window.TapListener, window.fizzyUIUtils);
      }
    })(window, function factory(window, Flickity, TapListener, utils$$2) {
      // -------------------------- PageDots -------------------------- //
      'use strict';
      function PageDots(parent) {
        this.parent = parent;
        this._create();
      }
      PageDots.prototype = new TapListener();
      PageDots.prototype._create = function () {
        // create holder element
        this.holder = document.createElement('ol');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
        // events
        this.on('tap', this.onTap);
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
      };
      PageDots.prototype.activate = function () {
        this.setDots();
        this.bindTap(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
      };
      PageDots.prototype.deactivate = function () {
        // remove from DOM
        this.parent.element.removeChild(this.holder);
        TapListener.prototype.destroy.call(this);
      };
      PageDots.prototype.setDots = function () {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) {
          this.addDots(delta);
        } else if (delta < 0) {
          this.removeDots(-delta);
        }
      };
      PageDots.prototype.addDots = function (count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for (var i = length; i < max; i++) {
          var dot = document.createElement('li');
          dot.className = 'dot';
          dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
          fragment.appendChild(dot);
          newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
      };
      PageDots.prototype.removeDots = function (count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function (dot) {
          this.holder.removeChild(dot);
        }, this);
      };
      PageDots.prototype.updateSelected = function () {
        // remove selected class on previous
        if (this.selectedDot) {
          this.selectedDot.className = 'dot';
          this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) {
          return;
        }
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = 'dot is-selected';
        this.selectedDot.setAttribute('aria-current', 'step');
      };
      PageDots.prototype.onTap = function (event) {
        var target = event.target;
        // only care about dot clicks
        if (target.nodeName != 'LI') {
          return;
        }
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
      };
      PageDots.prototype.destroy = function () {
        this.deactivate();
      };
      Flickity.PageDots = PageDots;
      // -------------------------- Flickity -------------------------- //
      utils$$2.extend(Flickity.defaults, {
        pageDots: true,
      });
      Flickity.createMethods.push('_createPageDots');
      var proto = Flickity.prototype;
      proto._createPageDots = function () {
        if (!this.options.pageDots) {
          return;
        }
        this.pageDots = new PageDots(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
      };
      proto.activatePageDots = function () {
        this.pageDots.activate();
      };
      proto.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      };
      proto.updatePageDots = function () {
        this.pageDots.setDots();
      };
      proto.deactivatePageDots = function () {
        this.pageDots.deactivate();
      };
      // -----  ----- //
      Flickity.PageDots = PageDots;
      return Flickity;
    });
  });
  var player = createCommonjsModule(function (module) {
    // player & autoPlay
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['ev-emitter/ev-emitter', 'fizzy-ui-utils/utils', './flickity'], function (EvEmitter, utils$$2, Flickity) {
          return factory(EvEmitter, utils$$2, Flickity);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(evEmitter, utils, flickity);
      } else {
        // browser global
        factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
      }
    })(window, function factory(EvEmitter, utils$$2, Flickity) {
      'use strict';
      // -------------------------- Player -------------------------- //
      function Player(parent) {
        this.parent = parent;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
      }
      Player.prototype = Object.create(EvEmitter.prototype);
      // start play
      Player.prototype.play = function () {
        if (this.state == 'playing') {
          return;
        }
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
          document.addEventListener('visibilitychange', this.onVisibilityPlay);
          return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
      };
      Player.prototype.tick = function () {
        // do not tick if not playing
        if (this.state != 'playing') {
          return;
        }
        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == 'number' ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function () {
          _this.parent.next(true);
          _this.tick();
        }, time);
      };
      Player.prototype.stop = function () {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      };
      Player.prototype.clear = function () {
        clearTimeout(this.timeout);
      };
      Player.prototype.pause = function () {
        if (this.state == 'playing') {
          this.state = 'paused';
          this.clear();
        }
      };
      Player.prototype.unpause = function () {
        // re-start play if paused
        if (this.state == 'paused') {
          this.play();
        }
      };
      // pause if page visibility is hidden, unpause if visible
      Player.prototype.visibilityChange = function () {
        var isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
      };
      Player.prototype.visibilityPlay = function () {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
      };
      // -------------------------- Flickity -------------------------- //
      utils$$2.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true,
      });
      Flickity.createMethods.push('_createPlayer');
      var proto = Flickity.prototype;
      proto._createPlayer = function () {
        this.player = new Player(this);
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
      };
      proto.activatePlayer = function () {
        if (!this.options.autoPlay) {
          return;
        }
        this.player.play();
        this.element.addEventListener('mouseenter', this);
      };
      // Player API, don't hate the ... thanks I know where the door is
      proto.playPlayer = function () {
        this.player.play();
      };
      proto.stopPlayer = function () {
        this.player.stop();
      };
      proto.pausePlayer = function () {
        this.player.pause();
      };
      proto.unpausePlayer = function () {
        this.player.unpause();
      };
      proto.deactivatePlayer = function () {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
      };
      // ----- mouseenter/leave ----- //
      // pause auto-play on hover
      proto.onmouseenter = function () {
        if (!this.options.pauseAutoPlayOnHover) {
          return;
        }
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
      };
      // resume auto-play on hover off
      proto.onmouseleave = function () {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
      };
      // -----  ----- //
      Flickity.Player = Player;
      return Flickity;
    });
  });
  var addRemoveCell = createCommonjsModule(function (module) {
    // add, remove cell
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', 'fizzy-ui-utils/utils'], function (Flickity, utils$$2) {
          return factory(window, Flickity, utils$$2);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, flickity, utils);
      } else {
        // browser global
        factory(window, window.Flickity, window.fizzyUIUtils);
      }
    })(window, function factory(window, Flickity, utils$$2) {
      'use strict';
      // append cells to a document fragment
      function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function (cell) {
          fragment.appendChild(cell.element);
        });
        return fragment;
      }
      // -------------------------- add/remove cell prototype -------------------------- //
      var proto = Flickity.prototype;
      /**
       * Insert, prepend, or append cells
       * @param {Element, Array, NodeList} elems
       * @param {Integer} index
       */
      proto.insert = function (elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) {
          return;
        }
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index == len;
        if (isAppend) {
          this.slider.appendChild(fragment);
        } else {
          var insertCellElement = this.cells[index].element;
          this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) {
          // prepend, add to start
          this.cells = cells.concat(this.cells);
        } else if (isAppend) {
          // append, add to end
          this.cells = this.cells.concat(cells);
        } else {
          // insert in this.cells
          var endCells = this.cells.splice(index, len - index);
          this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
      };
      proto.append = function (elems) {
        this.insert(elems, this.cells.length);
      };
      proto.prepend = function (elems) {
        this.insert(elems, 0);
      };
      /**
       * Remove cells
       * @param {Element, Array, NodeList} elems
       */
      proto.remove = function (elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) {
          return;
        }
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function (cell) {
          cell.remove();
          var index = this.cells.indexOf(cell);
          minCellIndex = Math.min(index, minCellIndex);
          utils$$2.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
      };
      /**
       * logic to be run after a cell's size changes
       * @param {Element} elem - cell's element
       */
      proto.cellSizeChange = function (elem) {
        var cell = this.getCell(elem);
        if (!cell) {
          return;
        }
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
      };
      /**
       * logic any time a cell is changed: added, removed, or size changed
       * @param {Integer} changedCellIndex - index of the changed cell, optional
       */
      proto.cellChange = function (changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) {
          this.selectedIndex = this.getCellSlideIndex(cell);
        }
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [changedCellIndex]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) {
          this.positionSliderAtSelected();
        }
      };
      // -----  ----- //
      return Flickity;
    });
  });
  var lazyload = createCommonjsModule(function (module) {
    // lazyload
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', 'fizzy-ui-utils/utils'], function (Flickity, utils$$2) {
          return factory(window, Flickity, utils$$2);
        });
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(window, flickity, utils);
      } else {
        // browser global
        factory(window, window.Flickity, window.fizzyUIUtils);
      }
    })(window, function factory(window, Flickity, utils$$2) {
      'use strict';
      Flickity.createMethods.push('_createLazyload');
      var proto = Flickity.prototype;
      proto._createLazyload = function () {
        this.on('select', this.lazyLoad);
      };
      proto.lazyLoad = function () {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) {
          return;
        }
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach(function (cellElem) {
          var lazyCellImages = getCellLazyImages(cellElem);
          lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function (img) {
          new LazyLoader(img, this);
        }, this);
      };
      function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == 'IMG') {
          var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
          var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
          var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
          if (lazyloadAttr || srcAttr || srcsetAttr) {
            return [cellElem];
          }
        }
        // select lazy images in cell
        var lazySelector = 'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils$$2.makeArray(imgs);
      }
      // -------------------------- LazyLoader -------------------------- //
      /**
       * class to handle loading images
       */
      function LazyLoader(img, flickity$$2) {
        this.img = img;
        this.flickity = flickity$$2;
        this.load();
      }
      LazyLoader.prototype.handleEvent = utils$$2.handleEvent;
      LazyLoader.prototype.load = function () {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
        var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
        // set src & serset
        this.img.src = src;
        if (srcset) {
          this.img.setAttribute('srcset', srcset);
        }
        // remove attr
        this.img.removeAttribute('data-flickity-lazyload');
        this.img.removeAttribute('data-flickity-lazyload-src');
        this.img.removeAttribute('data-flickity-lazyload-srcset');
      };
      LazyLoader.prototype.onload = function (event) {
        this.complete(event, 'flickity-lazyloaded');
      };
      LazyLoader.prototype.onerror = function (event) {
        this.complete(event, 'flickity-lazyerror');
      };
      LazyLoader.prototype.complete = function (event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent('lazyLoad', event, cellElem);
      };
      // -----  ----- //
      Flickity.LazyLoader = LazyLoader;
      return Flickity;
    });
  });
  var js$1 = createCommonjsModule(function (module) {
    /**
     * Flickity v2.1.1
     * Touch, responsive, flickable carousels
     *
     * Licensed GPLv3 for open source use
     * or Flickity Commercial License for commercial use
     *
     * https://flickity.metafizzy.co
     * Copyright 2015-2018 Metafizzy
     */
    (function (window, factory) {
      // universal module definition
      /* jshint strict: false */
      if (typeof undefined == 'function' && undefined.amd) {
        // AMD
        undefined(['./flickity', './drag', './prev-next-button', './page-dots', './player', './add-remove-cell', './lazyload'], factory);
      } else if ('object' == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(flickity, drag, prevNextButton, pageDots, player, addRemoveCell, lazyload);
      }
    })(window, function factory(Flickity) {
      /*jshint strict: false*/
      return Flickity;
    });
  });
  // This is required to fix an iOS10 bug for Flickity.
  // It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW
  jQuery(window).on('dragStart', function (event) {
    var $target = jQuery(event.target);
    var $flickityEnabledEl = $target.closest('.flickity-enabled');
    if ($flickityEnabledEl.length) {
      var flickity = js$1.data($flickityEnabledEl[0]);
      window.removeEventListener('scroll', flickity);
    }
  });
  /**
   * Copyright 2016 Google Inc. All Rights Reserved.
   *
   * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
   *
   *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
   *
   */
  (function (window, document) {
    'use strict';
    // Exits early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      // Minimal polyfill for Edge 15's lack of `isIntersecting`
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
          get: function () {
            return this.intersectionRatio > 0;
          },
        });
      }
      return;
    }
    /**
     * An IntersectionObserver registry. This registry exists to hold a strong
     * reference to IntersectionObserver instances currently observering a target
     * element. Without this registry, instances without another reference may be
     * garbage collected.
     */
    var registry = [];
    /**
     * Creates the global IntersectionObserverEntry constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
     * @param {Object} entry A dictionary of instance properties.
     * @constructor
     */
    function IntersectionObserverEntry(entry) {
      this.time = entry.time;
      this.target = entry.target;
      this.rootBounds = entry.rootBounds;
      this.boundingClientRect = entry.boundingClientRect;
      this.intersectionRect = entry.intersectionRect || getEmptyRect();
      this.isIntersecting = !!entry.intersectionRect;
      // Calculates the intersection ratio.
      var targetRect = this.boundingClientRect;
      var targetArea = targetRect.width * targetRect.height;
      var intersectionRect = this.intersectionRect;
      var intersectionArea = intersectionRect.width * intersectionRect.height;
      // Sets intersection ratio.
      if (targetArea) {
        this.intersectionRatio = intersectionArea / targetArea;
      } else {
        // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
      }
    }
    /**
     * Creates the global IntersectionObserver constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
     * @param {Function} callback The function to be invoked after intersection
     *     changes have queued. The function is not invoked if the queue has
     *     been emptied by calling the `takeRecords` method.
     * @param {Object=} opt_options Optional configuration options.
     * @constructor
     */
    function IntersectionObserver(callback, opt_options) {
      var options = opt_options || {};
      if (typeof callback != 'function') {
        throw new Error('callback must be a function');
      }
      if (options.root && options.root.nodeType != 1) {
        throw new Error('root must be an Element');
      }
      // Binds and throttles `this._checkForIntersections`.
      this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
      // Private properties.
      this._callback = callback;
      this._observationTargets = [];
      this._queuedEntries = [];
      this._rootMarginValues = this._parseRootMargin(options.rootMargin);
      // Public properties.
      this.thresholds = this._initThresholds(options.threshold);
      this.root = options.root || null;
      this.rootMargin = this._rootMarginValues
        .map(function (margin) {
          return margin.value + margin.unit;
        })
        .join(' ');
    }
    /**
     * The minimum interval within which the document will be checked for
     * intersection changes.
     */
    IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
     * The frequency in which the polyfill polls for intersection changes.
     * this can be updated on a per instance basis and must be set prior to
     * calling `observe` on the first target.
     */
    IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
     * Use a mutation observer on the root element
     * to detect intersection changes.
     */
    IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
     * Starts observing a target element for intersection changes based on
     * the thresholds values.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.observe = function (target) {
      var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
        return item.element == target;
      });
      if (isTargetAlreadyObserved) {
        return;
      }
      if (!(target && target.nodeType == 1)) {
        throw new Error('target must be an Element');
      }
      this._registerInstance();
      this._observationTargets.push({ element: target, entry: null });
      this._monitorIntersections();
      this._checkForIntersections();
    };
    /**
     * Stops observing a target element for intersection changes.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.unobserve = function (target) {
      this._observationTargets = this._observationTargets.filter(function (item) {
        return item.element != target;
      });
      if (!this._observationTargets.length) {
        this._unmonitorIntersections();
        this._unregisterInstance();
      }
    };
    /**
     * Stops observing all target elements for intersection changes.
     */
    IntersectionObserver.prototype.disconnect = function () {
      this._observationTargets = [];
      this._unmonitorIntersections();
      this._unregisterInstance();
    };
    /**
     * Returns any queue entries that have not yet been reported to the
     * callback and clears the queue. This can be used in conjunction with the
     * callback to obtain the absolute most up-to-date intersection information.
     * @return {Array} The currently queued entries.
     */
    IntersectionObserver.prototype.takeRecords = function () {
      var records = this._queuedEntries.slice();
      this._queuedEntries = [];
      return records;
    };
    /**
     * Accepts the threshold value from the user configuration object and
     * returns a sorted array of unique threshold values. If a value is not
     * between 0 and 1 and error is thrown.
     * @private
     * @param {Array|number=} opt_threshold An optional threshold value or
     *     a list of threshold values, defaulting to [0].
     * @return {Array} A sorted list of unique and valid threshold values.
     */
    IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
      var threshold = opt_threshold || [0];
      if (!Array.isArray(threshold)) threshold = [threshold];
      return threshold.sort().filter(function (t, i, a) {
        if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
          throw new Error('threshold must be a number between 0 and 1 inclusively');
        }
        return t !== a[i - 1];
      });
    };
    /**
     * Accepts the rootMargin value from the user configuration object
     * and returns an array of the four margin values as an object containing
     * the value and unit properties. If any of the values are not properly
     * formatted or use a unit other than px or %, and error is thrown.
     * @private
     * @param {string=} opt_rootMargin An optional rootMargin value,
     *     defaulting to '0px'.
     * @return {Array<Object>} An array of margin objects with the keys
     *     value and unit.
     */
    IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
      var marginString = opt_rootMargin || '0px';
      var margins = marginString.split(/\s+/).map(function (margin) {
        var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
        if (!parts) {
          throw new Error('rootMargin must be specified in pixels or percent');
        }
        return { value: parseFloat(parts[1]), unit: parts[2] };
      });
      // Handles shorthand.
      margins[1] = margins[1] || margins[0];
      margins[2] = margins[2] || margins[0];
      margins[3] = margins[3] || margins[1];
      return margins;
    };
    /**
     * Starts polling for intersection changes if the polling is not already
     * happening, and if the page's visibilty state is visible.
     * @private
     */
    IntersectionObserver.prototype._monitorIntersections = function () {
      if (!this._monitoringIntersections) {
        this._monitoringIntersections = true;
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) {
          this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
        } else {
          addEvent(window, 'resize', this._checkForIntersections, true);
          addEvent(document, 'scroll', this._checkForIntersections, true);
          if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
            this._domObserver = new MutationObserver(this._checkForIntersections);
            this._domObserver.observe(document, {
              attributes: true,
              childList: true,
              characterData: true,
              subtree: true,
            });
          }
        }
      }
    };
    /**
     * Stops polling for intersection changes.
     * @private
     */
    IntersectionObserver.prototype._unmonitorIntersections = function () {
      if (this._monitoringIntersections) {
        this._monitoringIntersections = false;
        clearInterval(this._monitoringInterval);
        this._monitoringInterval = null;
        removeEvent(window, 'resize', this._checkForIntersections, true);
        removeEvent(document, 'scroll', this._checkForIntersections, true);
        if (this._domObserver) {
          this._domObserver.disconnect();
          this._domObserver = null;
        }
      }
    };
    /**
     * Scans each observation target for intersection changes and adds them
     * to the internal entries queue. If new entries are found, it
     * schedules the callback to be invoked.
     * @private
     */
    IntersectionObserver.prototype._checkForIntersections = function () {
      var rootIsInDom = this._rootIsInDom();
      var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
      this._observationTargets.forEach(function (item) {
        var target = item.element;
        var targetRect = getBoundingClientRect(target);
        var rootContainsTarget = this._rootContainsTarget(target);
        var oldEntry = item.entry;
        var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);
        var newEntry = (item.entry = new IntersectionObserverEntry({
          time: now(),
          target: target,
          boundingClientRect: targetRect,
          rootBounds: rootRect,
          intersectionRect: intersectionRect,
        }));
        if (!oldEntry) {
          this._queuedEntries.push(newEntry);
        } else if (rootIsInDom && rootContainsTarget) {
          // If the new entry intersection ratio has crossed any of the
          // thresholds, add a new entry.
          if (this._hasCrossedThreshold(oldEntry, newEntry)) {
            this._queuedEntries.push(newEntry);
          }
        } else {
          // If the root is not in the DOM or target is not contained within
          // root but the previous entry for this target had an intersection,
          // add a new record indicating removal.
          if (oldEntry && oldEntry.isIntersecting) {
            this._queuedEntries.push(newEntry);
          }
        }
      }, this);
      if (this._queuedEntries.length) {
        this._callback(this.takeRecords(), this);
      }
    };
    /**
     * Accepts a target and root rect computes the intersection between then
     * following the algorithm in the spec.
     * TODO(philipwalton): at this time clip-path is not considered.
     * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
     * @param {Element} target The target DOM element
     * @param {Object} rootRect The bounding rect of the root after being
     *     expanded by the rootMargin value.
     * @return {?Object} The final intersection rect object or undefined if no
     *     intersection is found.
     * @private
     */
    IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {
      // If the element isn't displayed, an intersection can't happen.
      if (window.getComputedStyle(target).display == 'none') return;
      var targetRect = getBoundingClientRect(target);
      var intersectionRect = targetRect;
      var parent = getParentNode(target);
      var atRoot = false;
      while (!atRoot) {
        var parentRect = null;
        var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
        // If the parent isn't displayed, an intersection can't happen.
        if (parentComputedStyle.display == 'none') return;
        if (parent == this.root || parent == document) {
          atRoot = true;
          parentRect = rootRect;
        } else {
          // If the element has a non-visible overflow, and it's not the <body>
          // or <html> element, update the intersection rect.
          // Note: <body> and <html> cannot be clipped to a rect that's not also
          // the document rect, so no need to compute a new intersection.
          if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
            parentRect = getBoundingClientRect(parent);
          }
        }
        // If either of the above conditionals set a new parentRect,
        // calculate new intersection data.
        if (parentRect) {
          intersectionRect = computeRectIntersection(parentRect, intersectionRect);
          if (!intersectionRect) break;
        }
        parent = getParentNode(parent);
      }
      return intersectionRect;
    };
    /**
     * Returns the root rect after being expanded by the rootMargin value.
     * @return {Object} The expanded root rect.
     * @private
     */
    IntersectionObserver.prototype._getRootRect = function () {
      var rootRect;
      if (this.root) {
        rootRect = getBoundingClientRect(this.root);
      } else {
        // Use <html>/<body> instead of window since scroll bars affect size.
        var html = document.documentElement;
        var body = document.body;
        rootRect = {
          top: 0,
          left: 0,
          right: html.clientWidth || body.clientWidth,
          width: html.clientWidth || body.clientWidth,
          bottom: html.clientHeight || body.clientHeight,
          height: html.clientHeight || body.clientHeight,
        };
      }
      return this._expandRectByRootMargin(rootRect);
    };
    /**
     * Accepts a rect and expands it by the rootMargin value.
     * @param {Object} rect The rect object to expand.
     * @return {Object} The expanded rect.
     * @private
     */
    IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
      var margins = this._rootMarginValues.map(function (margin, i) {
        return margin.unit == 'px' ? margin.value : (margin.value * (i % 2 ? rect.width : rect.height)) / 100;
      });
      var newRect = {
        top: rect.top - margins[0],
        right: rect.right + margins[1],
        bottom: rect.bottom + margins[2],
        left: rect.left - margins[3],
      };
      newRect.width = newRect.right - newRect.left;
      newRect.height = newRect.bottom - newRect.top;
      return newRect;
    };
    /**
     * Accepts an old and new entry and returns true if at least one of the
     * threshold values has been crossed.
     * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
     *    particular target element or null if no previous entry exists.
     * @param {IntersectionObserverEntry} newEntry The current entry for a
     *    particular target element.
     * @return {boolean} Returns true if a any threshold has been crossed.
     * @private
     */
    IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
      // To make comparing easier, an entry that has a ratio of 0
      // but does not actually intersect is given a value of -1
      var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
      var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
      // Ignore unchanged ratios
      if (oldRatio === newRatio) return;
      for (var i = 0; i < this.thresholds.length; i++) {
        var threshold = this.thresholds[i];
        // Return true if an entry matches a threshold or if the new ratio
        // and the old ratio are on the opposite sides of a threshold.
        if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
          return true;
        }
      }
    };
    /**
     * Returns whether or not the root element is an element and is in the DOM.
     * @return {boolean} True if the root element is an element and is in the DOM.
     * @private
     */
    IntersectionObserver.prototype._rootIsInDom = function () {
      return !this.root || containsDeep(document, this.root);
    };
    /**
     * Returns whether or not the target element is a child of root.
     * @param {Element} target The target element to check.
     * @return {boolean} True if the target element is a child of root.
     * @private
     */
    IntersectionObserver.prototype._rootContainsTarget = function (target) {
      return containsDeep(this.root || document, target);
    };
    /**
     * Adds the instance to the global IntersectionObserver registry if it isn't
     * already present.
     * @private
     */
    IntersectionObserver.prototype._registerInstance = function () {
      if (registry.indexOf(this) < 0) {
        registry.push(this);
      }
    };
    /**
     * Removes the instance from the global IntersectionObserver registry.
     * @private
     */
    IntersectionObserver.prototype._unregisterInstance = function () {
      var index = registry.indexOf(this);
      if (index != -1) registry.splice(index, 1);
    };
    /**
     * Returns the result of the performance.now() method or null in browsers
     * that don't support the API.
     * @return {number} The elapsed time since the page was requested.
     */
    function now() {
      return window.performance && performance.now && performance.now();
    }
    /**
     * Throttles a function and delays its executiong, so it's only called at most
     * once within a given time period.
     * @param {Function} fn The function to throttle.
     * @param {number} timeout The amount of time that must pass before the
     *     function can be called again.
     * @return {Function} The throttled function.
     */
    function throttle(fn, timeout) {
      var timer = null;
      return function () {
        if (!timer) {
          timer = setTimeout(function () {
            fn();
            timer = null;
          }, timeout);
        }
      };
    }
    /**
     * Adds an event handler to a DOM node ensuring cross-browser compatibility.
     * @param {Node} node The DOM node to add the event handler to.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to add.
     * @param {boolean} opt_useCapture Optionally adds the even to the capture
     *     phase. Note: this only works in modern browsers.
     */
    function addEvent(node, event, fn, opt_useCapture) {
      if (typeof node.addEventListener == 'function') {
        node.addEventListener(event, fn, opt_useCapture || false);
      } else if (typeof node.attachEvent == 'function') {
        node.attachEvent('on' + event, fn);
      }
    }
    /**
     * Removes a previously added event handler from a DOM node.
     * @param {Node} node The DOM node to remove the event handler from.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} opt_useCapture If the event handler was added with this
     *     flag set to true, it should be set to true here in order to remove it.
     */
    function removeEvent(node, event, fn, opt_useCapture) {
      if (typeof node.removeEventListener == 'function') {
        node.removeEventListener(event, fn, opt_useCapture || false);
      } else if (typeof node.detatchEvent == 'function') {
        node.detatchEvent('on' + event, fn);
      }
    }
    /**
     * Returns the intersection between two rect objects.
     * @param {Object} rect1 The first rect.
     * @param {Object} rect2 The second rect.
     * @return {?Object} The intersection rect or undefined if no intersection
     *     is found.
     */
    function computeRectIntersection(rect1, rect2) {
      var top = Math.max(rect1.top, rect2.top);
      var bottom = Math.min(rect1.bottom, rect2.bottom);
      var left = Math.max(rect1.left, rect2.left);
      var right = Math.min(rect1.right, rect2.right);
      var width = right - left;
      var height = bottom - top;
      return (
        width >= 0 &&
        height >= 0 && {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height,
        }
      );
    }
    /**
     * Shims the native getBoundingClientRect for compatibility with older IE.
     * @param {Element} el The element whose bounding rect to get.
     * @return {Object} The (possibly shimmed) rect of the element.
     */
    function getBoundingClientRect(el) {
      var rect;
      try {
        rect = el.getBoundingClientRect();
      } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
      }
      if (!rect) return getEmptyRect();
      // Older IE
      if (!(rect.width && rect.height)) {
        rect = {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top,
        };
      }
      return rect;
    }
    /**
     * Returns an empty rect object. An empty rect is returned when an element
     * is not in the DOM.
     * @return {Object} The empty rect.
     */
    function getEmptyRect() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0,
      };
    }
    /**
     * Checks to see if a parent element contains a child elemnt (including inside
     * shadow DOM).
     * @param {Node} parent The parent element.
     * @param {Node} child The child element.
     * @return {boolean} True if the parent node contains the child node.
     */
    function containsDeep(parent, child) {
      var node = child;
      while (node) {
        if (node == parent) return true;
        node = getParentNode(node);
      }
      return false;
    }
    /**
     * Gets the parent node of an element or its host element if the parent node
     * is a shadow root.
     * @param {Node} node The node whose parent to get.
     * @return {Node|null} The parent node or null if no parent exists.
     */
    function getParentNode(node) {
      var parent = node.parentNode;
      if (parent && parent.nodeType == 11 && parent.host) {
        // If the parent is a shadow root, return the host element.
        return parent.host;
      }
      return parent;
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
  })(window, document);
  /**
   * image v2.1.4
   * (c) 2018 Pixel Union
   */
  /**
   * The default template render function. Turns a template string into an image
   * URL.
   *
   * @param {String} template
   * @param {Size} size
   * @returns {String}
   */
  function defaultTemplateRender(template, size) {
    return template.replace('{size}', size.width + 'x' + size.height);
  }
  /**
   * @type Settings
   */
  var defaults = {
    scale: 1,
    template: false,
    templateRender: defaultTemplateRender,
    max: { width: Infinity, height: Infinity },
    round: 32,
    placeholder: false,
    crop: null,
  };
  /**
   * Get a data attribute value from an element, with a default fallback and
   * sanitization step.
   *
   * @param {Element} el
   *
   * @param {String} name
   *        The data attribute name.
   *
   * @param {Object} options
   *        An object holding fallback values if the data attribute does not
   *        exist. If this object doesn't have the property, we further fallback
   *        to our defaults.
   *
   * @param {Function} [sanitize]
   *        A function to sanitize the data attribute value with.
   *
   * @returns {String|*}
   */
  function getData(el, name, options, sanitize) {
    var attr = 'data-image-' + name;
    if (!el.hasAttribute(attr)) return options[name] || defaults[name];
    var value = el.getAttribute(attr);
    return sanitize ? sanitize(value) : value;
  }
  /**
   * Sanitize data attributes that represent a size (in the form of `10x10`).
   *
   * @param {String} value
   * @returns {Object} An object with `width` and `height` properties.
   */
  function parseSize(value) {
    value = value.split('x');
    return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
  }
  /**
   * Loads information about an element.
   *
   * Options can be set on the element itself using data attributes, or through
   * the `options` parameter. Data attributes take priority.
   *
   * @param {HTMLElement} el
   * @param {Settings} options
   * @returns {Item}
   */
  function parseItem(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isImage = el.hasAttribute('data-image-template');
    /**
     * @typedef {Settings} Item
     */
    return {
      el: el,
      // Type of element
      isImage: isImage,
      isBackgroundImage: isImage && el.tagName !== 'IMG',
      // Image scale
      scale: getData(el, 'scale', options),
      // Device density
      density: window.devicePixelRatio || 1,
      // Image template URL
      template: getData(el, 'template', options),
      templateRender: options.templateRender || defaults.templateRender,
      // Maximum image dimensions
      max: getData(el, 'max', options, parseSize),
      // Round image dimensions to the nearest multiple
      round: getData(el, 'round', options),
      // Placeholder image dimensions
      placeholder: getData(el, 'placeholder', options, parseSize),
      // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
      crop: getData(el, 'crop', options, function (value) {
        return value === '' ? null : value;
      }),
    };
  }
  /**
   * Round to the nearest multiple.
   *
   * This is so we don't tax the image server too much.
   *
   * @param {Number} size The size, in pixels.
   * @param {Number} [multiple] The multiple to round to the nearest.
   * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
   * @returns {Number}
   */
  function roundSize(size) {
    var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
    var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
    return size === 0 ? multiple : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
  }
  /**
   * Get the size of an element.
   *
   * If it is too small, it's parent element is checked, and so on. This helps
   * avoid the situation where an element doesn't have a size yet or is positioned
   * out of the layout.
   *
   * @param {HTMLElement} el
   * @return {Object} size
   * @return {Number} size.width The width, in pixels.
   * @return {Number} size.height The height, in pixels.
   */
  function getElementSize(el) {
    var size = { width: 0, height: 0 };
    while (el) {
      size.width = el.offsetWidth;
      size.height = el.offsetHeight;
      if (size.width > 20 && size.height > 20) break;
      el = el.parentNode;
    }
    return size;
  }
  /**
   * Trigger a custom event.
   *
   * Note: this approach is deprecated, but still required to support older
   * browsers such as IE 10.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
   *
   * @param {HTMLElement} el
   *        The element to trigger the event on.
   *
   * @param {String} name
   *        The event name.
   *
   * @returns {Boolean}
   *          True if the event was canceled.
   */
  function trigger(el, name) {
    var event = document.createEvent('Event');
    event.initEvent(name, true, true);
    return !el.dispatchEvent(event);
  }
  /**
   * Return the maximum supported density of the image, given the container.
   *
   * @param {Item} item
   * @param {Size} size
   */
  function supportedDensity(item, size) {
    return Math.min(
      Math.min(Math.max(item.max.width / size.width, 1), item.density),
      Math.min(Math.max(item.max.height / size.height, 1), item.density)
    ).toFixed(2);
  }
  /**
   * Set the image URL on the element. Supports background images and `srcset`.
   *
   * @param {Item} item
   * @param {Size} size
   * @param {Boolean} isPlaceholder
   */
  function setImage(item, size, isPlaceholder, onLoad) {
    var render = item.templateRender;
    var density = isPlaceholder ? 1 : supportedDensity(item, size);
    var round = isPlaceholder ? 1 : item.round;
    // Calculate the final display size, taking into account the image's
    // maximum dimensions.
    var targetWidth = size.width * density;
    var targetHeight = size.height * density;
    var displaySize = void 0;
    if (item.crop) {
      displaySize = {
        width: roundSize(targetWidth, round, item.max.width),
        height: roundSize(targetHeight, round, item.max.height),
      };
    } else {
      // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
      // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
      // This isn't a problem with cropped images which are served at the exact dimension requested.
      var containerAspectRatio = size.width / size.height;
      var imageAspectRatio = item.max.width / item.max.height;
      if (containerAspectRatio > imageAspectRatio) {
        // fit width
        displaySize = {
          width: roundSize(targetWidth, round, item.max.width),
          height: roundSize(targetWidth / imageAspectRatio, round, item.max.height),
        };
      } else {
        // fit height
        displaySize = {
          width: roundSize(targetHeight * imageAspectRatio, round, item.max.width),
          height: roundSize(targetHeight, round, item.max.height),
        };
      }
    }
    var url = render(item.template, displaySize);
    // On load callback
    var image = new Image();
    image.onload = onLoad;
    image.src = url;
    // Set image
    if (item.isBackgroundImage) {
      item.el.style.backgroundImage = "url('" + url + "')";
    } else {
      item.el.setAttribute('srcset', url + ' ' + density + 'x');
    }
  }
  /**
   * Load the image, set loaded status, and trigger the load event.
   *
   * @fires image:load
   * @fires image:error
   * @param {Item} item
   * @param {Size} size
   */
  function loadFullImage(item, size) {
    var el = item.el;
    setImage(item, size, false, function (event) {
      if (event.type === 'load') {
        el.setAttribute('data-image', 'loaded');
      } else {
        el.setAttribute('data-image', 'error');
        trigger(el, 'image:error');
      }
      trigger(el, 'image:load');
    });
  }
  /**
   * Load in a responsive image.
   *
   * Sets the image's `srcset` attribute to the final image URLs, calculated based
   * on the actual size the image is being shown at.
   *
   * @fires image:loading
   *        The image URLs have been set and we are waiting for them to load.
   *
   * @fires image:loaded
   *        The final image has loaded.
   *
   * @fires image:error
   *        The final image failed loading.
   *
   * @param {Item} item
   */
  function loadImage(item) {
    var el = item.el;
    // Already loaded?
    var status = el.getAttribute('data-image');
    if (status === 'loading' || status === 'loaded') return;
    // Is the SVG loaded?
    if (!el.complete && !item.isBackgroundImage) {
      // Wait for the load event, then call load image
      el.addEventListener('load', function cb() {
        el.removeEventListener('load', cb);
        loadImage(item);
      });
      return;
    }
    // Trigger loading event, and stop if cancelled
    if (trigger(el, 'image:loading')) return;
    // Mark as loading
    el.setAttribute('data-image', 'loading');
    // Get element size. This is used as the ideal display size.
    var size = getElementSize(item.el);
    size.width *= item.scale;
    size.height *= item.scale;
    if (item.placeholder) {
      // Load a placeholder image first, followed by the full image. Force the
      // element to keep its dimensions while it loads. If the image is smaller
      // than the element size, use the image's size. Density is taken into account
      // for HiDPI devices to avoid blurry images.
      if (!item.isBackgroundImage) {
        el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
        el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
      }
      setImage(item, item.placeholder, true, function () {
        return loadFullImage(item, size);
      });
    } else {
      loadFullImage(item, size);
    }
  }
  /**
   * Prepare an element to be displayed on the screen.
   *
   * Images have special logic applied to them to swap out the different sources.
   *
   * @fires image:enter
   *        The element is entering the viewport.
   *
   * @param {HTMLElement} el
   * @param {Settings} options
   */
  function load(el, options) {
    if (!el) return;
    trigger(el, 'image:enter');
    var item = parseItem(el, options);
    if (item.isImage) {
      if (!item.isBackgroundImage) {
        el.setAttribute('data-image-template-svg', el.getAttribute('srcset'));
      }
      loadImage(item);
    }
  }
  /**
   * Reset an element's state so that its image can be recalculated.
   *
   * @fires image:update
   *        The element is being updated.
   *
   * @param {HTMLElement} el
   * @param {Settings} options
   */
  function update(el, options) {
    if (!el) return;
    trigger(el, 'image:update');
    var item = parseItem(el, options);
    if (item.isImage) {
      if (!item.isBackgroundImage) {
        el.setAttribute('data-image', 'lazy');
        el.setAttribute('srcset', el.getAttribute('data-image-template-svg'));
      }
      loadImage(item);
    }
  }
  /**
   * Returns true if the element is within the viewport.
   * @param {HTMLElement} el
   * @returns {Boolean}
   */
  function inViewport(el) {
    var root = document.documentElement;
    var width = Math.min(root.clientWidth, window.innerWidth);
    var height = Math.min(root.clientHeight, window.innerHeight);
    var rect = el.getBoundingClientRect();
    return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
  }
  /**
   * @typedef {Object} Size
   * @property {Number} width
   * @property {Number} height
   */
  /**
   * A function to turn a template string into a URL.
   *
   * @callback TemplateRenderer
   * @param {String} template
   * @param {Size} size
   * @returns {String}
   */
  /**
   * @typedef {Object} Settings
   *
   * @property {String} [template]
   *           A template string used to generate URLs for an image. This allows us to
   *           dynamically load images with sizes to match the container's size.
   *
   * @property {TemplateRenderer} [templateRender]
   *           A function to turn a template string into a URL.
   *
   * @property {Size} [max]
   *           The maximum available size for the image. This ensures we don't
   *           try to load an image larger than is possible.
   *
   * @property {Number} [scale]
   *           A number to scale the final image dimensions by.
   *           Only applies to lazy-loaded images. Defaults to 1.
   *
   * @property {Number} [round]
   *           Round image dimensions to the nearest multiple. This is intended to
   *           tax the image server less by lowering the number of possible image
   *           sizes requested.
   *
   * @property {Size} [placeholder]
   *           The size of the lo-fi image to load before the full image.
   *
   * @property {String} [crop]
   *           Crop value; null if image is uncropped, otherwise equal
   *           to the Shopify crop parameter ('center', 'top', etc.).
   */
  /**
   * Initialize the responsive image handler.
   *
   * @param {String|HTMLElement|NodeList} selector
   *        The CSS selector, element, or elements to track for lazy-loading.
   *
   * @param {Settings} options
   *
   * @returns {PublicApi}
   */
  function image$1() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-image="lazy"]';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Intersections
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            io.unobserve(entry.target);
            load(entry.target, options);
          }
        });
      },
      {
        // Watch the viewport, with 20% vertical margins
        rootMargin: '20% 0px',
      }
    );
    /**
     * @typedef {Object} PublicApi
     */
    var api = {
      /**
       * Track a new selector, element, or nodelist for lazy-loading.
       * @type Function
       * @param {String|HTMLElement|NodeList} selector
       */
      track: function track() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-image="lazy"]';
        var els = querySelector(selector);
        for (var i = 0; i < els.length; i++) {
          // If an element is already in the viewport, load it right away. This
          // fixes a race-condition with dynamically added elements.
          if (inViewport(els[i])) {
            load(els[i], options);
          } else {
            io.observe(els[i]);
          }
        }
      },
      /**
       * Update element(s) that have already been loaded to force their images
       * to be recalculated.
       * @type Function
       * @param {String|HTMLElement|NodeList} selector
       */
      update: function update$$1() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-image="loaded"]';
        var els = querySelector(selector);
        for (var i = 0; i < els.length; i++) {
          update(els[i], options);
        }
      },
      /**
       * Stop tracking element(s) for lazy-loading.
       * @type Function
       * @param {String|HTMLElement|NodeList} selector
       */
      untrack: function untrack() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-image]';
        var els = querySelector(selector);
        for (var i = 0; i < els.length; i++) {
          io.unobserve(els[i]);
        }
      },
      /**
       * Unload all event handlers and observers.
       * @type Function
       */
      unload: function unload() {
        io.disconnect();
      },
    };
    // Add initial elements
    api.track(selector);
    return api;
  }
  /**
   * Finds a group of elements on the page.
   *
   * @param {String|HTMLElement|NodeList} selector
   * @returns {Object} An array-like object.
   */
  function querySelector(selector) {
    if (typeof selector === 'string') {
      return document.querySelectorAll(selector);
    }
    if (selector instanceof HTMLElement) {
      return [selector];
    }
    if (selector instanceof NodeList) {
      return selector;
    }
    return [];
  }
  /**
   * image-shopify v2.2.3
   * (c) 2018 Pixel Union
   */
  /**
   * Polyfill for Element.matches().
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
   */
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) { }
        return i > -1;
      };
  }
  var state = {
    init: init,
    watch: watch,
    unwatch: unwatch,
  };
  function init() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-image="lazy"]';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    state.selector = selector;
    state.instance = image$1(selector, options);
    state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    // Listen for Shopify theme editor events
    document.addEventListener('shopify:section:load', function (event) {
      return watch(event.target);
    });
    window.addEventListener('resize', function () {
      return _update();
    });
    document.addEventListener('shopify:section:unload', function (event) {
      return unwatch(event.target);
    });
    // Listen for custom events to allow themes to hook into image
    document.addEventListener('theme:image:watch', function (event) {
      return watch(event.target);
    });
    document.addEventListener('theme:image:unwatch', function (event) {
      return unwatch(event.target);
    });
    // Support custom events triggered through jQuery
    // See: https://github.com/jquery/jquery/issues/3347
    if (window.jQuery) {
      jQuery(document).on({
        'theme:image:watch': function themeRimgWatch(event) {
          return watch(event.target);
        },
        'theme:image:unwatch': function themeRimgUnwatch(event) {
          return unwatch(event.target);
        },
      });
    }
  }
  /**
   * Track an element, and its children.
   *
   * @param {HTMLElement} el
   */
  function watch(el) {
    // Track element
    if (typeof el.matches === 'function' && el.matches(state.selector)) {
      state.instance.track(el);
    }
    // Track element's children
    state.instance.track(el.querySelectorAll(state.selector));
  }
  /**
   * Untrack an element, and its children
   *
   * @param {HTMLElement} el
   * @private
   */
  function unwatch(el) {
    // Untrack element's children
    state.instance.untrack(el.querySelectorAll(state.selector));
    // Untrack element
    if (typeof el.matches === 'function' && el.matches(state.selector)) {
      state.instance.untrack(el);
    }
  }
  /**
   * Update an element, and its children.
   *
   * @param {HTMLElement} el
   */
  function _update() {
    var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    // Return if we're not 2x smaller, or larger than the existing loading size
    if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
      return;
    }
    state.loadedWidth = currentWidth;
    state.instance.update();
  }
  var asyncGenerator = (function () {
    function AwaitValue(value) {
      this.value = value;
    }
    function AsyncGenerator(gen) {
      var front, back;
      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null,
          };
          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }
      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;
          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(
              function (arg) {
                resume('next', arg);
              },
              function (arg) {
                resume('throw', arg);
              }
            );
          } else {
            settle(result.done ? 'return' : 'normal', result.value);
          }
        } catch (err) {
          settle('throw', err);
        }
      }
      function settle(type, value) {
        switch (type) {
          case 'return':
            front.resolve({
              value: value,
              done: true,
            });
            break;
          case 'throw':
            front.reject(value);
            break;
          default:
            front.resolve({
              value: value,
              done: false,
            });
            break;
        }
        front = front.next;
        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }
      this._invoke = send;
      if (typeof gen.return !== 'function') {
        this.return = undefined;
      }
    }
    if (typeof Symbol === 'function' && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }
    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke('next', arg);
    };
    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke('throw', arg);
    };
    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke('return', arg);
    };
    return {
      wrap: function (fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function (value) {
        return new AwaitValue(value);
      },
    };
  })();
  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  };
  var createClass = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var inherits = function (subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true,
      },
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
  };
  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
  };
  var toConsumableArray = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
      return arr2;
    } else {
      return Array.from(arr);
    }
  };
  var Quantity = (function () {
    function Quantity(el) {
      classCallCheck(this, Quantity);
      this.$el = $(el);
      this.$inputParent = this.$el.find('.form-field--qty-input');
      this.$input = this.$el.find('[data-quantity-input]');
      this.$selectParent = this.$el.find('.form-field--qty-select');
      this.$select = this.$el.find('[data-quantity-select]');
      this._watchSelect = this._watchSelect.bind(this);
      this._watchInput = this._watchInput.bind(this);
      this.$select.on('change.quantity', this._watchSelect);
      this.$input.on('change.quantity', this._watchInput);
    }
    createClass(Quantity, [
      {
        key: 'unload',
        value: function unload() {
          this.$el.off('.quantity');
        },
      },
      {
        key: '_validateValue',
        value: function _validateValue(event) {
          var baseValue = parseInt(event.currentTarget.value, 10);
          return isNaN(baseValue) ? 1 : baseValue;
        },
      },
      {
        key: '_watchSelect',
        value: function _watchSelect(event) {
          var value = this._validateValue(event);
          // Update input to match select
          this.$input.val(value).trigger('change');
          // Switch to quantity input when 10 or more
          if (value >= 10) {
            this.$inputParent.removeClass('hidden').addClass('visible');
            this.$input.focus().removeAttr('tabindex').select();
            this.$selectParent.removeClass('visible').addClass('hidden');
            this.$select.attr('tabindex', '-1');
          }
        },
      },
      {
        key: '_watchInput',
        value: function _watchInput(event) {
          this.$input.val(this._validateValue(event));
        },
      },
    ]);
    return Quantity;
  })();
  var Forms = (function () {
    function Forms($el) {
      var _this = this;
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.x-form-input';
      classCallCheck(this, Forms);
      this.$el = $el;
      this.filledClass = 'form-field-filled';
      this.fieldSelector = selector;
      this.quantityItems = [];
      this.$quantityWrapper = this.$el.find('[data-quantity-wrapper]');
      this._toggleFilled = this._toggleFilled.bind(this);
      this.$el.on('focus.forms', this.fieldSelector, this._toggleFilled);
      this.$el.on('blur.forms', this.fieldSelector, this._toggleFilled);
      this._checkFilled();
      if (this.$quantityWrapper.length) {
        this.$quantityWrapper.each(function (i, el) {
          _this.quantityItems.push(new Quantity(el));
        });
      }
    }
    createClass(Forms, [
      {
        key: 'unload',
        value: function unload() {
          this.$el.off('.forms');
          this.quantityItems.forEach(function (quantityItem) {
            quantityItem.unload();
          });
        },
      },
      {
        key: '_checkFilled',
        value: function _checkFilled() {
          var _this2 = this;
          this.$el.find(this.fieldSelector).each(function (i, el) {
            if (jQuery(el).hasClass(_this2.filledClass)) return;
            _this2._toggleFilled(null, el);
          });
        },
      },
      {
        key: '_toggleFilled',
        value: function _toggleFilled() {
          var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var $el = event ? jQuery(event.currentTarget) : jQuery(el);
          var value = $el.val();
          var isFilled = value && value.length > 0 ? true : false;
          $el.toggleClass(this.filledClass, isFilled);
        },
      },
    ]);
    return Forms;
  })();
  var Account = (function () {
    function Account() {
      classCallCheck(this, Account);
      this.$accountContents = jQuery('[data-template-account]');
      this.$loginContent = jQuery('[data-template-account-login]');
      this.$addressesContent = jQuery('[data-template-account-addresses]');
      this.$addressButtonFocus = null;
      this._loginToggle = this._loginToggle.bind(this);
      if (this.$loginContent.length) {
        this._initLoginPage();
      }
      if (this.$addressesContent.length) {
        this._initAddressPage();
      }
      if (this.$accountContents.length) {
        this._init();
      }
    }
    createClass(Account, [
      {
        key: '_init',
        value: function _init() {
          new Forms(this.$accountContents);
        },
      },
      {
        key: '_initLoginPage',
        value: function _initLoginPage() {
          this.$loginToggle = this.$loginContent.find('[data-login-toggle]');
          this.$login = this.$loginContent.find('[data-account-login-main]');
          this.$recovery = this.$loginContent.find('[data-account-login-recovery]');
          this.$recoveryHasMessage = this.$recovery.find('[data-recovery-has-message]');
          this.$loginToggle.on('click', this._loginToggle);
          if (this.$recoveryHasMessage.length) {
            this._loginToggle();
          }
        },
      },
      {
        key: '_loginToggle',
        value: function _loginToggle() {
          var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          if (event) {
            event.preventDefault();
          }
          this.$login.toggleClass('visible');
          this.$recovery.toggleClass('visible');
        },
      },
      {
        key: '_initAddressPage',
        value: function _initAddressPage() {
          var _this = this;
          var $customerAddresses = this.$addressesContent.find('[data-address-id]');
          this.$addressesContent.on('click', '[data-edit-address]', function (event) {
            var $target = jQuery(event.currentTarget);
            var itemId = $target.attr('data-edit-address');
            $customerAddresses.removeClass('visible');
            _this.$addressButtonFocus = $target;
            jQuery('[data-address-id="' + itemId + '"]')
              .addClass('visible')
              .find('.x-form-input')
              .eq(0)
              .focus();
          });
          this.$addressesContent.on('click', '[data-edit-address-cancel]', function () {
            $customerAddresses.removeClass('visible');
            jQuery('[data-address-id="new"]').addClass('visible');
            // Return focus to last used button
            _this.$addressButtonFocus.focus();
            _this.$addressButtonFocus = null;
          });
          this.$addressesContent.on('click', '[data-delete-address]', function (event) {
            var itemId = jQuery(event.target).attr('data-delete-address');
            Shopify.CustomerAddress.destroy(itemId, '');
          });
          $customerAddresses.each(function (i, el) {
            var id = jQuery(el).attr('data-address-id');
            var countryEl = 'customer_addr_' + id + '_country';
            var provinceEl = 'customer_addr_' + id + '_province';
            var options = { hideElement: 'address_province_container_' + id };
            // Initiate provinces for address forms
            new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
          });
        },
      },
    ]);
    return Account;
  })();
  var Contact = function Contact() {
    classCallCheck(this, Contact);
    this.$contactContents = jQuery('[data-template-contact]');
    if (this.$contactContents.length) {
      new Forms(this.$contactContents);
    }
  };
  ('use strict');
  var selectors = [
    'iframe[src*="player.vimeo.com"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtube-nocookie.com"]',
    'iframe[src*="kickstarter.com"][src*="video.html"]',
    'object',
  ];
  var css =
    '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
  var fitvids = function (parentSelector, opts) {
    parentSelector = parentSelector || 'body';
    opts = opts || {};
    if (isObject(parentSelector)) {
      opts = parentSelector;
      parentSelector = 'body';
    }
    opts.ignore = opts.ignore || '';
    opts.players = opts.players || '';
    var containers = queryAll(parentSelector);
    if (!hasLength(containers)) return;
    if (!document.getElementById('fit-vids-style')) {
      var head = document.head || document.getElementsByTagName('head')[0];
      head.appendChild(styles());
    }
    var custom = toSelectorArray(opts.players) || [];
    var ignored = toSelectorArray(opts.ignore) || [];
    var selector = selectors.filter(notIgnored(ignored)).concat(custom).join();
    if (!hasLength(selector)) return;
    containers.forEach(function (container) {
      var videos = queryAll(container, selector);
      videos.forEach(function (video) {
        wrap(video);
      });
    });
  };
  function queryAll(el, selector) {
    if (typeof el === 'string') {
      selector = el;
      el = document;
    }
    return Array.prototype.slice.call(el.querySelectorAll(selector));
  }
  function toSelectorArray(input) {
    if (typeof input === 'string') {
      return input.split(',').map(trim).filter(hasLength);
    } else if (isArray(input)) {
      return flatten(input.map(toSelectorArray).filter(hasLength));
    }
    return input || [];
  }
  function wrap(el) {
    if (/fluid-width-video-wrapper/.test(el.parentNode.className)) return;
    var widthAttr = parseInt(el.getAttribute('width'), 10);
    var heightAttr = parseInt(el.getAttribute('height'), 10);
    var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth;
    var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight;
    var aspect = height / width;
    el.removeAttribute('width');
    el.removeAttribute('height');
    var wrapper = document.createElement('div');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.className = 'fluid-width-video-wrapper';
    wrapper.style.paddingTop = aspect * 100 + '%';
    wrapper.appendChild(el);
  }
  function styles() {
    var div = document.createElement('div');
    div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
    return div.childNodes[1];
  }
  function notIgnored(ignored) {
    if (ignored.length < 1) {
      return function () {
        return true;
      };
    }
    return function (selector) {
      return ignored.indexOf(selector) === -1;
    };
  }
  function hasLength(input) {
    return input.length > 0;
  }
  function trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
  }
  function flatten(input) {
    return [].concat.apply([], input);
  }
  function isObject(input) {
    return Object.prototype.toString.call(input) === '[object Object]';
  }
  function isArray(input) {
    return Object.prototype.toString.call(input) === '[object Array]';
  }
  ('use strict');
  // forEach method, could be shipped as part of an Object Literal/Module
  function forEach(array, callback, scope) {
    var index = 0;
    for (index = 0; index < array.length; index += 1) {
      callback.call(scope, array[index], index); // passes back stuff we need
    }
  }
  function hasClass(el, className) {
    var regex = new RegExp('^' + className + '| +' + className, 'g');
    return el.className.match(regex);
  }
  function addClass(el, className) {
    // Return if it already has the className
    if (hasClass(el, className)) return;
    el.className += ' ' + className;
  }
  function removeClass(el, className) {
    // Return if it doesn't already have the className
    if (!hasClass(el, className)) return;
    var regex = new RegExp('^' + className + '| +' + className, 'g');
    el.className = el.className.replace(regex, '');
  }
  function toggleClass(el, className) {
    if (hasClass(el, className)) {
      removeClass(el, className);
    } else {
      addClass(el, className);
    }
  }
  function findPairingFromPairingTrigger(pairings, pairingTrigger) {
    var foundPairing = null;
    forEach(pairings, function (pairing) {
      if (pairing.trigger === pairingTrigger) {
        foundPairing = pairing;
      }
    });
    return foundPairing;
  }
  /**
   * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
   * An RFC4122 v4 compliant uuid solution
   */
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  function init$1(groupedContent) {
    var triggers = groupedContent.triggers;
    var pairings = groupedContent.pairings;
    triggers.setAttribute('role', 'tablist');
    forEach(pairings, function (pairing, index) {
      pairing.trigger.setAttribute('role', 'tab');
      pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
      if (pairing.trigger.children.length > 0) {
        forEach(pairing.trigger.children, function (child) {
          child.setAttribute('tabIndex', '-1');
        });
      }
      if (hasClass(pairing.trigger, 'active')) {
        pairing.trigger.setAttribute('aria-selected', 'true');
        pairing.trigger.setAttribute('tabIndex', '0');
      } else {
        pairing.trigger.setAttribute('tabIndex', '-1');
      }
      pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
      pairing.content.setAttribute('role', 'tabpanel');
      if (!hasClass(pairing.content, 'active')) {
        pairing.content.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function update$1(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing) {
      pairing.trigger.removeAttribute('aria-selected');
      pairing.content.removeAttribute('aria-hidden');
      if (hasClass(pairing.trigger, 'active')) {
        pairing.trigger.setAttribute('aria-selected', 'true');
        pairing.trigger.setAttribute('tabIndex', '0');
      } else {
        pairing.trigger.setAttribute('tabIndex', '-1');
      }
      if (!hasClass(pairing.content, 'active')) {
        pairing.content.setAttribute('aria-hidden', 'true');
      }
    });
  }
  var a11y = {
    init: init$1,
    update: update$1,
  };
  var asyncGenerator$1 = (function () {
    function AwaitValue(value) {
      this.value = value;
    }
    function AsyncGenerator(gen) {
      var front, back;
      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null,
          };
          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }
      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;
          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(
              function (arg) {
                resume('next', arg);
              },
              function (arg) {
                resume('throw', arg);
              }
            );
          } else {
            settle(result.done ? 'return' : 'normal', result.value);
          }
        } catch (err) {
          settle('throw', err);
        }
      }
      function settle(type, value) {
        switch (type) {
          case 'return':
            front.resolve({
              value: value,
              done: true,
            });
            break;
          case 'throw':
            front.reject(value);
            break;
          default:
            front.resolve({
              value: value,
              done: false,
            });
            break;
        }
        front = front.next;
        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }
      this._invoke = send;
      if (typeof gen.return !== 'function') {
        this.return = undefined;
      }
    }
    if (typeof Symbol === 'function' && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }
    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke('next', arg);
    };
    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke('throw', arg);
    };
    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke('return', arg);
    };
    return {
      wrap: function (fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function (value) {
        return new AwaitValue(value);
      },
    };
  })();
  var classCallCheck$1 = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  };
  var createClass$1 = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  /** A class for creating, managing, and destroying groupable content as tabs. */
  var TabsLayout = (function () {
    function TabsLayout(groupedContent) {
      classCallCheck$1(this, TabsLayout);
      this.groupedContent = groupedContent;
      this.pairings = groupedContent.pairings;
      this.events = [];
      this._handleKeydown = this._handleKeydown.bind(this);
      this._handleClick = this._handleClick.bind(this);
      this._init();
      a11y.init(this.groupedContent);
    }
    createClass$1(TabsLayout, [
      {
        key: 'unload',
        value: function unload() {
          forEach(this.events, function (event) {
            event.trigger.removeEventListener(event.type, event.fn);
          });
        },
      },
      {
        key: '_init',
        value: function _init() {
          var _this = this;
          var existingActive = false;
          forEach(this.pairings, function (pairing) {
            var trigger = pairing.trigger;
            if (hasClass(trigger, 'active')) {
              existingActive = true;
            }
            trigger.addEventListener('keydown', _this._handleKeydown);
            trigger.addEventListener('click', _this._handleClick);
            _this.events.push({
              trigger: trigger,
              type: 'keydown',
              fn: _this._handleKeydown,
            });
            _this.events.push({
              trigger: trigger,
              type: 'click',
              fn: _this._handleClick,
            });
          });
          if (!existingActive) {
            addClass(this.pairings[0].trigger, 'active');
            addClass(this.pairings[0].content, 'active');
          }
        },
      },
      {
        key: '_handleKeydown',
        value: function _handleKeydown(event) {
          var trigger = event.currentTarget;
          var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
          var pairingIndex = this.pairings.indexOf(pairing);
          var prevIndex = pairingIndex - 1 < 0 ? this.pairings.length - 1 : pairingIndex - 1;
          var nextIndex = pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;
          var nextPairing = null;
          switch (event.key) {
            case 'ArrowLeft':
              nextPairing = this.pairings[prevIndex];
              break;
            case 'ArrowRight':
              nextPairing = this.pairings[nextIndex];
              break;
            default:
              nextPairing = null;
              break;
          }
          // Fast exit if we can't find the tab or tabs
          if (nextPairing === null) return;
          event.preventDefault();
          forEach(this.pairings, function (inactivePairing) {
            removeClass(inactivePairing.trigger, 'active');
            removeClass(inactivePairing.content, 'active');
          });
          addClass(nextPairing.trigger, 'active');
          addClass(nextPairing.content, 'active');
          nextPairing.trigger.focus();
          a11y.update(this.groupedContent);
        },
      },
      {
        key: '_handleClick',
        value: function _handleClick(event) {
          var trigger = event.currentTarget;
          var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
          // Fast exit if we can't find the tab or tabs
          if (pairing === null) return;
          event.preventDefault();
          forEach(this.pairings, function (inactivePairing) {
            removeClass(inactivePairing.trigger, 'active');
            removeClass(inactivePairing.content, 'active');
          });
          addClass(pairing.trigger, 'active');
          addClass(pairing.content, 'active');
          a11y.update(this.groupedContent);
        },
      },
    ]);
    return TabsLayout;
  })();
  function init$1$1(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing, index) {
      pairing.trigger.setAttribute('role', 'button');
      pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
      pairing.trigger.setAttribute('tabIndex', '0');
      if (pairing.trigger.children.length > 0) {
        forEach(pairing.trigger.children, function (child) {
          child.setAttribute('tabIndex', '-1');
        });
      }
      if (hasClass(pairing.trigger, 'active')) {
        pairing.trigger.setAttribute('aria-expanded', 'true');
      } else {
        pairing.trigger.setAttribute('aria-expanded', 'false');
      }
      pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
      if (!hasClass(pairing.content, 'active')) {
        pairing.content.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function update$1$1(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing) {
      pairing.content.removeAttribute('aria-hidden');
      if (hasClass(pairing.trigger, 'active')) {
        pairing.trigger.setAttribute('aria-expanded', 'true');
      } else {
        pairing.trigger.setAttribute('aria-expanded', 'false');
      }
      if (!hasClass(pairing.content, 'active')) {
        pairing.content.setAttribute('aria-hidden', 'true');
      }
    });
  }
  var a11y$1 = {
    init: init$1$1,
    update: update$1$1,
  };
  /** A class for creating, managing, and destroying groupable content as an accordion. */
  var AccordionLayout = (function () {
    function AccordionLayout(groupedContent) {
      classCallCheck$1(this, AccordionLayout);
      this.groupedContent = groupedContent;
      this.pairings = groupedContent.pairings;
      this.events = [];
      this._handleKeydown = this._handleKeydown.bind(this);
      this._handleClick = this._handleClick.bind(this);
      this._init(this.pairings);
      a11y$1.init(this.groupedContent);
    }
    createClass$1(AccordionLayout, [
      {
        key: 'unload',
        value: function unload() {
          forEach(this.events, function (event) {
            event.trigger.removeEventListener(event.type, event.fn);
          });
        },
      },
      {
        key: '_init',
        value: function _init() {
          var _this = this;
          forEach(this.pairings, function (pairing) {
            var trigger = pairing.trigger;
            var content = pairing.content;
            trigger.parentNode.insertBefore(content, trigger.nextSibling);
            trigger.addEventListener('keydown', _this._handleKeydown);
            trigger.addEventListener('click', _this._handleClick);
            _this.events.push({
              trigger: trigger,
              type: 'keydown',
              fn: _this._handleKeydown,
            });
            _this.events.push({
              trigger: trigger,
              type: 'click',
              fn: _this._handleClick,
            });
          });
          this.groupedContent.contents.remove();
        },
      },
      {
        key: '_handleKeydown',
        value: function _handleKeydown(event) {
          var trigger = event.currentTarget;
          var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
          // Fast exit if enter isn't pressed or we can't find the group
          if (event.key !== 'Enter' || pairing === null) return;
          event.preventDefault();
          toggleClass(pairing.trigger, 'active');
          toggleClass(pairing.content, 'active');
          a11y$1.update(this.groupedContent);
        },
      },
      {
        key: '_handleClick',
        value: function _handleClick(event) {
          var trigger = event.currentTarget;
          var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
          // Fast exit if we can't find the group
          if (pairing === null) return;
          event.preventDefault();
          toggleClass(pairing.trigger, 'active');
          toggleClass(pairing.content, 'active');
          a11y$1.update(this.groupedContent);
        },
      },
    ]);
    return AccordionLayout;
  })();
  /**
   * Returns an array of nodes related to the heading node.
   * @param {node} heading - The heading node to search for content from.
   * @returns {node[]}
   */
  function getHeadingContent(heading) {
    var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    var tagNameIndex = headingTagNames.indexOf(heading.tagName);
    var content = [];
    var sibling = heading.nextElementSibling;
    while (
      sibling !== null &&
      (headingTagNames.indexOf(sibling.tagName) === -1 || headingTagNames.indexOf(sibling.tagName) > tagNameIndex)
    ) {
      content.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    return content;
  }
  /**
   * Returns an object array representing the heading tree from a given node.
   * Root nodes are evaluated differently, and requires the evaluatingRoot flag
   * to be true.
   * @param {node} el - The node being evaluated.
   * @param {node[]} children - The children of the evaluated node.
   * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
   * @returns {Object[]}
   */
  function getHeadingTree(el, children) {
    var evaluatingRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    var tagNameIndex = headingTagNames.indexOf(el.tagName);
    var headings = [];
    var currentLowestTagNameIndex = 5;
    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      var childTagNameIndex = headingTagNames.indexOf(child.tagName);
      if (childTagNameIndex !== -1 && childTagNameIndex < currentLowestTagNameIndex) {
        currentLowestTagNameIndex = childTagNameIndex;
      }
      if (
        (evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex <= currentLowestTagNameIndex) ||
        (!evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex === tagNameIndex + 1)
      ) {
        var siblings = getHeadingContent(child);
        var childNode = {
          el: child,
          content: siblings,
          children: getHeadingTree(child, siblings),
        };
        headings.push(childNode);
      }
    }
    return headings;
  }
  /**
   * Returns groupings of headings that meet the minimum sequence value
   * and don't contain any invalid headings.
   * @param {Object[]} headings - An array of heading objects.
   * @param {int[]} invalidHeadings - An array of invalid heading integers,
   *                                  representing indexes of headings.
   * @param {*} minInSequence - Minimum headings in sequence before being considered
   *                            as a grouping.
   * @returns {Object[][]}
   */
  function getHeadingGroupsInSequence(headings, invalidHeadings, minInSequence) {
    var headingGroupsInSequence = [];
    var currentHeadingGroupInSequence = [];
    var currentSequence = 0;
    for (var i = 0; i < headings.length; i += 1) {
      if (invalidHeadings.indexOf(i) === -1) {
        currentHeadingGroupInSequence.push(headings[i]);
        currentSequence += 1;
        if (i !== headings.length - 1 && headings[i].el.tagName !== headings[i + 1].el.tagName && invalidHeadings.indexOf(i + 1)) {
          currentHeadingGroupInSequence = [];
          currentSequence = 0;
        } else if (i !== 0 && headings[i].el.tagName !== headings[i - 1].el.tagName) {
          currentHeadingGroupInSequence.pop();
          currentSequence -= 1;
          if (currentSequence >= minInSequence) {
            headingGroupsInSequence.push(currentHeadingGroupInSequence);
          }
          currentHeadingGroupInSequence = [headings[i]];
          currentSequence = 1;
        }
      }
    }
    if (currentSequence >= minInSequence) {
      headingGroupsInSequence.push(currentHeadingGroupInSequence);
    }
    return headingGroupsInSequence;
  }
  /**
   * Generates necessary DOM elements to group related content.
   * Returns a object array representing the grouped content.
   * @param {Object[]} children - An array of objects.
   * @returns {Object[]}
   */
  function createGroupedContent(children) {
    var pairings = [];
    var firstChild = children[0].el;
    var triggers = document.createElement('div');
    var contents = document.createElement('div');
    contents = firstChild.parentNode.insertBefore(contents, firstChild.nextSibling);
    triggers = firstChild.parentNode.insertBefore(triggers, firstChild.nextSibling);
    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      var trigger = child.el;
      var content = document.createElement('div');
      trigger = triggers.appendChild(trigger);
      content = contents.appendChild(content);
      for (var j = 0; j < child.content.length; j += 1) {
        content.appendChild(child.content[j]);
      }
      pairings.push({
        trigger: trigger,
        content: content,
      });
    }
    return {
      triggers: triggers,
      contents: contents,
      pairings: pairings,
    };
  }
  /**
   * Returns all groupable content within the supplied node.
   * @param {node} node - A node to traverse for groupable content.
   * @returns {Object[][]}
   */
  /*
   * Recursive function:
   *  Returns all groups of headings that
   *  are elegible to become grouped content.
   */
  function getGroupedContentSet(node) {
    var children = node.children;
    var childrenWithGroupableContent = [];
    var groupedContentSet = [];
    if (children.length === 0) {
      return [];
    }
    for (var i = 0; i < children.length; i += 1) {
      var childGroupableContent = getGroupedContentSet(children[i]);
      if (childGroupableContent.length > 0) {
        childrenWithGroupableContent.push(i);
        groupedContentSet = groupedContentSet.concat(childGroupableContent);
      }
    }
    var headingGroupsInSequence = getHeadingGroupsInSequence(children, childrenWithGroupableContent, 3);
    for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
      groupedContentSet.push(createGroupedContent(headingGroupsInSequence[_i]));
    }
    return groupedContentSet;
  }
  /**
   * When static parsing isn't enough, there's intelliparse™!
   * Searches through dom content to find heading groupings that
   * are elegible to become tab groups.
   * Assumes that content is in a flattened hierarchy in the dom
   * and interprets increasing heading values as a deeper level of nesting.
   * Returns all groupable content as an array of object arrays.
   * @param {node} el - The node who's content will be searched for groupable content.
   * @returns {Object[][]}
   */
  function intelliParse(el) {
    var children = el.children;
    var heading = el.querySelector('h1, h2, h3, h4, h5, h6');
    // Fast return if there's no headings
    if (children.length === 0) return [];
    var rootNode = {
      el: el,
      content: null,
      children: getHeadingTree(heading, children, true),
    };
    return getGroupedContentSet(rootNode);
  }
  /**
   * Parses content from a given node based on a static structure.
   * The structure is as follows:
   * <ul class="tabs">
   *   <li class="active">Tab 1</li>
   *   <li>Tab 2</li>
   *   <li>Tab 3</li>
   * </ul>
   *
   * <ul class="tabs-content">
   *   <li class="active">
   *     <p>Tab 1 content goes here.</p>
   *   </li>
   *   <li>
   *     <p>Tab 2 content goes here.</p>
   *   </li>
   *   <li>
   *     <p>Tab 3 content goes here.</p>
   *   </li>
   * </ul>
   * Returns all groupable content as an array of object arrays.
   * @param {node} el - The node who's content will be searched for groupable content.
   * @returns {Object[][]}
   */
  function staticParse(el) {
    var groupedContentSet = [];
    var tabs = el.querySelectorAll('.tabs');
    for (var i = 0; i < tabs.length; i += 1) {
      var triggers = tabs[i].children;
      var contents = tabs[i].nextElementSibling.children;
      // Only add a tab group if equal triggers to contents
      if (triggers.length === contents.length) {
        var length = groupedContentSet.push({
          triggers: tabs[i],
          contents: tabs[i].nextElementSibling,
          pairings: [],
        });
        var index = length - 1;
        for (var j = 0; j < triggers.length; j += 1) {
          var trigger = triggers[j];
          var content = contents[j];
          var pairing = {
            trigger: trigger,
            content: content,
          };
          groupedContentSet[index].pairings.push(pairing);
        }
      }
    }
    return groupedContentSet;
  }
  /**
   * Returns all groupable content as an array of object arrays.
   * @param {node} content - The node to parse for groupable content.
   * @param {boolean} intelliparse - Whether to use intelligent parsing.
   * @returns {Object[][]}
   */
  function parse(content) {
    var intelliparse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var groupedContentSet = intelliparse ? intelliParse(content) : staticParse(content);
    return groupedContentSet;
  }
  /** A class for creating, managing, and destroying groupable content. */
  var GroupedContent = (function () {
    /**
     * Create grouped content
     * @param {node} el - The element to search for groupable content in.
     * @param {Object}  [options] - Additional options
     * @param {string}  [options.layout] - The layout to display groupable content in.
     * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
     */
    function GroupedContent(el) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      classCallCheck$1(this, GroupedContent);
      this.namespace = 'grouped-content';
      this.el = el;
      this.groupedContentInstances = [];
      var layout = options.layout || 'tabs';
      var intelliparse = !!options.intelliparse;
      forEach(parse(el, intelliparse), function (groupedContent) {
        var id = uuidv4();
        var instance = null;
        var groupedContentWrapper = document.createElement('div');
        groupedContentWrapper = groupedContent.triggers.parentNode.insertBefore(groupedContentWrapper, groupedContent.triggers.nextSibling);
        addClass(groupedContentWrapper, _this.namespace);
        addClass(groupedContentWrapper, _this.namespace + '-layout-' + layout);
        groupedContentWrapper.appendChild(groupedContent.triggers);
        groupedContentWrapper.appendChild(groupedContent.contents);
        groupedContent.namespace = _this.namespace;
        groupedContent.id = id;
        groupedContent.triggers.id = _this.namespace + '-' + id + '-triggers';
        groupedContent.contents.id = _this.namespace + '-' + id + '-contents';
        addClass(groupedContent.triggers, _this.namespace + '-triggers');
        addClass(groupedContent.contents, _this.namespace + '-contents');
        forEach(groupedContent.pairings, function (pairing) {
          addClass(pairing.trigger, _this.namespace + '-trigger');
          addClass(pairing.content, _this.namespace + '-content');
        });
        switch (layout) {
          case 'accordion':
            instance = new AccordionLayout(groupedContent);
            break;
          case 'tabs':
          default:
            instance = new TabsLayout(groupedContent);
            break;
        }
        _this.groupedContentInstances.push({
          groupedContent: groupedContent,
          instance: instance,
        });
      });
    }
    /** Unload all grouped content instances */
    createClass$1(GroupedContent, [
      {
        key: 'unload',
        value: function unload() {
          forEach(this.groupedContentInstances, function (groupedContentInstance) {
            groupedContentInstance.instance.unload();
          });
        },
      },
    ]);
    return GroupedContent;
  })();
  var dist$1 = GroupedContent;
  var RichText = (function () {
    function RichText($el) {
      classCallCheck(this, RichText);
      this.$el = $el;
      this._initExternalLinks();
      this.groupedContent = null;
      if (this.$el.length) {
        this.groupedContent = new dist$1($el.get(0), {
          layout: 'tabs',
          intelliparse: false,
        });
        fitvids();
      }
    }
    createClass(RichText, [
      {
        key: 'unload',
        value: function unload() {
          if (this.groupedContent) {
            this.groupedContent.unload();
          }
        },
        /**
         * Open links within an RTE field in a new window if they point to external domains
         *
         * @private
         */
      },
      {
        key: '_initExternalLinks',
        value: function _initExternalLinks() {
          var anchors = this.$el.find('a[href^="http"]').filter(function (i, el) {
            return el.href.indexOf(location.hostname) === -1;
          });
          anchors.attr('target', '_blank');
        },
      },
    ]);
    return RichText;
  })();
  var Page = function Page() {
    classCallCheck(this, Page);
    this.$pageContent = jQuery('[data-template-page]');
    if (this.$pageContent.length) {
      new RichText(this.$pageContent);
    }
  };
  var Sections = (function () {
    function Sections() {
      classCallCheck(this, Sections);
      this.handlers = {};
      this.instances = {};
      this._onSectionEvent = this._onSectionEvent.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionEvent);
      document.addEventListener('shopify:section:unload', this._onSectionEvent);
      document.addEventListener('shopify:section:select', this._onSectionEvent);
      document.addEventListener('shopify:section:deselect', this._onSectionEvent);
      document.addEventListener('shopify:block:select', this._onSectionEvent);
      document.addEventListener('shopify:block:deselect', this._onSectionEvent);
    }
    /**
     * Stop listening for section events, and unbind all handlers.
     */
    createClass(Sections, [
      {
        key: 'unbind',
        value: function unbind() {
          document.removeEventListener('shopify:section:load', this._onSectionEvent);
          document.removeEventListener('shopify:section:unload', this._onSectionEvent);
          document.removeEventListener('shopify:section:select', this._onSectionEvent);
          document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
          document.removeEventListener('shopify:block:select', this._onSectionEvent);
          document.removeEventListener('shopify:block:deselect', this._onSectionEvent);
          // Unload all instances
          for (var i = 0; i < this.instances.length; i++) {
            this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
          }
          this.handlers = {};
          this.instances = {};
        },
        /**
         * Register a section handler.
         *
         * @param {string} type
         *        The section type to handle. The handler will be called for all
         *        sections with this type.
         *
         * @param {function} handler
         *        The handler function is passed information about a specific section
         *        instance. The handler is expected to return an object that will be
         *        associated with the section instance.
         *
         *        Section handlers are passed an object with the following parameters:
         *          {string} id
         *          An ID that maps to a specific section instance. Typically the
         *          section's filename for static sections, or a generated ID for
         *          dynamic sections.
         *
         *          {string} type
         *          The section type, as supplied when registered.
         *
         *          {Element} el
         *          The root DOM element for the section instance.
         *
         *          {Object} data
         *          Data loaded from the section script element. Defaults to an
         *          empty object.
         *
         *          {Function} postMessage
         *          A function that can be called to pass messages between sections.
         *          The function should be called with a message "name", and
         *          optionally some data.
         */
      },
      {
        key: 'register',
        value: function register(type, handler) {
          if (this.handlers[type]) {
            console.warn("Sections: section handler already exists of type '" + type + "'.");
          }
          // Store the section handler
          this.handlers[type] = handler;
          // Init sections for this type
          this._initSections(type);
        },
        /**
         * Initialize sections already on the page.
         */
      },
      {
        key: '_initSections',
        value: function _initSections(type) {
          // Fetch all existing sections of our type on the page
          var dataEls = document.querySelectorAll('[data-section-type="' + type + '"]');
          if (!dataEls) return;
          // Create an instance for each section
          for (var i = 0; i < dataEls.length; i++) {
            var dataEl = dataEls[i];
            var el = dataEl.parentNode;
            // Get instance ID
            var idEl = el.querySelector('[data-section-id]');
            if (!idEl) {
              console.warn("Sections: unable to find section id for '" + type + "'.", el);
              continue;
            }
            var sectionId = idEl.getAttribute('data-section-id');
            if (!sectionId) {
              console.warn("Sections: unable to find section id for '" + type + "'.", el);
              continue;
            }
            this._createInstance(sectionId, el);
          }
        },
      },
      {
        key: '_onSectionEvent',
        value: function _onSectionEvent(event) {
          var el = event.target;
          var sectionId = event.detail.sectionId;
          var blockId = event.detail.blockId;
          var instance = this.instances[sectionId];
          switch (event.type) {
            case 'shopify:section:load':
              this._createInstance(sectionId, el);
              break;
            case 'shopify:section:unload':
              this._triggerInstanceEvent(instance, 'onSectionUnload', { el: el, id: sectionId });
              delete this.instances[sectionId];
              break;
            case 'shopify:section:select':
              this._triggerInstanceEvent(instance, 'onSectionSelect', { el: el, id: sectionId });
              break;
            case 'shopify:section:deselect':
              this._triggerInstanceEvent(instance, 'onSectionDeselect', { el: el, id: sectionId });
              break;
            case 'shopify:block:select':
              this._triggerInstanceEvent(instance, 'onSectionBlockSelect', { el: el, id: blockId });
              break;
            case 'shopify:block:deselect':
              this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', { el: el, id: blockId });
              break;
          }
        },
      },
      {
        key: '_triggerInstanceEvent',
        value: function _triggerInstanceEvent(instance, eventName) {
          if (instance && instance[eventName]) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = arguments[_key];
            }
            instance[eventName].apply(instance, args);
          }
        },
      },
      {
        key: '_postMessage',
        value: function _postMessage(name, data) {
          var _this = this;
          Object.keys(this.instances).forEach(function (id) {
            _this._triggerInstanceEvent(_this.instances[id], 'onSectionMessage', name, data);
          });
        },
      },
      {
        key: '_createInstance',
        value: function _createInstance(id, el) {
          var typeEl = el.querySelector('[data-section-type]');
          if (!typeEl) return;
          var type = typeEl.getAttribute('data-section-type');
          if (!type) return;
          var handler = this.handlers[type];
          if (!handler) return console.warn("Sections: unable to find section handler for type '" + type + "'.");
          var data = this._loadData(el);
          var postMessage = this._postMessage.bind(this);
          this.instances[id] = handler({ id: id, type: type, el: el, data: data, postMessage: postMessage });
        },
      },
      {
        key: '_loadData',
        value: function _loadData(el) {
          var dataEl = el.querySelector('[data-section-data]');
          if (!dataEl) return {};
          // Load data from attribute, or innerHTML
          var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
          try {
            return JSON.parse(data);
          } catch (error) {
            console.warn('Sections: invalid section data found. ' + error.message);
            return {};
          }
        },
      },
    ]);
    return Sections;
  })();
  ('use strict');
  var moneyFormats = {
    USD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} USD',
    },
    EUR: {
      money_format: '&euro;{{amount}}',
      money_with_currency_format: '&euro;{{amount}} EUR',
    },
    GBP: {
      money_format: '&pound;{{amount}}',
      money_with_currency_format: '&pound;{{amount}} GBP',
    },
    CAD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} CAD',
    },
    ALL: {
      money_format: 'Lek {{amount}}',
      money_with_currency_format: 'Lek {{amount}} ALL',
    },
    DZD: {
      money_format: 'DA {{amount}}',
      money_with_currency_format: 'DA {{amount}} DZD',
    },
    AOA: {
      money_format: 'Kz{{amount}}',
      money_with_currency_format: 'Kz{{amount}} AOA',
    },
    ARS: {
      money_format: '${{amount_with_comma_separator}}',
      money_with_currency_format: '${{amount_with_comma_separator}} ARS',
    },
    AMD: {
      money_format: '{{amount}} AMD',
      money_with_currency_format: '{{amount}} AMD',
    },
    AWG: {
      money_format: 'Afl{{amount}}',
      money_with_currency_format: 'Afl{{amount}} AWG',
    },
    AUD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} AUD',
    },
    BBD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} Bds',
    },
    AZN: {
      money_format: 'm.{{amount}}',
      money_with_currency_format: 'm.{{amount}} AZN',
    },
    BDT: {
      money_format: 'Tk {{amount}}',
      money_with_currency_format: 'Tk {{amount}} BDT',
    },
    BSD: {
      money_format: 'BS${{amount}}',
      money_with_currency_format: 'BS${{amount}} BSD',
    },
    BHD: {
      money_format: '{{amount}}0 BD',
      money_with_currency_format: '{{amount}}0 BHD',
    },
    BYR: {
      money_format: 'Br {{amount}}',
      money_with_currency_format: 'Br {{amount}} BYR',
    },
    BZD: {
      money_format: 'BZ${{amount}}',
      money_with_currency_format: 'BZ${{amount}} BZD',
    },
    BTN: {
      money_format: 'Nu {{amount}}',
      money_with_currency_format: 'Nu {{amount}} BTN',
    },
    BAM: {
      money_format: 'KM {{amount_with_comma_separator}}',
      money_with_currency_format: 'KM {{amount_with_comma_separator}} BAM',
    },
    BRL: {
      money_format: 'R$ {{amount_with_comma_separator}}',
      money_with_currency_format: 'R$ {{amount_with_comma_separator}} BRL',
    },
    BOB: {
      money_format: 'Bs{{amount_with_comma_separator}}',
      money_with_currency_format: 'Bs{{amount_with_comma_separator}} BOB',
    },
    BWP: {
      money_format: 'P{{amount}}',
      money_with_currency_format: 'P{{amount}} BWP',
    },
    BND: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} BND',
    },
    BGN: {
      money_format: '{{amount}} лв',
      money_with_currency_format: '{{amount}} лв BGN',
    },
    MMK: {
      money_format: 'K{{amount}}',
      money_with_currency_format: 'K{{amount}} MMK',
    },
    KHR: {
      money_format: 'KHR{{amount}}',
      money_with_currency_format: 'KHR{{amount}}',
    },
    KYD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} KYD',
    },
    XAF: {
      money_format: 'FCFA{{amount}}',
      money_with_currency_format: 'FCFA{{amount}} XAF',
    },
    CLP: {
      money_format: '${{amount_no_decimals}}',
      money_with_currency_format: '${{amount_no_decimals}} CLP',
    },
    CNY: {
      money_format: '&#165;{{amount}}',
      money_with_currency_format: '&#165;{{amount}} CNY',
    },
    COP: {
      money_format: '${{amount_with_comma_separator}}',
      money_with_currency_format: '${{amount_with_comma_separator}} COP',
    },
    CRC: {
      money_format: '&#8353; {{amount_with_comma_separator}}',
      money_with_currency_format: '&#8353; {{amount_with_comma_separator}} CRC',
    },
    HRK: {
      money_format: '{{amount_with_comma_separator}} kn',
      money_with_currency_format: '{{amount_with_comma_separator}} kn HRK',
    },
    CZK: {
      money_format: '{{amount_with_comma_separator}} K&#269;',
      money_with_currency_format: '{{amount_with_comma_separator}} K&#269;',
    },
    DKK: {
      money_format: '{{amount_with_comma_separator}}',
      money_with_currency_format: 'kr.{{amount_with_comma_separator}}',
    },
    DOP: {
      money_format: 'RD$ {{amount}}',
      money_with_currency_format: 'RD$ {{amount}}',
    },
    XCD: {
      money_format: '${{amount}}',
      money_with_currency_format: 'EC${{amount}}',
    },
    EGP: {
      money_format: 'LE {{amount}}',
      money_with_currency_format: 'LE {{amount}} EGP',
    },
    ETB: {
      money_format: 'Br{{amount}}',
      money_with_currency_format: 'Br{{amount}} ETB',
    },
    XPF: {
      money_format: '{{amount_no_decimals_with_comma_separator}} XPF',
      money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} XPF',
    },
    FJD: {
      money_format: '${{amount}}',
      money_with_currency_format: 'FJ${{amount}}',
    },
    GMD: {
      money_format: 'D {{amount}}',
      money_with_currency_format: 'D {{amount}} GMD',
    },
    GHS: {
      money_format: 'GH&#8373;{{amount}}',
      money_with_currency_format: 'GH&#8373;{{amount}}',
    },
    GTQ: {
      money_format: 'Q{{amount}}',
      money_with_currency_format: '{{amount}} GTQ',
    },
    GYD: {
      money_format: 'G${{amount}}',
      money_with_currency_format: '${{amount}} GYD',
    },
    GEL: {
      money_format: '{{amount}} GEL',
      money_with_currency_format: '{{amount}} GEL',
    },
    HNL: {
      money_format: 'L {{amount}}',
      money_with_currency_format: 'L {{amount}} HNL',
    },
    HKD: {
      money_format: '${{amount}}',
      money_with_currency_format: 'HK${{amount}}',
    },
    HUF: {
      money_format: '{{amount_no_decimals_with_comma_separator}}',
      money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} Ft',
    },
    ISK: {
      money_format: '{{amount_no_decimals}} kr',
      money_with_currency_format: '{{amount_no_decimals}} kr ISK',
    },
    INR: {
      money_format: 'Rs. {{amount}}',
      money_with_currency_format: 'Rs. {{amount}}',
    },
    IDR: {
      money_format: '{{amount_with_comma_separator}}',
      money_with_currency_format: 'Rp {{amount_with_comma_separator}}',
    },
    ILS: {
      money_format: '{{amount}} NIS',
      money_with_currency_format: '{{amount}} NIS',
    },
    JMD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} JMD',
    },
    JPY: {
      money_format: '&#165;{{amount_no_decimals}}',
      money_with_currency_format: '&#165;{{amount_no_decimals}} JPY',
    },
    JEP: {
      money_format: '&pound;{{amount}}',
      money_with_currency_format: '&pound;{{amount}} JEP',
    },
    JOD: {
      money_format: '{{amount}}0 JD',
      money_with_currency_format: '{{amount}}0 JOD',
    },
    KZT: {
      money_format: '{{amount}} KZT',
      money_with_currency_format: '{{amount}} KZT',
    },
    KES: {
      money_format: 'KSh{{amount}}',
      money_with_currency_format: 'KSh{{amount}}',
    },
    KWD: {
      money_format: '{{amount}}0 KD',
      money_with_currency_format: '{{amount}}0 KWD',
    },
    KGS: {
      money_format: 'лв{{amount}}',
      money_with_currency_format: 'лв{{amount}}',
    },
    LVL: {
      money_format: 'Ls {{amount}}',
      money_with_currency_format: 'Ls {{amount}} LVL',
    },
    LBP: {
      money_format: 'L&pound;{{amount}}',
      money_with_currency_format: 'L&pound;{{amount}} LBP',
    },
    LTL: {
      money_format: '{{amount}} Lt',
      money_with_currency_format: '{{amount}} Lt',
    },
    MGA: {
      money_format: 'Ar {{amount}}',
      money_with_currency_format: 'Ar {{amount}} MGA',
    },
    MKD: {
      money_format: 'ден {{amount}}',
      money_with_currency_format: 'ден {{amount}} MKD',
    },
    MOP: {
      money_format: 'MOP${{amount}}',
      money_with_currency_format: 'MOP${{amount}}',
    },
    MVR: {
      money_format: 'Rf{{amount}}',
      money_with_currency_format: 'Rf{{amount}} MRf',
    },
    MXN: {
      money_format: '$ {{amount}}',
      money_with_currency_format: '$ {{amount}} MXN',
    },
    MYR: {
      money_format: 'RM{{amount}} MYR',
      money_with_currency_format: 'RM{{amount}} MYR',
    },
    MUR: {
      money_format: 'Rs {{amount}}',
      money_with_currency_format: 'Rs {{amount}} MUR',
    },
    MDL: {
      money_format: '{{amount}} MDL',
      money_with_currency_format: '{{amount}} MDL',
    },
    MAD: {
      money_format: '{{amount}} dh',
      money_with_currency_format: 'Dh {{amount}} MAD',
    },
    MNT: {
      money_format: '{{amount_no_decimals}} &#8366',
      money_with_currency_format: '{{amount_no_decimals}} MNT',
    },
    MZN: {
      money_format: '{{amount}} Mt',
      money_with_currency_format: 'Mt {{amount}} MZN',
    },
    NAD: {
      money_format: 'N${{amount}}',
      money_with_currency_format: 'N${{amount}} NAD',
    },
    NPR: {
      money_format: 'Rs{{amount}}',
      money_with_currency_format: 'Rs{{amount}} NPR',
    },
    ANG: {
      money_format: '&fnof;{{amount}}',
      money_with_currency_format: '{{amount}} NA&fnof;',
    },
    NZD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} NZD',
    },
    NIO: {
      money_format: 'C${{amount}}',
      money_with_currency_format: 'C${{amount}} NIO',
    },
    NGN: {
      money_format: '&#8358;{{amount}}',
      money_with_currency_format: '&#8358;{{amount}} NGN',
    },
    NOK: {
      money_format: 'kr {{amount_with_comma_separator}}',
      money_with_currency_format: 'kr {{amount_with_comma_separator}} NOK',
    },
    OMR: {
      money_format: '{{amount_with_comma_separator}} OMR',
      money_with_currency_format: '{{amount_with_comma_separator}} OMR',
    },
    PKR: {
      money_format: 'Rs.{{amount}}',
      money_with_currency_format: 'Rs.{{amount}} PKR',
    },
    PGK: {
      money_format: 'K {{amount}}',
      money_with_currency_format: 'K {{amount}} PGK',
    },
    PYG: {
      money_format: 'Gs. {{amount_no_decimals_with_comma_separator}}',
      money_with_currency_format: 'Gs. {{amount_no_decimals_with_comma_separator}} PYG',
    },
    PEN: {
      money_format: 'S/. {{amount}}',
      money_with_currency_format: 'S/. {{amount}} PEN',
    },
    PHP: {
      money_format: '&#8369;{{amount}}',
      money_with_currency_format: '&#8369;{{amount}} PHP',
    },
    PLN: {
      money_format: '{{amount_with_comma_separator}} zl',
      money_with_currency_format: '{{amount_with_comma_separator}} zl PLN',
    },
    QAR: {
      money_format: 'QAR {{amount_with_comma_separator}}',
      money_with_currency_format: 'QAR {{amount_with_comma_separator}}',
    },
    RON: {
      money_format: '{{amount_with_comma_separator}} lei',
      money_with_currency_format: '{{amount_with_comma_separator}} lei RON',
    },
    RUB: {
      money_format: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
      money_with_currency_format: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB',
    },
    RWF: {
      money_format: '{{amount_no_decimals}} RF',
      money_with_currency_format: '{{amount_no_decimals}} RWF',
    },
    WST: {
      money_format: 'WS$ {{amount}}',
      money_with_currency_format: 'WS$ {{amount}} WST',
    },
    SAR: {
      money_format: '{{amount}} SR',
      money_with_currency_format: '{{amount}} SAR',
    },
    STD: {
      money_format: 'Db {{amount}}',
      money_with_currency_format: 'Db {{amount}} STD',
    },
    RSD: {
      money_format: '{{amount}} RSD',
      money_with_currency_format: '{{amount}} RSD',
    },
    SCR: {
      money_format: 'Rs {{amount}}',
      money_with_currency_format: 'Rs {{amount}} SCR',
    },
    SGD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} SGD',
    },
    SYP: {
      money_format: 'S&pound;{{amount}}',
      money_with_currency_format: 'S&pound;{{amount}} SYP',
    },
    ZAR: {
      money_format: 'R {{amount}}',
      money_with_currency_format: 'R {{amount}} ZAR',
    },
    KRW: {
      money_format: '&#8361;{{amount_no_decimals}}',
      money_with_currency_format: '&#8361;{{amount_no_decimals}} KRW',
    },
    LKR: {
      money_format: 'Rs {{amount}}',
      money_with_currency_format: 'Rs {{amount}} LKR',
    },
    SEK: {
      money_format: '{{amount_no_decimals}} kr',
      money_with_currency_format: '{{amount_no_decimals}} kr SEK',
    },
    CHF: {
      money_format: 'SFr. {{amount}}',
      money_with_currency_format: 'SFr. {{amount}} CHF',
    },
    TWD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} TWD',
    },
    THB: {
      money_format: '{{amount}} &#xe3f;',
      money_with_currency_format: '{{amount}} &#xe3f; THB',
    },
    TZS: {
      money_format: '{{amount}} TZS',
      money_with_currency_format: '{{amount}} TZS',
    },
    TTD: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}} TTD',
    },
    TND: {
      money_format: '{{amount}}',
      money_with_currency_format: '{{amount}} DT',
    },
    TRY: {
      money_format: '{{amount}}TL',
      money_with_currency_format: '{{amount}}TL',
    },
    UGX: {
      money_format: 'Ush {{amount_no_decimals}}',
      money_with_currency_format: 'Ush {{amount_no_decimals}} UGX',
    },
    UAH: {
      money_format: '₴{{amount}}',
      money_with_currency_format: '₴{{amount}} UAH',
    },
    AED: {
      money_format: 'Dhs. {{amount}}',
      money_with_currency_format: 'Dhs. {{amount}} AED',
    },
    UYU: {
      money_format: '${{amount_with_comma_separator}}',
      money_with_currency_format: '${{amount_with_comma_separator}} UYU',
    },
    VUV: {
      money_format: '${{amount}}',
      money_with_currency_format: '${{amount}}VT',
    },
    VEF: {
      money_format: 'Bs. {{amount_with_comma_separator}}',
      money_with_currency_format: 'Bs. {{amount_with_comma_separator}} VEF',
    },
    VND: {
      money_format: '{{amount_no_decimals_with_comma_separator}}&#8363;',
      money_with_currency_format: '{{amount_no_decimals_with_comma_separator}} VND',
    },
    XBT: {
      money_format: '{{amount_no_decimals}} BTC',
      money_with_currency_format: '{{amount_no_decimals}} BTC',
    },
    XOF: {
      money_format: 'CFA{{amount}}',
      money_with_currency_format: 'CFA{{amount}} XOF',
    },
    ZMW: {
      money_format: 'K{{amount_no_decimals_with_comma_separator}}',
      money_with_currency_format: 'ZMW{{amount_no_decimals_with_comma_separator}}',
    },
  };
  /**
   * Format a number to a specific format
   *
   * @param number {Number}
   * @param precision {Number}
   * @param thousands {String}
   * @param decimal {String}
   * @returns {String}
   */
  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    if (isNaN(number) || !number) {
      return 0;
    }
    var preciseNumber = (number / 100.0).toFixed(precision);
    var parts = preciseNumber.split(thousands);
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  /**
   * Convert a money value in cents to a formatted currency string
   *
   * @param cents {Number|String}
   * @param format {String}
   * @returns {String}
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
    }
    return format.replace(placeholderRegex, value);
  }
  /**
   * Return the value of money in cents value
   *
   * @param moneyAmount {Number}
   * @param format {String}
   * @param currency {String}
   * @returns {Number}
   * @private
   */
  function getCentsValue(moneyAmount, format, currency) {
    var cents = 0;
    // Convert prices from float values to integers if needed, then convert
    if (format.indexOf('amount_no_decimals') !== -1) {
      cents = moneyAmount * 100;
    } else if (currency === 'JOD' || currency === 'KWD' || currency === 'BHD') {
      cents = moneyAmount / 10;
    } else {
      cents = moneyAmount;
    }
    return cents;
  }
  /**
   * Converts formatted money to a number
   *
   * @param priceEl {HTMLElement}
   * @returns {Number|String}
   */
  function getMoneyValue(priceEl) {
    var price = priceEl.textContent;
    var value = parseInt(price.replace(/[^0-9]/g, ''), 10);
    return !isNaN(value) ? value : '';
  }
  var classCallCheck$2 = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  };
  var createClass$2 = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var CurrencyConverter = (function () {
    function CurrencyConverter() {
      classCallCheck$2(this, CurrencyConverter);
      /**
       * @property {object} defaults                       - The default configuration for CurrencyConverter
       * @property {string} defaults.switcherSelector      - CSS Selector for dropdown which controls currency conversion
       * @property {string} defaults.priceSelector         - CSS Selector for elements containing prices
       * @property {string} defaults.shopCurrency          - Shop's currency (Currency which prices are printed as)
       * @property {string} defaults.defaultCurrency       - Theme's currency setting, or initial currency to show on the page
       * @property {string} defaults.displayFormat         - `money_with_currency_format` or `money_format`
       * @property {string} defaults.moneyFormat           - Shop's currency formatted using the display format
       * @property {string} defaults.moneyFormatNoCurrency - Shop's currency formatted without showing currency
       * @property {string} defaults.moneyFormatCurrency   - Shop's currency formatted showing currency
       */
      this.defaults = {
        switcherSelector: '[data-currency-converter]',
        priceSelector: '.money',
        shopCurrency: '',
        defaultCurrency: '',
        displayFormat: '',
        moneyFormat: '',
        moneyFormatNoCurrency: '',
        moneyFormatCurrency: '',
      };
      this.options = {};
      this.moneyFormats = moneyFormats;
      this.storage = 'currency';
      this.currentCurrency = null;
      this.isInitialised = false;
    }
    createClass$2(CurrencyConverter, [
      {
        key: 'init',
        value: function init(settings) {
          var _this = this;
          if (!window.Currency || this.isInitialised) return;
          Object.keys(this.defaults).forEach(function (key) {
            _this.options[key] = settings[key] || _this.defaults[key];
          });
          this.currentCurrency = this._getStoredCurrency() || this.options.defaultCurrency;
          this.moneyFormats[this.options.shopCurrency].money_with_currency_format = this.options.moneyFormatCurrency;
          this.moneyFormats[this.options.shopCurrency].money_format = this.options.moneyFormatNoCurrency;
          this.isInitialised = true;
          this._current();
        },
        /**
         * Change the currency to a new currency using an ISO currency code
         *
         * @param newCurrency
         */
      },
      {
        key: 'setCurrency',
        value: function setCurrency(newCurrency) {
          if (!this.isInitialised) return;
          this._convertAll(this.currentCurrency, newCurrency);
        },
        /**
         * Updates a price on the page to use the active Currency, and formatting
         *
         * @param priceEl {HTMLElement}
         */
      },
      {
        key: 'update',
        value: function update(priceEl) {
          if (!this.isInitialised) return;
          var attributes = priceEl.attributes;
          for (var attr = 0; attr < attributes.length; attr++) {
            var attribute = attributes[attr];
            if (attribute.name.indexOf('data-currency') === 0) {
              priceEl.setAttribute(attribute.name, '');
            }
          }
          var moneyValue = getMoneyValue(priceEl);
          var centsValue = getCentsValue(moneyValue, this.options.moneyFormat, this.options.shopCurrency);
          // Cents value is empty, but not 0. 0$ is a valid price, while empty is not
          if (centsValue === '') return;
          var priceFormatted = formatMoney(centsValue, this.options.moneyFormat);
          priceEl.innerHTML = priceFormatted;
          priceEl.removeAttribute('data-currency');
          priceEl.setAttribute('data-currency-' + this.options.shopCurrency, priceFormatted);
          priceEl.setAttribute('data-currency', this.options.shopCurrency);
          this._convertEl(priceEl, this.options.shopCurrency, this.currentCurrency);
        },
      },
      {
        key: '_getStoredCurrency',
        value: function _getStoredCurrency() {
          try {
            return localStorage.getItem(this.storage);
          } catch (error) {
            console.warn(error);
            return this.options.defaultCurrency;
          }
        },
      },
      {
        key: '_setStoredCurrency',
        value: function _setStoredCurrency(currency) {
          try {
            localStorage.setItem(this.storage, currency);
          } catch (error) {
            console.warn(error);
          }
        },
        /**
         * Update the currency switcher to the current currency
         * @private
         */
      },
      {
        key: '_current',
        value: function _current() {
          var switchers = document.querySelectorAll(this.options.switcherSelector);
          for (var i = 0; i < switchers.length; i++) {
            var switcher = switchers[i];
            var childrenEls = switcher.querySelectorAll('option');
            for (var _i = 0; _i < childrenEls.length; _i++) {
              var optionEl = childrenEls[_i];
              if (optionEl.selected && optionEl.value !== this.currentCurrency) {
                optionEl.selected = false;
              }
              if (optionEl.value === this.currentCurrency) {
                optionEl.selected = true;
              }
            }
          }
          this._convertAll(this.options.shopCurrency, this.currentCurrency);
        },
        /**
         * Converts an individual price to the new format
         *
         * @param priceEl
         * @param oldCurrency
         * @param newCurrency
         * @private
         */
      },
      {
        key: '_convertEl',
        value: function _convertEl(priceEl, oldCurrency, newCurrency) {
          // If the amount has already been converted, we leave it alone.
          if (priceEl.getAttribute('data-currency') === newCurrency) {
            return;
          }
          // If we are converting to a currency that we have saved, we will use the saved amount.
          if (priceEl.getAttribute('data-currency-' + newCurrency)) {
            priceEl.innerHTML = priceEl.getAttribute('data-currency-' + newCurrency);
          } else {
            var oldFormat = this.moneyFormats[oldCurrency][this.options.displayFormat];
            var newFormat = this.moneyFormats[newCurrency][this.options.displayFormat];
            var moneyValue = getMoneyValue(priceEl);
            var centsValue = getCentsValue(moneyValue, oldFormat, oldCurrency);
            // Cents value is empty, but not 0. 0$ is a valid price, while empty is not
            if (centsValue === '') return;
            var cents = window.Currency.convert(centsValue, oldCurrency, newCurrency);
            var priceFormatted = formatMoney(cents, newFormat);
            priceEl.setAttribute('data-currency-' + newCurrency, priceFormatted);
            priceEl.innerHTML = priceFormatted;
          }
          priceEl.setAttribute('data-currency', newCurrency);
        },
        /**
         * Convert all prices on the page to the new currency
         *
         * @param oldCurrency
         * @param newCurrency
         * @private
         */
      },
      {
        key: '_convertAll',
        value: function _convertAll(oldCurrency, newCurrency) {
          var priceEls = document.querySelectorAll(this.options.priceSelector);
          if (!priceEls) return;
          this.currentCurrency = newCurrency;
          this._setStoredCurrency(newCurrency);
          for (var i = 0; i < priceEls.length; i++) {
            this._convertEl(priceEls[i], oldCurrency, newCurrency);
          }
        },
      },
    ]);
    return CurrencyConverter;
  })();
  var CurrencyConverter$1 = new CurrencyConverter();
  var dist$2 = CurrencyConverter$1;
  var script$1 = createCommonjsModule(function (module) {
    /**
     * $script.js JS loader & dependency manager
     * https://github.com/ded/script.js
     * (c) Dustin Diaz 2014 | License MIT
     */
    (function (name, definition) {
      if ('object' != 'undefined' && module.exports) module.exports = definition();
      else if (typeof undefined == 'function' && undefined.amd) undefined(definition);
      else this[name] = definition();
    })('$script', function () {
      var doc = document,
        head = doc.getElementsByTagName('head')[0],
        s = 'string',
        f = false,
        push = 'push',
        readyState = 'readyState',
        onreadystatechange = 'onreadystatechange',
        list = {},
        ids = {},
        delay = {},
        scripts = {},
        scriptpath,
        urlArgs;
      function every(ar, fn) {
        for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f;
        return 1;
      }
      function each(ar, fn) {
        every(ar, function (el) {
          return !fn(el);
        });
      }
      function $script(paths, idOrDone, optDone) {
        paths = paths[push] ? paths : [paths];
        var idOrDoneIsDone = idOrDone && idOrDone.call,
          done = idOrDoneIsDone ? idOrDone : optDone,
          id = idOrDoneIsDone ? paths.join('') : idOrDone,
          queue = paths.length;
        function loopFn(item) {
          return item.call ? item() : list[item];
        }
        function callback() {
          if (!--queue) {
            list[id] = 1;
            done && done();
            for (var dset in delay) {
              every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
            }
          }
        }
        setTimeout(function () {
          each(paths, function loading(path, force) {
            if (path === null) return callback();
            if (!force && !/^https?:\/\//.test(path) && scriptpath) {
              path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
            }
            if (scripts[path]) {
              return scripts[path] == 2
                ? callback()
                : setTimeout(function () {
                  loading(path, true);
                }, 0);
            }
            scripts[path] = 1;
            create(path, callback);
          });
        }, 0);
        return $script;
      }
      function create(path, fn) {
        var el = doc.createElement('script'),
          loaded;
        el.onload =
          el.onerror =
          el[onreadystatechange] =
          function () {
            if ((el[readyState] && !/^c|loade/.test(el[readyState])) || loaded) return;
            el.onload = el[onreadystatechange] = null;
            loaded = 1;
            scripts[path] = 2;
            fn();
          };
        el.async = 1;
        el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
        head.insertBefore(el, head.lastChild);
      }
      $script.get = create;
      $script.order = function (scripts, id, done) {
        (function callback(s) {
          s = scripts.shift();
          !scripts.length ? $script(s, id, done) : $script(s, callback);
        })();
      };
      $script.path = function (p) {
        scriptpath = p;
      };
      $script.urlArgs = function (str) {
        urlArgs = str;
      };
      $script.ready = function (deps, ready, req) {
        deps = deps[push] ? deps : [deps];
        var missing = [];
        !each(deps, function (dep) {
          list[dep] || missing[push](dep);
        }) &&
          every(deps, function (dep) {
            return list[dep];
          })
          ? ready()
          : !(function (key) {
            delay[key] = delay[key] || [];
            delay[key][push](ready);
            req && req(missing);
          })(deps.join('|'));
        return $script;
      };
      $script.done = function (idOrDone) {
        $script([null], idOrDone);
      };
      return $script;
    });
  });
  var eventHandlers = [];
  var previousBreakpoint = null;
  jQuery(window).on('resize', function (event) {
    var currentBreakpoint = getBreakpoint();
    if (previousBreakpoint !== currentBreakpoint) {
      eventHandlers.forEach(function (eventHandler) {
        eventHandler(event, {
          previous: previousBreakpoint,
          current: currentBreakpoint,
        });
      });
    }
    previousBreakpoint = currentBreakpoint;
  });
  function getBreakpoint() {
    return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
  }
  function isBreakpoint(breakpoint) {
    return getBreakpoint() === breakpoint;
  }
  function onBreakpointChange(eventHandler) {
    if (eventHandlers.indexOf(eventHandler) === -1) {
      eventHandlers.push(eventHandler);
    }
  }
  function offBreakpointChange(eventHandler) {
    var index = eventHandlers.indexOf(eventHandler);
    if (index !== -1) {
      eventHandlers.splice(index, 1);
    }
  }
  var layout = {
    isBreakpoint: isBreakpoint,
    onBreakpointChange: onBreakpointChange,
    offBreakpointChange: offBreakpointChange,
  };
  var ignoredEls = ['data-mobile-nav', 'data-x-navigation'];
  function isIgnored(element) {
    // Disallow if element is a <script>
    if (element.tagName === 'SCRIPT') {
      return true;
    }
    // Allow if element has no attributes
    if (element.attributes.length === 0) {
      return false;
    }
    // Check if any attributes match to the ignore list
    return [].slice.call(element.attributes).some(function (attr) {
      return ignoredEls.indexOf(attr.name) !== -1;
    });
  }
  /**
   * Get the offset of the header
   *
   * @param {HTMLElement} header
   * @param {Boolean} withAnnouncementBar
   * @returns {number}
   */
  function getHeaderOffset(header) {
    var withAnnouncementBar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var headerEls = header.childNodes;
    var isSticky = header.querySelector('[data-x-head-sticky]');
    var _window = window,
      pageYOffset = _window.pageYOffset;
    var offset = 0;
    if (isSticky) {
      for (var i = 0; i < headerEls.length; i++) {
        if (headerEls[i] instanceof HTMLElement && !isIgnored(headerEls[i])) {
          offset += headerEls[i].getBoundingClientRect().height;
        }
      }
      if (jQuery(header).hasClass('x-head-sticky--open') || pageYOffset === 0) {
        offset += header.querySelector('[data-x-navigation]').getBoundingClientRect().height;
      }
    } else {
      // If is not sticky header, then DOM can be trusted to return values
      var _header$getBoundingCl = header.getBoundingClientRect(),
        bottom = _header$getBoundingCl.bottom;
      offset = bottom > 0 ? bottom : 0;
    }
    if (withAnnouncementBar) {
      offset += parseInt(header.style.top, 10) || 0;
    }
    return offset;
  }
  var StickyHeader = (function () {
    function StickyHeader(options, settings) {
      var _this = this;
      classCallCheck(this, StickyHeader);
      this.postMessage = options.postMessage;
      this.$body = jQuery(document.body);
      this.$window = jQuery(window);
      this.$siteMain = jQuery('.x-main');
      this.$el = options.$el;
      this.$toggle = options.$toggle;
      this.settings = settings;
      this.stickyClass = 'x-head-sticky';
      this.scrolledClass = 'x-head-sticky--scrolled';
      this.navOpenClass = 'x-head-sticky--open';
      this.$announcementBar = this.$el.find('.announcement-bar');
      this.header = this.$el[0];
      if (!this.settings.sticky_header) {
        return this._stickyReset();
      }
      // Revert navigation to original state on breakpoint change
      this.navVisibility = this.navVisibility.bind(this);
      layout.onBreakpointChange(this.navVisibility);
      this._stickyOffset = this._stickyOffset.bind(this);
      document.addEventListener('resize', function () {
        return _this._stickyOffset();
      });
      this._toggleStickyHeader = this._toggleStickyHeader.bind(this);
      this._headerChecker = this._headerChecker.bind(this);
      this.slideToggle = this._slideToggle.bind(this);
      this._init();
    }
    createClass(StickyHeader, [
      {
        key: 'closeNavigation',
        value: function closeNavigation() {
          var _this2 = this;
          if (!this.settings.sticky_header) return;
          this.$el.removeClass(this.navOpenClass).one('trend', function () {
            _this2.$body.trigger('position-banners');
          });
          this.postMessage('nav:close-all');
        },
      },
      {
        key: 'openNavigation',
        value: function openNavigation() {
          var _this3 = this;
          this.$el.addClass(this.navOpenClass).one('trend', function () {
            _this3.$body.trigger('position-banners');
          });
        },
      },
      {
        key: 'navVisibility',
        value: function navVisibility(event, breakpoints) {
          if (breakpoints.previous === 'L') this.closeNavigation();
        },
      },
      {
        key: 'unload',
        value: function unload() {
          if (!this.settings.sticky_header) return;
          this.$body.removeClass(this.stickyClass).removeClass(this.scrolledClass);
          this.$toggle.off('.sticky-header');
          this.$window.off('.sticky-header');
          layout.offBreakpointChange(this.navVisibility);
          layout.offBreakpointChange(this._stickyOffset);
          if (this.requestAnimationFrameId) {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
          }
        },
      },
      {
        key: '_init',
        value: function _init() {
          this._stickyOffset(true);
          this._bindEvents();
          if (window.requestAnimationFrame) {
            this._headerChecker();
          }
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this4 = this;
          this.$toggle.on('click.sticky-header', function (event) {
            event.preventDefault();
            if (layout.isBreakpoint('L')) _this4._slideToggle();
          });
          this.$window.on('scroll.sticky-header', this._toggleStickyHeader);
        },
      },
      {
        key: '_stickyReset',
        value: function _stickyReset() {
          this.$siteMain.css('paddingTop', '');
        },
        /**
         * Determine the offset when breakpoints change
         *  - Offset is used to determine scroll threshold
         *  - Offset is used to set a body offset on browsers that don't support Sticky
         *
         * @param isInit
         * @private
         */
      },
      {
        key: '_stickyOffset',
        value: function _stickyOffset(isInit) {
          if (!this.$body.hasClass(this.stickyClass)) {
            this.$body.addClass(this.stickyClass);
          }
          var offset = getHeaderOffset(this.header);
          this.$siteMain.css('paddingTop', offset);
          if (isInit) {
            this._toggleStickyHeader();
          }
        },
        /**
         * Open or close the navigation
         *
         * @param open
         * @private
         */
      },
      {
        key: '_slideToggle',
        value: function _slideToggle() {
          var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          if (this.$el.hasClass(this.navOpenClass) && !open) {
            this.closeNavigation();
            this.$toggle.removeClass('active');
          } else {
            this.openNavigation();
            this.$toggle.addClass('active');
          }
        },
        /**
         *
         *
         * @param hide
         * @private
         */
      },
      {
        key: '_toggleAnnouncementBar',
        value: function _toggleAnnouncementBar() {
          var _this5 = this;
          var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          if (!this.$announcementBar.length) {
            return;
          }
          var top = 0;
          if (hide) {
            var mobileOnly = this.$announcementBar.hasClass('only-mobile');
            if ((layout.isBreakpoint('XS') && mobileOnly) || !mobileOnly) {
              top = this.$announcementBar.outerHeight() * -1;
            }
          }
          this.$el.css('top', top).one('trend', function () {
            _this5.$body.trigger('position-banners');
          });
        },
        /**
         * Sticky header only shows as sticky after scroll
         *
         * @private
         */
      },
      {
        key: '_toggleStickyHeader',
        value: function _toggleStickyHeader() {
          if (this.$body.hasClass('scroll-lock')) {
            return;
          }
          var scrollThreshold = getHeaderOffset(this.header) + 20; // Extend threshold 20px past header
          var shouldShrink = window.pageYOffset > scrollThreshold;
          // Sticky header is scrolled, is and is visible -- nothing more to do!
          if (shouldShrink && this.$body.hasClass(this.scrolledClass)) {
            return;
          }
          if (shouldShrink) {
            this._shrink();
            this._toggleAnnouncementBar(true);
          } else {
            this._expand();
            this._toggleAnnouncementBar(false);
          }
        },
      },
      {
        key: '_shrink',
        value: function _shrink() {
          var _this6 = this;
          this.closeNavigation();
          this.$toggle.removeClass('active');
          this.$el.revealer('show').one('revealer-animating.sticky-header', function () {
            _this6.$body.addClass(_this6.scrolledClass).one('trend', function () {
              _this6.$body.trigger('position-banners');
            });
          });
        },
      },
      {
        key: '_expand',
        value: function _expand() {
          var _this7 = this;
          this.openNavigation();
          this.$el
            .revealer('hide')
            .one('revealer-animating.sticky-header', function () {
              _this7.$body.removeClass(_this7.scrolledClass).one('trend', function () {
                _this7.$body.trigger('position-banners');
              });
            })
            .one('revealer-hide.sticky-header', function () {
              _this7.$toggle.removeClass('active');
            });
        },
      },
      {
        key: '_headerChecker',
        value: function _headerChecker() {
          // Periodically check to make sure header is offset correctly
          //this.requestAnimationFrameId = window.requestAnimationFrame(this._headerChecker);
          if (!this.$body.hasClass(this.scrolledClass)) {
            this._stickyOffset();
          }
        },
      },
    ]);
    return StickyHeader;
  })();
  var Accordion = (function () {
    function Accordion($el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      classCallCheck(this, Accordion);
      this.$el = $el;
      this.options = jQuery.extend(
        {},
        {
          activeClass: 'accordion--active',
          autoCollapse: false,
          content: '[data-accordion-content]',
          eligibleClass: 'has-accordion',
        },
        options
      );
    }
    createClass(Accordion, [
      {
        key: 'toggle',
        value: function toggle($block) {
          var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          if (open || !$block.hasClass(this.options.activeClass)) {
            if (this.options.autoCollapse) this.closeOpen();
            this._open($block);
          } else {
            this._close($block);
          }
        },
      },
      {
        key: 'closeOpen',
        value: function closeOpen() {
          var _this = this;
          jQuery(this.$el.find('.' + this.options.activeClass)).each(function (i, block) {
            var $block = jQuery(block);
            if ($block.hasClass(_this.options.activeClass)) {
              _this._close($block);
            }
          });
        },
      },
      {
        key: 'openAll',
        value: function openAll() {
          var _this2 = this;
          jQuery(this.$el.find('.' + this.options.eligibleClass)).each(function (i, block) {
            _this2._open(jQuery(block), 0);
          });
        },
      },
      {
        key: '_open',
        value: function _open($block) {
          $block.addClass(this.options.activeClass);
        },
      },
      {
        key: '_close',
        value: function _close($block) {
          $block.removeClass(this.options.activeClass);
        },
      },
    ]);
    return Accordion;
  })();
  var NavMobileSubMenus = (function () {
    function NavMobileSubMenus($el) {
      classCallCheck(this, NavMobileSubMenus);
      this.$el = $el;
      this.Accordion = new Accordion(this.$el, {
        activeClass: 'visible',
        content: '[data-accordion-content]',
      });
      // Sub menu selectors
      this.activeMenuClass = 'x-navmenu-link-parent-active';
      this.activeMenu = '.' + this.activeMenuClass;
      this.navTrigger = '[data-x-navmenu-trigger]';
      this.subMenu = '[data-x-navmenu-submenu]';
      this._bindEvents();
    }
    createClass(NavMobileSubMenus, [
      {
        key: 'unload',
        value: function unload() {
          this.$el.off('.mobile-nav');
          delete this.Accordion;
        },
      },
      {
        key: 'closeSubMenus',
        value: function closeSubMenus($current) {
          var _this = this;
          $current.find(this.activeMenu).each(function (index, el) {
            _this._closeSubmenu(jQuery(el));
          });
        },
      },
      {
        key: 'closeAllSubmenus',
        value: function closeAllSubmenus() {
          this.Accordion.closeOpen();
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this2 = this;
          // Prevent focus state from applying on mouse click
          this.$el.on('mousedown.mobile-nav', '.x-navmenu-link', function (event) {
            event.preventDefault();
          });
          this.$el.on('click.mobile-nav', this.navTrigger + ' > .x-navmenu-link-parent', function (event) {
            event.preventDefault();
            _this2._toggleSubmenu(event);
          });
        },
      },
      {
        key: '_selectSubMenu',
        value: function _selectSubMenu($target) {
          return $target.next(this.subMenu);
        },
      },
      {
        key: '_toggleSubmenu',
        value: function _toggleSubmenu(event) {
          var $target = jQuery(event.currentTarget);
          if ($target.hasClass(this.activeMenuClass)) {
            this._closeSubmenu($target);
          } else {
            this._openSubmenu($target);
          }
        },
      },
      {
        key: '_openSubmenu',
        value: function _openSubmenu($target) {
          var $menu = this._selectSubMenu($target);
          $target.addClass(this.activeMenuClass).attr('aria-expanded', true);
          this.Accordion.toggle($menu);
        },
      },
      {
        key: '_closeSubmenu',
        value: function _closeSubmenu($target) {
          var $menu = this._selectSubMenu($target);
          $target.removeClass(this.activeMenuClass).attr('aria-expanded', false);
          this.Accordion.toggle($menu);
          this.closeSubMenus($menu);
        },
      },
    ]);
    return NavMobileSubMenus;
  })();
  var NavMobile = (function () {
    function NavMobile(elements) {
      classCallCheck(this, NavMobile);
      this.$body = jQuery(document.body);
      this.$window = jQuery(window);
      this.$el = elements.$el;
      this.$toggleOpen = elements.$toggleOpen;
      this.isOpen = false;
      this.subMenus = null;
      this.$mobileNav = this.$el.find('[data-mobile-nav]');
      this.$panel = this.$el.find('[data-mobile-nav-panel]');
      this.$overlay = this.$el.find('[data-mobile-nav-overlay]');
      this.$toggleClose = this.$el.find('[data-mobile-nav-close]');
      // Revert navigation to original state on breakpoint change
      this.layoutHandler = this.onBreakpointChange.bind(this);
      layout.onBreakpointChange(this.layoutHandler);
      this._bindEvents();
    }
    createClass(NavMobile, [
      {
        key: 'unload',
        value: function unload() {
          this._close();
          this.$window.off('resize.mobile-nav');
          layout.offBreakpointChange(this.layoutHandler);
        },
      },
      {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
          if (layout.isBreakpoint('L') && this.isOpen) {
            this._close();
          }
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$toggleOpen.on('click.mobile-nav', function (event) {
            event.preventDefault();
            if (!layout.isBreakpoint('L')) _this._open();
          });
          this.$window.on('resize.mobile-nav', function () {
            _this.$el.find('[data-menu-toggle]').removeClass('active');
            if (_this.isOpen) {
              _this._setPanelHeight();
            }
          });
        },
      },
      {
        key: '_setPanelHeight',
        value: function _setPanelHeight() {
          this.$panel.height(window.innerHeight);
        },
      },
      {
        key: '_open',
        value: function _open() {
          var _this2 = this;
          this.$body.addClass('scroll-lock');
          this.isOpen = true;
          // Activate Submenu handler
          this.subMenus = new NavMobileSubMenus(this.$panel);
          this._setPanelHeight();
          // Animate in elements
          this.$mobileNav.addClass('animating animating-in').one('trend', function () {
            _this2.$mobileNav.removeClass('animating animating-in').addClass('visible').off('trend');
          });
          // Event handlers
          this.events = [
            // Close menu when clicking on the overlay
            this.$overlay.on('click.mobile-nav', function (event) {
              return _this2._close(event);
            }),
            this.$toggleClose.on('click.mobile-nav', function (event) {
              return _this2._close(event);
            }),
            // Disable scrolling on overlay and contactbar
            this.$overlay.on('touchmove.mobile-nav', function (event) {
              return event.preventDefault();
            }),
          ];
        },
      },
      {
        key: '_close',
        value: function _close() {
          var _this3 = this;
          var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          if (event) event.preventDefault();
          this.$mobileNav.addClass('animating animating-out').one('trend', function () {
            _this3.$mobileNav.removeClass('animating animating-out').removeClass('visible').off('trend');
          });
          this.$body.removeClass('scroll-lock');
          this.isOpen = false;
          // Close any open drop down menus
          if (this.subMenus) {
            this.subMenus.closeSubMenus(this.$el);
            this.subMenus.closeAllSubmenus();
            // Unbind Mobile sub menus
            this.subMenus.unload();
          }
          // Unbind events
          if (this.events) {
            this.events.forEach(function ($el) {
              return $el.off('.mobile-nav');
            });
            this.events = [];
          }
        },
      },
    ]);
    return NavMobile;
  })();
  function scrollLeft($el) {
    var $container = $el.parent();
    $container.animate({
      scrollLeft: $el.offset().left - $el.width() / 2 - $container.width() / 2,
    });
  }
  var MegaNavScroller = (function () {
    function MegaNavScroller($el) {
      var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      classCallCheck(this, MegaNavScroller);
      this.$el = $el;
      this.$menuList = this.$el.find('.x-navmenu-large-items');
      this._bindEvents();
      this._addScrollClasses();
      if (block) {
        scrollLeft(jQuery(block.el));
      }
    }
    createClass(MegaNavScroller, [
      {
        key: 'unload',
        value: function unload() {
          this.$menuList.off('.large');
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$menuList.on('scroll.large', function () {
            return _this._addScrollClasses();
          });
        },
      },
      {
        key: '_addScrollClasses',
        value: function _addScrollClasses() {
          var scrollLeft$$1 = this.$menuList.scrollLeft();
          var scrollWidth = this.$menuList[0].scrollWidth;
          var width = this.$menuList.width();
          this.$el.toggleClass('large--overflows-left', scrollLeft$$1 > 0);
          this.$el.toggleClass('large--overflows-right', scrollLeft$$1 < scrollWidth - width);
        },
      },
    ]);
    return MegaNavScroller;
  })();
  var NavDesktop = (function () {
    function NavDesktop(options) {
      var _this = this;
      classCallCheck(this, NavDesktop);
      this.$el = jQuery(options.$el);
      this.postMessage = options.postMessage;
      this.activeMenu = 'x-navmenu-active';
      this.activeItem = 'x-navmenu-item-active';
      this.navTrigger = '[data-x-navmenu-trigger]';
      this.subMenu = '[data-x-navmenu-submenu]';
      this.inlineChildren = 'x-navmenu-submenu-inline-children';
      this.events = [
        this.$el.on('mouseenter.x-navmenu', '.x-navmenu-item-parent', function () {
          _this.openItem(jQuery(this));
        }),
        this.$el.on('mouseleave.x-navmenu', '.x-navmenu-item-parent', function () {
          _this.closeItem(jQuery(this));
        }),
      ];
    }
    createClass(NavDesktop, [
      {
        key: 'unload',
        value: function unload() {
          this.events.forEach(function ($el) {
            return $el.off('.x-navmenu');
          });
          if (this.megaNav) {
            delete this.megaNav;
          }
        },
        /**
         * Open the MegaNav
         * @param $menu
         * @param block
         */
      },
      {
        key: 'openMegaNav',
        value: function openMegaNav($menu, block) {
          this.megaNav = new MegaNavScroller($menu, block);
        },
        /**
         * Open a dropdown menu, or scroll to a large item
         *
         * @param el - Parent LI containing sub menu
         * @param block - Meganav menu block
         */
      },
      {
        key: 'openItem',
        value: function openItem(el) {
          var _this2 = this;
          var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var $el = jQuery(el);
          // Check if menu is already open
          var $menu = $el.children(this.subMenu);
          if ($menu.is(':visible')) {
            // If its not a large, do nothing
            if ($menu.attr('data-large-menu') === undefined) return;
            // If its a large, scroll horizontally to the item
            scrollLeft(jQuery(block.el));
            return;
          }
          // Close previously opened items
          this.closeAll(el);
          $el.data('transitioning', true);
          var $parent = $menu.parent(this.navTrigger);
          // Add an active class to the menu's parent
          $parent.find('.x-navmenu-link-parent:first').addClass(this.activeMenu);
          // Show menu
          $menu.addClass('animating animating-in').one('trend', function () {
            $menu.removeClass('animating animating-in').addClass('visible').off('trend');
            _this2._inlineMenu($menu);
            $el.data('transitioning', false);
            $parent.find('> .x-navmenu-link').attr('aria-expanded', true);
            // Load MegaNavScroller if is a mega nav
            if ($menu.attr('data-large-menu') !== undefined) {
              _this2.openMegaNav($menu, block);
            }
          });
        },
      },
      {
        key: 'closeAll',
        value: function closeAll(target) {
          var _this3 = this;
          this.$el
            .find(this.subMenu + '.visible, ' + this.subMenu + '.animating-in')
            .parent(this.navTrigger)
            .each(function (i, el) {
              if (target && jQuery.contains(el, target)) return;
              // Close any submenus in this tree
              jQuery(el)
                .find(_this3.navTrigger)
                .each(function (i, submenu) {
                  return _this3.closeItem(submenu);
                });
              // Close root-level menu item
              _this3.closeItem(el);
            });
        },
      },
      {
        key: 'closeItem',
        value: function closeItem(el) {
          var _this4 = this;
          var $el = jQuery(el);
          var $menu = $el.children(this.subMenu + '.visible, ' + this.subMenu + '.animating-in');
          var $parent = $menu.parent(this.navTrigger);
          if (!$menu.length) return;
          // Menu is in the progress of being animated, try in 300ms
          if ($el.data('transitioning')) {
            setTimeout(function () {
              return _this4.closeItem(el);
            }, 300);
          }
          // Add an active class to the menu's parent
          $parent.find('.x-navmenu-link-parent:first').removeClass(this.activeMenu);
          // Ensure $menu is scrolled to top
          if ($menu.hasClass(this.inlineChildren)) {
            $menu.scrollTop(0);
          }
          // Hide menu
          $menu
            .addClass('animating animating-out')
            .removeClass('animating-in')
            .one('trend', function () {
              $menu.removeClass('animating animating-out visible').off('trend');
              $parent.find('> .x-navmenu-link').attr('aria-expanded', false);
              // Unload MegaNavScroller if is a mega-nav
              if ($menu.data('large-menu') !== undefined && _this4.megaNav) {
                _this4.megaNav.unload();
                _this4.megaNav = null;
              }
            });
        },
      },
      {
        key: 'toggleItem',
        value: function toggleItem(el) {
          var $el = jQuery(el);
          var $menu = $el.children(this.subMenu);
          if ($menu.is(':visible')) {
            this.closeItem(el);
          } else {
            this.openItem(el);
          }
        },
      },
      {
        key: '_handleDocumentClick',
        value: function _handleDocumentClick(target) {
          var $parent = jQuery(target).parents(this.navTrigger);
          if ($parent.length) return;
          this.closeAll();
        },
      },
      {
        key: '_menuLimits',
        value: function _menuLimits($menu) {
          var windowHeight = window.innerHeight;
          var windowWidth = window.innerWidth;
          var menuRect = $menu[0].getBoundingClientRect();
          var hasChildren = $menu.find(this.subMenu).length > 0;
          var stickyHeaderOffset = jQuery('.x-head-sticky--scrolled').length ? 20 : 0; // Padding difference
          var edges = {
            bottomEdge: menuRect.bottom + stickyHeaderOffset,
            rightEdge: menuRect.right + menuRect.width,
          };
          // Store bottom offset for subsequent openings
          if (!$menu.data('bottom-edge') || $menu.data('bottom-edge') !== edges.bottomEdge) {
            $menu.data('bottom-edge', edges.bottomEdge);
          }
          // Store child menu right edge
          if (!$menu.data('right-edge') || $menu.data('right-edge') !== edges.rightEdge) {
            $menu.data('right-edge', edges.rightEdge);
          }
          var bottomEdge = parseInt($menu.data('bottom-edge'), 10);
          var rightEdge = parseInt($menu.data('right-edge'), 10);
          return {
            childrenExceedHorizontal: rightEdge >= windowWidth && hasChildren,
            exceedsVertical: bottomEdge >= windowHeight,
            maxHeight: windowHeight - menuRect.top,
          };
        },
        /**
         * Set a menu to be
         */
      },
      {
        key: '_inlineMenu',
        value: function _inlineMenu($menu) {
          var _menuLimits2 = this._menuLimits($menu),
            childrenExceedHorizontal = _menuLimits2.childrenExceedHorizontal,
            exceedsVertical = _menuLimits2.exceedsVertical,
            maxHeight = _menuLimits2.maxHeight;
          // Unset inline style if height allows, and children menu don't exceed window bounds
          if (!exceedsVertical && !childrenExceedHorizontal) {
            return this._unsetInlineMenu($menu);
          }
          return $menu.css({ maxHeight: maxHeight }).addClass(this.inlineChildren);
        },
      },
      {
        key: '_unsetInlineMenu',
        value: function _unsetInlineMenu($menu) {
          $menu.removeAttr('data-bottom-edge').removeAttr('data-right-edge').removeClass(this.inlineChildren).css('max-height', '');
        },
      },
    ]);
    return NavDesktop;
  })();
  var justDebounce$1 = debounce;
  function debounce(fn, delay, at_start, guarantee) {
    var timeout;
    var args;
    var self;
    return function debounced() {
      self = this;
      args = Array.prototype.slice.call(arguments);
      if (timeout && (at_start || guarantee)) {
        return;
      } else if (!at_start) {
        clear();
        timeout = setTimeout(run, delay);
        return timeout;
      }
      timeout = setTimeout(clear, delay);
      fn.apply(self, args);
      function run() {
        clear();
        fn.apply(self, args);
      }
      function clear() {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  }
  var eventemitter2 = createCommonjsModule(function (module, exports) {
    /**
     * EventEmitter2
     * https://github.com/hij1nx/EventEmitter2
     *
     * Copyright (c) 2013 hij1nx
     * Licensed under the MIT license.
     */
    !(function (undefined) {
      var isArray = Array.isArray
        ? Array.isArray
        : function _isArray(obj) {
          return Object.prototype.toString.call(obj) === '[object Array]';
        };
      var defaultMaxListeners = 10;
      function init() {
        this._events = {};
        if (this._conf) {
          configure.call(this, this._conf);
        }
      }
      function configure(conf) {
        if (conf) {
          this._conf = conf;
          conf.delimiter && (this.delimiter = conf.delimiter);
          this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
          conf.wildcard && (this.wildcard = conf.wildcard);
          conf.newListener && (this.newListener = conf.newListener);
          conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
          if (this.wildcard) {
            this.listenerTree = {};
          }
        } else {
          this._events.maxListeners = defaultMaxListeners;
        }
      }
      function logPossibleMemoryLeak(count, eventName) {
        var errorMsg =
          '(node) warning: possible EventEmitter memory ' +
          'leak detected. %d listeners added. ' +
          'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) {
          errorMsg += ' Event name: %s.';
          console.error(errorMsg, count, eventName);
        } else {
          console.error(errorMsg, count);
        }
        if (console.trace) {
          console.trace();
        }
      }
      function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
      }
      EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
      //
      // Attention, function return type now is array, always !
      // It has zero elements if no any matches found and one or more
      // elements (leafs) if there are matches
      //
      function searchListenerTree(handlers, type, tree, i) {
        if (!tree) {
          return [];
        }
        var listeners = [],
          leaf,
          len,
          branch,
          xTree,
          xxTree,
          isolatedBranch,
          endReached,
          typeLength = type.length,
          currentType = type[i],
          nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
          //
          // If at the end of the event(s) list and the tree has listeners
          // invoke those listeners.
          //
          if (typeof tree._listeners === 'function') {
            handlers && handlers.push(tree._listeners);
            return [tree];
          } else {
            for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
              handlers && handlers.push(tree._listeners[leaf]);
            }
            return [tree];
          }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
          //
          // If the event emitted is '*' at this part
          // or there is a concrete match at this patch
          //
          if (currentType === '*') {
            for (branch in tree) {
              if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
              }
            }
            return listeners;
          } else if (currentType === '**') {
            endReached = i + 1 === typeLength || (i + 2 === typeLength && nextType === '*');
            if (endReached && tree._listeners) {
              // The next element has a _listeners, add it to the handlers.
              listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
            }
            for (branch in tree) {
              if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                if (branch === '*' || branch === '**') {
                  if (tree[branch]._listeners && !endReached) {
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                  }
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                } else if (branch === nextType) {
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                } else {
                  // No match on this one, shift into the tree but not in the type array.
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
              }
            }
            return listeners;
          }
          listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) {
          //
          // If the listener tree will allow any match for this part,
          // then recursively explore all branches of the tree
          //
          searchListenerTree(handlers, type, xTree, i + 1);
        }
        xxTree = tree['**'];
        if (xxTree) {
          if (i < typeLength) {
            if (xxTree._listeners) {
              // If we have a listener on a '**', it will catch all, so add its handler.
              searchListenerTree(handlers, type, xxTree, typeLength);
            }
            // Build arrays of matching next branches and others.
            for (branch in xxTree) {
              if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                if (branch === nextType) {
                  // We know the next element will match, so jump twice.
                  searchListenerTree(handlers, type, xxTree[branch], i + 2);
                } else if (branch === currentType) {
                  // Current node matches, move into the tree.
                  searchListenerTree(handlers, type, xxTree[branch], i + 1);
                } else {
                  isolatedBranch = {};
                  isolatedBranch[branch] = xxTree[branch];
                  searchListenerTree(handlers, type, { '**': isolatedBranch }, i + 1);
                }
              }
            }
          } else if (xxTree._listeners) {
            // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
          } else if (xxTree['*'] && xxTree['*']._listeners) {
            searchListenerTree(handlers, type, xxTree['*'], typeLength);
          }
        }
        return listeners;
      }
      function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for (var i = 0, len = type.length; i + 1 < len; i++) {
          if (type[i] === '**' && type[i + 1] === '**') {
            return;
          }
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while (name !== undefined) {
          if (!tree[name]) {
            tree[name] = {};
          }
          tree = tree[name];
          if (type.length === 0) {
            if (!tree._listeners) {
              tree._listeners = listener;
            } else {
              if (typeof tree._listeners === 'function') {
                tree._listeners = [tree._listeners];
              }
              tree._listeners.push(listener);
              if (!tree._listeners.warned && this._events.maxListeners > 0 && tree._listeners.length > this._events.maxListeners) {
                tree._listeners.warned = true;
                logPossibleMemoryLeak.call(this, tree._listeners.length, name);
              }
            }
            return true;
          }
          name = type.shift();
        }
        return true;
      }
      // By default EventEmitters will print a warning if more than
      // 10 listeners are added to it. This is a useful default which
      // helps finding memory leaks.
      //
      // Obviously not all Emitters should be limited to 10. This function allows
      // that to be increased. Set to zero for unlimited.
      EventEmitter.prototype.delimiter = '.';
      EventEmitter.prototype.setMaxListeners = function (n) {
        if (n !== undefined) {
          this._events || init.call(this);
          this._events.maxListeners = n;
          if (!this._conf) this._conf = {};
          this._conf.maxListeners = n;
        }
      };
      EventEmitter.prototype.event = '';
      EventEmitter.prototype.once = function (event, fn) {
        this.many(event, 1, fn);
        return this;
      };
      EventEmitter.prototype.many = function (event, ttl, fn) {
        var self = this;
        if (typeof fn !== 'function') {
          throw new Error('many only accepts instances of Function');
        }
        function listener() {
          if (--ttl === 0) {
            self.off(event, listener);
          }
          return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this.on(event, listener);
        return self;
      };
      EventEmitter.prototype.emit = function () {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
          if (!this._events.newListener) {
            return false;
          }
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
          handler = this._all.slice();
          if (al > 3) {
            args = new Array(al);
            for (j = 0; j < al; j++) args[j] = arguments[j];
          }
          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
              case 1:
                handler[i].call(this, type);
                break;
              case 2:
                handler[i].call(this, type, arguments[1]);
                break;
              case 3:
                handler[i].call(this, type, arguments[1], arguments[2]);
                break;
              default:
                handler[i].apply(this, args);
            }
          }
        }
        if (this.wildcard) {
          handler = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
          handler = this._events[type];
          if (typeof handler === 'function') {
            this.event = type;
            switch (al) {
              case 1:
                handler.call(this);
                break;
              case 2:
                handler.call(this, arguments[1]);
                break;
              case 3:
                handler.call(this, arguments[1], arguments[2]);
                break;
              default:
                args = new Array(al - 1);
                for (j = 1; j < al; j++) args[j - 1] = arguments[j];
                handler.apply(this, args);
            }
            return true;
          } else if (handler) {
            // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
          }
        }
        if (handler && handler.length) {
          if (al > 3) {
            args = new Array(al - 1);
            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          }
          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
              case 1:
                handler[i].call(this);
                break;
              case 2:
                handler[i].call(this, arguments[1]);
                break;
              case 3:
                handler[i].call(this, arguments[1], arguments[2]);
                break;
              default:
                handler[i].apply(this, args);
            }
          }
          return true;
        } else if (!this._all && type === 'error') {
          if (arguments[1] instanceof Error) {
            throw arguments[1]; // Unhandled 'error' event
          } else {
            throw new Error("Uncaught, unspecified 'error' event.");
          }
          return false;
        }
        return !!this._all;
      };
      EventEmitter.prototype.emitAsync = function () {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
          if (!this._events.newListener) {
            return Promise.resolve([false]);
          }
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
          if (al > 3) {
            args = new Array(al);
            for (j = 1; j < al; j++) args[j] = arguments[j];
          }
          for (i = 0, l = this._all.length; i < l; i++) {
            this.event = type;
            switch (al) {
              case 1:
                promises.push(this._all[i].call(this, type));
                break;
              case 2:
                promises.push(this._all[i].call(this, type, arguments[1]));
                break;
              case 3:
                promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                break;
              default:
                promises.push(this._all[i].apply(this, args));
            }
          }
        }
        if (this.wildcard) {
          handler = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
          handler = this._events[type];
        }
        if (typeof handler === 'function') {
          this.event = type;
          switch (al) {
            case 1:
              promises.push(handler.call(this));
              break;
            case 2:
              promises.push(handler.call(this, arguments[1]));
              break;
            case 3:
              promises.push(handler.call(this, arguments[1], arguments[2]));
              break;
            default:
              args = new Array(al - 1);
              for (j = 1; j < al; j++) args[j - 1] = arguments[j];
              promises.push(handler.apply(this, args));
          }
        } else if (handler && handler.length) {
          handler = handler.slice();
          if (al > 3) {
            args = new Array(al - 1);
            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          }
          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
              case 1:
                promises.push(handler[i].call(this));
                break;
              case 2:
                promises.push(handler[i].call(this, arguments[1]));
                break;
              case 3:
                promises.push(handler[i].call(this, arguments[1], arguments[2]));
                break;
              default:
                promises.push(handler[i].apply(this, args));
            }
          }
        } else if (!this._all && type === 'error') {
          if (arguments[1] instanceof Error) {
            return Promise.reject(arguments[1]); // Unhandled 'error' event
          } else {
            return Promise.reject("Uncaught, unspecified 'error' event.");
          }
        }
        return Promise.all(promises);
      };
      EventEmitter.prototype.on = function (type, listener) {
        if (typeof type === 'function') {
          this.onAny(type);
          return this;
        }
        if (typeof listener !== 'function') {
          throw new Error('on only accepts instances of Function');
        }
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
          growListenerTree.call(this, type, listener);
          return this;
        }
        if (!this._events[type]) {
          // Optimize the case of one listener. Don't need the extra array object.
          this._events[type] = listener;
        } else {
          if (typeof this._events[type] === 'function') {
            // Change to array.
            this._events[type] = [this._events[type]];
          }
          // If we've already got an array, just append.
          this._events[type].push(listener);
          // Check for listener leak
          if (!this._events[type].warned && this._events.maxListeners > 0 && this._events[type].length > this._events.maxListeners) {
            this._events[type].warned = true;
            logPossibleMemoryLeak.call(this, this._events[type].length, type);
          }
        }
        return this;
      };
      EventEmitter.prototype.onAny = function (fn) {
        if (typeof fn !== 'function') {
          throw new Error('onAny only accepts instances of Function');
        }
        if (!this._all) {
          this._all = [];
        }
        // Add the function to the event listener collection.
        this._all.push(fn);
        return this;
      };
      EventEmitter.prototype.addListener = EventEmitter.prototype.on;
      EventEmitter.prototype.off = function (type, listener) {
        if (typeof listener !== 'function') {
          throw new Error('removeListener only takes instances of Function');
        }
        var handlers,
          leafs = [];
        if (this.wildcard) {
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
          // does not use listeners(), so no side effect of creating _events[type]
          if (!this._events[type]) return this;
          handlers = this._events[type];
          leafs.push({ _listeners: handlers });
        }
        for (var iLeaf = 0; iLeaf < leafs.length; iLeaf++) {
          var leaf = leafs[iLeaf];
          handlers = leaf._listeners;
          if (isArray(handlers)) {
            var position = -1;
            for (var i = 0, length = handlers.length; i < length; i++) {
              if (
                handlers[i] === listener ||
                (handlers[i].listener && handlers[i].listener === listener) ||
                (handlers[i]._origin && handlers[i]._origin === listener)
              ) {
                position = i;
                break;
              }
            }
            if (position < 0) {
              continue;
            }
            if (this.wildcard) {
              leaf._listeners.splice(position, 1);
            } else {
              this._events[type].splice(position, 1);
            }
            if (handlers.length === 0) {
              if (this.wildcard) {
                delete leaf._listeners;
              } else {
                delete this._events[type];
              }
            }
            this.emit('removeListener', type, listener);
            return this;
          } else if (
            handlers === listener ||
            (handlers.listener && handlers.listener === listener) ||
            (handlers._origin && handlers._origin === listener)
          ) {
            if (this.wildcard) {
              delete leaf._listeners;
            } else {
              delete this._events[type];
            }
            this.emit('removeListener', type, listener);
          }
        }
        function recursivelyGarbageCollect(root) {
          if (root === undefined) {
            return;
          }
          var keys = Object.keys(root);
          for (var i in keys) {
            var key = keys[i];
            var obj = root[key];
            if (obj instanceof Function || typeof obj !== 'object' || obj === null) continue;
            if (Object.keys(obj).length > 0) {
              recursivelyGarbageCollect(root[key]);
            }
            if (Object.keys(obj).length === 0) {
              delete root[key];
            }
          }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
      };
      EventEmitter.prototype.offAny = function (fn) {
        var i = 0,
          l = 0,
          fns;
        if (fn && this._all && this._all.length > 0) {
          fns = this._all;
          for (i = 0, l = fns.length; i < l; i++) {
            if (fn === fns[i]) {
              fns.splice(i, 1);
              this.emit('removeListenerAny', fn);
              return this;
            }
          }
        } else {
          fns = this._all;
          for (i = 0, l = fns.length; i < l; i++) this.emit('removeListenerAny', fns[i]);
          this._all = [];
        }
        return this;
      };
      EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
      EventEmitter.prototype.removeAllListeners = function (type) {
        if (arguments.length === 0) {
          !this._events || init.call(this);
          return this;
        }
        if (this.wildcard) {
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
          for (var iLeaf = 0; iLeaf < leafs.length; iLeaf++) {
            var leaf = leafs[iLeaf];
            leaf._listeners = null;
          }
        } else if (this._events) {
          this._events[type] = null;
        }
        return this;
      };
      EventEmitter.prototype.listeners = function (type) {
        if (this.wildcard) {
          var handlers = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
          return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) {
          this._events[type] = [this._events[type]];
        }
        return this._events[type];
      };
      EventEmitter.prototype.listenerCount = function (type) {
        return this.listeners(type).length;
      };
      EventEmitter.prototype.listenersAny = function () {
        if (this._all) {
          return this._all;
        } else {
          return [];
        }
      };
      if (typeof undefined === 'function' && undefined.amd) {
        // AMD. Register as an anonymous module.
        undefined(function () {
          return EventEmitter;
        });
      } else {
        // CommonJS
        module.exports = EventEmitter;
      }
    })();
  });
  /**
   * Search API Class
   */
  var Search = (function (_EventEmitter) {
    inherits(Search, _EventEmitter);
    /**
     * Create a new Search instance, and override defaults
     *
     * @param options
     * @property {string} options.type - Search restriction. Use 'article', 'page', 'product', or ''
     * @property {string} options.view - Search template suffix. Specify different templates as needed
     */
    function Search() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, Search);
      var _this = possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));
      _this.searchType = options.type || '';
      _this.view = options.view || 'json';
      _this.inProgress = false;
      _this.xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      _this._xhrLoad = _this._xhrLoad.bind(_this);
      _this._xhrError = _this._xhrError.bind(_this);
      _this._xhrAbort = _this._xhrAbort.bind(_this);
      _this._bindEvents();
      return _this;
    }
    createClass(Search, [
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          this.xhr.addEventListener('load', this._xhrLoad);
          this.xhr.addEventListener('error', this._xhrError);
          this.xhr.addEventListener('abort', this._xhrAbort);
        },
        /**
         * XHR was successfull
         *
         * @description XHR completed successfully
         * @param {object} event
         * @fires Search#complete
         * @private
         */
      },
      {
        key: '_xhrLoad',
        value: function _xhrLoad(event) {
          var response = {};
          var readyState = event.target.readyState;
          var status = event.target.status;
          try {
            if (readyState > 3 && status == 200) {
              response = JSON.parse(event.target.responseText);
              this.emit('complete', response);
            } else {
              var message = 'Invalid readyState: ' + readyState + ', or status: ' + status + '.';
              return this._xhrError(event, message);
            }
          } catch (error) {
            return this._xhrError(event, 'Invalid JSON', error);
          }
          this.inProgress = false;
        },
        /**
         * XHR contains an error
         *
         * @description XHR has contained an error, and was unable to complete
         * @param {object} event
         * @param {object|string} message
         * @param {object} error
         * @fires Search#error
         * @private
         */
      },
      {
        key: '_xhrError',
        value: function _xhrError(event) {
          var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          this.inProgress = false;
          this.emit('error', { event: event, message: message, error: error });
        },
        /**
         * XHR has been aborted
         *
         * @description This event only fires if there is an active XHR request that has been terminated
         * @fires Search#aborted
         * @private
         */
      },
      {
        key: '_xhrAbort',
        value: function _xhrAbort() {
          this.emit('aborted');
        },
        /**
         * Perform the search
         *
         * @param {string} term - Search term(s)
         * @fires Search#initialized
         * @fires Search#cancelled
         */
      },
      {
        key: 'execute',
        value: function execute(term) {
          this.emit('initialized', { term: term });
          if (this.inProgress) {
            this.emit('cancelled');
            this.xhr.abort();
          }
          this.inProgress = true;
          var url = '/search';
          var params = {
            q: term,
            type: this.searchType,
            view: this.view,
          };
          var searchParams = Object.keys(params)
            .map(function (key) {
              var value = params[key];
              return encodeURIComponent(key) + '=' + encodeURIComponent(value);
            })
            .join('&');
          this.xhr.open('get', url + '?' + searchParams);
          this.xhr.setRequestHeader('Accept', 'application/json');
          this.xhr.send();
        },
      },
    ]);
    return Search;
  })(eventemitter2);
  var SearchForm = (function () {
    function SearchForm($container) {
      classCallCheck(this, SearchForm);
      this.$body = jQuery('body');
      this.$container = $container;
      this.$form = this.$container.find('[data-x-search-form]');
      this.submitHandler = this.submitHandler.bind(this);
      this.events = [this.$form.on('submit.search-form', this.submitHandler)];
    }
    createClass(SearchForm, [
      {
        key: 'unload',
        value: function unload() {
          this.events.forEach(function ($el) {
            return $el.off('.search-form');
          });
        },
      },
      {
        key: 'submitHandler',
        value: function submitHandler(event) {
          event.preventDefault();
          var $form = jQuery(event.currentTarget).clone();
          var $terms = $form.find('[name=q]');
          $form.css({
            position: 'absolute',
            left: -1000,
            bottom: -1000,
            visibility: 'hidden',
          });
          var terms = $terms.val();
          // Adds `*` after each word in search terms, doesn't add to last word
          if (terms.indexOf(' ') > 0) {
            terms = terms.split(' ').join('* ').trim();
          }
          // Adds `*` at the end of the search terms
          terms = terms + '*';
          // Update value
          $terms.val(terms);
          if (window.Rockrooster) {
            window.Rockrooster.report('search');
          }
          // Forms must be in the browser context in order to submit
          this.$body.append($form);
          $form.submit();
        },
      },
    ]);
    return SearchForm;
  })();
  /**
   * Shows a list item component when result is an article, or a page
   *
   * @param contentItem
   * @returns {string}
   * @constructor
   */
  function ContentItem(contentItem) {
    return (
      '\n  <li class="x-search-down--content-item">\n    <a href="' + contentItem.url + '">' + contentItem.title + '</a>\n  </li>\n  '
    );
  }
  /**
   * Shows a header for the article and page results
   *
   * @param context
   * @returns {string}
   * @constructor
   */
  function ContentResultsHeader(context) {
    return '\n    <h5 class="x-search-down--content-title">\n      ' + context.content_results.title + '\n    </h5>  \n  ';
  }
  /**
   * Shows a list of results from articles, or pages
   *
   * @param props
   * @returns {jQuery|HTMLElement}
   * @constructor
   */
  function ContentResults(props) {
    var content = props.content,
      context = props.context;
    var $title = ContentResultsHeader(context);
    var contentItems = content.map(function (contentItem) {
      return ContentItem(contentItem);
    });
    return $(
      '\n    <div class="x-search-down--content-items">\n      ' +
      $title +
      '\n      \n      <ul class="x-search-down--content-items-list">\n        ' +
      contentItems.join('') +
      '\n      </ul>\n    </div>\n  '
    );
  }
  /**
   * Shows a message when there are no article or page results
   *
   * @param props
   * @returns {jQuery|HTMLElement}
   * @constructor
   */
  function ContentNoResults(props) {
    var context = props.context;
    var $title = ContentResultsHeader(context);
    return $(
      '\n    <div class="x-search-down--content-items">\n      ' +
      $title +
      '\n      \n      <p class="x-search-down--content-items-none">\n        ' +
      context.content_results.no_results +
      '\n      </p>\n    </div>\n  '
    );
  }
  /**
   * Shows the product's compare_at_price, with connection for CurrencyConverter
   *
   * @param price
   * @returns {string}
   * @constructor
   */
  function ProductPriceCompareAt(price) {
    return (
      '\n  <span class="x-search-down--product-price--compare-at">\n    <span class="money">' +
      price.compare_at_price +
      '</span>\n  </span>\n  '
    );
  }
  /**
   * Shows the product's price, with connection for CurrencyConverter
   *
   * @param price
   * @returns {string}
   * @constructor
   */
  function ProductPriceMain(price) {
    return '\n  <span class="x-search-down--product-price--main">\n    <span class="money">' + price.price + '</span>\n  </span>\n  ';
  }
  /**
   * Shows the product's prices
   *
   * @param props
   * @returns {string}
   * @constructor
   */
  function ProductPrice(props) {
    var price = props.price,
      onSale = props.onSale,
      consistentSaved = props.consistentSaved;
    var $compareAt = onSale && consistentSaved ? ProductPriceCompareAt(price) : '';
    var $price = ProductPriceMain(price);
    return (
      '\n    <span class="x-search-down--product-price ' +
      (onSale ? 'x-search-down--product-price-has-sale' : '') +
      '">\n      ' +
      $price +
      '\n      ' +
      $compareAt +
      '\n    </span>\n  '
    );
  }
  /**
   * Shows a product's main content
   *
   * @param product
   * @returns {string}
   * @constructor
   */
  function ProductContent(product) {
    var $price = ProductPrice({
      price: product.price,
      onSale: product.on_sale,
      consistentSaved: product.consistent_saved,
    });
    return (
      '\n    <div class="x-search-down--product-text">\n      <span class="x-search-down--product-title">\n        ' +
      product.title +
      '\n      </span>\n      ' +
      $price +
      '\n    </div>\n  '
    );
  }
  /**
   * Shows a product's image
   *
   * @param image
   * @returns {string}
   * @constructor
   */
  function ProductImage(image) {
    return '\n    <div class="x-search-down--product-image">\n      ' + image + '\n    </div>\n  ';
  }
  /**
   * Shows a product list item component when result is a product
   *
   * @param product
   * @param enableImages
   * @returns {string}
   * @constructor
   */
  function ProductItem(product, enableImages) {
    var $image = enableImages ? ProductImage(product.image) : '';
    var $content = ProductContent(product);
    return (
      '\n    <a class="x-search-down--product x-search-down--product" href="' +
      product.url +
      '">\n      ' +
      $image +
      '\n      ' +
      $content +
      '\n    </a>\n  '
    );
  }
  /**
   * Shows a list of product results
   *
   * @param props
   * @returns {jQuery|HTMLElement}
   * @constructor
   */
  function ProductResults(props) {
    var products = props.products,
      enableImages = props.enableImages;
    var productItems = products.map(function (product) {
      return ProductItem(product, enableImages);
    });
    return $('\n    <div class="x-search-down--product-items">\n      ' + productItems.join('') + '\n    </div>\n  ');
  }
  /**
   * Show a message when no product results are found
   *
   * @param props
   * @returns {jQuery|HTMLElement}
   * @constructor
   */
  function ProductNoResults(props) {
    var context = props.context,
      terms = props.terms;
    return $(
      '\n    <div class="x-search-down--product-items--none" data-live-search-no-products>\n      <h5>\n        ' +
      context.no_results_products.title.replace('*terms*', terms) +
      '\n      </h5>\n      <p>\n        ' +
      context.no_results_products.message +
      '\n      </p>\n      <p>\n        <a class="x-search-down--continue" href="/collections/all">\n          ' +
      context.view_all_products +
      '\n        </a>\n      </p>\n    </div>\n  '
    );
  }
  /**
   * Show's the Results footer, directing customers to all products
   *
   * @param props
   * @returns {jQuery|HTMLElement}
   * @constructor
   */
  function ResultsFooter(props) {
    var context = props.context,
      terms = props.terms,
      type = props.type;
    return $(
      '\n    <div class="x-search-down--footer">\n      <a class="x-search-down--continue" href="/search?q=' +
      terms +
      '&type=' +
      type +
      '">\n        ' +
      context.view_all_results +
      '\n      </a>\n    </div>\n  '
    );
  }
  var LiveSearch = (function () {
    function LiveSearch($els, settings) {
      var _this = this;
      classCallCheck(this, LiveSearch);
      this.$el = $els.$el;
      this.$body = jQuery('body');
      this.$header = $els.$header;
      this.$document = jQuery(document);
      this.settings = settings;
      this.enableContent = this.settings.enable_content;
      this.enableImages = this.settings.enable_images;
      this.flyDownActive = false;
      this.takeOverActive = false;
      this.showFlyDown = false;
      this.searchType = this.enableContent ? 'article,page,product' : 'product';
      this.$form = this.$el.find('[data-x-search-form]');
      this.$input = this.$form.find('[data-live-search-input]');
      this.$button = this.$form.find('[data-live-search-submit]');
      this.$takeOverButton = this.$form.find('[data-live-search-takeover-cancel]');
      this.$flyDown = this.$el.find('[data-live-x-search-down]');
      this.$searchResults = this.$flyDown.find('[data-live-search-results]');
      this.$searchPlaceholder = this.$flyDown.find('[data-live-search-placeholder]');
      this.$quickLinks = this.$flyDown.find('[data-live-search-quick-links]');
      this.staticSearch = new SearchForm(this.$el);
      this.search = new Search({
        view: 'header',
        type: this.searchType,
      });
      this._search = this._search.bind(this);
      this._toggleTakeOver = this._toggleTakeOver.bind(this);
      this._searchFocused = this._searchFocused.bind(this);
      this._documentFocus = this._documentFocus.bind(this);
      this._searchCancelled = this._searchCancelled.bind(this);
      this._searchComplete = this._searchComplete.bind(this);
      this._searchError = this._searchError.bind(this);
      this.closeEvents = [];
      this.search.on('cancelled', this._searchCancelled);
      this.search.on('complete', this._searchComplete);
      this.search.on('error', this._searchError);
      this.events = [
        this.$button.on('click.live-search', function (event) {
          event.preventDefault();
          _this._search(event);
        }),
        this.$input.on('keyup.live-search', justDebounce$1(this._search, 250)),
        this.$input.on('focus.live-search', this._searchFocused),
        this.$takeOverButton.on('click.live-search', this._toggleTakeOver),
      ];
    }
    createClass(LiveSearch, [
      {
        key: 'unload',
        value: function unload() {
          this.events.forEach(function ($el) {
            return $el.off('.live-search');
          });
          this.search.off('cancelled', this._searchCancelled);
          this.search.off('complete', this._searchComplete);
          this.search.off('error', this._searchError);
          this.staticSearch.unload();
        },
        /**
         * If is searching, only show placeholder
         *
         * @private
         */
      },
      {
        key: '_flyDownSearching',
        value: function _flyDownSearching() {
          this.$searchResults.removeClass('visible');
          this.$quickLinks.removeClass('visible');
          this.$searchPlaceholder.addClass('visible');
        },
        /**
         * Search field has been focused, or has been cleared of contents
         *   - If previous search contents, show
         *   - If no previous search contents, show quicklinks if exists
         *
         * @param hasTerms
         * @private
         */
      },
      {
        key: '_flyDownInitial',
        value: function _flyDownInitial(hasTerms) {
          this.showFlyDown = false;
          var hasNoResults = this.$searchResults.find('[data-live-search-no-products]').length === 0;
          var hasPreviousResults = this.$searchResults.children().length > 0;
          if (hasTerms && hasNoResults && hasPreviousResults) {
            this.$searchResults.addClass('visible');
            this.$quickLinks.removeClass('visible');
            this.showFlyDown = true;
          } else if (this.$quickLinks.length) {
            this.$searchResults.removeClass('visible');
            this.$quickLinks.addClass('visible');
            this.showFlyDown = true;
          }
        },
      },
      {
        key: '_search',
        value: function _search(event) {
          // Ignore non character key strokes
          var invalidKeyStrokes = ['Alt', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Capslock', 'Control', 'Meta', 'Shift', 'Tab'];
          if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) {
            return;
          }
          var terms = this.$input.val();
          var hasTerms = terms.length > 0;
          // If is XS, pop the search out into a Takeover screen
          if (layout.isBreakpoint('XS')) {
            this._toggleTakeOver(null, true);
          }
          if (!hasTerms) {
            this._flyDownInitial(true);
            if (!this.showFlyDown) {
              this._closeFlyDown(true);
            }
            return;
          }
          this._flyDownSearching();
          // Clear previous results
          this.$searchResults.html('');
          // If terms has length, this will be true
          this._toggleButton(hasTerms);
          // Show the flyout if it isn't open
          if (!this.$flyDown.data('is-open')) {
            this.showFlyDown = true;
            this._openFlyDown();
          }
          // Adds `*` after each word in search terms, doesn't add to last word
          if (terms.indexOf(' ') > 0) {
            terms = terms.split(' ').join('* ').trim();
          }
          // Adds `*` at the end of the search terms
          terms = terms + '*';
          this.search.execute(terms);
        },
      },
      {
        key: '_searchError',
        value: function _searchError(response) {
          console.warn('Search had error');
          console.log(response.message, response.error, response.event);
          this._toggleButton(false);
        },
        /**
         * Search has been cancelled due to new search being performed
         *
         * @private
         */
      },
      {
        key: '_searchCancelled',
        value: function _searchCancelled() {
          // Searches are canceled on user interaction, UI should remain unchanged
        },
      },
      {
        key: '_searchComplete',
        value: function _searchComplete(response) {
          var _this2 = this;
          var content = response.content,
            products = response.products,
            terms = response.terms,
            sanitizedTerms = response.sanitizedTerms;
          var settings = {
            products: {
              results: {
                products: products,
                enableImages: this.enableImages,
              },
              noResults: {
                context: this.settings.context,
                terms: sanitizedTerms,
              },
            },
            content: {
              results: {
                context: this.settings.context,
                content: content,
              },
              noResults: {
                context: this.settings.context,
              },
            },
            footer: {
              context: this.settings.context,
              terms: terms,
              type: this.searchType,
            },
          };
          var $productResults = products.length ? ProductResults(settings.products.results) : ProductNoResults(settings.products.noResults);
          var $contentResults = content.length ? ContentResults(settings.content.results) : ContentNoResults(settings.content.noResults);
          $productResults.find('.money').each(function (i, el) {
            el.innerHTML = Shopify.formatMoney(el.innerHTML, _this2.settings.money_format);
            dist$2.update(el);
          });
          // Hide placeholder
          // TODO: Lock minimum height?
          this.$searchPlaceholder.removeClass('visible');
          // Show results
          this.$searchResults.html($productResults).addClass('visible');
          if (this.enableContent) {
            this.$searchResults.append($contentResults);
          }
          this.$searchResults.append(ResultsFooter(settings.footer));
          this._toggleButton(false);
        },
        /**
         * Toggles search button while processing
         *
         * @param disable
         * @private
         */
      },
      {
        key: '_toggleButton',
        value: function _toggleButton(disable) {
          if (disable) {
            this.$button.addClass('search-icon--processing').attr('disabled');
          } else {
            this.$button.removeClass('search-icon--processing').removeAttr('disabled');
          }
        },
      },
      {
        key: '_searchFocused',
        value: function _searchFocused() {
          if (this.flyDownActive) {
            return;
          }
          var hasTerms = this.$input.val().length > 0;
          // Only listen for events outside of the search down when its open
          this.closeEvents.concat([
            this.$header.on('focus.live-search', 'a, button', this._documentFocus),
            this.$document.on('touchstart.live-search', this._documentFocus),
            this.$document.on('click.live-search', this._documentFocus),
          ]);
          this.$el.addClass('live-search--focused');
          // If is XS, pop the search out into a Takeover screen
          if (layout.isBreakpoint('XS')) {
            this._toggleTakeOver(null, true);
          }
          this._flyDownInitial(hasTerms);
          this._openFlyDown();
        },
      },
      {
        key: '_openFlyDown',
        value: function _openFlyDown() {
          if (!this.showFlyDown) {
            return;
          }
          this.$el.addClass('live-search--active');
          this.$flyDown.data('is-open', true);
          this.flyDownActive = true;
        },
        /**
         * Close the FlyDown when no longer needed
         *  - Keep focus styling if input is still being interacted with
         *
         * @param retainFocus
         * @private
         */
      },
      {
        key: '_closeFlyDown',
        value: function _closeFlyDown() {
          var retainFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          if (!this.flyDownActive) {
            if (!retainFocus) {
              this.$el.removeClass('live-search--focused');
            }
            return;
          }
          if (this.takeOverActive) {
            this._toggleTakeOver(null, false);
          }
          this.$flyDown.data('is-open', false);
          this.$el.removeClass('live-search--active');
          if (!retainFocus) {
            this.$el.removeClass('live-search--focused');
          }
          this.flyDownActive = false;
          this.closeEvents.forEach(function ($el) {
            return $el.off('.live-search');
          });
          this.closeEvents = [];
        },
        /**
         * Open or close the Take over for mobile
         *
         *
         * @param event
         * @param enable
         * @private
         */
      },
      {
        key: '_toggleTakeOver',
        value: function _toggleTakeOver() {
          var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          this.takeOverActive = enable;
          if (event) {
            event.preventDefault();
          }
          if (!enable) {
            this._closeFlyDown(false);
          }
          if (this.$header.hasClass('search--section')) {
            this.$body.toggleClass('search-takeover-active', enable);
          }
          this.$el.toggleClass('live-search--takeover', enable);
          this.$body.toggleClass('scroll-lock', enable);
        },
        /**
         * When the focus element has changed, either by clicking, touching, or tabbing
         * check to see if it is within the down
         *
         * @param event
         * @private
         */
      },
      {
        key: '_documentFocus',
        value: function _documentFocus(event) {
          var $parent = jQuery(event.target).parents('[data-live-search]');
          if ($parent.length) {
            return;
          }
          this._closeFlyDown();
        },
      },
    ]);
    return LiveSearch;
  })();
  var XSectionHeader = (function () {
    function XSectionHeader(section) {
      var _this = this;
      classCallCheck(this, XSectionHeader);
      this.$el = jQuery(section.el);
      this.settings = section.data.settings;
      this.currency = section.data.currency;
      this.postMessage = section.postMessage;
      this.headerSearch = null;
      this.$scripts = jQuery('[data-scripts]');
      this.$menuToggle = this.$el.find('[data-menu-toggle]');
      this.$cartCount = this.$el.find('[data-header-cart-count]');
      this.$searchField = this.$el.find('[data-live-search]');
      this.$siteNavigation = this.$el.find('[data-x-navigation]');
      this.$desktopNavigation = this.$siteNavigation.find('ul.x-navmenu-depth-1');
      this.$headerTools = this.$siteNavigation.find('[data-header-actions]');
      this.converter = '[data-currency-converter]';
      this.$converter = jQuery(this.converter);
      this.stickyHeader = new StickyHeader(
        {
          $el: this.$el,
          $toggle: this.$menuToggle,
          postMessage: this.postMessage,
        },
        this.settings
      );
      this.navMobile = new NavMobile({
        $el: this.$el,
        $toggleOpen: this.$menuToggle,
      });
      this.navDesktop = new NavDesktop({
        $el: this.$siteNavigation,
        postMessage: this.postMessage,
      });
      this.forms = new Forms(this.$el);
      if (this.settings.live_search.enable) {
        script$1(this.$scripts.data('shopify-api-url'), function () {
          _this.headerSearch = new LiveSearch(
            {
              $el: _this.$searchField,
              $header: _this.$el,
            },
            _this.settings.live_search
          );
        });
      } else {
        this.headerSearch = new SearchForm(this.$searchField);
      }
      if (this.currency.enable) {
        script$1(this.$scripts.data('shopify-currencies'), function () {
          _this._converter();
        });
      }
      // Handle Accordion interaction when window size changes
      this._headerToolsSize = this._headerToolsSize.bind(this);
      layout.onBreakpointChange(this._headerToolsSize);
      this.$el.on('cartcount:update', function (event, data) {
        _this.$cartCount.attr('data-header-cart-count', data.response.item_count).toggleClass('visible', data.response.item_count > 0);
      });
      this._headerToolsSize();
    }
    createClass(XSectionHeader, [
      {
        key: 'onSectionDeselect',
        value: function onSectionDeselect() {
          this.navDesktop.closeAll(null);
          this.stickyHeader.closeNavigation();
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.stickyHeader.unload();
          this.navMobile.unload();
          this.navDesktop.unload();
          this.forms.unload();
          this.$el.off('cartcount:update');
          this.headerSearch.unload();
          if (this.currency.enable) {
            this.$converter.off('change.converter');
          }
        },
      },
      {
        key: 'onSectionMessage',
        value: function onSectionMessage(name, data) {
          if (name === 'nav:close-all' && layout.isBreakpoint('L')) {
            this.navDesktop.closeAll(null);
          }
          if (name === 'stickyheader:open' && this.settings.sticky_header) {
            this.stickyHeader.openNavigation(true);
          }
        },
      },
      {
        key: 'onSectionBlockSelect',
        value: function onSectionBlockSelect(block) {
          var _this2 = this;
          if (!layout.isBreakpoint('L')) {
            return;
          }
          setTimeout(function () {
            if (_this2.settings.sticky_header) {
              _this2.stickyHeader.slideToggle(true);
            }
            if (!jQuery(block.el).find('.x-navmenu-link').hasClass('x-navmenu-active')) {
              _this2.navDesktop.toggleItem(block.el);
            }
          }, 100);
        },
      },
      {
        key: 'onSectionBlockDeselect',
        value: function onSectionBlockDeselect() {
          if (this.$menuToggle.hasClass('active') && layout.isBreakpoint('L') && this.settings.sticky_header) {
            this.stickyHeader.slideToggle(false);
          }
          this.navDesktop.closeAll(null);
        },
      },
      {
        key: '_converter',
        value: function _converter() {
          var _this3 = this;
          dist$2.init({
            switcherSelector: this.converter,
            priceSelector: '.money',
            shopCurrency: this.currency.shop_currency,
            defaultCurrency: this.currency.default_currency,
            displayFormat: this.currency.display_format,
            moneyFormat: this.currency.money_format,
            moneyFormatNoCurrency: this.currency.money_format_no_currency,
            moneyFormatCurrency: this.currency.money_format_currency,
          });
          this.$converter.on('change.converter', function (event) {
            _this3.$converter.each(function (index, converter) {
              if (converter.value !== event.currentTarget.value) {
                converter.value = event.currentTarget.value;
              }
            });
            dist$2.setCurrency(event.currentTarget.value);
          });
        },
      },
      {
        key: '_headerToolsSize',
        value: function _headerToolsSize() {
          if (!layout.isBreakpoint('L')) {
            return;
          }
          var outerWidth = this.$headerTools.width();
          var innerWidths = [];
          this.$headerTools.find('li').each(function (index, el) {
            innerWidths.push(Math.ceil(jQuery(el).outerWidth()));
          });
          var combinedWidths = innerWidths.reduce(function (a, b) {
            return a + b;
          }, 0);
          if (combinedWidths > outerWidth) {
            this.$headerTools.css('max-width', combinedWidths + 'px');
            this.$desktopNavigation.css('max-width', 'calc(100% - ' + combinedWidths + 'px)');
          }
        },
      },
    ]);
    return XSectionHeader;
  })();
  var XSectionFooter = (function () {
    function XSectionFooter(section) {
      classCallCheck(this, XSectionFooter);
      this.$el = jQuery(section.el);
      this.Accordion = new Accordion(this.$el);
      this.forms = new Forms(this.$el);
      // Handle Accordion interaction when window size changes
      this.layoutHandler = this.onBreakpointChange.bind(this);
      layout.onBreakpointChange(this.layoutHandler);
      this._bindEvents();
    }
    createClass(XSectionFooter, [
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$el.on('click.footer', '[data-accordion-trigger]', function (event) {
            event.preventDefault();
            _this._toggleAccordion(jQuery(event.currentTarget).parent());
          });
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.$el.off('.footer');
          this.forms.unload();
          delete this.Accordion;
        },
      },
      {
        key: 'onSectionBlockSelect',
        value: function onSectionBlockSelect(block) {
          var $block = jQuery(block.el);
          if ($block.hasClass('has-accordion')) this._toggleAccordion($block, true);
        },
      },
      {
        key: 'onSectionBlockDeselect',
        value: function onSectionBlockDeselect(block) {
          var $block = jQuery(block.el);
          if ($block.hasClass('has-accordion')) this._toggleAccordion($block, false);
        },
      },
      {
        key: '_toggleAccordion',
        value: function _toggleAccordion($block) {
          if (layout.isBreakpoint('L')) return;
          this.Accordion.toggle($block);
        },
      },
      {
        key: 'onBreakpointChange',
        value: function onBreakpointChange(event, breakpoints) {
          if (layout.isBreakpoint('L')) {
            this.Accordion.openAll();
          } else if (breakpoints.previous === 'L' && !layout.isBreakpoint('L')) {
            this.Accordion.closeOpen();
          }
        },
      },
    ]);
    return XSectionFooter;
  })();
  var XArticle = (function () {
    function XArticle(section) {
      classCallCheck(this, XArticle);
      this.$el = jQuery(section.el);
      this.$commentForm = this.$el.find('[data-articlecomments-form]');
      this.richText = new RichText(this.$el);
      if (this.$commentForm.length) {
        this.commentForm = new Forms(this.$commentForm);
      }
    }
    createClass(XArticle, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.richText.unload();
          if (this.commentForm) {
            this.commentForm.unload();
          }
        },
      },
    ]);
    return XArticle;
  })();
  var XBlog = (function () {
    function XBlog(section) {
      classCallCheck(this, XBlog);
      this.$el = jQuery(section.el);
      this.richText = new RichText(this.$el);
    }
    createClass(XBlog, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.richText.unload();
        },
      },
    ]);
    return XBlog;
  })();
  var MessageBanner = (function () {
    function MessageBanner() {
      var _this = this;
      classCallCheck(this, MessageBanner);
      this.$window = jQuery(window);
      this.$document = jQuery(document);
      this.$body = jQuery(document.body);
      this.$bannerTemplate = jQuery('[data-templates] [data-x-message]');
      this.$banners = [];
      this.header = document.querySelector('.x-head-wrapper');
      this.events = [];
      this.$document.on('touchstart.x-message, click.x-message', function (event) {
        _this._handleDocumentClick(event.target);
      });
    }
    createClass(MessageBanner, [
      {
        key: 'unload',
        value: function unload() {
          this.$document.off('touchstart.x-message, click.x-message');
        },
      },
      {
        key: 'message',
        value: function message(_message, type) {
          var $banner = this.$bannerTemplate.clone();
          $banner
            .addClass('message--' + type)
            .find('[data-x-message-content]')
            .html(_message);
          this.$body.append($banner);
          this._bindEvents($banner);
          this._show($banner);
        },
      },
      {
        key: 'dismissBanners',
        value: function dismissBanners() {
          var _this2 = this;
          var $visibleBanners = jQuery('[data-x-message]:visible');
          $visibleBanners.each(function (index, banner) {
            _this2._hide(jQuery(banner), index);
          });
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents($banner) {
          var _this3 = this;
          this.events.push([
            $banner.on('click.x-message', '[data-x-message-close]', function (event) {
              event.preventDefault();
              _this3._hide($banner);
            }),
            this.$body.on('position-banners.x-message', function () {
              _this3._positionBanner($banner);
            }),
            this.$window.on(
              'resize.x-message',
              justDebounce$1(function () {
                return _this3._positionBanner($banner);
              }, 250)
            ),
            this.$window.on('scroll.x-message', function () {
              return _this3._positionBanner($banner);
            }),
          ]);
        },
        /**
         * Position Message beneath header if its in viewport, or at top of viewport
         *
         * @param $banner
         * @private
         */
      },
      {
        key: '_positionBanner',
        value: function _positionBanner($banner) {
          $banner.css({ top: getHeaderOffset(this.header, true) });
        },
      },
      {
        key: '_show',
        value: function _show($banner) {
          this._positionBanner($banner);
          this.$banners.push($banner);
          $banner.addClass('animating animating-in').one('trend', function () {
            $banner.removeClass('animating animating-in').addClass('visible').off('trend');
          });
        },
      },
      {
        key: '_hide',
        value: function _hide($banner) {
          var _this4 = this;
          var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          $banner.addClass('animating animating-out').one('trend', function () {
            $banner.removeClass('animating animating-out visible').off('trend');
            _this4._removeBanner($banner, index);
          });
        },
      },
      {
        key: '_removeBanner',
        value: function _removeBanner($banner, index) {
          if (this.events[index]) {
            this.events[index].forEach(function ($el) {
              return $el.off('.x-message');
            });
            this.events.splice(index, 1);
          }
          this.$banners.splice(index, 1);
          $banner.remove();
        },
      },
      {
        key: '_handleDocumentClick',
        value: function _handleDocumentClick(target) {
          var $parent = jQuery(target).parents('[data-x-message]');
          if ($parent.length) return;
          this.dismissBanners();
        },
      },
    ]);
    return MessageBanner;
  })();
  var XCart = (function () {
    function XCart(section) {
      var _this = this;
      classCallCheck(this, XCart);
      this.settings = section.data.settings;
      this.shipping = section.data.shipping;
      this.messageBanner = new MessageBanner();
      this.$window = jQuery(window);
      this.$el = jQuery(section.el);
      this.$header = jQuery('.x-head-wrapper');
      this.$total = this.$el.find('[data-cart-total]');
      this.$shipping = this.$el.find('[data-cartshipping]');
      // Product form containers
      this.$titleTotalSmall = this.$el.find('.cart-title-total--small');
      this.$titleTotalLarge = this.$el.find('.cart-title-total--large');
      this.$titleTotalContents = this.$el.find('[data-cart-title-total]');
      // Shipping calculator elements
      this.$shippingToggle = this.$el.find('[data-cartshipping-toggle]');
      this.$shippingResponse = this.$shipping.find('[data-cartshipping-response]');
      this.$shippingResponseMessage = this.$shippingResponse.find('[data-cartshipping-message]');
      this.$shippingResponseRates = this.$shippingResponse.find('[data-cartshipping-rates]');
      this.$shippingSubmit = this.$shipping.find('[data-cartshipping-submit]');
      this._moveTitleTotal();
      var $scripts = jQuery('[data-scripts]');
      script$1($scripts.data('shopify-api-url'), function () {
        _this._bindEvents();
        Shopify.onError = _this._handleErrors.bind(_this);
      });
      this.forms = new Forms(this.$el);
      // Update the section when onSectionLoad fires to restore prices to local currency
      this.$el.find('.money').each(function (index, el) {
        return dist$2.update(el);
      });
      if (this.settings.shipping && this.$shipping.length) {
        script$1($scripts.data('shopify-countries'), function () {
          script$1($scripts.data('shopify-common'), function () {
            script$1($scripts.data('shopify-cart'), function () {
              _this._initShippingCalc();
            });
          });
        });
      }
    }
    createClass(XCart, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.$el.off('.cart-page');
          this.$window.off('.cart-page');
          this.forms.unload();
          this.messageBanner.unload();
          this.messageBanner.dismissBanners();
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this2 = this;
          this.$el.on('keydown.cart-page', '[data-cartitem-quantity]', function (event) {
            _this2._quantityKeyDown(event);
          });
          this.$el.on('change.cart-page', '[data-cartitem-quantity]', function (event) {
            _this2._editItemQuantity(event);
          });
          this.$el.on('click.cart-page', '[data-cartitem-remove]', function (event) {
            event.preventDefault();
            _this2._editItemQuantity(event, true);
          });
          this.$window.on(
            'resize.cart-page',
            justDebounce$1(function () {
              return _this2._moveTitleTotal();
            }, 20)
          );
        },
      },
      {
        key: '_moveTitleTotal',
        value: function _moveTitleTotal() {
          if (!this.$titleTotalContents.length) {
            return;
          }
          if (this.$window.outerWidth() >= 480) {
            if (!jQuery.contains(this.$titleTotalLarge[0], this.$titleTotalContents[0])) {
              var $form = this.$titleTotalContents.detach();
              this.$titleTotalLarge.append($form);
            }
          } else {
            if (!jQuery.contains(this.$titleTotalSmall[0], this.$titleTotalContents[0])) {
              var _$form = this.$titleTotalContents.detach();
              this.$titleTotalSmall.append(_$form);
            }
          }
        },
        /**
         * Prevent form submission when pressing `enter` within a quantity selector
         *
         * @param event
         * @private
         */
      },
      {
        key: '_quantityKeyDown',
        value: function _quantityKeyDown(event) {
          // Only block enter keys
          if (event.keyCode !== 13) {
            return;
          }
          // Block form submission, but update field
          jQuery(event.currentTarget).trigger('change');
          event.preventDefault();
        },
        /**
         * Handle an item quantity change
         *
         * @param event
         * @param {Boolean} remove - Set as true to remove cart item
         * @private
         */
      },
      {
        key: '_editItemQuantity',
        value: function _editItemQuantity(event) {
          var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          this.messageBanner.dismissBanners();
          var $target = jQuery(event.currentTarget);
          var $cartItem = $target.closest('[data-cartitem-id]');
          var quantity = remove ? 0 : parseInt($target.val(), 10);
          quantity = Math.max(quantity, 0);
          this._updateCart($cartItem, quantity);
          // Remove item from cart visually if it is being removed
          if (quantity === 0 || remove) {
            $cartItem.height($cartItem.height());
          }
        },
        /**
         * Update cart with a valid quantity
         *
         * @param $cartItem
         * @param quantity
         * @private
         */
      },
      {
        key: '_updateCart',
        value: function _updateCart($cartItem, quantity) {
          var _this3 = this;
          var id = $cartItem.data('cartitem-id');
          // Notify Shopify updated item
          Shopify.changeItem(id, quantity, function (response) {
            _this3._didUpdate(id, quantity, response, $cartItem);
          });
        },
      },
      {
        key: '_quantityError',
        value: function _quantityError(limit, title) {
          var errorMessage = this.settings.stock_limit.replace('** quantity **', limit).replace('** title **', title);
          this.messageBanner.message(errorMessage, 'error');
        },
        /**
         * Update cart content based on information from Shopify
         *
         * @param id
         * @param quantity
         * @param response
         * @param $cartItem
         * @returns {*}
         * @private
         */
      },
      {
        key: '_didUpdate',
        value: function _didUpdate(id, quantity, response, $cartItem) {
          var _this4 = this;
          // Reload page if all items are removed from cart
          if (!response.items.length) {
            return (window.location = '/cart');
          }
          this.$header.trigger('cartcount:update', { response: response });
          this.$total.each(function (i, el) {
            el.innerHTML = Shopify.formatMoney(response.total_price, _this4.settings.money_format);
            dist$2.update(el);
          });
          // Select item from response
          var filteredItems = response.items.filter(function (item) {
            return item.id === id;
          });
          if (!filteredItems.length) {
            return $cartItem.addClass('removing').one('trend', function () {
              $cartItem.off('trend').remove();
            });
          }
          var cartItem = filteredItems[0];
          var itemTotal = $cartItem[0].querySelector('[data-cartitem-total]');
          if (cartItem.quantity !== quantity) {
            this._quantityError(cartItem.quantity, cartItem.title);
            $cartItem.find('[data-quantity-input]').val(cartItem.quantity);
            $cartItem.find('[data-quantity-select]').val(cartItem.quantity);
          }
          itemTotal.innerHTML = Shopify.formatMoney(cartItem.price * cartItem.quantity, this.settings.money_format);
          dist$2.update(itemTotal);
        },
        /**
         * Handle Errors returned from Shopify
         *
         * @param xhr
         * @private
         */
      },
      {
        key: '_handleErrors',
        value: function _handleErrors() {
          var xhr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          if (!xhr) {
            return;
          }
          var errors = jQuery.parseJSON(xhr.responseText);
          var shippingResponse = {
            message: this.shipping.error_general,
          };
          if (errors.zip && errors.zip.length > 0) {
            if (errors.zip[0].indexOf('is not valid') !== -1 || errors.zip[0].indexOf("can't be blank") !== -1) {
              shippingResponse.message = this.shipping.zip + ' ' + errors.zip;
            }
          }
          if (errors.error && errors.error.length > 0) {
            if (errors.error[0].indexOf('shipment_too_heavy') !== -1) {
              shippingResponse.message = this.shipping.shipment_too_heavy;
            }
          }
          this._handleShippingResponse(shippingResponse);
        },
      },
      {
        key: '_initShippingCalc',
        value: function _initShippingCalc() {
          this._bindShippingCalcEvents();
          Shopify.Cart.ShippingCalculator.show({
            submitButton: this.shipping.calculate_shipping,
            submitButtonDisabled: this.shipping.calculating,
            customerIsLoggedIn: this.shipping.customer,
            moneyFormat: this.settings.money_format,
          });
        },
      },
      {
        key: '_bindShippingCalcEvents',
        value: function _bindShippingCalcEvents() {
          var _this5 = this;
          this.$el.on('click.cart-page', '[data-cartshipping-toggle]', function () {
            _this5._toggleShippingCalc();
          });
          this.$el.on('click.cart-page', '[data-cartshipping-submit]', function () {
            _this5._getShippingRates();
          });
          this.$el.on('keypress.cart-page', '#address_zip', function (event) {
            if (event.keyCode === 10 || event.keyCode === 13) {
              event.preventDefault();
              _this5.$shippingSubmit.trigger('click');
            }
          });
        },
      },
      {
        key: '_toggleShippingCalc',
        value: function _toggleShippingCalc() {
          var oldText = this.$shippingToggle.text();
          var newText = this.$shippingToggle.data('cartshipping-toggle');
          this.$shippingToggle.text(newText).data('cartshipping-toggle', oldText);
          this.$shipping.toggleClass('open');
        },
      },
      {
        key: '_getShippingRates',
        value: function _getShippingRates() {
          var _this6 = this;
          this._disableShippingButton();
          var shippingAddress = {};
          shippingAddress.country = jQuery('#address_country').val() || '';
          shippingAddress.province = jQuery('#address_province').val() || '';
          shippingAddress.zip = jQuery('#address_zip').val() || '';
          // Creates an ajax request which returns shipping information
          Shopify.getCartShippingRatesForDestination(shippingAddress, function (response, shippingAddress) {
            var addressBase = [];
            if (shippingAddress.zip.length) {
              addressBase.push(shippingAddress.zip.trim());
            }
            if (shippingAddress.province.length) {
              addressBase.push(shippingAddress.province);
            }
            if (shippingAddress.country.length) {
              addressBase.push(shippingAddress.country);
            }
            var address = addressBase.join(', ');
            var message = '';
            if (response.length > 1) {
              var firstRate = Shopify.Cart.ShippingCalculator.formatRate(response[0].price);
              message = _this6.shipping.multiple_rates
                .replace('*address*', address)
                .replace('*number_of_rates*', response.length)
                .replace('*rate*', '<span class="money">' + firstRate + '</span>');
            } else if (response.length === 1) {
              message = _this6.shipping.one_rate.replace('*address*', address);
            } else {
              message = _this6.shipping.no_rates;
            }
            var rates = [];
            response.forEach(function (rate) {
              var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
              var rateValue = _this6.shipping.rate_value
                .replace('*rate_title*', rate.name)
                .replace('*rate*', '<span class="money">' + price + '</span>');
              rates.push('<li>' + rateValue + '</li>');
            });
            _this6._handleShippingResponse({
              message: message,
              rates: rates,
            });
          });
        },
      },
      {
        key: '_enableShippingButton',
        value: function _enableShippingButton() {
          this.$shippingSubmit.text(this.shipping.calculate_shipping).attr('disabled', false);
        },
      },
      {
        key: '_disableShippingButton',
        value: function _disableShippingButton() {
          this.$shippingSubmit.text(this.shipping.calculating).attr('disabled', true);
        },
      },
      {
        key: '_showShippingResponse',
        value: function _showShippingResponse() {
          this.$shippingResponse.addClass('visible');
        },
      },
      {
        key: '_hideShippingResponse',
        value: function _hideShippingResponse() {
          this.$shippingResponse.removeClass('visible');
        },
        /**
         * Handle shipping responses
         *
         * @param {object} shippingResponse
         * @property {String} shippingResponse.messages - Error / Success message
         * @property {Array|String} shippingResponse.rates - Shipping rates
         * @private
         */
      },
      {
        key: '_handleShippingResponse',
        value: function _handleShippingResponse() {
          var shippingResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          // Hide the response so that it can be populated smoothly
          this._hideShippingResponse();
          var message = shippingResponse.message || null;
          var rates = shippingResponse.rates || null;
          // Empty out contents
          this.$shippingResponseMessage.empty();
          this.$shippingResponseRates.empty();
          if (message) {
            this.$shippingResponseMessage.html(message);
          }
          if (rates) {
            this.$shippingResponseRates.html(rates);
          }
          // Reset the calculating button so it can be used again
          this._enableShippingButton();
          // No error provided
          if (!message && !rates) {
            return;
          }
          // Show the response
          this._showShippingResponse();
        },
      },
    ]);
    return XCart;
  })();
  var dist$3 = createCommonjsModule(function (module, exports) {
    (function (global, factory) {
      if (typeof undefined === 'function' && undefined.amd) {
        undefined(['exports'], factory);
      } else {
        factory(exports);
      }
    })(commonjsGlobal, function (exports) {
      'use strict';
      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }
      var _createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();
      var _extends =
        Object.assign ||
        function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
      var defaults = {
        modal: '.modal',
        modalInner: '.modal-inner',
        modalContent: '.modal-content',
        open: '[data-modal-open]',
        close: '[data-modal-close]',
        page: 'body',
        class: 'modal-visible',
        loadClass: 'vanilla-modal',
        clickOutside: true,
        closeKeys: [27],
        transitions: true,
        transitionEnd: null,
        onBeforeOpen: null,
        onBeforeClose: null,
        onOpen: null,
        onClose: null,
      };
      function throwError(message) {
        // eslint-disable-next-line no-console
        console.error('VanillaModal: ' + message);
      }
      function find(arr, callback) {
        return function (key) {
          var filteredArray = arr.filter(callback);
          return filteredArray[0] ? filteredArray[0][key] : undefined;
        };
      }
      function transitionEndVendorSniff() {
        var el = document.createElement('div');
        var transitions = [
          { key: 'transition', value: 'transitionend' },
          { key: 'OTransition', value: 'otransitionend' },
          { key: 'MozTransition', value: 'transitionend' },
          { key: 'WebkitTransition', value: 'webkitTransitionEnd' },
        ];
        return find(transitions, function (_ref) {
          var key = _ref.key;
          return typeof el.style[key] !== 'undefined';
        })('value');
      }
      function isPopulatedArray(arr) {
        return Object.prototype.toString.call(arr) === '[object Array]' && arr.length;
      }
      function getNode(selector, parent) {
        var targetNode = parent || document;
        var node = targetNode.querySelector(selector);
        if (!node) {
          throwError(selector + ' not found in document.');
        }
        return node;
      }
      function addClass(el, className) {
        if (!(el instanceof HTMLElement)) {
          throwError('Not a valid HTML element.');
        }
        el.setAttribute(
          'class',
          el.className
            .split(' ')
            .filter(function (cn) {
              return cn !== className;
            })
            .concat(className)
            .join(' ')
        );
      }
      function removeClass(el, className) {
        if (!(el instanceof HTMLElement)) {
          throwError('Not a valid HTML element.');
        }
        el.setAttribute(
          'class',
          el.className
            .split(' ')
            .filter(function (cn) {
              return cn !== className;
            })
            .join(' ')
        );
      }
      function getElementContext(e) {
        if (e && typeof e.hash === 'string') {
          return document.querySelector(e.hash);
        } else if (typeof e === 'string') {
          return document.querySelector(e);
        }
        throwError('No selector supplied to open()');
        return null;
      }
      function applyUserSettings(settings) {
        return _extends({}, defaults, settings, {
          transitionEnd: transitionEndVendorSniff(),
        });
      }
      function matches(e, selector) {
        var allMatches = (e.target.document || e.target.ownerDocument).querySelectorAll(selector);
        for (var i = 0; i < allMatches.length; i += 1) {
          var node = e.target;
          while (node && node !== document.body) {
            if (node === allMatches[i]) {
              return node;
            }
            node = node.parentNode;
          }
        }
        return null;
      }
      var VanillaModal = (function () {
        function VanillaModal(settings) {
          _classCallCheck(this, VanillaModal);
          this.isOpen = false;
          this.current = null;
          this.isListening = false;
          this.settings = applyUserSettings(settings);
          this.dom = this.getDomNodes();
          this.open = this.open.bind(this);
          this.close = this.close.bind(this);
          this.closeKeyHandler = this.closeKeyHandler.bind(this);
          this.outsideClickHandler = this.outsideClickHandler.bind(this);
          this.delegateOpen = this.delegateOpen.bind(this);
          this.delegateClose = this.delegateClose.bind(this);
          this.listen = this.listen.bind(this);
          this.destroy = this.destroy.bind(this);
          this.addLoadedCssClass();
          this.listen();
        }
        _createClass(VanillaModal, [
          {
            key: 'getDomNodes',
            value: function getDomNodes() {
              var _settings = this.settings,
                modal = _settings.modal,
                page = _settings.page,
                modalInner = _settings.modalInner,
                modalContent = _settings.modalContent;
              return {
                modal: getNode(modal),
                page: getNode(page),
                modalInner: getNode(modalInner, getNode(modal)),
                modalContent: getNode(modalContent, getNode(modal)),
              };
            },
          },
          {
            key: 'addLoadedCssClass',
            value: function addLoadedCssClass() {
              addClass(this.dom.page, this.settings.loadClass);
            },
          },
          {
            key: 'setOpenId',
            value: function setOpenId(id) {
              var page = this.dom.page;
              page.setAttribute('data-current-modal', id || 'anonymous');
            },
          },
          {
            key: 'removeOpenId',
            value: function removeOpenId() {
              var page = this.dom.page;
              page.removeAttribute('data-current-modal');
            },
          },
          {
            key: 'open',
            value: function open(allMatches, e) {
              var page = this.dom.page;
              var _settings2 = this.settings,
                onBeforeOpen = _settings2.onBeforeOpen,
                onOpen = _settings2.onOpen;
              if (!(this.current instanceof HTMLElement === false)) {
                throwError('VanillaModal target must exist on page.');
                return;
              }
              this.releaseNode(this.current);
              this.current = getElementContext(allMatches);
              if (typeof onBeforeOpen === 'function') {
                onBeforeOpen.call(this, e);
              }
              this.captureNode(this.current);
              addClass(page, this.settings.class);
              this.setOpenId(this.current.id);
              this.isOpen = true;
              if (typeof onOpen === 'function') {
                onOpen.call(this, e);
              }
            },
          },
          {
            key: 'detectTransition',
            value: function detectTransition() {
              var modal = this.dom.modal;
              var css = window.getComputedStyle(modal, null);
              return Boolean(
                ['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'].filter(function (i) {
                  return typeof css[i] === 'string' && parseFloat(css[i]) > 0;
                }).length
              );
            },
          },
          {
            key: 'close',
            value: function close(e) {
              var _settings3 = this.settings,
                transitions = _settings3.transitions,
                transitionEnd = _settings3.transitionEnd,
                onBeforeClose = _settings3.onBeforeClose;
              var hasTransition = this.detectTransition();
              if (this.isOpen) {
                this.isOpen = false;
                if (typeof onBeforeClose === 'function') {
                  onBeforeClose.call(this, e);
                }
                removeClass(this.dom.page, this.settings.class);
                if (transitions && transitionEnd && hasTransition) {
                  this.closeModalWithTransition(e);
                } else {
                  this.closeModal(e);
                }
              }
            },
          },
          {
            key: 'closeModal',
            value: function closeModal(e) {
              var onClose = this.settings.onClose;
              this.removeOpenId(this.dom.page);
              this.releaseNode(this.current);
              this.isOpen = false;
              this.current = null;
              if (typeof onClose === 'function') {
                onClose.call(this, e);
              }
            },
          },
          {
            key: 'closeModalWithTransition',
            value: function closeModalWithTransition(e) {
              var _this = this;
              var modal = this.dom.modal;
              var transitionEnd = this.settings.transitionEnd;
              var closeTransitionHandler = function closeTransitionHandler() {
                modal.removeEventListener(transitionEnd, closeTransitionHandler);
                _this.closeModal(e);
              };
              modal.addEventListener(transitionEnd, closeTransitionHandler);
            },
          },
          {
            key: 'captureNode',
            value: function captureNode(node) {
              var modalContent = this.dom.modalContent;
              while (node.childNodes.length) {
                modalContent.appendChild(node.childNodes[0]);
              }
            },
          },
          {
            key: 'releaseNode',
            value: function releaseNode(node) {
              var modalContent = this.dom.modalContent;
              while (modalContent.childNodes.length) {
                node.appendChild(modalContent.childNodes[0]);
              }
            },
          },
          {
            key: 'closeKeyHandler',
            value: function closeKeyHandler(e) {
              var closeKeys = this.settings.closeKeys;
              if (isPopulatedArray(closeKeys) && closeKeys.indexOf(e.which) > -1 && this.isOpen === true) {
                e.preventDefault();
                this.close(e);
              }
            },
          },
          {
            key: 'outsideClickHandler',
            value: function outsideClickHandler(e) {
              var clickOutside = this.settings.clickOutside;
              var modalInner = this.dom.modalInner;
              if (clickOutside) {
                var node = e.target;
                while (node && node !== document.body) {
                  if (node === modalInner) {
                    return;
                  }
                  node = node.parentNode;
                }
                this.close(e);
              }
            },
          },
          {
            key: 'delegateOpen',
            value: function delegateOpen(e) {
              var open = this.settings.open;
              var matchedNode = matches(e, open);
              if (matchedNode) {
                e.preventDefault();
                this.open(matchedNode, e);
              }
            },
          },
          {
            key: 'delegateClose',
            value: function delegateClose(e) {
              var close = this.settings.close;
              if (matches(e, close)) {
                e.preventDefault();
                this.close(e);
              }
            },
          },
          {
            key: 'listen',
            value: function listen() {
              var modal = this.dom.modal;
              if (!this.isListening) {
                modal.addEventListener('click', this.outsideClickHandler, false);
                document.addEventListener('keydown', this.closeKeyHandler, false);
                document.addEventListener('click', this.delegateOpen, false);
                document.addEventListener('click', this.delegateClose, false);
                this.isListening = true;
              } else {
                throwError('Event listeners already applied.');
              }
            },
          },
          {
            key: 'destroy',
            value: function destroy() {
              var modal = this.dom.modal;
              if (this.isListening) {
                this.close();
                modal.removeEventListener('click', this.outsideClickHandler);
                document.removeEventListener('keydown', this.closeKeyHandler);
                document.removeEventListener('click', this.delegateOpen);
                document.removeEventListener('click', this.delegateClose);
                this.isListening = false;
              } else {
                throwError('Event listeners already removed.');
              }
            },
          },
        ]);
        return VanillaModal;
      })();
      exports.default = VanillaModal;
    });
  });
  var VanillaModal = unwrapExports(dist$3);
  var Modal = (function () {
    function Modal() {
      var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, Modal);
      this.$body = jQuery(document.body);
      this.$window = jQuery(window);
      this.modal = null;
      this.$modal = jQuery('[data-modal-container]');
      this.$modalInner = this.$modal.find('[data-modal-inner]');
      // Extend default vanilla-modal callbacks back to instantiator of Modal
      this.defaultCallbacks = {
        onOpen: function onOpen() { },
        onClose: function onClose() { },
        onBeforeOpen: function onBeforeOpen() { },
        onBeforeClose: function onBeforeClose() { },
      };
      this.callbacks = jQuery.extend({}, this.defaultCallbacks, callbacks);
      this._onOpen = this._onOpen.bind(this);
      this._onBeforeOpen = this._onBeforeOpen.bind(this);
      this._onClose = this._onClose.bind(this);
      this._onBeforeClose = this._onBeforeClose.bind(this);
      this.position = this.position.bind(this);
      this.modalOptions = {
        loadClass: '',
        class: 'modal-loaded',
        onOpen: this._onOpen,
        onClose: this._onClose,
        onBeforeOpen: this._onBeforeOpen,
        onBeforeClose: this._onBeforeClose,
        transitions: false,
      };
    }
    createClass(Modal, [
      {
        key: 'unload',
        value: function unload() {
          if (!this.modal || !this.modal.isOpen) return;
          this.modal.destroy();
        },
        /**
         * Open a modal with contents from selector
         *
         * @param selector
         * @param handle
         */
      },
      {
        key: 'open',
        value: function open(selector) {
          var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'general';
          this._addModalClass(handle);
          this.modal = new VanillaModal(this.modalOptions);
          this.modal.open(selector);
        },
      },
      {
        key: 'close',
        value: function close() {
          this.modal.close();
        },
      },
      {
        key: 'isOpen',
        value: function isOpen() {
          return this.modal && this.modal.isOpen;
        },
        /**
         * Update the vertical positioning of modal
         */
      },
      {
        key: 'position',
        value: function position() {
          var windowHeight = window.innerHeight;
          var modalHeight = this.$modalInner.outerHeight();
          var modalPadding = parseInt(this.$modal.css('padding-top'), 10) * 2;
          var offset = (windowHeight - modalPadding - modalHeight) / 2;
          var marginTop = offset > 0 ? offset : 0;
          this.$modalInner.css({ marginTop: marginTop });
        },
        /**
         * Add a class to the modal for individual styling
         * @param handle
         * @private
         */
      },
      {
        key: '_addModalClass',
        value: function _addModalClass(handle) {
          this.$modal.addClass('modal--' + handle);
        },
        /**
         * Remove modal class based on the handle
         * @private
         */
      },
      {
        key: '_removeModalClass',
        value: function _removeModalClass() {
          var modalClass = this.$modal.attr('class').match(/modal--[\w-]*\b/);
          if (!modalClass) {
            return;
          }
          this.$modal.removeClass(modalClass[0]);
        },
      },
      {
        key: '_onClose',
        value: function _onClose() {
          this._removeModalClass();
          this.$body.removeClass('scroll-lock').removeClass('modal-visible');
          this.$window.off('resize.modal');
          this.$modalInner.css({ marginTop: '' });
          this.callbacks.onClose();
        },
      },
      {
        key: '_onOpen',
        value: function _onOpen() {
          var _this = this;
          this.position();
          this.$body.addClass('scroll-lock').addClass('modal-visible');
          this.$window.on(
            'resize.modal',
            justDebounce$1(
              function () {
                return _this.position();
              },
              16,
              true,
              true
            )
          );
          this.callbacks.onOpen();
        },
      },
      {
        key: '_onBeforeClose',
        value: function _onBeforeClose() {
          this.callbacks.onBeforeClose();
        },
      },
      {
        key: '_onBeforeOpen',
        value: function _onBeforeOpen() {
          this.callbacks.onBeforeOpen();
        },
      },
    ]);
    return Modal;
  })();
  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }
    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    jQuery(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  }
  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    jQuery(document).off(eventName);
  }
  var Node = (function () {
    function Node(variant) {
      classCallCheck(this, Node);
      this.variant = variant;
      this.optionsCount = this.variant.options.length;
      this.neighbors = [];
      for (var i = 0; i < this.optionsCount; i++) {
        this.neighbors.push([]);
      }
    }
    createClass(Node, [
      {
        key: 'addNeighbor',
        value: function addNeighbor(variant) {
          for (var i = 0; i < this.optionsCount; i++) {
            if (this.variant.options[i] !== variant.options[i]) {
              this.neighbors[i].push(variant);
              break;
            }
          }
        },
      },
      {
        key: 'getValidOptions',
        value: function getValidOptions() {
          var _this = this;
          var options = [];
          var _loop = function _loop(i) {
            var variants = [_this.variant].concat(toConsumableArray(_this.neighbors[i]));
            options[i] = {};
            variants.forEach(function (item) {
              var variant = item;
              var option = variant.options[i];
              options[i][option] = {
                available: (options[i][option] && options[i][option].available) || variant.available,
              };
            });
          };
          for (var i = 0; i < this.optionsCount; i++) {
            _loop(i);
          }
          return options;
        },
      },
    ]);
    return Node;
  })();
  var ProductOptions = (function () {
    function ProductOptions(product) {
      classCallCheck(this, ProductOptions);
      this.productHandle = product.handle;
      this.optionsCount = product.options.length;
      this.variants = product.variants;
      this.nodeMap = {};
      this._generateNodeMap(product);
    }
    createClass(ProductOptions, [
      {
        key: '_generateNodeMap',
        value: function _generateNodeMap() {
          var _this2 = this;
          this.variants.forEach(function (variant) {
            _this2.nodeMap[variant.id] = new Node(variant);
            _this2.variants.forEach(function (variant2) {
              _this2.nodeMap[variant.id].addNeighbor(variant2);
            });
          });
        },
      },
      {
        key: 'getVariantFromOptions',
        value: function getVariantFromOptions(options) {
          this.variants.forEach(function (variant) {
            var found = true;
            for (var i = 0; i < variant.options.length; i++) {
              if (options[i] !== variant.options[i]) {
                found = false;
              }
            }
            if (found) {
              return variant;
            }
          });
          return false;
        },
      },
      {
        key: 'getClosestVariantFromOptions',
        value: function getClosestVariantFromOptions(options) {
          var closestVariant = null;
          var matchingValues = 0;
          this.variants.forEach(function (variant) {
            var tempMatchingValues = 0;
            for (var i = 0; i < variant.options.length; i++) {
              if (options[i] === variant.options[i]) {
                tempMatchingValues++;
              } else {
                break;
              }
            }
            if (tempMatchingValues >= matchingValues) {
              closestVariant = variant;
              matchingValues = tempMatchingValues;
            }
          });
          return closestVariant ? closestVariant : false;
        },
      },
      {
        key: 'getVariantOrClosestFromOptions',
        value: function getVariantOrClosestFromOptions(options) {
          return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
        },
      },
      {
        key: 'getAvailableOptionsFromVariant',
        value: function getAvailableOptionsFromVariant(variant) {
          return this.nodeMap[variant.id].getValidOptions();
        },
      },
    ]);
    return ProductOptions;
  })();
  var VariantHelper = (function () {
    function VariantHelper(product, $variants, $options) {
      classCallCheck(this, VariantHelper);
      this.product = product;
      this.optionsCount = this.product.options.length;
      this.$variants = $variants;
      this.$options = $options;
      this.productOptions = new ProductOptions(this.product);
      this.optionsTypes = {
        select: 'select',
        radio: 'input[type="radio"]',
      };
      this._bindEvents();
      if (this.$options.is(this.optionsTypes.select)) {
        this.optionsType = this.optionsTypes.select;
      } else if (this.$options.is(this.optionsTypes.radio)) {
        this.optionsType = this.optionsTypes.radio;
      } else {
        console.warn('Variant helper: Option set is not a valid type');
        this._unbindEvents();
      }
      this._switchVariant(true);
    }
    createClass(VariantHelper, [
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$options.on('change.variant-helper', function () {
            return _this._switchVariant();
          });
        },
      },
      {
        key: '_unbindEvents',
        value: function _unbindEvents() {
          this.$options.off('change.variant-helper');
        },
      },
      {
        key: '_switchVariant',
        value: function _switchVariant() {
          var firstLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var options = [];
          var product = this.product;
          var variant = null;
          var availableOptions = null;
          if (this.optionsType === this.optionsTypes.select) {
            this.$options.each(function (i, option) {
              options.push(option.value);
            });
          } else if (this.optionsType === this.optionsTypes.radio) {
            this.$options.filter(':checked').each(function (i, option) {
              options.push(option.value);
            });
          } else {
            return;
          }
          variant = this.productOptions.getVariantOrClosestFromOptions(options);
          if (variant) {
            availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
          } else {
            return;
          }
          if (this.optionsType === this.optionsTypes.select) {
            this._switchVariantSelect(variant, availableOptions);
          } else if (this.optionsType === this.optionsTypes.radio) {
            this._switchVariantRadio(variant, availableOptions);
          } else {
            return;
          }
          this.$variants.val(variant.id);
          jQuery(window).trigger('product-variant-switch', { product: product, variant: variant, firstLoad: firstLoad });
        },
      },
      {
        key: '_switchVariantSelect',
        value: function _switchVariantSelect(variant, availableOptions) {
          var _this2 = this;
          var _loop = function _loop(i) {
            // Corresponding select dropdown
            var $select = jQuery(_this2.$options[i]);
            var $optionEls = $select.find('option');
            // Iterate over each option on dropdown
            $optionEls.each(function (index, option) {
              var $option = jQuery(option);
              var value = option.value;
              // Not an available option
              $option.prop('disabled', !availableOptions[i][value] || !availableOptions[i][value].available).prop('selected', false);
              // Dropdown option matches variant option
              if (variant.options[i] === value) {
                $option.prop('disabled', false).prop('selected', true);
              }
            });
          };
          // Iterate over each option type
          for (var i = 0; i < this.product.options.length; i++) {
            _loop(i);
          }
        },
      },
      {
        key: '_switchVariantRadio',
        value: function _switchVariantRadio(variant, availableOptions) {
          var _this3 = this;
          this.$options.attr('disabled', true).prop('checked', false).attr('data-soldout', false);
          var _loop2 = function _loop2(i) {
            var selector = encodeURIComponent(_this3.product.options[i])
              .replace(/%20/g, '+')
              .replace(/[!'()*]/g, function (char) {
                return '%' + char.charCodeAt(0).toString(16).toUpperCase();
              });
            var $options = _this3.$options.filter('[name="' + selector + '"]');
            $options.each(function (index, option) {
              var $option = jQuery(option);
              if (variant.options[i] === $option.val()) {
                $option.prop('checked', true);
              }
              if (availableOptions[i][$option.val()]) {
                $option.attr('disabled', false);
                if (!availableOptions[i][$option.val()].available) {
                  $option.attr('disabled', true);
                  $option.attr('data-soldout', true);
                }
              }
            });
          };
          for (var i = 0; i < this.product.options.length; i++) {
            _loop2(i);
          }
        },
      },
      {
        key: 'isDefault',
        value: function isDefault() {
          if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
            return true;
          }
        },
      },
      {
        key: 'hasSingleOption',
        value: function hasSingleOption() {
          return this.optionsCount === 1;
        },
      },
      {
        key: 'getSelectedVariant',
        value: function getSelectedVariant() {
          var options = [];
          if (this.optionsType === this.optionsTypes.select) {
            this.$options.each(function (i, option) {
              options.push(option.value);
            });
          } else if (this.optionsType === this.optionsTypes.radio) {
            this.$options.filter(':checked').each(function (i, option) {
              options.push(option.value);
            });
          } else {
            return;
          }
          return this.productOptions.getVariantFromOptions(options);
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this._unbindEvents();
        },
      },
    ]);
    return VariantHelper;
  })();
  var Images = (function () {
    function Images() {
      classCallCheck(this, Images);
    }
    createClass(Images, [
      {
        key: 'preload',
        /**
         * Preloads an image in memory and uses the browsers cache to store it until needed.
         *
         * @param {Array} images - A list of image urls
         * @param {String} size - A shopify image size attribute
         */
        value: function preload(images, size) {
          if (typeof images === 'string') {
            images = [images];
          }
          for (var i = 0; i < images.length; i++) {
            this.loadImage(this.getSizedImageUrl(images[i], size));
          }
        },
        /**
         * Loads and caches an image in the browsers cache.
         *
         * @param {string} path - An image url
         */
      },
      {
        key: 'loadImage',
        value: function loadImage(path) {
          return (new Image().src = path);
        },
        /**
         * Adds a Shopify size attribute to a URL
         *
         * @param src
         * @param size
         * @returns {*}
         */
      },
      {
        key: 'getSizedImageUrl',
        value: function getSizedImageUrl() {
          var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var size = arguments[1];
          if (!size) {
            return null;
          }
          if (size === 'master') {
            return this.removeProtocol(src);
          }
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + '_' + size + suffix);
          } else {
            console.warn('No ' + size + " found for '" + src);
            return null;
          }
        },
      },
      {
        key: 'removeProtocol',
        value: function removeProtocol(path) {
          return path.replace(/http(s)?:/, '');
        },
      },
    ]);
    return Images;
  })();
  var AddToCartFlyout = (function () {
    function AddToCartFlyout() {
      classCallCheck(this, AddToCartFlyout);
      this.formData = {};
      this.settings = {};
      this.events = [];
      this.Images = new Images();
      this.flyOutSelector = '[data-x-banner]';
      this.$atcTemplate = jQuery('[data-templates] ' + this.flyOutSelector);
      this._onInit = this._onInit.bind(this);
      this._onOpen = this._onOpen.bind(this);
      this._onClose = this._onClose.bind(this);
      this._onError = this._onError.bind(this);
      this._onSuccess = this._onSuccess.bind(this);
      this._handleDocumentClick = this._handleDocumentClick.bind(this);
      this.messageBanner = new MessageBanner();
      this.header = document.querySelector('.x-head-wrapper');
      this.$header = jQuery(this.header);
      this.$body = jQuery(document.body);
    }
    createClass(AddToCartFlyout, [
      {
        key: 'init',
        value: function init(formData, options) {
          var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          // If any FlyOuts are fully open, close them
          this._closeFlyOuts();
          this.formData = formData;
          // Allows ATC Flow to be overridden
          this.callbacks = jQuery.extend(
            {
              onInit: this._onInit,
              onClose: this._onClose,
              onError: this._onError,
              onOpen: this._onOpen,
              onSuccess: this._onSuccess,
            },
            callbacks
          );
          var $atcButton = options.$atcButton;
          this.settings = jQuery.extend(
            {
              moneyFormat: null,
              cartRedirection: false,
            },
            options.settings
          );
          this.callbacks.onInit();
          this._updateCart($atcButton);
          this._disableButton($atcButton);
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this.messageBanner.dismissBanners();
          this._removeFlyOuts();
          delete this.Images;
        },
      },
      {
        key: '_updateCart',
        value: function _updateCart($atcButton) {
          var _this = this;
          var $flyOut = this.$atcTemplate.clone();
          var quantityField = this.formData.filter(function (data) {
            return data.name === 'quantity';
          });
          var quantity = quantityField[0].value;
          jQuery
            .ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: jQuery.param(this.formData),
              dataType: 'json',
            })
            .done(function (response) {
              if (response.image) {
                var imageUrl = _this.Images.getSizedImageUrl(response.image, '200x');
                var image = _this.Images.loadImage(imageUrl);
                $flyOut.find('[data-x-banner-product-image]').html('<img src="' + image + '" alt="' + response.product_title + '">');
              }
              $flyOut.find('[data-x-banner-product-title]').text(response.product_title + ' \xD7 ' + quantity);
              /*
            TODO: Bring in `variant.options`, iterate through to get option
            name for: <strong>Option name:</strong> Option
           */
              if (response.variant_options[0] !== 'Title' && response.variant_options[0] !== 'Default Title') {
                $flyOut.find('[data-x-banner-product-options]').text(response.variant_options.join(', '));
              }
              /*
            TODO: Bring in variant, and use that to check compare_at_price
            to see if the item is on sale
           */
              var $productPrice = $flyOut.find('[data-x-banner-product-price]');
              $productPrice.text(Shopify.formatMoney(response.price, _this.settings.moneyFormat));
              // Update price to local currency
              dist$2.update($productPrice[0]);
              jQuery
                .ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                })
                .done(function (response) {
                  if (_this.settings.cartRedirection) {
                    return (location.href = '/cart');
                  }
                  _this.callbacks.onSuccess();
                  // Reset formData in case instance is never cleared
                  _this.formData = {};
                  var $subTotal = $flyOut.find('[data-x-banner-cart-subtotal]');
                  $subTotal.text(Shopify.formatMoney(response.original_total_price, _this.settings.moneyFormat));
                  dist$2.update($subTotal[0]);
                  $flyOut.find('[data-x-banner-cart-button]').find('span').text(response.item_count);
                  _this.$body.append($flyOut);
                  // Notifiy Header of new cart count
                  _this.$header.trigger('cartcount:update', { response: response });
                  _this._positionFlyOut($flyOut);
                  _this._bindEvents($flyOut);
                  _this._openFlyOut($flyOut, $atcButton);
                });
            })
            .fail(function (response) {
              var responseText = JSON.parse(response.responseText);
              var error = responseText.description;
              _this._enableButton($atcButton);
              _this.callbacks.onError(error);
            });
        },
      },
      {
        key: '_onError',
        value: function _onError(error) {
          this.messageBanner.message(error, 'error');
        },
      },
      {
        key: '_onInit',
        value: function _onInit() {
          this.messageBanner.dismissBanners();
        },
      },
      {
        key: '_onOpen',
        value: function _onOpen() {
          /*
          The `this.callbacks.onOpen` is used pull keyboard focus into the active flyout
         */
          console.warn('AddToCartFlyout onOpen callback not specified');
        },
      },
      {
        key: '_onClose',
        value: function _onClose() {
          /*
          The `this.callbacks.onClose` is used to return focus to originating DOM
         */
          console.warn('AddToCartFlyout onClose callback not specified');
        },
      },
      {
        key: '_onSuccess',
        value: function _onSuccess() {
          /*
          By default, the ATC Flyout doesn't need any additional success callbacks
           The `this.callbacks.onSuccess` is used to allow other views to initiate
          behaviour when a product has been added to the cart
         */
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents($flyOut) {
          var _this2 = this;
          this.events.push([
            $flyOut.on('click.x-banner', '[data-x-banner-close]', function (event) {
              event.preventDefault();
              _this2._closeFlyOut($flyOut);
            }),
            this.$body.on('position-banners.x-banner', function () {
              _this2._positionFlyOut($flyOut);
            }),
            jQuery(window).on('resize.x-banner', function () {
              justDebounce$1(_this2._positionFlyOut($flyOut), 250);
            }),
            jQuery(window).on('scroll.x-banner', function () {
              _this2._positionFlyOut($flyOut);
            }),
            jQuery(document).on('touchstart.x-banner, click.x-banner', this._handleDocumentClick),
          ]);
        },
        /**
         * Trigger any existing open FlyOuts to close
         *
         * @private
         */
      },
      {
        key: '_closeFlyOuts',
        value: function _closeFlyOuts() {
          var _this3 = this;
          var $excludeFlyOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          jQuery(this.flyOutSelector)
            .filter('[data-flyout-active]')
            .each(function (index, el) {
              var $flyOut = jQuery(el);
              if ($excludeFlyOut && $flyOut.is($excludeFlyOut)) {
                return;
              }
              _this3._closeFlyOut($flyOut, index);
            });
        },
      },
      {
        key: '_openFlyOut',
        value: function _openFlyOut($flyOut, $atcButton) {
          var _this4 = this;
          /*
         If user has initiated a new ATC Flow before the first has finished,
         the first FlyOut could have opened after the first attempt to close open flyouts
        */
          this._closeFlyOuts($flyOut);
          $flyOut.addClass('animating animating-in').one('trend', function () {
            $flyOut.removeClass('animating animating-in').addClass('visible').off('trend');
            $flyOut.attr('data-flyout-active', true);
            _this4.callbacks.onOpen({
              $container: $flyOut,
              $elementToFocus: $flyOut.find('[data-x-banner-cart-button]'),
            });
            _this4._enableButton($atcButton);
          });
        },
        /**
         * Close an open FlyOut
         *
         * @param $flyOut
         * @param index
         * @private
         */
      },
      {
        key: '_closeFlyOut',
        value: function _closeFlyOut() {
          var _this5 = this;
          var $flyOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          if (!$flyOut) {
            return;
          }
          $flyOut.addClass('animating animating-out').one('trend', function () {
            $flyOut.removeClass('animating animating-out visible').one('trend', function () {
              $flyOut.off('trend');
              _this5._removeFlyOut($flyOut, index);
              _this5.callbacks.onClose();
            });
          });
        },
      },
      {
        key: '_removeFlyOuts',
        value: function _removeFlyOuts() {
          var _this6 = this;
          jQuery(this.flyOutSelector)
            .filter('[data-flyout-active]')
            .each(function (index, el) {
              _this6._removeFlyOut(jQuery(el), index);
            });
        },
        /**
         * Remove the Flyout from the DOM, and clean up listeners
         *
         * @param $flyOut
         * @param index
         * @private
         */
      },
      {
        key: '_removeFlyOut',
        value: function _removeFlyOut($flyOut, index) {
          if (this.events[index]) {
            this.events[index].forEach(function ($el) {
              return $el.off('.x-banner');
            });
            this.events.splice(index, 1);
          }
          if ($flyOut) {
            $flyOut.remove();
          }
        },
        /**
         * Position FlyOut beneath header if its in viewport, or at top of viewport
         *
         * @param $flyOut
         * @private
         */
      },
      {
        key: '_positionFlyOut',
        value: function _positionFlyOut($flyOut) {
          $flyOut.css({ top: getHeaderOffset(this.header, true) });
        },
      },
      {
        key: '_disableButton',
        value: function _disableButton($atcButton) {
          $atcButton.addClass('processing').prop('disabled', true);
        },
      },
      {
        key: '_enableButton',
        value: function _enableButton($atcButton) {
          $atcButton.prop('disabled', false).removeClass('processing');
        },
      },
      {
        key: '_handleDocumentClick',
        value: function _handleDocumentClick(event) {
          var target = event.target;
          var $parent = jQuery(target).parents('[data-x-banner]');
          if ($parent.length) {
            return;
          }
          this._closeFlyOuts();
        },
      },
    ]);
    return AddToCartFlyout;
  })();
  var AddToCartFlyout$1 = new AddToCartFlyout();
  var api = 'https://www.youtube.com/iframe_api';
  var apiLoadedCallbacks = [];
  var apiLoaded = false;
  window.onYouTubeIframeAPIReady = function () {
    apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
      return apiLoadedCallback();
    });
    apiLoadedCallbacks = [];
    apiLoaded = true;
  };
  var Youtube = (function () {
    function Youtube(el) {
      classCallCheck(this, Youtube);
      var url = el.getAttribute('data-video-url');
      var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
      this.el = el;
      this.id = url.match(regex)[1] || null;
      this.onApiLoaded = this._onApiLoaded.bind(this);
      this.isReady = false;
      this.onReady = this._onReady.bind(this);
      this.onReadyCallback = null;
      this.onStateChange = this._onStateChange.bind(this);
      this.onPlayCallback = null;
      if (apiLoaded) {
        this._onApiLoaded();
      } else {
        apiLoadedCallbacks.push(this.onApiLoaded);
        script$1(api);
      }
    }
    createClass(Youtube, [
      {
        key: 'play',
        value: function play() {
          var _this = this;
          return new Promise(function (resolve) {
            _this.onPlayCallback = resolve;
            if (_this.isReady) {
              _this.player.playVideo();
            } else {
              _this.onReadyCallback = function () {
                _this.player.playVideo();
              };
            }
          });
        },
      },
      {
        key: 'pause',
        value: function pause() {
          var _this2 = this;
          return new Promise(function (resolve) {
            _this2.onPlayCallback = resolve;
            if (_this2.isReady) {
              _this2.player.pauseVideo();
            } else {
              _this2.onReadyCallback = function () {
                _this2.player.pauseVideo();
              };
            }
          });
        },
      },
      {
        key: 'autoplay',
        value: function autoplay() {
          var _this3 = this;
          return new Promise(function (resolve) {
            _this3.onPlayCallback = resolve;
            if (_this3.isReady) {
              _this3.player.playVideo();
              _this3.player.mute();
            } else {
              _this3.onReadyCallback = function () {
                _this3.player.playVideo();
                _this3.player.mute();
              };
            }
          });
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this.player.destroy();
        },
      },
      {
        key: '_onApiLoaded',
        value: function _onApiLoaded() {
          this.player = new YT.Player(this.el, {
            videoId: this.id,
            playerVars: {
              modestbranding: true,
              showinfo: false,
              controls: false,
              rel: 0,
            },
            events: {
              onReady: this.onReady,
              onStateChange: this.onStateChange,
            },
          });
        },
      },
      {
        key: '_onReady',
        value: function _onReady() {
          this.isReady = true;
          if (this.onReadyCallback) {
            this.onReadyCallback();
          }
        },
      },
      {
        key: '_onStateChange',
        value: function _onStateChange(event) {
          var state = event.data;
          if (this.onPlayCallback && state === YT.PlayerState.PLAYING) {
            this.onPlayCallback();
            this.onPlayCallback = null;
          }
        },
      },
    ]);
    return Youtube;
  })();
  var api$1 = 'https://player.vimeo.com/api/player.js';
  var apiLoaded$1 = false;
  var VimeoPlayer$1 = (function () {
    function VimeoPlayer(el) {
      classCallCheck(this, VimeoPlayer);
      var url = el.getAttribute('data-video-url');
      var urlParts = url.split('/');
      this.el = el;
      this.id = urlParts[urlParts.length - 1];
      this.onReadyCallback = null;
      this.onApiLoaded = this._onApiLoaded.bind(this);
      this.onProgress = this._onProgress.bind(this);
      this.onProgressCallback = null;
      if (apiLoaded$1) {
        this._onApiLoaded();
      } else {
        script$1(api$1, this.onApiLoaded);
      }
    }
    createClass(VimeoPlayer, [
      {
        key: 'play',
        value: function play() {
          var _this = this;
          return new Promise(function (resolve) {
            _this.onProgressCallback = resolve;
            if (apiLoaded$1) {
              _this.player.on('progress', _this.onProgress);
              _this.player.play();
            } else {
              _this.onReadyCallback = function () {
                _this.player.on('progress', _this.onProgress);
                _this.player.play();
              };
            }
          });
        },
      },
      {
        key: 'pause',
        value: function pause() {
          var _this2 = this;
          return new Promise(function (resolve) {
            _this2.onProgressCallback = resolve;
            if (apiLoaded$1) {
              _this2.player.on('progress', _this2.onProgress);
              _this2.player.pause();
            } else {
              _this2.onReadyCallback = function () {
                _this2.player.on('progress', _this2.onProgress);
                _this2.player.pause();
              };
            }
          });
        },
      },
      {
        key: 'autoplay',
        value: function autoplay() {
          var _this3 = this;
          return new Promise(function (resolve) {
            _this3.onProgressCallback = resolve;
            if (apiLoaded$1) {
              _this3.player.on('progress', _this3.onProgress);
              _this3.player.setVolume(0);
              _this3.player.play();
            } else {
              _this3.onReadyCallback = function () {
                _this3.player.on('progress', _this3.onProgress);
                _this3.player.setVolume(0);
                _this3.player.play();
              };
            }
          });
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this.player.unload().catch();
        },
      },
      {
        key: '_onApiLoaded',
        value: function _onApiLoaded() {
          this.player = new window.Vimeo.Player(this.el, { id: this.id });
          this.player.ready().then().catch();
          apiLoaded$1 = true;
          if (this.onReadyCallback) {
            this.onReadyCallback();
          }
        },
      },
      {
        key: '_onProgress',
        value: function _onProgress() {
          this.player.off('progress', this.onProgress);
          if (this.onProgressCallback) {
            this.onProgressCallback();
            this.onProgressCallback = null;
          }
        },
      },
    ]);
    return VimeoPlayer;
  })();
  var Video = (function () {
    function Video(el, options) {
      classCallCheck(this, Video);
      this.el = el;
      this.options = options;
      this.platform = el.getAttribute('data-video').trim();
      this.playButton = el.querySelector('[data-video-play-button]');
      this.videoEl = el.querySelector('[data-video-element]');
      this.onPlayClick = this._onPlayClick.bind(this);
      this.onPauseClick = this._onPauseClick.bind(this);
      this.autoplay = this._autoplay.bind(this);
      this.video = null;
      switch (this.platform) {
        case 'youtube':
          this.video = new Youtube(this.videoEl);
          break;
        case 'vimeo':
          this.video = new VimeoPlayer$1(this.videoEl);
          break;
        default:
          this.video = null;
          break;
      }
      if (this.playButton) {
        if (this.options && this.options.autoplay) {
          this.autoplay();
        }
        this.playButton.addEventListener('click', this.onPlayClick);
      }
    }
    createClass(Video, [
      {
        key: '_onPlayClick',
        value: function _onPlayClick() {
          var _this = this;
          this.el.classList.add('video-loading');
          this.video.play().then(function () {
            _this.el.classList.add('video-transitioning');
            setTimeout(function () {
              _this.el.classList.remove('video-loading');
              _this.el.classList.remove('video-transitioning');
              _this.el.classList.add('video-playing');
            }, 200);
          });
        },
      },
      {
        key: '_onPauseClick',
        value: function _onPauseClick() {
          this.video.pause();
        },
      },
      {
        key: '_autoplay',
        value: function _autoplay() {
          var _this2 = this;
          this.el.classList.add('video-loading');
          this.video.autoplay().then(function () {
            _this2.el.classList.add('video-transitioning');
            setTimeout(function () {
              _this2.el.classList.remove('video-loading');
              _this2.el.classList.remove('video-transitioning');
              _this2.el.classList.add('video-playing');
            }, 200);
          });
        },
      },
      {
        key: 'unload',
        value: function unload() {
          if (this.playButton) {
            this.playButton.removeEventListener('click', this.onPlayClick);
          }
          if (this.video) {
            this.video.unload();
          }
        },
      },
    ]);
    return Video;
  })();
  /**
   * pixelzoom v0.0.1
   * (c) 2018 Pixel Union
   */
  var classCallCheck$3 = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  };
  var createClass$3 = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _extends$1 =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  var Pixelzoom = (function () {
    function Pixelzoom(container, options) {
      classCallCheck$3(this, Pixelzoom);
      this.options = _extends$1(
        {
          imageClass: 'pixelzoom--image',
          imageSource: options.imageSource || container.querySelector('img').src,
          initialZoom: 1,
          dragPan: false,
          naturalPan: false,
          maxZoom: 9999,
          zoomSensitivity: 1,
          zoomSteps: 1,
          overflowContainer: null,
        },
        options
      );
      // Overflow container
      this.overflowContainer = this.options.overflowContainer;
      // Image container
      this.container = container;
      this.container.style.cursor = this.options.maxZoom > this.options.initialZoom ? 'zoom-in' : 'zoom-out';
      this.containerWidth = null;
      this.containerHeight = null;
      // Image
      this.image = new Image();
      this.imageSrc = this.options.imageSource;
      this.imageWidth = null;
      this.imageHeight = null;
      // State
      this.x = 0;
      this.y = 0;
      this.lastX = 0;
      this.lastY = 0;
      this.dragX = null;
      this.dragY = null;
      this.lastDragX = null;
      this.lastDragY = null;
      this.zoom = Math.min(this.options.maxZoom, this.options.initialZoom);
      this.zoomMax = this.options.maxZoom;
      this.zoomMin = 1;
      this.zoomSensitivity = this.options.zoomSensitivity;
      this.zoomSteps = Math.min(this.options.maxZoom, this.options.zoomSteps);
      this.distance = 0;
      this.cursor = this.container.style.cursor;
      this.panning = false;
      this.mouseDown = false;
      this.dragging = false;
      this.touched = false;
      this._triggerEvent('loading');
      this._loadImage();
    }
    /**
     * Load image
     *
     * @private
     */
    createClass$3(Pixelzoom, [
      {
        key: '_loadImage',
        value: function _loadImage() {
          var _this = this;
          this.image.addEventListener('load', function () {
            _this._appendImage();
          });
          this.image.classList.add(this.options.imageClass);
          this.image.src = this.imageSrc;
          this.image.style.position = 'absolute';
          this.image.style.top = '100%';
          this.image.style.left = '100%';
          this.image.style.maxWidth = '100%';
          this.image.style.maxHeight = '100%';
          this.image.style.transformOrigin = 'top left';
        },
        /**
         * Append image to the DOM
         *
         * @private
         */
      },
      {
        key: '_appendImage',
        value: function _appendImage() {
          this._triggerEvent('loaded');
          this.container.appendChild(this.image);
          this.refresh();
          this._bindEvents();
          if (this.zoom > this.zoomMin) {
            this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
            this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;
            if (this.lastDragX === null && this.lastDragY == null) {
              var offset = this.container.getBoundingClientRect();
              var dragX =
                this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom
                  ? this.overflowContainer.offsetWidth
                  : this.containerWidth;
              var dragY =
                this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageHeight * this.zoom
                  ? this.overflowContainer.offsetHeight
                  : this.containerHeight;
              var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
              var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;
              this.lastDragX = dragX / 2 + offset.left + scrollLeft;
              this.lastDragY = dragY / 2 + offset.top + scrollTop;
            }
          } else {
            this.x = -this.imageWidth;
            this.y = -this.imageHeight;
          }
          this.lastX = this.x;
          this.lastY = this.y;
          this._update();
        },
        /**
         * Bind mouse and touch events
         *
         * @private
         */
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this2 = this;
          this.container.addEventListener('mousedown', function (event) {
            event.stopPropagation();
            var pointer = _this2._getPointerBounds(event);
            _this2._initializeDrag(pointer[0]);
          });
          this.container.addEventListener('mouseenter', function () {
            event.stopPropagation();
            _this2._initializeMouse();
          });
          this.container.addEventListener('touchstart', function (event) {
            event.stopPropagation();
            var pointers = _this2._getPointerBounds(event);
            _this2._initializeTouch(pointers[0], pointers[1]);
          });
          this.container.addEventListener('dragstart', function (event) {
            event.stopPropagation();
            _this2._preventDrag(event);
          });
          ['mousemove', 'touchmove'].forEach(function (eventType) {
            _this2.container.addEventListener(eventType, function (event) {
              var pointers = _this2._getPointerBounds(event);
              _this2._pan(eventType, pointers[0], pointers[1]);
            });
          });
          this.container.addEventListener('mouseup', function (event) {
            event.stopPropagation();
            _this2._tap({
              x: event.pageX,
              y: event.pageY,
            });
          });
          ['mouseleave', 'touchend'].forEach(function (eventType) {
            _this2.container.addEventListener(eventType, function (event) {
              event.stopPropagation();
              _this2._release();
            });
          });
          this.container.addEventListener('wheel', function (event) {
            event.stopPropagation();
            _this2._scroll(event.deltaY, {
              x: event.pageX,
              y: event.pageY,
            });
          });
          document.body.addEventListener('touchmove', function (event) {
            _this2._preventScroll(event);
          });
        },
        /**
         * Increment or decrement zoom
         *
         * @param {number} adjustment
         * @private
         */
      },
      {
        key: '_setZoom',
        value: function _setZoom(adjustment) {
          this._triggerEvent('zoom');
          var zoom = this.zoom + adjustment;
          zoom = Math.min(this.zoomMax, zoom);
          zoom = Math.max(this.zoomMin, zoom);
          this.zoom = zoom;
          if (this.zoom === this.zoomMax) {
            this.container.style.cursor = 'zoom-out';
            this.cursor = 'zoom-out';
            this._triggerEvent('zoomMax');
          } else {
            this.container.style.cursor = 'zoom-in';
            this.cursor = 'zoom-in';
          }
          if (this.zoom === this.zoomMin) {
            this.lastDragX = null;
            this.lastDragY = null;
            this._triggerEvent('zoomMin');
          }
        },
        /**
         * Set image center position
         *
         * @param {object} pointer
         * @private
         */
      },
      {
        key: '_setCenter',
        value: function _setCenter(pointer, event) {
          if (this.zoom !== this.zoomMin) {
            var offset = this.container.getBoundingClientRect();
            var zoomWidth = this.imageWidth * this.zoom - this.containerWidth;
            var zoomHeight = this.imageHeight * this.zoom - this.containerHeight;
            var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
            var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;
            if (!(this.zoom - 1 > this.zoomMin && event === 'tap') || (event === 'tap' && this.zoomSteps >= this.zoomMax)) {
              this.lastX = pointer.x;
              this.lastY = pointer.y;
            }
            var currentX =
              (offset.left - this.lastX) * (zoomWidth / this.containerWidth) - this.containerWidth + scrollLeft * this.zoom - scrollLeft;
            var currentY =
              (offset.top - this.lastY) * (zoomHeight / this.containerHeight) - this.containerHeight + scrollTop * this.zoom - scrollTop;
            currentX = Math.max(-this.imageWidth * this.zoom, currentX);
            currentY = Math.max(-this.imageHeight * this.zoom, currentY);
            if (this.overflowContainer) {
              currentX = Math.max(-this.imageWidth * this.zoom + offset.left, currentX);
              currentY = Math.max(-this.imageHeight * this.zoom + offset.top, currentY);
              currentX = Math.min(-this.imageWidth - offset.left, currentX);
              currentY = Math.min(-this.imageHeight - offset.top, currentY);
            }
            if (this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom) {
              this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
            } else {
              this.x = Math.min(-this.imageWidth, currentX);
            }
            if (this.overflowContainer && this.overflowContainer.offsetHeight >= this.imageHeight * this.zoom) {
              this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;
            } else {
              this.y = Math.min(-this.imageHeight, currentY);
            }
          } else {
            this.x = -this.imageWidth;
            this.y = -this.imageHeight;
            this.lastX = 0;
            this.lastY = 0;
            this.lastDragX = null;
            this.lastDragY = null;
          }
        },
        /**
         * Initialize zoom for non-touch devices
         *
         * @private
         */
      },
      {
        key: '_initializeMouse',
        value: function _initializeMouse() {
          this._triggerEvent('touch');
          this.refresh();
        },
        /**
         * Initialize drag
         *
         * @private
         */
      },
      {
        key: '_initializeDrag',
        value: function _initializeDrag(pointer) {
          if (this.options.dragPan) {
            this.mouseDown = true;
            if (this.lastDragX === null && this.lastDragY === null) {
              this.lastDragX = pointer.x;
              this.lastDragY = pointer.y;
            }
          }
        },
        /**
         * Initialize zoom for touch devices
         *
         * @param {object} touches
         * @param {object} pointerOne
         * @param {object} pointerTwo
         * @private
         */
      },
      {
        key: '_initializeTouch',
        value: function _initializeTouch(pointerOne, pointerTwo) {
          this._triggerEvent('touch');
          this.touched = true;
          if (this.lastDragX === null && this.lastDragY == null) {
            this.lastDragX = pointerOne.x;
            this.lastDragY = pointerOne.y;
          }
          if (pointerTwo && pointerTwo.x && pointerTwo.y) {
            this.distance = Math.hypot(pointerOne.x - pointerTwo.x, pointerOne.y - pointerTwo.y);
          }
        },
        /**
         * Pan image
         *
         * @param {string} eventType
         * @param {object} touches
         * @param {object} pointerOne
         * @param {object} pointerTwo
         * @private
         */
      },
      {
        key: '_pan',
        value: function _pan(eventType, pointerOne, pointerTwo) {
          if (pointerTwo && pointerTwo.x && pointerTwo.y) {
            if (this.panning || !this.touched) {
              this._pinch(
                {
                  x: pointerOne.x,
                  y: pointerOne.y,
                },
                {
                  x: pointerTwo.x,
                  y: pointerTwo.y,
                }
              );
            }
          } else {
            if (this.options.dragPan && this.mouseDown === false && eventType !== 'touchmove') {
              return;
            } else if ((this.options.dragPan && this.mouseDown) || eventType === 'touchmove') {
              this.dragging = true;
              this.container.style.cursor = 'move';
            }
            if (this.panning || !this.touched) {
              if (this.dragging) {
                this._drag({
                  x: pointerOne.x,
                  y: pointerOne.y,
                });
              } else {
                this._setCenter({
                  x: pointerOne.x,
                  y: pointerOne.y,
                });
                this._update();
              }
            } else {
              if (!this.dragging) {
                this._setCenter({
                  x: this.lastX,
                  y: this.lastY,
                });
                this._update();
              }
            }
          }
          if (eventType === 'touchmove' && !this.panning) {
            this.panning = true;
            this._triggerEvent('pan');
          }
        },
        /**
         * Zoom into the image on pinch
         *
         * @param {object} touchOne
         * @param {object} touchTwo
         * @private
         */
      },
      {
        key: '_pinch',
        value: function _pinch(touchOne, touchTwo) {
          this._triggerEvent('pinch');
          var distance = Math.hypot(touchOne.x - touchTwo.x, touchOne.y - touchTwo.y);
          var zoomAdjustment = this.zoom / (this.zoomSensitivity * 2);
          var difference = Math.abs(distance) - Math.abs(this.distance);
          if (difference > 0.5 || difference < -0.5) {
            this._setZoom(distance > this.distance ? +zoomAdjustment : -zoomAdjustment);
          }
          this.refresh();
          if (this.zoom < this.zoomMax) {
            if (distance > this.distance) {
              touchOne.x -= (touchOne.x - touchTwo.x) / 2;
              touchOne.y -= (touchOne.y - touchTwo.y) / 2;
            } else {
              touchOne.x = this.lastDragX;
              touchOne.y = this.lastDragY;
            }
            this.lastDragX = touchOne.x;
            this.lastDragY = touchOne.y;
            this.dragX = 0;
            this.dragY = 0;
            this._setCenter({
              x: touchOne.x,
              y: touchOne.y,
            });
            this.distance = distance;
            this._update();
          }
        },
        /**
         * Drag image
         *
         * @param {object} pointer
         * @private
         */
      },
      {
        key: '_drag',
        value: function _drag(pointer) {
          if (this.dragX && this.dragY && this.lastDragX !== null && this.lastDragY !== null) {
            var differenceX = (this.dragX - pointer.x) / (this.zoom / 2);
            var differenceY = (this.dragY - pointer.y) / (this.zoom / 2);
            var dragX = this.lastDragX;
            var dragY = this.lastDragY;
            if (this.options.naturalPan) {
              dragX += differenceX;
              dragY += differenceY;
            } else {
              dragX -= differenceX;
              dragY -= differenceY;
            }
            dragX = Math.min(this.imageWidth * this.zoom, dragX);
            this.lastDragX = Math.max(0, dragX);
            dragY = Math.min(this.imageHeight * this.zoom, dragY);
            this.lastDragY = Math.max(0, dragY);
            this.lastX = this.lastDragX;
            this.lastY = this.lastDragY;
            this._setCenter({
              x: this.lastDragX,
              y: this.lastDragY,
            });
            this._update();
          }
          this.dragX = pointer.x;
          this.dragY = pointer.y;
        },
        /**
         * Zoom into the image on tap/click
         *
         * @param {object} pointer
         * @private
         */
      },
      {
        key: '_tap',
        value: function _tap(pointer) {
          this._triggerEvent('tap');
          if (!this.panning && !this.dragging) {
            this._setZoom(this.zoomMax > this.zoom ? +this.zoomSteps : -this.zoomMax);
            this.refresh();
            this._setCenter(pointer, 'tap');
            this.lastDragX = this.lastX;
            this.lastDragY = this.lastY;
            this._update();
          }
          this.panning = false;
          this.mouseDown = false;
          this.dragging = false;
          this.touched = false;
          this.distance = 0;
          this.dragX = 0;
          this.dragY = 0;
          this.container.style.cursor = this.cursor;
        },
        /**
         * Zoom into the image on scroll
         *
         * @param {int} scale
         * @param {object} pointer
         * @private
         */
      },
      {
        key: '_scroll',
        value: function _scroll(scale, pointer) {
          if (!this.dragging) {
            this._triggerEvent('scroll');
            var zoomAdjustment = this.zoom / this.zoomSensitivity;
            if (this.options.dragPan && this.zoom > this.zoomMin) {
              pointer.x = this.lastDragX;
              pointer.y = this.lastDragY;
            }
            this.lastDragX = pointer.x;
            this.lastDragY = pointer.y;
            this.dragX = 0;
            this.dragY = 0;
            this._setZoom(scale < 0 ? +zoomAdjustment : -zoomAdjustment);
            this.refresh();
            this._setCenter(pointer);
            this._update();
          }
        },
        /**
         * Set panning to false
         *
         * @private
         */
      },
      {
        key: '_release',
        value: function _release() {
          this._triggerEvent('release');
          this.panning = false;
          this.mouseDown = false;
          this.dragging = false;
          this.dragX = 0;
          this.dragY = 0;
          this.container.style.cursor = this.cursor;
        },
        /**
         * Prevent images from being dragged
         *
         * @param {object} event
         * @private
         */
      },
      {
        key: '_preventDrag',
        value: function _preventDrag(event) {
          event.preventDefault();
        },
        /**
         * Prevent body from scrolling when image is being panned
         *
         * @param {object} event
         * @private
         */
      },
      {
        key: '_preventScroll',
        value: function _preventScroll(event) {
          if (this.panning) {
            event.preventDefault();
          }
        },
        /**
         * Get the pointer bounds from the event
         *
         * @param {object} event
         * @private
         */
      },
      {
        key: '_getPointerBounds',
        value: function _getPointerBounds(event) {
          var pointers = [
            {
              x: event.pageX ? event.pageX : event.touches[0].clientX,
              y: event.pageY ? event.pageY : event.touches[0].clientY,
            },
            {
              x: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientX : null,
              y: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientY : null,
            },
          ];
          return pointers;
        },
        /**
         * Create an event and trigger it
         *
         * @param {string} name
         * @private
         */
      },
      {
        key: '_triggerEvent',
        value: function _triggerEvent(name) {
          var event = new Event('pixelzoom:' + name, { bubbles: true, cancelable: false });
          this.container.dispatchEvent(event);
        },
        /**
         * Update the image position by adjustng the CSS
         *
         * @private
         */
      },
      {
        key: '_update',
        value: function _update() {
          var _this3 = this;
          requestAnimationFrame(function () {
            _this3.image.style.transform = 'translate(' + _this3.x + 'px, ' + _this3.y + 'px) scale(' + _this3.zoom + ')';
          });
        },
        /**
         * Refresh variables
         *
         * @public
         */
      },
      {
        key: 'refresh',
        value: function refresh() {
          this.containerWidth = this.container.offsetWidth;
          this.containerHeight = this.container.offsetHeight;
          this.imageWidth = Math.min(this.containerWidth, this.image.width);
          this.imageHeight = Math.min(this.containerHeight, this.image.height);
          var maxZoom = Math.floor(this.image.naturalWidth / this.containerWidth);
          this.zoomMax = this.options.maxZoom < maxZoom ? this.options.maxZoom : maxZoom;
          this.zoom = Math.min(this.zoomMax, this.zoom);
          this.zoomSteps = Math.min(this.zoomMax, this.zoomSteps);
          if (this.zoomMax <= 1) {
            this.container.style.cursor = 'default';
            this.cursor = 'default';
          }
        },
        /**
         * Update the image position by adjustng the CSS
         *
         * @public
         */
      },
      {
        key: 'unload',
        value: function unload() {
          var _this4 = this;
          this.image.removeEventListener('load', this._appendImage);
          document.body.removeEventListener('touchmove', this._preventScroll);
          [
            ['mouseenter', this._initializeMouse],
            ['touchstart', this._initializeTouch],
            ['mousedown', this._initializeDrag],
            ['dragstart', this._preventDrag],
            ['mousemove', this._pan],
            ['touchmove', this._pan],
            ['mouseup', this._tap],
            ['touchend', this._release],
            ['mouseleave', this._release],
            ['wheel', this._scroll],
          ].forEach(function (eventType) {
            _this4.container.removeEventListener(eventType[0], eventType[1]);
          });
          this.image.parentNode.removeChild(this.image);
        },
      },
    ]);
    return Pixelzoom;
  })();
  var ProductZoom = (function () {
    function ProductZoom(options) {
      classCallCheck(this, ProductZoom);
      this.$gallery = options.$gallery;
      this.settings = options.settings;
      this.$slider = this.$gallery.find('[data-product-slider]');
      this.$pixelzoomOverlay = this.$gallery.find('[data-pixelzoom-overlay]');
      this.$pixelzoomOverlayContainer = this.$pixelzoomOverlay.find('[data-pixelzoom-overlay-container]');
      this.imageZoom = {};
      this.zoomOverlay = null;
      this.index = 0;
      this._beforeOpen = this._beforeOpen.bind(this);
      this._onOpen = this._onOpen.bind(this);
      this._onClose = this._onClose.bind(this);
      this.modal = new Modal({
        onBeforeOpen: this._beforeOpen,
        onOpen: this._onOpen,
        onClose: this._onClose,
      });
      this.modalOpen = false;
      this.swipping = false;
      this.touched = false;
      this._bindEvents();
      this.enableZoom();
    }
    createClass(ProductZoom, [
      {
        key: 'unload',
        value: function unload() {
          var _this = this;
          if (Object.keys(this.imageZoom).length !== 0) {
            Object.keys(this.imageZoom).forEach(function (image) {
              _this.imageZoom[image].unload();
            });
          }
          if (this.zoomOverlay) {
            this.zoomOverlay.unload();
            this.zoomOverlay = null;
          }
          document.body.removeEventListener(
            'touchmove',
            function (event) {
              event.preventDefault();
            },
            { passive: false }
          );
          this.modal.unload();
          this.$pixelzoomOverlayContainer.off('pixelzoom:pan');
          this.$pixelzoomOverlayContainer.off('pixelzoom:release');
          this.$slider.off('.product-zoom');
        },
      },
      {
        key: 'enableZoom',
        value: function enableZoom(index) {
          var _this2 = this;
          if ((index !== -1 && index) || index === 0) {
            this.index = index;
          }
          var $newSlide = this.$slider.find('[data-product-image-index=' + this.index + '] .product-galley--image-background');
          var inObject = !this.imageZoom[this.index];
          var slideExists = this.$gallery.find('[data-product-image-index=' + this.index + '][data-product-image-zoom]').length;
          if (inObject && slideExists) {
            this.imageZoom[this.index] =
              //layout.isBreakpoint('XS') ? true :
              new Pixelzoom($newSlide[0], {
                imageSource: $newSlide[0].dataset.image,
                initialZoom: this.settings.image_zoom_level === 'min' ? 1 : 9999,
                zoomSensitivity: 10,
                maxZoom: 9999,
                zoomSteps: 9999,
                naturalPan: true,
              });
            $newSlide.on('pixelzoom:touch', function () {
              var imageWidth = $newSlide.find('.pixelzoom--image').get(0).naturalWidth;
              var imageHeight = $newSlide.find('.pixelzoom--image').get(0).naturalHeight;
              if (!layout.isBreakpoint('XS') && (imageWidth / $newSlide.width() >= 2 || imageHeight / $newSlide.height() >= 2)) {
                _this2._toggleClass(jQuery('body'), 'pixelzoom--active');
              }
              _this2.touched = true;
            });
            $newSlide.on('pixelzoom:release', function () {
              _this2._toggleClass(jQuery('body'), 'pixelzoom--active', true);
              _this2.touched = false;
            });
          }
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this3 = this;
          this.$slider.on('dragStart.flickity', function (event) {
            _this3._preventClick();
          });
          this.$slider.on('settle.flickity', function (event) {
            _this3._resolveClick();
          });
          this.$slider.on('click.product-zoom', function () {
            _this3._openModal();
          });
          document.body.addEventListener(
            'touchmove',
            function (event) {
              _this3._preventScroll(event);
            },
            { passive: false }
          );
        },
      },
      {
        key: '_toggleClass',
        value: function _toggleClass(element, className, remove) {
          if (remove) {
            element.removeClass(className);
          } else {
            element.addClass(className);
          }
        },
      },
      {
        key: '_openModal',
        value: function _openModal() {
          /*
          TODO: Add mobile functionality for image zoom
           if (layout.isBreakpoint('XS') && this.imageZoom[this.index] && !this.swipping) {
          this.modal.open('[data-pixelzoom-overlay-container]', 'pixelzoom');
          this.zoomOverlay.refresh();
          }
        */
        },
      },
      {
        key: '_beforeOpen',
        value: function _beforeOpen() {
          var $newSlide = this.$slider.find('[data-product-image-index=' + this.index + '] .product-galley--image-background');
          this.$pixelzoomOverlayContainer.find('[data-image]').replaceWith($newSlide.find('[data-image]').clone());
        },
      },
      {
        key: '_onOpen',
        value: function _onOpen() {
          var _this4 = this;
          var $newSlide = this.$slider.find('[data-product-image-index=' + this.index + '] .product-galley--image-background');
          this.modalOpen = true;
          setTimeout(function () {
            _this4.zoomOverlay = new Pixelzoom(document.querySelector('[data-modal-content]'), {
              imageSource: $newSlide[0].dataset.image,
              naturalPan: true,
              dragPan: true,
              initialZoom: _this4.settings.image_zoom_level === 'min' ? 1 : 9999,
              maxZoom: 9999,
              zoomSensitivity: 10,
              zoomSteps: 9999,
              overflowContainer: document.querySelector('.modal--pixelzoom'),
            });
            jQuery('[data-modal-content]').on('pixelzoom:loaded', function () {
              jQuery('[data-modal-content]').addClass('loaded');
            });
            jQuery('[data-modal-content]').on('pixelzoom:touch', function () {
              _this4._toggleClass(jQuery('body'), 'pixelzoom--active');
            });
            jQuery('[data-modal-content]').on('pixelzoom:release', function () {
              _this4._toggleClass(jQuery('body'), 'pixelzoom--active', true);
            });
          }, 500);
        },
      },
      {
        key: '_onClose',
        value: function _onClose() {
          jQuery('[data-modal-content]').removeClass('loaded');
          this.zoomOverlay.unload();
          this.zoomOverlay = null;
          this.modalOpen = false;
        },
      },
      {
        key: '_preventScroll',
        value: function _preventScroll(event) {
          if (this.modalOpen || (this.touched && !layout.isBreakpoint('XS'))) {
            event.preventDefault();
          }
        },
      },
      {
        key: '_preventClick',
        value: function _preventClick() {
          this.swipping = true;
        },
      },
      {
        key: '_resolveClick',
        value: function _resolveClick() {
          this.swipping = false;
        },
      },
    ]);
    return ProductZoom;
  })();
  var ProductGallery = (function () {
    function ProductGallery(options) {
      classCallCheck(this, ProductGallery);
      this.$gallery = options.$gallery;
      this.settings = options.settings;
      this.isQuickshop = options.isQuickshop || false;
      // Gallery
      this.flickity = null;
      this.slider = '[data-product-slider]';
      this.$slider = this.$gallery.find(this.slider);
      this.slides = '[data-product-image]';
      this.$slides = this.$gallery.find(this.slides);
      this.slideImages = this.$slider[0].querySelectorAll('[data-image]');
      this.$sliderPagination = this.$gallery.find('[data-product-slider-pagination]');
      this.$paginationTrigger = this.$gallery.find('[data-product-thumbnail]');
      this.productZoom = null;
      if (this.settings.enable_image_zoom) {
        this.productZoom = new ProductZoom(options);
      }
      this.videos = {};
      this.videoSlides = this.$slider[0].querySelectorAll('[data-product-image-video]');
      // Re-initialise gallery when crossing breakpoints if needed
      this._onUpdateGallery = this._onUpdateGallery.bind(this);
      layout.onBreakpointChange(this._onUpdateGallery);
      this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
      this.variantChange = this._onVariantChange.bind(this);
      if (this.isQuickshop) {
        this.$gallery.trigger('theme:image:watch');
      }
      this._init();
    }
    createClass(ProductGallery, [
      {
        key: 'unload',
        value: function unload() {
          for (var i = 0; i < this.slideImages.length; i += 1) {
            this.slideImages[i].removeEventListener('image:load', this.slideImageLoaded);
          }
          if (this.productZoom) {
            this.productZoom.unload();
          }
          if (this.isQuickshop) {
            this.$gallery.trigger('theme:image:unwatch');
          }
          if (this.isQuickshop) {
            this._onUpdateGallery();
          }
          layout.offBreakpointChange(this._onUpdateGallery);
          this._unloadGallery();
        },
      },
      {
        key: '_init',
        value: function _init() {
          for (var i = 0; i < this.slideImages.length; i += 1) {
            this.slideImages[i].addEventListener('image:load', this.slideImageLoaded);
          }
          if (this.videoSlides.length) {
            for (var _i = 0; _i < this.videoSlides.length; _i += 1) {
              var videoSlide = this.videoSlides[_i];
              var slideId = videoSlide.getAttribute('data-product-image');
              var videoEl = videoSlide.querySelector('[data-video]');
              this.videos[slideId] = new Video(videoEl);
            }
          }
          if (this.$slides.length) {
            this._initGallery();
          }
        },
        /**
         * Make sure Flickity updates viewport height when images load in
         * @private
         */
      },
      {
        key: '_onSlideImageLoaded',
        value: function _onSlideImageLoaded() {
          if (!this.flickity) {
            return;
          }
          var activeHeight = this.flickity.selectedElement.offsetHeight;
          var flickityHeight = this.flickity.viewport.offsetHeight;
          // If flickity height is greater than slide height, ignore
          if (activeHeight < flickityHeight) {
            return;
          }
          this.flickity.resize();
        },
      },
      {
        key: '_unloadGallery',
        value: function _unloadGallery() {
          if (this.flickity) {
            this.$paginationTrigger.off('.gallery');
            this.flickity.destroy();
            this.flickity = null;
            this.$slider.find(this.slides).attr('style', '');
          }
        },
      },
      {
        key: '_onUpdateGallery',
        value: function _onUpdateGallery() {
          this._unloadGallery();
          this._initGallery();
        },
        /**
         * Update gallery on variant change
         *
         * @param variant
         * @property {Object} options.featured_image - Featured image information
         * @private
         */
      },
      {
        key: '_onVariantChange',
        value: function _onVariantChange(variant) {
          if (!variant.featured_image || !this.flickity) {
            return;
          }
          var index = this.$slider.find('[data-product-image=' + variant.featured_image.id + ']').attr('data-product-image-index');
          this.flickity.select(index, false, false);
        },
      },
      {
        key: '_initGallery',
        value: function _initGallery() {
          var $selectedImage = this.$slider.find('.image--selected');
          // Options shared on Desktop and Mobile
          var flickityOptions = {
            autoPlay: 0,
            accessibility: true,
            adaptiveHeight: true,
            cellAlign: 'left',
            cellSelector: this.slides,
            pageDots: false,
            imagesLoaded: false,
            prevNextButtons: false,
            wrapAround: true,
          };
          // Mobile only options
          var optionsMobile = {
            draggable: true,
            friction: 0.8,
            selectedAttraction: 0.2,
          };
          // Desktop only options
          var optionsDesktop = {
            draggable: false,
          };
          if (layout.isBreakpoint('XS')) {
            flickityOptions = jQuery.extend({}, optionsMobile, flickityOptions);
          } else {
            flickityOptions = jQuery.extend({}, optionsDesktop, flickityOptions);
          }
          // If a variant has an image pre-selected, start the slideshow at that image
          // If the slideshow has been re-initalised across a break point, slideshow
          // restarts at same slide
          if ($selectedImage.length) {
            var initialIndex = parseInt($selectedImage.attr('data-product-image-index'), 10);
            flickityOptions = jQuery.extend({}, { initialIndex: initialIndex }, flickityOptions);
          }
          this.flickity = new js$1(this.$slider[0], flickityOptions);
          this._bindGallery();
          this._handleGalleryVideos();
        },
      },
      {
        key: '_bindGallery',
        value: function _bindGallery() {
          var _this = this;
          this.flickity.on('select', function () {
            _this._updateActiveSlide(_this.flickity.selectedIndex);
            _this._handleGalleryVideos();
          });
          this.$paginationTrigger.on('click.gallery', function (event) {
            event.preventDefault();
            var $target = jQuery(event.currentTarget);
            _this.flickity.select($target.attr('data-product-thumbnail'), false, false);
          });
        },
        /**
         * Handle gallery videos
         * - Pause video if is not active slide
         * - Play video if is active slide, and is autoplay
         *
         * @private
         */
      },
      {
        key: '_handleGalleryVideos',
        value: function _handleGalleryVideos() {
          var _this2 = this;
          var slideId = parseInt(this.flickity.selectedElement.getAttribute('data-product-image'), 10);
          Object.keys(this.videos).forEach(function (key) {
            var videoKey = parseInt(key, 10);
            // Pause inactive slide videos
            if (slideId !== videoKey) {
              _this2.videos[videoKey].onPauseClick();
            }
            // Play video if is selected, and auto play enabled
            if (slideId === videoKey && _this2.settings.enable_video_autoplay) {
              _this2.videos[videoKey].autoplay();
            }
          });
        },
        /**
         * Adds a non-flickity active class to thumbnails, and main slideshow
         *  - Is used on re-init across breakpoints
         *  - Is used to show the active thumbnail in the pagination
         *
         * @param index
         * @private
         */
      },
      {
        key: '_updateActiveSlide',
        value: function _updateActiveSlide(index) {
          var $newSlide = this.$slider.find('[data-product-image-index=' + index + ']');
          var $newThumbnail = this.$sliderPagination.find('[data-product-thumbnail=' + index + ']');
          $newSlide.addClass('image--selected').siblings('.image--selected').removeClass('image--selected');
          $newThumbnail.addClass('thumbnail--selected').siblings('.thumbnail--selected').removeClass('thumbnail--selected');
          if (layout.isBreakpoint('XS')) {
            scrollLeft($newThumbnail);
          }
          if (this.settings.enable_image_zoom) {
            this.productZoom.enableZoom(index);
          }
        },
      },
    ]);
    return ProductGallery;
  })();
  var ProductDetails = (function () {
    function ProductDetails(options) {
      classCallCheck(this, ProductDetails);
      this.$window = jQuery(window);
      this.$formArea = options.$formArea;
      this.$gallery = options.$gallery;
      this.$details = options.$details;
      this.context = options.context;
      this.settings = options.settings;
      this.product = options.product;
      this.useHistory = options.useHistory;
      this.variantHelper = null;
      // Product ATC Actions
      this._onATCOpen = this._onATCOpen.bind(this);
      this._onATCClose = this._onATCClose.bind(this);
      this.atcCallbacks = jQuery.extend(
        {
          onClose: this._onATCClose,
          onOpen: this._onATCOpen,
        },
        options.atcCallbacks
      );
      // Form
      this.$form = this.$formArea.find('[data-product-form]');
      this.$productAtcButton = this.$formArea.find('[data-product-atc]');
      this.$productVariants = this.$form.find('[data-variants]');
      this.$productOptions = this.$form.find('[data-product-option]');
      this.variantFields = {
        $price: this.$details.find('[data-price]'),
        $priceMoney: this.$details.find('[data-price] .money'),
        $compareAtPrice: this.$details.find('[data-price-compare-at]'),
        $compareAtPriceMoney: this.$details.find('[data-price-compare-at] .money'),
        $badge: this.$details.find('[data-badge-sales]'),
        $badgeMoneySaved: this.$details.find('[data-price-money-saved]'),
        $badgePercentSaved: this.$details.find('[data-price-percent-saved]'),
      };
      this.forms = new Forms(this.$form);
      this.gallery = new ProductGallery(options);
      this._bindEvents();
      this._initOptions();
    }
    createClass(ProductDetails, [
      {
        key: 'unload',
        value: function unload() {
          this.$form.off('.product-details');
          this.forms.unload();
          if (this.variantHelper) {
            this.variantHelper.unload();
          }
          this.gallery.unload();
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$window.on('product-variant-switch.product-details', function (event, data) {
            return _this._switchVariant(event, data);
          });
          this.$form.on('submit.product-details', function (event) {
            return _this._AddToCartFlyout(event);
          });
        },
      },
      {
        key: '_initOptions',
        value: function _initOptions() {
          if (!this.$productVariants.length) return;
          this.variantHelper = new VariantHelper(this.product, this.$productVariants, this.$productOptions);
        },
      },
      {
        key: '_switchVariant',
        value: function _switchVariant(event, data) {
          if (data.product !== this.product) return;
          var variant = data.variant;
          var firstLoad = data.firstLoad;
          if (firstLoad) {
            return;
          }
          // Update main select
          this.$productVariants.val(data.variant.id);
          this.gallery.variantChange(variant);
          // Update Variant information
          this._updatePrice(variant);
          // this._updateBadge(variant)
          this._updateButton(variant);
          if (this.useHistory) {
            var url = this.product.handle + '?' + jQuery.param({ variant: variant.id });
            history.replaceState({}, 'variant', url);
          }
        },
      },
      {
        key: '_updatePrice',
        value: function _updatePrice(variant) {
          // Update compare at price
          var hasComparePrice = !!variant.compare_at_price && variant.compare_at_price > variant.price;
          this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
          this.variantFields.$compareAtPriceMoney.text(Shopify.formatMoney(variant.compare_at_price, this.settings.money_format));
          dist$2.update(this.variantFields.$compareAtPriceMoney[0]);
          // Update price
          this.variantFields.$priceMoney.text(Shopify.formatMoney(variant.price, this.settings.money_format));
          dist$2.update(this.variantFields.$priceMoney[0]);
        },
      },
      {
        key: '_updateBadge',
        value: function _updateBadge(variant) {
          var priceSaved = variant.compare_at_price ? variant.compare_at_price - variant.price : 0;
          this.variantFields.$badge.toggle(!!priceSaved);
          if (this.variantFields.$badgeMoneySaved.length) {
            // Update badge if it shows money saved
            this.variantFields.$badgeMoneySaved.text(Shopify.formatMoney(priceSaved, this.settings.money_format));
            dist$2.update(this.variantFields.$badgeMoneySaved[0]);
          }
          if (this.variantFields.$badgePercentSaved.length) {
            // Update badge if it shows percentiles
            var percentileSaved = Math.round((priceSaved * 100) / variant.compare_at_price);
            this.variantFields.$badgePercentSaved.text(percentileSaved);
          }
        },
      },
      {
        key: '_updateButton',
        value: function _updateButton(variant) {
          if (variant.available) {
            this.$productAtcButton.text(this.context.product_available);
            this.$productAtcButton.removeClass('disabled').prop('disabled', false);
          } else {
            this.$productAtcButton.text(this.context.product_unavailable);
            this.$productAtcButton.addClass('disabled').prop('disabled', true);
          }
        },
      },
      {
        key: '_AddToCartFlyout',
        value: function _AddToCartFlyout(event) {
          event.preventDefault();
          var formData = this.$form.serializeArray();
          var options = {
            $atcButton: this.$productAtcButton,
            settings: {
              moneyFormat: this.settings.money_format,
              cartRedirection: this.settings.cart_redirection,
            },
          };
          AddToCartFlyout$1.init(formData, options, this.atcCallbacks);
        },
        /**
         * Callback when AddToCartFlyout opens
         * Move keyboard focus into flyout
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
         * @private
         */
      },
      {
        key: '_onATCOpen',
        value: function _onATCOpen(options) {
          trapFocus({
            $container: options.$container,
            $elementToFocus: options.$elementToFocus,
            namespace: 'product-details-flyout',
          });
        },
        /**
         * Callback when AddToCartFlyout closes
         * Move keyboard focus back into grid item
         *
         * @private
         */
      },
      {
        key: '_onATCClose',
        value: function _onATCClose() {
          removeTrapFocus({
            namespace: 'product-details-flyout',
          });
          this.$productAtcButton.focus();
        },
      },
    ]);
    return ProductDetails;
  })();
  var ProductQuickshop = (function () {
    function ProductQuickshop(options) {
      classCallCheck(this, ProductQuickshop);
      this.$el = options.$el;
      this.$quickShop = this.$el.find('[data-product-quickshop]');
      this.modalClass = options.modalClass;
      this.loaded = false;
      this.richText = null;
      this.productDetails = null;
      this.quickShopHTML = null;
      try {
        this.data = JSON.parse(this.$el.find('[data-product-quickshop-data]').text());
      } catch (error) {
        return console.warn('Quickshop: invalid quickshop data found. ' + error.message);
      }
      try {
        this.quickShopHTML = JSON.parse(this.$el.find('[data-product-quickshop-html]').text());
      } catch (error) {
        return console.warn('Quickshop: invalid quickshop html found. ' + error.message);
      }
      if (!this.$quickShop[0].hasAttribute('data-loaded')) {
        this.$quickShop.append(this.quickShopHTML);
        this.$quickShop.attr('data-loaded', true);
        this.$quickShop.find('.money').each(function (index, el) {
          return dist$2.update(el);
        });
        this._initSPR();
      }
      this._initialize();
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    }
    createClass(ProductQuickshop, [
      {
        key: '_initSPR',
        value: function _initSPR() {
          if (!window.SPR) {
            return;
          }
          window.SPR.registerCallbacks();
          window.SPR.initRatingHandler();
          window.SPR.initDomEls();
          window.SPR.loadProducts();
          window.SPR.loadBadges();
        },
      },
      {
        key: '_initialize',
        value: function _initialize() {
          this.$message = this.$el.find('[data-product-quickshop-message]');
          this.$formArea = this.$el.find('[data-product-form-area]');
          this.$gallery = this.$el.find('[data-x-product-gallery]');
          this.$details = this.$el.find('[data-product-details]');
          this.$description = this.$el.find('[data-product-description]');
          this.context = this.data.context;
          this.settings = this.data.settings;
          this.product = this.data.product;
          this._open = this._open.bind(this);
          this._close = this._close.bind(this);
          this._onATCClose = this._onATCClose.bind(this);
          this._onATCInit = this._onATCInit.bind(this);
          this._onATCError = this._onATCError.bind(this);
          this._onATCSuccess = this._onATCSuccess.bind(this);
          var modalCallbacks = {
            onOpen: this._open,
            onClose: this._close,
          };
          this.atcCallbacks = {
            onClose: this._onATCClose,
            onInit: this._onATCInit,
            onError: this._onATCError,
            onSuccess: this._onATCSuccess,
          };
          this.modal = new Modal(modalCallbacks);
          this.modal.open('[data-product-quickshop="' + this.product.id + '"]', this.modalClass);
        },
      },
      {
        key: '_open',
        value: function _open() {
          if (this.loaded) {
            return;
          }
          if (this.$description.length) {
            this.richText = new RichText(this.$description);
          }
          var options = {
            $formArea: this.$formArea,
            $gallery: this.$gallery,
            $details: this.$details,
            atcCallbacks: this.atcCallbacks,
            context: this.context,
            settings: this.settings,
            product: this.product,
            useHistory: false,
            isQuickshop: true,
          };
          this.productDetails = new ProductDetails(options);
        },
      },
      {
        key: '_close',
        value: function _close() {
          if (this.productDetails) {
            this.productDetails.unload();
          }
          if (this.richText) {
            this.richText.unload();
          }
          this._toggleMessage('', false);
          this.modal.unload();
        },
      },
      {
        key: '_toggleMessage',
        value: function _toggleMessage(message, isVisible) {
          this.$message.html(message).toggleClass('visible', isVisible);
        },
      },
      {
        key: '_onATCClose',
        value: function _onATCClose() {
          removeTrapFocus({
            namespace: 'product-details-flyout',
          });
          this.$el.focus();
        },
      },
      {
        key: '_onATCInit',
        value: function _onATCInit() {
          this.$message.removeClass('visible');
        },
      },
      {
        key: '_onATCError',
        value: function _onATCError(error) {
          var $content = jQuery('<div class="product-message--error">' + error + '</div>');
          this._toggleMessage($content, true);
        },
      },
      {
        key: '_onATCSuccess',
        value: function _onATCSuccess() {
          this._close();
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this._close();
        },
      },
    ]);
    return ProductQuickshop;
  })();
  var ProductGridItem = (function () {
    function ProductGridItem($el) {
      var _this = this;
      classCallCheck(this, ProductGridItem);
      this.$el = $el;
      this.productQuickshop = null;
      this.quickBuySettings = null;
      this.events = [];
      this.$window = jQuery(window);
      this.$html = jQuery('html');
      this.$content = this.$el.find('[data-product-item-content]');
      this.$actions = this.$el.find('[data-product-actions]');
      this.hasProductActions = this.$actions.length;
      this._addToCart = this._addToCart.bind(this);
      this._actionsToggle = this._actionsToggle.bind(this);
      this._openQuickShop = this._openQuickShop.bind(this);
      this._onATCOpen = this._onATCOpen.bind(this);
      this._onATCClose = this._onATCClose.bind(this);
      if (this.hasProductActions) {
        this._setSortByQueryParameters();
        this.events.push(this.$el.on('mouseenter.product-item', this._actionsToggle));
        this.events.push(this.$el.on('mouseleave.product-item', this._actionsToggle));
        //$scripts checks existence of script in header before attempting to inject
        script$1(jQuery('[data-scripts]').data('shopify-api-url'), function () {
          _this.events.push(_this.$el.on('click.product-item', '[data-quick-buy]', _this._addToCart));
          _this.events.push(_this.$el.on('click.product-item', '[data-quickshop-slim]', _this._openQuickShop));
          _this.events.push(_this.$el.on('click.product-item', '[data-quickshop-full]', _this._openQuickShop));
        });
      }
      if (this.$el.find('[data-quick-buy]').length) {
        this._initQuickBuy();
      }
      this._objectFitPolyfill();
    }
    /**
     * Make Shopify aware of releavent collection search info
     *  - tag
     *  - vendor
     *  - pagination
     *  - sorting criteria
     *
     * @private
     */
    createClass(ProductGridItem, [
      {
        key: '_setSortByQueryParameters',
        value: function _setSortByQueryParameters() {
          Shopify.queryParams = {};
          if (location.search.length) {
            for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
              var aKeyValue = aCouples[i].split('=');
              // Reset the page number when we apply (i.e. don't add it to params)
              if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
        },
      },
      {
        key: '_initQuickBuy',
        value: function _initQuickBuy() {
          try {
            this.quickBuySettings = JSON.parse(this.$el.find('[data-quick-buy-settings]').text());
          } catch (error) {
            return console.warn('Quick buy: invalid QuickBuy data found. ' + error.message);
          }
        },
      },
      {
        key: '_openQuickShop',
        value: function _openQuickShop(event) {
          event.preventDefault();
          var modalClass = event.currentTarget.hasAttribute('data-quickshop-full') ? 'quickshop-full' : 'quickshop-slim';
          if (this.productQuickshop) {
            this.productQuickshop.unload();
          }
          this.productQuickshop = new ProductQuickshop({
            $el: this.$el,
            modalClass: modalClass,
          });
        },
      },
      {
        key: '_isObjectFitAvailable',
        value: function _isObjectFitAvailable() {
          return 'objectFit' in document.documentElement.style;
        },
      },
      {
        key: '_objectFitPolyfill',
        value: function _objectFitPolyfill() {
          if (this._isObjectFitAvailable()) {
            return;
          }
          var $figure = jQuery('[data-product-item-image]', this.$el);
          var featuredSrc = jQuery('img:not(.x-product--image-alternate)', $figure).attr('src');
          var alternateSrc = jQuery('.x-product--image-alternate', $figure).attr('src');
          $figure.addClass('product-item-image-no-objectfit');
          $figure.css('background-image', 'url("' + featuredSrc + '")');
          if (alternateSrc) {
            this.$el.on('mouseover', function () {
              $figure.css('background-image', 'url("' + alternateSrc + '")');
            });
            this.$el.on('mouseleave', function () {
              $figure.css('background-image', 'url("' + featuredSrc + '")');
            });
          }
        },
        /**
         * Get height of element, and combined height of element + actions
         *
         * @returns {{heightBase, heightExpanded: *}}
         * @private
         */
      },
      {
        key: '_getHeights',
        value: function _getHeights() {
          var height = this.$el.height();
          var actionsHeight = this.$el.find('[data-product-actions]').outerHeight(true);
          return {
            heightBase: height,
            heightExpanded: height + actionsHeight,
          };
        },
      },
      {
        key: '_actionsToggle',
        value: function _actionsToggle(event) {
          if (!layout.isBreakpoint('L')) return;
          var open = event.type === 'mouseenter';
          if (open) {
            this._showActions();
          }
          if (!open) {
            this._hideActions();
          }
        },
      },
      {
        key: '_showActions',
        value: function _showActions() {
          var _this2 = this;
          if (this.$el.revealer('isVisible')) {
            return this._hideActions();
          }
          var _getHeights2 = this._getHeights(),
            heightBase = _getHeights2.heightBase,
            heightExpanded = _getHeights2.heightExpanded;
          // Lock heights to prevent jumping
          this.$el.css('height', heightBase);
          this.$content.css('height', heightBase);
          // Store height for when hovering out
          this.$el.data('base-height', heightBase);
          // Start animation, and transition height to expanded height
          this.$el.revealer('show').one('revealer-animating.product-item', function () {
            _this2.$content.css('height', heightExpanded);
          });
        },
      },
      {
        key: '_hideActions',
        value: function _hideActions() {
          var _this3 = this;
          var height = this.$el.data('base-height');
          /*
          - Transition buttons up, using base height for animation
          - Remove heights after animation is complete in case of resize
         */
          this.$el
            .revealer('hide')
            .one('revealer-animating', function () {
              _this3.$el.off('revealer-animating.product-item');
              _this3.$el.css({ height: height });
              _this3.$content.css({ height: height });
            })
            .one('revealer-hide', function () {
              _this3.$el.off('revealer-hide.product-item').css('height', '');
              _this3.$content.css('height', '');
            });
        },
      },
      {
        key: '_addToCart',
        value: function _addToCart(event) {
          event.preventDefault();
          var $atcButton = jQuery(event.currentTarget);
          var variantID = $atcButton.attr('data-variant-id');
          var formData = [
            {
              name: 'id',
              value: variantID,
            },
            {
              name: 'quantity',
              value: 1,
            },
          ];
          var options = {
            $atcButton: $atcButton,
            settings: {
              moneyFormat: this.quickBuySettings.money_format,
              cartRedirection: this.quickBuySettings.cart_redirection,
            },
          };
          var callbacks = {
            onOpen: this._onATCOpen,
            onClose: this._onATCClose,
          };
          AddToCartFlyout$1.init(formData, options, callbacks);
        },
        /**
         * Callback when AddToCartFlyout opens
         * Move keyboard focus into flyout
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
         * @private
         */
      },
      {
        key: '_onATCOpen',
        value: function _onATCOpen(options) {
          trapFocus({
            $container: options.$container,
            $elementToFocus: options.$elementToFocus,
            namespace: 'product-item-flyout',
          });
        },
        /**
         * Callback when AddToCartFlyout closes
         * Move keyboard focus back into grid item
         *
         * @private
         */
      },
      {
        key: '_onATCClose',
        value: function _onATCClose() {
          removeTrapFocus({
            namespace: 'product-item-flyout',
          });
          this.$el.focus();
        },
      },
      {
        key: 'unload',
        value: function unload() {
          this.events.forEach(function ($el) {
            return $el.off('.product-item');
          });
          if (this.productQuickshop) {
            this.productQuickshop.unload();
          }
        },
      },
    ]);
    return ProductGridItem;
  })();
  var RecentlyViewed = (function () {
    function RecentlyViewed(section) {
      classCallCheck(this, RecentlyViewed);
      this.$el = jQuery(section.el);
      this.recentlyViewed = section.data.recently_viewed_info;
      this.time = section.data.time;
      this.flickity = null;
      if (this.recentlyViewed && this.time) {
        this.recentlyViewed.timestamp = Math.round(new Date().getTime() / 1000);
      }
      if (this.time) {
        var recentlyViewed = [];
        if (JSON.parse(localStorage.getItem('recentlyViewed')) !== null) {
          recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
          for (var i = recentlyViewed.length - 1; i >= 0; i--) {
            var timeSince = this.timeSince(recentlyViewed[i].timestamp);
            var isPlaceholder = recentlyViewed[i].image.indexOf('svg+url') !== 1;
            this.$el
              .find('[data-recently-viewed-container]')
              .append(
                '<div class="product-recently-viewed-card"\n              data-recently-viewed-card\n            >\n              <div class="product-recently-viewed-card-time">\n                ' +
                timeSince +
                '\n                <div class="product-recently-viewed-card-remove"\n                  data-remove-recently-viewed="' +
                recentlyViewed[i].handle +
                '">\n                  <svg\n                    aria-hidden="true"\n                    focusable="false"\n                    role="presentation"\n                    width="10"\n                    height="10"\n                    viewBox="0 0 10 10"\n                    xmlns="http://www.w3.org/2000/svg"\n                  >\n                    <path d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>\n                  </svg>\n                </div>\n              </div>\n              <a href="' +
                recentlyViewed[i].link +
                '">\n                <div\n                  class="\n                    product-recently-viewed-card-image-wrapper\n                    x-product--image\n                  "\n                >\n                  <img\n                    class="\n                      product-recently-viewed-card-image\n                      ' +
                (isPlaceholder ? 'product-recently-viewed-card-image-placeholder' : '') +
                '\n                    "\n                    src="' +
                recentlyViewed[i].image.trim() +
                '"\n                    alt="' +
                recentlyViewed[i].title +
                '"\n                  >\n                </div>\n              </a>\n              <div class="product-recently-viewed-card-price">\n                ' +
                recentlyViewed[i].price +
                '\n              </div>\n              <a\n                href="' +
                recentlyViewed[i].link +
                '"\n                class="product-recently-viewed-card-title"\n              >\n                ' +
                recentlyViewed[i].title +
                '\n              </a>\n            </div>'
              );
          }
          if (this.recentlyViewed) {
            this.removeRecentlyViewed(this.recentlyViewed.handle, recentlyViewed);
            recentlyViewed.push(this.recentlyViewed);
            localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
          }
          this.$carousel = this.$el.find('.product-recently-viewed--content');
          this.slides = '.product-recently-viewed-card';
          if (this.$carousel.find(this.slides).length > 1) {
            this._initSlider();
          }
        } else {
          if (this.recentlyViewed) {
            recentlyViewed.push(this.recentlyViewed);
            localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
          }
          this.$el.find('.product-recently-viewed--section').addClass('hide');
        }
      }
      this.bindEvents();
    }
    createClass(RecentlyViewed, [
      {
        key: 'bindEvents',
        value: function bindEvents() {
          var _this = this;
          this.$el.on('click', '[data-remove-recently-viewed]', function (event) {
            var $target = jQuery(event.currentTarget);
            var handle = $target.data('remove-recently-viewed');
            var recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
            _this.removeRecentlyViewed(handle, recentlyViewed);
            localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
            $target.parents('[data-recently-viewed-card]').addClass('hide-card');
            $target.parents('[data-recently-viewed-card]').nextAll().addClass('move-card');
            setTimeout(function () {
              var index = $target.parents('[data-recently-viewed-card]').index();
              if (index !== 0) {
                index--;
              }
              $target.parents('[data-recently-viewed-card]').nextAll().removeClass('move-card');
              _this.flickity.remove($target.parents('[data-recently-viewed-card]'));
              _this.flickity.selectCell(index);
            }, 500);
          });
          this.$el.on('click', '[data-clear-recently-viewed]', function (event) {
            _this.clearRecentlyViewed();
          });
        },
      },
      {
        key: 'timeSince',
        value: function timeSince(timestamp) {
          var now = Math.round(new Date().getTime() / 1000);
          var secondsPast = now - timestamp;
          if (secondsPast < 60) {
            var secondsAgo = parseInt(secondsPast);
            return secondsAgo === 1
              ? secondsAgo + ' ' + this.time.second + ' ' + this.time.ago
              : secondsAgo + ' ' + this.time.seconds + ' ' + this.time.ago;
          }
          if (secondsPast < 3600) {
            var minutesAgo = parseInt(secondsPast / 60);
            return minutesAgo === 1
              ? minutesAgo + ' ' + this.time.minute + ' ' + this.time.ago
              : minutesAgo + ' ' + this.time.minutes + ' ' + this.time.ago;
          }
          if (secondsPast <= 86400) {
            var hoursAgo = parseInt(secondsPast / 3600);
            return hoursAgo === 1
              ? hoursAgo + ' ' + this.time.hour + ' ' + this.time.ago
              : hoursAgo + ' ' + this.time.hours + ' ' + this.time.ago;
          }
          if (secondsPast > 86400) {
            var date = new Date(timestamp);
            var currentDate = new Date(now);
            var day = date.getDate();
            var month = date
              .toDateString()
              .match(/ [a-zA-Z]*/)[0]
              .replace(' ', '');
            var year = date.getFullYear() == currentDate.getFullYear() ? '' : ', ' + date.getFullYear();
            return month + ' ' + day + ' ' + year;
          }
        },
      },
      {
        key: 'removeRecentlyViewed',
        value: function removeRecentlyViewed(handle, recentlyViewed) {
          for (var i = 0; i < recentlyViewed.length; i++) {
            if (recentlyViewed[i].handle === handle) {
              recentlyViewed.splice(i, 1);
              if (recentlyViewed.length === 0) {
                this.$el.find('.product-recently-viewed--section').addClass('hide');
              }
            }
          }
        },
      },
      {
        key: 'clearRecentlyViewed',
        value: function clearRecentlyViewed() {
          localStorage.setItem('recentlyViewed', null);
          this.$el.find('[data-recently-viewed-card]').remove();
          this.$el.find('.product-recently-viewed--section').addClass('hide');
        },
      },
      {
        key: '_initSlider',
        value: function _initSlider() {
          var _this2 = this;
          this.flickityOptions = {
            autoPlay: 0,
            accessibility: true,
            cellAlign: 'left',
            cellSelector: this.slides,
            groupCells: true,
            imagesLoaded: true,
            pageDots: false,
            contain: true,
            arrowShape: {
              x0: 10,
              x1: 60,
              y1: 50,
              x2: 65,
              y2: 45,
              x3: 20,
            },
          };
          this.flickity = new js$1(this.$carousel[0], this.flickityOptions);
          setTimeout(function () {
            _this2.flickity.resize();
          }, 100);
        },
      },
    ]);
    return RecentlyViewed;
  })();
  var SelectWidth = (function () {
    function SelectWidth($select) {
      classCallCheck(this, SelectWidth);
      this.$select = $select;
      this.$html = jQuery('html');
      this.$body = jQuery('body');
      this._adjustWidth = this._adjustWidth.bind(this);
      this.$select.on('change.select', this._adjustWidth);
      // Update width of <select> on load
      this._adjustWidth();
    }
    createClass(SelectWidth, [
      {
        key: 'unload',
        value: function unload() {
          this.$select.off('.select');
        },
        /**
         * Adjust select to have width equal to its selected option
         *
         * @private
         */
      },
      {
        key: '_adjustWidth',
        value: function _adjustWidth() {
          var selectedText = this.$select.find(':selected').text();
          var $select = this.$select.parent().clone();
          var additionalStyles = {
            position: 'absolute',
            bottom: '-100%',
            left: '-100%',
            display: 'inline-block',
            visibility: 'hidden',
          };
          // Replace contents of copied <select> with selected text, and additional styles
          $select
            .css(additionalStyles)
            .find('select')
            .css('width', '') // Remove any width applied from previous with assignment
            .html('<option>' + selectedText + '</option>');
          this.$body.append($select);
          var width = $select.outerWidth(true);
          $select.remove();
          this.$select.css({ width: width });
        },
      },
    ]);
    return SelectWidth;
  })();
  var XCollection = (function () {
    function XCollection(section) {
      var _this = this;
      classCallCheck(this, XCollection);
      this.section = section;
      this.$el = jQuery(section.el);
      this.context = section.data.context;
      this.sortWidth = null;
      this.$focusItem = null;
      this.filtersContent = '[data-product-box-filters-content]';
      this.sortContent = '[data-product-box-sort-content]';
      this.$sortTrigger = this.$el.find('[data-product-box-trigger-sort]');
      this.$sortTriggerButton = this.$el.find('[data-product-box-trigger-sort-button]');
      this.$sortTriggerModal = this.$el.find('[data-product-box-modal-sort]');
      this.$filtersTrigger = this.$el.find('[data-product-box-trigger-filters]');
      this.$allTags = this.$el.find(this.filtersContent + ' .filter-item a:not([data-filter-toggle])');
      this.$advandedTags = this.$el.find('[data-tag-advanced] a');
      this.$additionalTags = this.$el.find('[data-filter-toggle]');
      this.$listViewToggle = this.$el.find('[data-collection-list-view]');
      this.$gridContainer = this.$el.find('.product-box--outer');
      this._changeSorting = this._changeSorting.bind(this);
      this._changeSortingButton = this._changeSortingButton.bind(this);
      this._showSortModal = this._showSortModal.bind(this);
      this._showFiltersModal = this._showFiltersModal.bind(this);
      this._activateTag = this._activateTag.bind(this);
      this._advancedTags = this._advancedTags.bind(this);
      this._toggleTags = this._toggleTags.bind(this);
      this._onModalOpen = this._onModalOpen.bind(this);
      this._onModalClose = this._onModalClose.bind(this);
      var modalCallbacks = {
        onOpen: this._onModalOpen,
        onClose: this._onModalClose,
      };
      this.events = [
        this.$sortTrigger.on('change.collection', this._changeSorting),
        this.$sortTriggerButton.on('click.collection', this._changeSortingButton),
        this.$sortTriggerModal.on('click.collection', this._showSortModal),
        this.$filtersTrigger.on('click.collection', this._showFiltersModal),
        this.$advandedTags.on('click.collection', this._advancedTags),
        this.$allTags.on('click.collection', this._activateTag),
        this.$additionalTags.on('click.collection', this._toggleTags),
      ];
      // Product items
      this.productItems = [];
      var $productItems = this.$el.find('[data-product-item]');
      $productItems.each(function (i, productItem) {
        _this.productItems.push(new ProductGridItem(jQuery(productItem)));
      });
      if (this.$sortTrigger.length) {
        this.sortWidth = new SelectWidth(this.$sortTrigger);
      }
      this._setSortByQueryParameters();
      this._updatePrices();
      this.modal = new Modal(modalCallbacks);
      this.recentlyViewed = new RecentlyViewed(section);
    }
    createClass(XCollection, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.events.forEach(function ($el) {
            return $el.off('.collection');
          });
          this.modal.unload();
          this.recentlyViewed.unload();
          if (this.sortWidth) {
            this.sortWidth.unload();
          }
          this.productItems.forEach(function (productItem) {
            productItem.unload();
          });
        },
        /**
         * Set product grid prices to match CurrencyConverter settings on page load, section re-load
         *
         * @private
         */
      },
      {
        key: '_updatePrices',
        value: function _updatePrices() {
          this.$el.find('.money').each(function (index, el) {
            return dist$2.update(el);
          });
        },
        /**
         * Open Tags/Filters modal (on mobile)
         *
         * @param event
         * @private
         */
      },
      {
        key: '_showFiltersModal',
        value: function _showFiltersModal(event) {
          event.preventDefault();
          this.$focusItem = jQuery(event.currentTarget);
          this.modal.open(this.filtersContent, 'product-box-filters');
        },
        /**
         * Open Sort by modal (on mobile)
         *
         * @param event
         * @private
         */
      },
      {
        key: '_showSortModal',
        value: function _showSortModal(event) {
          event.preventDefault();
          this.$focusItem = jQuery(event.currentTarget);
          this.modal.open(this.sortContent, 'product-box-sort');
        },
        /**
         * Style a tag as active after click, before page transition
         *
         * @param event
         * @private
         */
      },
      {
        key: '_activateTag',
        value: function _activateTag(event) {
          jQuery(event.currentTarget).addClass('filter-link--active');
        },
        /**
         * Used by advanced tags to concatenate tag searches
         *
         * @param event
         * @private
         */
      },
      {
        key: '_advancedTags',
        value: function _advancedTags(event) {
          var $target = jQuery(event.currentTarget).parent();
          var tagGroup = $target.attr('data-group');
          var $activeGroup = jQuery('.filter-item--active[data-group="' + tagGroup + '"]');
          if (!$target.hasClass('filter-item--active') && $activeGroup.length) {
            var tagHandle = $target.attr('data-handle');
            event.preventDefault();
            $target.siblings().removeClass('filter-item--active');
            location.href = location.href
              // swap tag
              .replace($activeGroup.attr('data-handle'), tagHandle)
              // go back to page 1
              .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
          }
        },
        /**
         * Expand / Collapse additional tags in the sidebar
         *
         * @param event
         * @private
         */
      },
      {
        key: '_toggleTags',
        value: function _toggleTags(event) {
          event.preventDefault();
          var $trigger = jQuery(event.currentTarget);
          var $items = $trigger.parent().siblings('[data-hidden-default]');
          var siblingsVisible = $trigger.data('filter-toggle');
          $items.toggleClass('filter-item--hidden', siblingsVisible);
          $trigger.data('filter-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);
          if (this.modal.isOpen()) {
            this.modal.position();
          }
        },
        /**
         * Make Shopify aware of releavent collection search info
         *  - tag
         *  - vendor
         *  - pagination
         *  - sorting criteria
         *
         * @private
         */
      },
      {
        key: '_setSortByQueryParameters',
        value: function _setSortByQueryParameters() {
          Shopify.queryParams = {};
          if (location.search.length) {
            for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
              var aKeyValue = aCouples[i].split('=');
              // Reset the page number when we apply (i.e. don't add it to params)
              if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
        },
        /**
         * Sort by opens a modal on mobile, this handles button events
         *
         * @param event
         * @private
         */
      },
      {
        key: '_changeSortingButton',
        value: function _changeSortingButton(event) {
          var activeClass = 'utils-sortby--modal-button--active';
          jQuery(event.currentTarget)
            .addClass(activeClass)
            .parent()
            .siblings()
            .find('.' + activeClass)
            .removeClass(activeClass);
          this._changeSorting(event);
        },
        /**
         * Change sorting of collection
         *
         * @param event
         * @private
         */
      },
      {
        key: '_changeSorting',
        value: function _changeSorting(event) {
          event.preventDefault();
          var $target = jQuery(event.currentTarget);
          Shopify.queryParams.sort_by = $target.val();
          location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
        },
        /**
         * When a modal is open, move focus into the modal for a11y
         *
         * @private
         */
      },
      {
        key: '_onModalOpen',
        value: function _onModalOpen() {
          trapFocus({
            $container: this.modal.$modal,
            namespace: 'product-box-modal',
          });
        },
        /**
         * Return focus to last used button (if found) on modal close
         *
         * @private
         */
      },
      {
        key: '_onModalClose',
        value: function _onModalClose() {
          removeTrapFocus({
            $container: this.modal.$modal,
            namespace: 'product-box-modal',
          });
          if (this.$focusItem) {
            this.$focusItem.focus();
            this.$focusItem = null;
          }
        },
        /**
         * Toggle grid view
         *
         */
      },
    ]);
    return XCollection;
  })();
  var XGiftcard = (function () {
    function XGiftcard(section) {
      var _this = this;
      classCallCheck(this, XGiftcard);
      this.$el = jQuery(section.el);
      this.$qrCode = this.$el.find('[data-giftcard-qr]');
      this.$giftCardCode = this.$el.find('[data-giftcard-code]');
      script$1(jQuery('[data-scripts]').data('shopify-qrcode'), function () {
        _this.QRCode = new QRCode(_this.$qrCode[0], {
          text: _this.$qrCode.attr('data-giftcard-qr'),
          width: 120,
          height: 120,
        });
      });
      this._bindEvents();
    }
    createClass(XGiftcard, [
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this2 = this;
          this.$el.on('click', '[data-giftcard-print]', function () {
            window.print();
          });
          // Auto-select gift card code on click, based on ID passed to the function
          this.$el.on('click', '[data-giftcard-code]', function () {
            _this2._selectText();
          });
        },
      },
      {
        key: '_selectText',
        value: function _selectText() {
          var text = this.$giftCardCode[0];
          var range = '';
          if (document.body.createTextRange) {
            // ms method
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
          } else if (window.getSelection) {
            // moz, opera, webkit method
            var selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        },
      },
    ]);
    return XGiftcard;
  })();
  var XPassword = (function () {
    function XPassword(section) {
      classCallCheck(this, XPassword);
      this.$el = jQuery(section.el);
      this.modalForms = null;
      this.newsletterForm = null;
      this.modalContents = '[data-passwordentry]';
      this.$newsletterForm = this.$el.find('[data-password-newsletter]');
      this.modalOpen = this.onModalOpen.bind(this);
      this.modalClose = this.onModalClose.bind(this);
      this._openModal = this._openModal.bind(this);
      this.modal = new Modal({
        onOpen: this.modalOpen,
        onClose: this.modalClose,
      });
      if (this.$newsletterForm) {
        this.newsletterForm = new Forms(this.$newsletterForm);
      }
      this._checkForPasswordAttempt();
      this._bindEvents();
    }
    createClass(XPassword, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.$el.off('.static-password');
          if (this.newsletterForm) {
            this.newsletterForm.unload();
          }
          if (this.modalForms) {
            this.modalForms.unload();
          }
        },
      },
      {
        key: 'onModalOpen',
        value: function onModalOpen() {
          var $contents = jQuery('[data-passwordentry-contents]');
          this.modalForms = new Forms($contents);
        },
      },
      {
        key: 'onModalClose',
        value: function onModalClose() {
          this.modalForms.unload();
          this.modalForms = null;
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          this.$el.on('click.static-password', '[data-passwordentry-toggle]', this._openModal);
        },
      },
      {
        key: '_openModal',
        value: function _openModal() {
          this.modal.open(this.modalContents, 'passwordentry');
        },
      },
      {
        key: '_checkForPasswordAttempt',
        value: function _checkForPasswordAttempt() {
          if (!jQuery('[data-passwordentry-errors]').length) {
            return;
          }
          this._openModal();
        },
      },
    ]);
    return XPassword;
  })();
  var ProductRowScroller = (function () {
    function ProductRowScroller(productRow) {
      classCallCheck(this, ProductRowScroller);
      this.$window = $(window);
      this.flickity = null;
      this.productRow = productRow;
      this.$productRow = $(this.productRow);
      // Activate flickity on mobile
      this._mobileSlider = this._mobileSlider.bind(this);
      layout.onBreakpointChange(this._mobileSlider);
      this._mobileSlider();
    }
    createClass(ProductRowScroller, [
      {
        key: 'unload',
        value: function unload() {
          layout.offBreakpointChange(this._mobileSlider);
          this._destroyFlickity();
        },
      },
      {
        key: '_initFlickity',
        value: function _initFlickity() {
          this.flickity = new js$1(this.productRow, {
            cellSelector: '.product-box--item',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
          });
          this._bindSlider();
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.$window.off('.product-row');
          this.$productRow.off('.product-row');
          this.flickity.destroy();
          this.flickity = null;
        },
      },
      {
        key: '_mobileSlider',
        value: function _mobileSlider() {
          // If is Large layout, attempt to destroy flickity
          if (layout.isBreakpoint('L')) {
            this._destroyFlickity();
            return;
          }
          // Is XS/S/M, and flickity is init'd -- do nothing
          if (this.flickity) {
            return;
          }
          // Is XS/S/M, and flickity is not init'd
          this._initFlickity();
        },
      },
      {
        key: '_bindSlider',
        value: function _bindSlider() {
          var _this = this;
          var $slider = this.$productRow.find('.flickity-slider');
          this.$window.on(
            'resize.product-row',
            justDebounce$1(function () {
              _this.$productRow.trigger('heightUpdate.product-row');
            })
          );
          this.flickity.on('cellSelect', function () {
            _this.$productRow.trigger('heightUpdate.product-row');
          });
          this.$productRow.on('heightUpdate.product-row', function () {
            if (!_this.flickity) {
              return;
            }
            $slider.height(Math.ceil(_this.flickity.maxCellHeight));
          });
          // Sets the Slider to the height of the first slide
          this.$productRow.trigger('heightUpdate.product-row');
        },
      },
    ]);
    return ProductRowScroller;
  })();
  var XProduct = (function () {
    function XProduct(section) {
      var _this = this;
      classCallCheck(this, XProduct);
      this.postMessage = section.postMessage;
      this.context = section.data.context;
      this.settings = section.data.settings;
      this.product = section.data.product;
      this.richText = null;
      this.reviewForm = null;
      this.flickity = null;
      this.flickityOptions = null;
      this.$el = jQuery(section.el);
      this.$product = this.$el.find('[data-product-wrapper]');
      if (this.settings) {
        this.isThreeColumn = this.settings.layout === 'layout--three-col';
      }
      // History
      this.isThemeEditor = window.Shopify && window.Shopify.designMode;
      this.useHistory = !this.isThemeEditor && history.replaceState;
      this.$gallery = this.$product.find('[data-x-product-gallery]');
      // Product details
      this.$details = this.$product.find('[data-product-details]');
      // Product description
      this.$description = this.$product.find('[data-product-description]');
      // Product form containers
      this.$formRegular = this.$product.find('[data-product-form-regular]');
      this.$formAlt = this.$product.find('[data-product-form-alt]');
      // Product form area
      this.$formArea = this.$product.find('[data-product-form-area]');
      // Move product form and information on breakpoint change
      this.layoutHandler = this.onBreakpointChange.bind(this);
      layout.onBreakpointChange(this.layoutHandler);
      // Related Products
      this.$relatedProducts = this.$el.find('[data-related-products]');
      this.relatedProducts = [];
      this.relatedProductsScroller = null;
      // Product reviews
      this.$productReviews = this.$el.find('[data-product-reviews]');
      this._moveForm();
      if (this.$description.length) {
        this.richText = new RichText(this.$description);
      }
      if (this.$relatedProducts.length) {
        this.relatedProductsScroller = new ProductRowScroller(section.el.querySelector('[data-product-row]'));
        this.$relatedProducts.find('[data-product-item]').each(function (i, productItem) {
          new ProductGridItem(jQuery(productItem));
        });
        /* If related products are disabled/enabled with while in the TE,
         * they'll have shop.currency as the monetary value. This updates it to
         * the active currency
         */
        this.$relatedProducts.find('.money').each(function (index, el) {
          return dist$2.update(el);
        });
      }
      if (this.$productReviews.length) {
        this.reviewForm = new Forms(this.$productReviews, '.spr-form-input');
      }
      // Instantiate ProductDetails after Shopify API is loaded
      script$1(jQuery('[data-scripts]').data('shopify-api-url'), function () {
        var options = {
          $formArea: _this.$formArea,
          $gallery: _this.$gallery,
          $details: _this.$details,
          context: _this.context,
          settings: _this.settings,
          product: _this.product,
          useHistory: _this.useHistory,
        };
        _this.productDetails = new ProductDetails(options);
      });
      this.recentlyViewed = new RecentlyViewed(section);
    }
    createClass(XProduct, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          layout.offBreakpointChange(this.layoutHandler);
          this.productDetails.unload();
          if (this.richText) {
            this.richText.unload();
          }
          if (this.relatedProductsScroller) {
            this.relatedProductsScroller.unload();
          }
          this.relatedProducts.forEach(function (productItem) {
            productItem.unload();
          });
          if (this.reviewForm) {
            this.reviewForm.unload();
          }
        },
      },
      {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
          this._moveForm();
        },
        /**
         * Move product form if is a three column layout
         * @private
         */
      },
      {
        key: '_moveForm',
        value: function _moveForm() {
          if (!this.isThreeColumn) return;
          if (layout.isBreakpoint('L')) {
            if (!jQuery.contains(this.$formAlt[0], this.$formArea[0])) {
              var $form = this.$formArea.detach();
              this.$formAlt.append($form);
            }
          } else {
            if (!jQuery.contains(this.$formRegular[0], this.$formArea[0])) {
              var _$form = this.$formArea.detach();
              this.$formRegular.append(_$form);
            }
          }
        },
      },
    ]);
    return XProduct;
  })();
  var XSearch = (function () {
    function XSearch(section) {
      var _this = this;
      classCallCheck(this, XSearch);
      this.section = section;
      this.$el = jQuery(section.el);
      this.$searchField = this.$el.find('[data-live-search]');
      this.modal = new Modal();
      // Product items
      this.productItems = [];
      var $productItems = this.$el.find('[data-product-item]');
      $productItems.each(function (i, productItem) {
        _this.productItems.push(new ProductGridItem(jQuery(productItem)));
      });
      this._updatePrices();
      this.searchForm = new SearchForm(this.$searchField);
    }
    createClass(XSearch, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.modal.unload();
          this.searchForm.unload();
          this.productItems.forEach(function (productItem) {
            productItem.unload();
          });
        },
      },
      {
        key: '_updatePrices',
        value: function _updatePrices() {
          this.$el.find('.money').each(function (index, el) {
            return dist$2.update(el);
          });
        },
      },
    ]);
    return XSearch;
  })();
  var XTwitterFeed = (function () {
    function XTwitterFeed(section) {
      classCallCheck(this, XTwitterFeed);
      this.$el = jQuery(section.el);
      this.$window = jQuery(window);
      this.flickity = null;
      this.$blogPosts = this.$el.find('[data-blog-posts]');
      // Activate flickity on mobile
      this._mobileSlider = this._mobileSlider.bind(this);
      layout.onBreakpointChange(this._mobileSlider);
      this._mobileSlider();
    }
    /**
     * Unbind events when section is re-drawn
     */
    createClass(XTwitterFeed, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          layout.offBreakpointChange(this._mobileSlider);
          this._destroyFlickity();
        },
      },
      {
        key: '_initFlickity',
        value: function _initFlickity() {
          this.flickity = new js$1(this.$blogPosts[0], {
            cellSelector: '.x-article-extract',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
          });
          this._bindSlider();
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.$window.off('.blog-posts');
          this.$blogPosts.off('.blog-posts');
          this.flickity.destroy();
          this.flickity = null;
        },
      },
      {
        key: '_mobileSlider',
        value: function _mobileSlider() {
          // If is Large layout, attempt to destroy flickity
          if (layout.isBreakpoint('L')) {
            this._destroyFlickity();
            return;
          }
          // Is XS/S/M, and flickity is init'd -- do nothing
          if (this.flickity) {
            return;
          }
          // Is XS/S/M, and flickity is not init'd
          this._initFlickity();
        },
      },
      {
        key: '_bindSlider',
        value: function _bindSlider() {
          var _this = this;
          var $slider = this.$blogPosts.find('.flickity-slider');
          this.$window.on(
            'resize.blog-posts',
            justDebounce$1(function () {
              _this.$blogPosts.trigger('heightUpdate.blog-posts');
            })
          );
          this.flickity.on('cellSelect', function () {
            _this.$blogPosts.trigger('heightUpdate.blog-posts');
          });
          this.$blogPosts.on('heightUpdate.blog-posts', function () {
            if (!_this.flickity) {
              return;
            }
            $slider.height(Math.ceil(_this.flickity.maxCellHeight));
          });
          // Sets the Slider to the height of the first slide
          this.$blogPosts.trigger('heightUpdate.blog-posts');
        },
      },
    ]);
    return XTwitterFeed;
  })();
  var XHighlightsBanners = (function () {
    function XHighlightsBanners(section) {
      classCallCheck(this, XHighlightsBanners);
      this.$el = jQuery(section.el);
      this.$window = jQuery(window);
      this.$carousel = this.$el.find('.x-highlight-banner');
      this.slides = '.x-highlight-banner-block';
      this.flickity = null;
      this.flickityOptions = null;
      if (this.$carousel.find(this.slides).length > 1) {
        this._initSlider();
      }
    }
    createClass(XHighlightsBanners, [
      {
        key: '_initSlider',
        value: function _initSlider() {
          this.flickityOptions = {
            autoPlay: 0,
            accessibility: true,
            cellAlign: 'left',
            cellSelector: this.slides,
            imagesLoaded: false,
            pageDots: false,
            prevNextButtons: false,
            setGallerySize: false,
            contain: true,
          };
          this._bindFlickity();
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this._destroyFlickity();
          this.$window.off('.twitter');
        },
      },
      {
        key: '_bindFlickity',
        value: function _bindFlickity() {
          var _this = this;
          if (layout.isBreakpoint('L') === false && this.flickity === null) {
            this.flickity = new js$1(this.$carousel[0], this.flickityOptions);
          }
          this.$window.on(
            'resize',
            justDebounce$1(function () {
              if (layout.isBreakpoint('L') === false && _this.flickity === null) {
                _this._bindFlickity();
              } else if (layout.isBreakpoint('L') && _this.flickity) {
                _this._destroyFlickity();
              }
            })
          );
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.flickity.destroy();
          this.flickity = null;
        },
      },
    ]);
    return XHighlightsBanners;
  })();
  var XSlideshow = (function () {
    function XSlideshow(section) {
      classCallCheck(this, XSlideshow);
      this.el = section.el;
      this.settings = section.data;
      this.$window = jQuery(window);
      this.carousel = this.el.querySelector('.slideshow');
      this.slides = '.slider-show';
      this.container = this.el.querySelector('.slideshow-height-fullscreen');
      this.isFullscreen = !!this.container;
      this.selectBlockOnLoad = true;
      this.continueAutoplay = true;
      this.stopAutoplay = false;
      this.autoplayTimeout = 0;
      this.flickity = null;
      this.flickityOptions = null;
      if (this.carousel && this.carousel.querySelectorAll(this.slides).length > 1) {
        this._initSlider();
      }
    }
    createClass(XSlideshow, [
      {
        key: '_initSlider',
        value: function _initSlider() {
          var _this = this;
          this.flickityOptions = {
            autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_duration * 1000 : false,
            setGallerySize: !this.isFullscreen,
            pauseAutoPlayOnHover: false,
            accessibility: true,
            adaptiveHeight: true,
            cellAlign: 'left',
            cellSelector: this.slides,
            imagesLoaded: true,
            contain: true,
            wrapAround: true,
            arrowShape: {
              x0: 10,
              x1: 60,
              y1: 50,
              x2: 65,
              y2: 45,
              x3: 20,
            },
          };
          this.$firstSlideImage = jQuery(this.slides, this.carousel).find('img[data-image]').first();
          this.$firstSlideImage.one('image:load', function () {
            _this.flickity = new js$1(_this.carousel, _this.flickityOptions);
            _this._bindEvents();
          });
        },
      },
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this2 = this;
          this._slideshowHeight();
          this._positionDots();
          this._changeArrrowColors();
          this.$window.on(
            'resize.slideshow',
            justDebounce$1(function () {
              _this2._slideshowHeight();
              _this2._positionDots();
              _this2._changeArrrowColors();
            })
          );
          this.flickity.on('select', function () {
            _this2._slideshowHeight();
            _this2._positionDots();
            _this2._changeArrrowColors();
            _this2.selectBlockOnLoad = false;
            if (_this2.settings.enable_autoplay && !_this2.stopAutoplay) {
              _this2.flickity.pausePlayer();
              if (_this2.continueAutoplay) {
                _this2.autoplayTimeout = 0;
              } else {
                _this2.autoplayTimeout = 10000;
              }
              _this2.continueAutoplay = true;
              setTimeout(function () {
                _this2.flickity.playPlayer();
              }, _this2.autoplayTimeout);
            }
          });
          this.flickity.on('dragStart', function () {
            _this2.continueAutoplay = false;
          });
        },
      },
      {
        key: '_positionDots',
        value: function _positionDots() {
          var pageDots = this.el.querySelector('.flickity-page-dots');
          if (layout.isBreakpoint('XS') && !this.isFullscreen) {
            var content = this.flickity.selectedElement.querySelector('.slider-show-content');
            var height = this.flickity.selectedElement.querySelector('.slideshow-background').offsetHeight;
            var dotGutter = 5;
            var top = 'auto';
            if (content) {
              top = height + dotGutter + 'px';
            } else {
              var pageDotsHeight = pageDots.offsetHeight;
              var dotBottomGutter = 20;
              // If no content, and mobile, offset by height of dots, and the bottom gutter
              top = height - (pageDotsHeight + dotBottomGutter) + 'px';
            }
            pageDots.style.top = top;
          }
        },
      },
      {
        key: '_changeArrrowColors',
        value: function _changeArrrowColors() {
          var currentColor = this.flickity.selectedElement.querySelector('.slideshow-background').dataset;
          var dots = this.el.querySelectorAll('.flickity-page-dots .dot');
          if (layout.isBreakpoint('XS') && !this.isFullscreen) {
            currentColor = currentColor.themecolor;
          } else {
            currentColor = currentColor.slidecolor;
          }
          this.el.querySelector('.flickity-prev-next-button.previous svg').style.fill = currentColor;
          this.el.querySelector('.flickity-prev-next-button.next svg').style.fill = currentColor;
          for (var i = 0; i < dots.length; i++) {
            dots[i].style.background = currentColor;
          }
        },
      },
      {
        key: '_slideshowHeight',
        value: function _slideshowHeight() {
          var headerHeight = getHeaderOffset(document.querySelector('.x-head-wrapper'));
          if (this.isFullscreen) {
            this.el.querySelector('.flickity-viewport').style.height = 'calc(100vh - ' + headerHeight + 'px)';
            this.container.style.height = 'calc(100vh - ' + headerHeight + 'px)';
          }
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this._destroyFlickity();
          this.$window.off('.slideshow');
          this.$firstSlideImage.off('image:load');
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.flickity.destroy();
        },
      },
      {
        key: 'onSectionBlockSelect',
        value: function onSectionBlockSelect(block) {
          var _this3 = this;
          setTimeout(function () {
            _this3.flickity.resize();
          }, 100);
          if (this.settings.enable_autoplay) {
            var $slides = jQuery(this.slides);
            var $slide = jQuery(block.el);
            var slideIndex = $slides.index($slide);
            this.stopAutoplay = true;
            this.flickity.pausePlayer();
            if (!$slide.hasClass('is-selected') && !this.selectBlockOnLoad) {
              this.flickity.select(slideIndex, false, false);
            } else if (this.selectBlockOnLoad) {
              this.flickity.select(slideIndex, false, true);
            }
          }
        },
      },
      {
        key: 'onSectionBlockDeselect',
        value: function onSectionBlockDeselect() {
          if (this.settings.enable_autoplay) {
            this.stopAutoplay = false;
            this.flickity.playPlayer();
          }
        },
      },
    ]);
    return XSlideshow;
  })();
  var XPromoBlocks = (function () {
    function XPromoBlocks(section) {
      classCallCheck(this, XPromoBlocks);
      this.$el = jQuery(section.el);
      this.content = '[data-market-block-content]';
      this.expandedClass = 'market-block--expanded';
      this.compressBlocks = section.data.compress_blocks;
      // Revert navigation to original state on breakpoint change
      this.layoutHandler = this.onBreakpointChange.bind(this);
      layout.onBreakpointChange(this.layoutHandler);
      this._blockInteraction = this._blockInteraction.bind(this);
      this.$el.on('click.market-block', this.content, this._blockInteraction);
    }
    /**
     * Remove block's toggled state and attributes when leaving mobile
     */
    createClass(XPromoBlocks, [
      {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
          var _this = this;
          if (!layout.isBreakpoint('XS')) {
            this.$el.find('.' + this.expandedClass).each(function (i, content) {
              _this._collapse(content);
            });
          }
        },
        /**
         * Unbind events when section is re-drawn
         */
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.$el.off('.market-block');
          layout.offBreakpointChange(this.layoutHandler);
        },
        /**
         * Callback to open block on mobile from the TE
         *
         * @param block
         */
      },
      {
        key: 'onSectionBlockSelect',
        value: function onSectionBlockSelect(block) {
          if (!layout.isBreakpoint('XS')) return;
          this._expand(block.el.querySelector(this.content));
        },
        /**
         * Callback to close block on mobile from the TE
         *
         * @param block
         */
      },
      {
        key: 'onSectionBlockDeselect',
        value: function onSectionBlockDeselect(block) {
          if (!layout.isBreakpoint('XS')) return;
          this._collapse(block.el.querySelector(this.content));
        },
        /**
         * Expand a block on first click, then allow it to behave as normal
         *
         * @param event
         * @private
         */
      },
      {
        key: '_blockInteraction',
        value: function _blockInteraction(event) {
          var content = event.currentTarget;
          var clicked = content.getAttribute('data-clicked');
          // On second click, or on desktop, don't interfere with block
          if (clicked || !layout.isBreakpoint('XS') || !this.compressBlocks) {
            return;
          }
          event.preventDefault();
          content.setAttribute('data-clicked', 'clicked');
          this._expand(content);
        },
        /**
         * Expand market block
         *
         * @param content
         * @private
         */
      },
      {
        key: '_expand',
        value: function _expand(content) {
          var _this2 = this;
          if (!this.compressBlocks) {
            return;
          }
          var $content = jQuery(content);
          $content.addClass('animating animating-in').one('trend', function () {
            $content.removeClass('animating animating-in').addClass(_this2.expandedClass).off('trend');
          });
        },
        /**
         * Collapse a block
         *
         * @param content
         * @private
         */
      },
      {
        key: '_collapse',
        value: function _collapse(content) {
          var _this3 = this;
          if (!this.compressBlocks) {
            return;
          }
          var $content = jQuery(content);
          $content.addClass('animating animating-out').one('trend', function () {
            $content.removeClass('animating animating-out ' + _this3.expandedClass).off('trend');
            content.removeAttribute('data-clicked');
          });
        },
      },
    ]);
    return XPromoBlocks;
  })();
  var XMenuList = (function () {
    function XMenuList(section) {
      classCallCheck(this, XMenuList);
      this.$el = jQuery(section.el);
      this.context = section.data.context;
      this.Accordion = new Accordion(this.$el);
      // Handle Accordion interaction when window size changes
      this.layoutHandler = this.onBreakpointChange.bind(this);
      layout.onBreakpointChange(this.layoutHandler);
      this._bindEvents();
    }
    createClass(XMenuList, [
      {
        key: '_bindEvents',
        value: function _bindEvents() {
          var _this = this;
          this.$el.on('click.menu-list', '[data-accordion-trigger]', function (event) {
            event.preventDefault();
            _this._toggleAccordion(jQuery(event.currentTarget).parent());
          });
          this.$el.on('click.menu-list', '[data-x-menu-list-toggle]', function (event) {
            event.preventDefault();
            _this._toggleList(event.currentTarget);
          });
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.$el.off('.menu-list');
          delete this.Accordion;
        },
      },
      {
        key: 'onSectionBlockSelect',
        value: function onSectionBlockSelect(block) {
          this._toggleAccordion(jQuery(block.el), true);
        },
      },
      {
        key: 'onSectionBlockDeselect',
        value: function onSectionBlockDeselect(block) {
          this._toggleAccordion(jQuery(block.el), false);
        },
      },
      {
        key: '_toggleAccordion',
        value: function _toggleAccordion($block) {
          if (layout.isBreakpoint('L')) return;
          this.Accordion.toggle($block);
        },
      },
      {
        key: '_toggleList',
        value: function _toggleList(el) {
          var $trigger = jQuery(el);
          var $items = $trigger.parent().siblings('[data-hidden-default]');
          var siblingsVisible = $trigger.data('x-menu-list-toggle');
          $items.toggleClass('x-menu-list--menu-item-hidden', siblingsVisible);
          $trigger.data('x-menu-list-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);
        },
      },
      {
        key: 'onBreakpointChange',
        value: function onBreakpointChange(event, breakpoints) {
          if (layout.isBreakpoint('L')) {
            this.Accordion.openAll();
          } else if (breakpoints.previous === 'L' && !layout.isBreakpoint('L')) {
            this.Accordion.closeOpen();
          }
        },
      },
    ]);
    return XMenuList;
  })();
  var twitterFetcher_min = createCommonjsModule(function (module, exports) {
    /*********************************************************************
     *  #### Twitter Post Fetcher v17.0.3 ####
     *  Coded by Jason Mayes 2015. A present to all the developers out there.
     *  www.jasonmayes.com
     *  Please keep this disclaimer with my code if you use it. Thanks. :-)
     *  Got feedback or questions, ask here:
     *  http://www.jasonmayes.com/projects/twitterApi/
     *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
     *  Updates will be posted to this site.
     *********************************************************************/
    (function (root, factory) {
      if (typeof undefined === 'function' && undefined.amd) {
        undefined([], factory);
      } else {
        module.exports = factory();
      }
    })(commonjsGlobal, function () {
      var domNode = '';
      var maxTweets = 20;
      var parseLinks = true;
      var queue = [];
      var inProgress = false;
      var printTime = true;
      var printUser = true;
      var formatterFunction = null;
      var supportsClassName = true;
      var showRts = true;
      var customCallbackFunction = null;
      var showInteractionLinks = true;
      var showImages = false;
      var useEmoji = false;
      var targetBlank = true;
      var lang = 'en';
      var permalinks = true;
      var dataOnly = false;
      var script = null;
      function handleTweets(tweets) {
        if (customCallbackFunction === null) {
          var x = tweets.length;
          var n = 0;
          var element = document.getElementById(domNode);
          var html = '<ul>';
          while (n < x) {
            html += '<li>' + tweets[n] + '</li>';
            n++;
          }
          html += '</ul>';
          element.innerHTML = html;
        } else {
          customCallbackFunction(tweets);
        }
      }
      function strip(data) {
        return data
          .replace(/<b[^>]*>(.*?)<\/b>/gi, function (a, s) {
            return s;
          })
          .replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, '');
      }
      function targetLinksToNewWindow(el) {
        var links = el.getElementsByTagName('a');
        for (var i = links.length - 1; i >= 0; i--) {
          links[i].setAttribute('target', '_blank');
        }
      }
      function getElementsByClassName(node, classname) {
        var a = [];
        var regex = new RegExp('(^| )' + classname + '( |$)');
        var elems = node.getElementsByTagName('*');
        for (var i = 0, j = elems.length; i < j; i++) {
          if (regex.test(elems[i].className)) {
            a.push(elems[i]);
          }
        }
        return a;
      }
      function extractImageUrl(image_data) {
        if (image_data !== undefined && image_data.innerHTML.indexOf('data-image') >= 0) {
          var data_src = image_data.innerHTML.match(
            /data-image=\"([A-z0-9]+:\/\/[A-z0-9]+\.[A-z0-9]+\.[A-z0-9]+\/[A-z0-9]+\/[A-z0-9\-]+)/i
          )[1];
          return decodeURIComponent(data_src) + '.jpg';
        }
      }
      var twitterFetcher = {
        fetch: function (config) {
          if (config.maxTweets === undefined) {
            config.maxTweets = 20;
          }
          if (config.enableLinks === undefined) {
            config.enableLinks = true;
          }
          if (config.showUser === undefined) {
            config.showUser = true;
          }
          if (config.showTime === undefined) {
            config.showTime = true;
          }
          if (config.dateFunction === undefined) {
            config.dateFunction = 'default';
          }
          if (config.showRetweet === undefined) {
            config.showRetweet = true;
          }
          if (config.customCallback === undefined) {
            config.customCallback = null;
          }
          if (config.showInteraction === undefined) {
            config.showInteraction = true;
          }
          if (config.showImages === undefined) {
            config.showImages = false;
          }
          if (config.useEmoji === undefined) {
            config.useEmoji = false;
          }
          if (config.linksInNewWindow === undefined) {
            config.linksInNewWindow = true;
          }
          if (config.showPermalinks === undefined) {
            config.showPermalinks = true;
          }
          if (config.dataOnly === undefined) {
            config.dataOnly = false;
          }
          if (inProgress) {
            queue.push(config);
          } else {
            inProgress = true;
            domNode = config.domId;
            maxTweets = config.maxTweets;
            parseLinks = config.enableLinks;
            printUser = config.showUser;
            printTime = config.showTime;
            showRts = config.showRetweet;
            formatterFunction = config.dateFunction;
            customCallbackFunction = config.customCallback;
            showInteractionLinks = config.showInteraction;
            showImages = config.showImages;
            useEmoji = config.useEmoji;
            targetBlank = config.linksInNewWindow;
            permalinks = config.showPermalinks;
            dataOnly = config.dataOnly;
            var head = document.getElementsByTagName('head')[0];
            if (script !== null) {
              head.removeChild(script);
            }
            script = document.createElement('script');
            script.type = 'text/javascript';
            if (config.list !== undefined) {
              script.src =
                'https://syndication.twitter.com/timeline/list?' +
                'callback=__twttrf.callback&dnt=false&list_slug=' +
                config.list.listSlug +
                '&screen_name=' +
                config.list.screenName +
                '&suppress_response_codes=true&lang=' +
                (config.lang || lang) +
                '&rnd=' +
                Math.random();
            } else if (config.profile !== undefined) {
              script.src =
                'https://syndication.twitter.com/timeline/profile?' +
                'callback=__twttrf.callback&dnt=false' +
                '&screen_name=' +
                config.profile.screenName +
                '&suppress_response_codes=true&lang=' +
                (config.lang || lang) +
                '&rnd=' +
                Math.random();
            } else if (config.likes !== undefined) {
              script.src =
                'https://syndication.twitter.com/timeline/likes?' +
                'callback=__twttrf.callback&dnt=false' +
                '&screen_name=' +
                config.likes.screenName +
                '&suppress_response_codes=true&lang=' +
                (config.lang || lang) +
                '&rnd=' +
                Math.random();
            } else {
              script.src =
                'https://cdn.syndication.twimg.com/widgets/timelines/' +
                config.id +
                '?&lang=' +
                (config.lang || lang) +
                '&callback=__twttrf.callback&' +
                'suppress_response_codes=true&rnd=' +
                Math.random();
            }
            head.appendChild(script);
          }
        },
        callback: function (data) {
          if (data === undefined || data.body === undefined) {
            inProgress = false;
            if (queue.length > 0) {
              twitterFetcher.fetch(queue[0]);
              queue.splice(0, 1);
            }
            return;
          }
          if (!useEmoji) {
            data.body = data.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g, '');
          }
          if (!showImages) {
            data.body = data.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g, '');
          }
          if (!printUser) {
            data.body = data.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g, '');
          }
          var div = document.createElement('div');
          div.innerHTML = data.body;
          if (typeof div.getElementsByClassName === 'undefined') {
            supportsClassName = false;
          }
          function swapDataSrc(element) {
            var avatarImg = element.getElementsByTagName('img')[0];
            if (avatarImg && avatarImg.length) {
              avatarImg.src = avatarImg.getAttribute('data-src-2x');
            }
            return element;
          }
          var tweets = [];
          var authors = [];
          var times = [];
          var images = [];
          var rts = [];
          var tids = [];
          var permalinksURL = [];
          var x = 0;
          if (supportsClassName) {
            var tmp = div.getElementsByClassName('timeline-Tweet');
            while (x < tmp.length) {
              if (tmp[x].getElementsByClassName('timeline-Tweet-retweetCredit').length > 0) {
                rts.push(true);
              } else {
                rts.push(false);
              }
              if (!rts[x] || (rts[x] && showRts)) {
                tweets.push(tmp[x].getElementsByClassName('timeline-Tweet-text')[0]);
                tids.push(tmp[x].getAttribute('data-tweet-id'));
                if (printUser) {
                  authors.push(swapDataSrc(tmp[x].getElementsByClassName('timeline-Tweet-author')[0]));
                }
                times.push(tmp[x].getElementsByClassName('dt-updated')[0]);
                permalinksURL.push(tmp[x].getElementsByClassName('timeline-Tweet-timestamp')[0]);
                if (tmp[x].getElementsByClassName('timeline-Tweet-media')[0] !== undefined) {
                  images.push(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]);
                } else {
                  images.push(undefined);
                }
              }
              x++;
            }
          } else {
            var tmp = getElementsByClassName(div, 'timeline-Tweet');
            while (x < tmp.length) {
              if (getElementsByClassName(tmp[x], 'timeline-Tweet-retweetCredit').length > 0) {
                rts.push(true);
              } else {
                rts.push(false);
              }
              if (!rts[x] || (rts[x] && showRts)) {
                tweets.push(getElementsByClassName(tmp[x], 'timeline-Tweet-text')[0]);
                tids.push(tmp[x].getAttribute('data-tweet-id'));
                if (printUser) {
                  authors.push(swapDataSrc(getElementsByClassName(tmp[x], 'timeline-Tweet-author')[0]));
                }
                times.push(getElementsByClassName(tmp[x], 'dt-updated')[0]);
                permalinksURL.push(getElementsByClassName(tmp[x], 'timeline-Tweet-timestamp')[0]);
                if (getElementsByClassName(tmp[x], 'timeline-Tweet-media')[0] !== undefined) {
                  images.push(getElementsByClassName(tmp[x], 'timeline-Tweet-media')[0]);
                } else {
                  images.push(undefined);
                }
              }
              x++;
            }
          }
          if (tweets.length > maxTweets) {
            tweets.splice(maxTweets, tweets.length - maxTweets);
            authors.splice(maxTweets, authors.length - maxTweets);
            times.splice(maxTweets, times.length - maxTweets);
            rts.splice(maxTweets, rts.length - maxTweets);
            images.splice(maxTweets, images.length - maxTweets);
            permalinksURL.splice(maxTweets, permalinksURL.length - maxTweets);
          }
          var arrayTweets = [];
          var x = tweets.length;
          var n = 0;
          if (dataOnly) {
            while (n < x) {
              arrayTweets.push({
                tweet: tweets[n].innerHTML,
                author: authors[n] ? authors[n].innerHTML : 'Unknown Author',
                author_data: {
                  profile_url: authors[n] ? authors[n].querySelector('[data-scribe="element:user_link"]').href : null,
                  profile_image: authors[n] ? authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-1x') : null,
                  profile_image_2x: authors[n]
                    ? authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-2x')
                    : null,
                  screen_name: authors[n] ? authors[n].querySelector('[data-scribe="element:screen_name"]').title : null,
                  name: authors[n] ? authors[n].querySelector('[data-scribe="element:name"]').title : null,
                },
                time: times[n].textContent,
                timestamp: times[n]
                  .getAttribute('datetime')
                  .replace('+0000', 'Z')
                  .replace(/([\+\-])(\d\d)(\d\d)/, '$1$2:$3'),
                image: extractImageUrl(images[n]),
                rt: rts[n],
                tid: tids[n],
                permalinkURL: permalinksURL[n] === undefined ? '' : permalinksURL[n].href,
              });
              n++;
            }
          } else {
            while (n < x) {
              if (typeof formatterFunction !== 'string') {
                var datetimeText = times[n].getAttribute('datetime');
                var newDate = new Date(times[n].getAttribute('datetime').replace(/-/g, '/').replace('T', ' ').split('+')[0]);
                var dateString = formatterFunction(newDate, datetimeText);
                times[n].setAttribute('aria-label', dateString);
                if (tweets[n].textContent) {
                  if (supportsClassName) {
                    times[n].textContent = dateString;
                  } else {
                    var h = document.createElement('p');
                    var t = document.createTextNode(dateString);
                    h.appendChild(t);
                    h.setAttribute('aria-label', dateString);
                    times[n] = h;
                  }
                } else {
                  times[n].textContent = dateString;
                }
              }
              var op = '';
              if (parseLinks) {
                if (targetBlank) {
                  targetLinksToNewWindow(tweets[n]);
                  if (printUser) {
                    targetLinksToNewWindow(authors[n]);
                  }
                }
                if (printUser) {
                  op += '<div class="user">' + strip(authors[n].innerHTML) + '</div>';
                }
                op += '<p class="tweet">' + strip(tweets[n].innerHTML) + '</p>';
                if (printTime) {
                  if (permalinks) {
                    op += '<p class="timePosted"><a href="' + permalinksURL[n] + '">' + times[n].getAttribute('aria-label') + '</a></p>';
                  } else {
                    op += '<p class="timePosted">' + times[n].getAttribute('aria-label') + '</p>';
                  }
                }
              } else {
                if (tweets[n].textContent) {
                  if (printUser) {
                    op += '<p class="user">' + authors[n].textContent + '</p>';
                  }
                  op += '<p class="tweet">' + tweets[n].textContent + '</p>';
                  if (printTime) {
                    op += '<p class="timePosted">' + times[n].textContent + '</p>';
                  }
                } else {
                  if (printUser) {
                    op += '<p class="user">' + authors[n].textContent + '</p>';
                  }
                  op += '<p class="tweet">' + tweets[n].textContent + '</p>';
                  if (printTime) {
                    op += '<p class="timePosted">' + times[n].textContent + '</p>';
                  }
                }
              }
              if (showInteractionLinks) {
                op +=
                  '<p class="interact"><a href="https://twitter.com/intent/' +
                  'tweet?in_reply_to=' +
                  tids[n] +
                  '" class="twitter_reply_icon"' +
                  (targetBlank ? ' target="_blank">' : '>') +
                  'Reply</a><a href="https://twitter.com/intent/retweet?' +
                  'tweet_id=' +
                  tids[n] +
                  '" class="twitter_retweet_icon"' +
                  (targetBlank ? ' target="_blank">' : '>') +
                  'Retweet</a>' +
                  '<a href="https://twitter.com/intent/favorite?tweet_id=' +
                  tids[n] +
                  '" class="twitter_fav_icon"' +
                  (targetBlank ? ' target="_blank">' : '>') +
                  'Favorite</a></p>';
              }
              if (showImages && images[n] !== undefined && extractImageUrl(images[n]) !== undefined) {
                op += '<div class="media">' + '<img src="' + extractImageUrl(images[n]) + '" alt="Image from tweet" />' + '</div>';
              }
              if (showImages) {
                arrayTweets.push(op);
              } else if (!showImages && tweets[n].textContent.length) {
                arrayTweets.push(op);
              }
              n++;
            }
          }
          handleTweets(arrayTweets);
          inProgress = false;
          if (queue.length > 0) {
            twitterFetcher.fetch(queue[0]);
            queue.splice(0, 1);
          }
        },
      };
      window.__twttrf = twitterFetcher;
      window.twitterFetcher = twitterFetcher;
      return twitterFetcher;
    });
  });
  var XTwitterFeed$1 = (function () {
    function XTwitterFeed(section) {
      var _this = this;
      classCallCheck(this, XTwitterFeed);
      this.$el = jQuery(section.el);
      this.settings = section.data;
      this.$window = jQuery(window);
      this.isIE9 = jQuery('body').hasClass('ie9');
      this.flickity = null;
      this.$content = this.$el.find('[data-twitter-content]');
      this.$wrapper = this.$el.find('[data-twitter-wrapper]');
      this.$tweets = this.$el.find('[data-tweet-content]');
      this.$wrapper.on('image:enter', function (event) {
        _this._load();
      });
      state.instance.track(this.$wrapper[0]);
    }
    createClass(XTwitterFeed, [
      {
        key: '_load',
        value: function _load() {
          var _this2 = this;
          this.$template = jQuery(this.settings.template);
          var onboarding = this.settings.onboarding;
          var username = this.settings.username;
          var retweets = this.settings.retweets;
          var images = this.settings.images;
          var locale = this.settings.locale || 'en';
          // Activate flickity on mobile
          this._mobileSlider = this._mobileSlider.bind(this);
          layout.onBreakpointChange(this._mobileSlider);
          this._mobileSlider();
          this._evenHeights = this._evenHeights.bind(this);
          this._evenHeights();
          if (onboarding || !username) {
            return;
          }
          this.$window.on(
            'resize.twitter',
            justDebounce$1(
              function () {
                return _this2._evenHeights;
              },
              16,
              true,
              true
            )
          );
          twitterFetcher_min.fetch({
            profile: { screenName: username },
            maxTweets: 3,
            enableLinks: true,
            showUser: true,
            showTime: true,
            dataOnly: false,
            useEmoji: true,
            showImages: images,
            showRetweet: retweets,
            lang: locale,
            customCallback: function customCallback(tweets) {
              return _this2._renderTweets(tweets);
            },
            showInteraction: false,
          });
        },
        /**
         * Unbind events when section is re-drawn
         */
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          state.instance.untrack(this.$wrapper[0]);
          this.$window.off('.twitter');
          this.$content.off('.twitter');
          layout.offBreakpointChange(this._mobileSlider);
          this._destroyFlickity();
        },
        /**
         * Evens the height of the twitter blocks if the browser doesn't support Flexbox
         * @private
         */
      },
      {
        key: '_evenHeights',
        value: function _evenHeights() {
          if (!this.isIE9) {
            return;
          }
          var heights = [];
          this.$tweets.height('');
          this.$tweets.each(function (i, el) {
            var $el = jQuery(el);
            heights.push($el.outerHeight());
          });
          this.$tweets.height(Math.ceil(Math.max.apply(null, heights)));
        },
      },
      {
        key: '_initFlickity',
        value: function _initFlickity() {
          this.flickity = new js$1(this.$content[0], {
            cellSelector: '[data-tweet-content]',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
          });
          this._bindSlider();
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.flickity.destroy();
          this.flickity = null;
        },
      },
      {
        key: '_mobileSlider',
        value: function _mobileSlider() {
          // If is Large layout, attempt to destroy flickity
          if (layout.isBreakpoint('L')) {
            this._destroyFlickity();
            return;
          }
          // Is XS/S/M, and flickity is init'd -- do nothing
          if (this.flickity) {
            return;
          }
          // Is XS/S/M, and flickity is not init'd
          this._initFlickity();
        },
      },
      {
        key: '_bindSlider',
        value: function _bindSlider() {
          var _this3 = this;
          var $slider = this.$content.find('.flickity-slider');
          this.$window.on(
            'resize.twitter',
            justDebounce$1(function () {
              _this3.$content.trigger('heightUpdate.twitter');
            })
          );
          this.flickity.on('cellSelect', function () {
            _this3.$content.trigger('heightUpdate.twitter');
          });
          this.$content.on('heightUpdate.twitter', function () {
            if (!_this3.flickity) {
              return;
            }
            $slider.height(Math.ceil(_this3.flickity.maxCellHeight));
          });
          // Sets the Slider to the height of the first slide
          this.$content.trigger('heightUpdate.twitter');
        },
        /**
         * Retrieve information about user who tweeted
         *
         * @param el
         * @returns {{$avatar: *, link: *, name, screenName}}
         * @private
         */
      },
      {
        key: '_extractAuthor',
        value: function _extractAuthor(el) {
          var $el = jQuery(el);
          var link = $el.find('a').attr('href');
          var name = $el.find('[data-scribe="element:name"]').text();
          var screenName = $el.find('[data-scribe="element:screen_name"]').text();
          var $avatar = $el.find('img');
          return { $avatar: $avatar, link: link, name: name, screenName: screenName };
        },
        /**
         * Retrieve link to tweet, and when it was tweeted
         *
         * @param el
         * @returns {{link: *, postedAt: *}}
         * @private
         */
      },
      {
        key: '_extractMeta',
        value: function _extractMeta(el) {
          var $el = jQuery(el);
          var link = $el.find('a').attr('href');
          var postedAt = $el.text();
          return { link: link, postedAt: postedAt };
        },
      },
      {
        key: '_extractWrapperClass',
        value: function _extractWrapperClass() {
          var wrapperClass = this.$wrapper.attr('class').match(/tweet--count-\d+$/);
          if (wrapperClass) {
            return wrapperClass[0];
          } else {
            return '';
          }
        },
      },
      {
        key: '_renderTweets',
        value: function _renderTweets(tweets) {
          var _this4 = this;
          var tweetsLength = tweets.length;
          if (!tweets || !tweetsLength) return;
          var tweetsArray = [];
          var wrapperClass = 'tweet--count-' + tweetsLength;
          tweets.forEach(function (tweet) {
            var $tweet = jQuery(tweet);
            var $template = _this4.$template.clone();
            var authorInfo = _this4._extractAuthor($tweet[0]);
            var meta = _this4._extractMeta($tweet[2]);
            var content = $tweet[1];
            // Render header
            $template.find('.tweet--header').attr('href', authorInfo.link);
            $template.find('.tweet--header-image').html(authorInfo.$avatar);
            $template.find('.tweet--header-name').text(authorInfo.name);
            $template.find('.tweet--header-screenname').text(authorInfo.screenName);
            // Render content
            $template
              .find('.tweet--content')
              .append($tweet[3] ? $tweet[3] : null)
              .append(content);
            // Render footer
            $template.find('.tweet--footer').attr('href', meta.link).find('.tweet--footer--posted').text(meta.postedAt);
            tweetsArray.push($template);
          });
          this.$wrapper.css('min-height', this.$wrapper.height());
          this.$tweets
            .fadeOut()
            .promise()
            .then(function () {
              _this4._destroyFlickity();
              _this4.$tweets.remove();
              _this4.$content.append(tweetsArray);
              _this4.$wrapper.removeClass(_this4._extractWrapperClass()).addClass(wrapperClass).css('min-height', '');
              _this4.$tweets = _this4.$el.find('[data-tweet-content]');
              _this4._evenHeights();
              _this4._mobileSlider();
            });
        },
      },
    ]);
    return XTwitterFeed;
  })();
  var XInstagramFeed = (function () {
    function XInstagramFeed(section) {
      var _this = this;
      classCallCheck(this, XInstagramFeed);
      this.settings = section.data;
      this.onboarding = this.settings.onboarding;
      this.photoCount = this.settings.photo_count;
      this.accessToken = this.settings.access_token;
      this.$el = jQuery(section.el);
      this.$window = jQuery(window);
      this.$photoContainer = this.$el.find('[data-instagram-content]');
      this.$photoContainerPlaceholder = this.$el.find('[data-instagram-photo-placeholder]');
      this.$photoTemplate = jQuery('<figure class="instagram--photo" data-instagram-photo />');
      this.$photoContainer.on('image:enter', function (event) {
        _this._load();
      });
      state.instance.track(this.$photoContainer[0]);
    }
    createClass(XInstagramFeed, [
      {
        key: '_load',
        value: function _load() {
          var _this2 = this;
          // Activate flickity on mobile
          this._mobileSlider = this._mobileSlider.bind(this);
          layout.onBreakpointChange(this._mobileSlider);
          this._mobileSlider();
          if (this.onboarding || !this.accessToken) {
            return;
          }
          this._getPhotos()
            .done(function (photos) {
              return _this2._renderPhotos(photos);
            })
            .fail(function (error) {
              console.warn('Instagram: ' + error);
            });
        },
      },
      {
        key: '_getPhotos',
        value: function _getPhotos() {
          var url =
            'https://api.instagram.com/v1/users/self/media/recent?access_token=' +
            this.accessToken +
            '&count=' +
            this.photoCount +
            '&callback=';
          var photoPromise = jQuery.ajax(url, {
            dataType: 'jsonp',
          });
          return photoPromise.then(function (response) {
            if (response.meta.code !== 200) {
              var error = response.meta.error_message + ' (' + response.meta.error_type + ')';
              return jQuery.Deferred().reject(error).promise();
            }
            return response.data;
          });
        },
      },
      {
        key: '_renderPhotos',
        value: function _renderPhotos(photos) {
          var _this3 = this;
          var photoArray = [];
          photos.forEach(function (photo) {
            var $template = _this3.$photoTemplate.clone();
            var lowResolution = photo.images.low_resolution;
            var standardResolution = photo.images.standard_resolution;
            var $link = jQuery('<a target="_blank" href="' + photo.link + '"></a>');
            var $photo = jQuery('<img src="' + lowResolution.url + '">');
            if (standardResolution.width >= lowResolution.width * 2) {
              $photo.attr('srcset', standardResolution.url + ' 2x');
            } else {
              $photo.attr('src', '' + standardResolution.url);
            }
            $link.append($photo);
            $template.append($link);
            photoArray.push($template);
          });
          this.$photoContainerPlaceholder.fadeOut(function () {
            _this3._destroyFlickity();
            _this3.$photoContainer.append(photoArray);
            _this3.$photoContainerPlaceholder.remove();
            _this3._mobileSlider();
          });
        },
      },
      {
        key: '_initFlickity',
        value: function _initFlickity() {
          this.flickity = new js$1(this.$photoContainer[0], {
            cellSelector: '.instagram--photo',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
          });
          this._bindSlider();
        },
      },
      {
        key: '_destroyFlickity',
        value: function _destroyFlickity() {
          if (!this.flickity) {
            return;
          }
          this.$window.off('.instagram-feed');
          this.$photoContainer.off('.instagram-feed');
          this.flickity.destroy();
          this.flickity = null;
        },
      },
      {
        key: '_mobileSlider',
        value: function _mobileSlider() {
          // If is Large layout, attempt to destroy flickity
          if (layout.isBreakpoint('L') || layout.isBreakpoint('M')) {
            this._destroyFlickity();
            return;
          }
          // Is XS/S/M, and flickity is init'd -- do nothing
          if (this.flickity) {
            return;
          }
          // Is XS/S/M, and flickity is not init'd
          this._initFlickity();
        },
      },
      {
        key: '_bindSlider',
        value: function _bindSlider() {
          var _this4 = this;
          var $slider = this.$photoContainer.find('.flickity-slider');
          this.$window.on(
            'resize.instagram-feed',
            justDebounce$1(function () {
              _this4.$photoContainer.trigger('heightUpdate.instagram-feed');
            })
          );
          this.flickity.on('cellSelect', function () {
            _this4.$photoContainer.trigger('heightUpdate.instagram-feed');
          });
          this.$photoContainer.on('heightUpdate.instagram-feed', function () {
            if (!_this4.flickity) {
              return;
            }
            $slider.height(Math.ceil(_this4.flickity.maxCellHeight));
          });
          // Sets the Slider to the height of the first slide
          this.$photoContainer.trigger('heightUpdate.instagram-feed');
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          state.instance.untrack(this.$photoContainer[0]);
        },
      },
    ]);
    return XInstagramFeed;
  })();
  var XFeaturedCollection = (function () {
    function XFeaturedCollection(section) {
      var _this = this;
      classCallCheck(this, XFeaturedCollection);
      this.section = section;
      this.$el = jQuery(section.el);
      // Product items
      this.productItems = [];
      var $productItems = this.$el.find('[data-product-item]');
      $productItems.each(function (i, productItem) {
        _this.productItems.push(new ProductGridItem(jQuery(productItem)));
      });
      this.ProductRowScroller = new ProductRowScroller(section.el.querySelector('[data-product-row]'));
      this._updatePrices();
    }
    createClass(XFeaturedCollection, [
      {
        key: '_updatePrices',
        value: function _updatePrices() {
          this.$el.find('.money').each(function (index, el) {
            return dist$2.update(el);
          });
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.productItems.forEach(function (productItem) {
            productItem.unload();
          });
          this.ProductRowScroller.unload();
        },
      },
    ]);
    return XFeaturedCollection;
  })();
  var XSearch = (function () {
    function XSearch(section) {
      var _this = this;
      classCallCheck(this, XSearch);
      this.$el = jQuery(section.el);
      this.settings = section.data.settings;
      this.search = null;
      this.$scripts = jQuery('[data-scripts]');
      this.$searchField = this.$el.find('[data-live-search]');
      this.forms = new Forms(this.$el);
      if (this.settings.live_search.enable) {
        script$1(this.$scripts.data('shopify-api-url'), function () {
          _this.search = new LiveSearch(
            {
              $el: _this.$searchField,
              $header: _this.$el,
            },
            _this.settings.live_search
          );
        });
      } else {
        this.search = new SearchForm(this.$searchField);
      }
    }
    createClass(XSearch, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.search.unload();
          this.forms.unload();
        },
      },
    ]);
    return XSearch;
  })();
  var XTwitterFeed$3 = (function () {
    function XTwitterFeed(section) {
      var _this = this;
      classCallCheck(this, XTwitterFeed);
      this.$el = jQuery(section.el);
      this.rte = [];
      this.$el.find('[data-rte]').each(function (i, el) {
        _this.rte.push(new RichText(jQuery(el)));
      });
    }
    /**
     * Unbind events when section is re-drawn
     */
    createClass(XTwitterFeed, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.rte.forEach(function (richTextArea) {
            richTextArea.unload();
          });
        },
      },
    ]);
    return XTwitterFeed;
  })();
  var XVideo = (function () {
    function XVideo(section) {
      classCallCheck(this, XVideo);
      var videoEl = section.el.querySelector('[data-video]');
      this.$el = section.el;
      this.autoplay = section.data.autoplay;
      this.hasPlayed = false;
      if (videoEl) {
        this.video = new Video(videoEl);
        this.bindEvents();
      }
    }
    createClass(XVideo, [
      {
        key: 'bindEvents',
        value: function bindEvents() {
          var _this = this;
          window.addEventListener('scroll', function () {
            if (_this.autoplay) {
              var rect = _this.$el.getBoundingClientRect();
              if (rect.top >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                if (!_this.hasPlayed) {
                  _this.video._autoplay();
                  _this.hasPlayed = true;
                }
              } else {
                _this.video._onPauseClick();
              }
            }
          });
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          if (this.video) {
            this.video.unload();
          }
        },
      },
    ]);
    return XVideo;
  })();
  var XNewsletter = (function () {
    function XNewsletter(section) {
      classCallCheck(this, XNewsletter);
      this.$el = jQuery(section.el);
      this.forms = new Forms(this.$el);
    }
    createClass(XNewsletter, [
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          this.forms.unload();
        },
      },
    ]);
    return XNewsletter;
  })();
  /**
   * x-map v2.0.1
   * (c) 2018 undefined
   */
  var justDebounce$2 = debounce$2;
  function debounce$2(fn, delay, at_start, guarantee) {
    var timeout;
    var args;
    var self;
    return function debounced() {
      self = this;
      args = Array.prototype.slice.call(arguments);
      if (timeout && (at_start || guarantee)) {
        return;
      } else if (!at_start) {
        clear();
        timeout = setTimeout(run, delay);
        return timeout;
      }
      timeout = setTimeout(clear, delay);
      fn.apply(self, args);
      function run() {
        clear();
        fn.apply(self, args);
      }
      function clear() {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  }
  var classCallCheck$4 = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  };
  var createClass$4 = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var PxsMap = (function () {
    function PxsMap(section) {
      var _this = this;
      classCallCheck$4(this, PxsMap);
      this.$el = jQuery('[data-map]', section.el);
      this.settings = section.data;
      this.map = null;
      this.center = null;
      this.$container = jQuery('[data-map-container]', this.$el);
      // Scale so range is 12 ~ 17, rather than 1 to 6
      this.zoom = 11 + parseInt(this.settings.zoom, 10);
      if (isNaN(this.zoom)) this.zoom = 13;
      this.colors = null;
      if (this.settings.colors) {
        this.colors = this.settings.colors;
      }
      this.resize = this.resize.bind(this);
      this.address = this.settings.address;
      this.apiKey = this.settings.api_key;
      if (this.apiKey) {
        if (window.googleMaps === undefined) {
          script$1('https://maps.googleapis.com/maps/api/js?key=' + this.apiKey, function () {
            window.googleMaps = true;
            _this._createMap();
          });
        } else {
          this._createMap();
        }
      }
    }
    createClass$4(PxsMap, [
      {
        key: '_createMap',
        value: function _createMap() {
          var _this2 = this;
          return this.geolocate()
            .done(function (results) {
              _this2.map = new google.maps.Map(_this2.$container.get(0), {
                center: results[0].geometry.location,
                clickableIcons: false,
                disableDefaultUI: true,
                disableDoubleClickZoom: true,
                gestureHandling: 'none',
                keyboardShortcuts: false,
                maxZoom: _this2.zoom,
                minZoom: _this2.zoom,
                scrollWheel: false,
                styles: _this2._getMapStyles(),
                zoom: _this2.zoom,
                zoomControl: false,
              });
              _this2.center = _this2.map.getCenter();
              _this2.map.panBy(0, 0);
              new google.maps.Marker({
                clickable: false,
                map: _this2.map,
                position: _this2.center,
              });
              google.maps.event.addDomListener(window, 'resize', justDebounce$2(_this2.resize, 250, true, true));
            })
            .fail(function (status) {
              var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
              var errorMessage = void 0;
              switch (status) {
                case 'ZERO_RESULTS':
                  errorMessage = '<p>Unable to find the address:</p> ' + _this2.address;
                  break;
                case 'OVER_QUERY_LIMIT':
                  errorMessage =
                    '\n              <p>Unable to load Google Maps, you have reached your usage limit.</p>\n              <p>\n                Please visit\n                <a href="' +
                    usageLimits +
                    '" target="_blank">' +
                    usageLimits +
                    '</a>\n                for more details.\n              </p>\n            ';
                  break;
                default:
                  errorMessage = 'Unable to load Google Maps.';
                  break;
              }
              _this2.displayErrorInThemeEditor(errorMessage, status);
            });
        },
      },
      {
        key: 'geolocate',
        value: function geolocate() {
          var deferred = jQuery.Deferred();
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: this.address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              deferred.reject(status);
            }
            deferred.resolve(results);
          });
          return deferred;
        },
      },
      {
        key: 'resize',
        value: function resize() {
          if (this.map) {
            google.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(this.center);
            this.map.panBy(0, 100);
          }
        },
      },
      {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          if (this.map) {
            google.maps.event.clearListeners(this.map, 'resize');
          }
        },
      },
      {
        key: '_getMapStyles',
        value: function _getMapStyles() {
          if (!this.colors) {
            return;
          }
          return [
            { elementType: 'geometry', stylers: [{ color: this.colors.e }] },
            { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: this.colors.a }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] },
            { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
            { featureType: 'administrative.country', stylers: [{ visibility: 'off' }] },
            { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
            { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] },
            { featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: this.colors.d }] },
            { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: this.colors.c }] },
            { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: this.colors.b }] },
            { featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] },
            { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: this.colors.b }] },
            { featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] },
            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: this.colors.f }] },
          ];
        },
      },
      {
        key: 'displayErrorInThemeEditor',
        value: function displayErrorInThemeEditor(errorMessage) {
          var isThemeEditor = window.Shopify && window.Shopify.designMode;
          if (!isThemeEditor) {
            return;
          }
          this.$container.html('<div class="map-error-message">' + errorMessage + '</div>');
        },
      },
    ]);
    return PxsMap;
  })();
  state.init();
  var sections = new Sections();
  sections.register('static-header', function (section) {
    return new XSectionHeader(section);
  });
  sections.register('static-footer', function (section) {
    return new XSectionFooter(section);
  });
  sections.register('static-article', function (section) {
    return new XArticle(section);
  });
  sections.register('static-blog', function (section) {
    return new XBlog(section);
  });
  sections.register('static-cart', function (section) {
    return new XCart(section);
  });
  sections.register('static-collection', function (section) {
    return new XCollection(section);
  });
  sections.register('static-giftcard', function (section) {
    return new XGiftcard(section);
  });
  sections.register('static-password', function (section) {
    return new XPassword(section);
  });
  sections.register('static-product', function (section) {
    return new XProduct(section);
  });
  sections.register('static-search', function (section) {
    return new XSearch(section);
  });
  sections.register('live-blog-posts', function (section) {
    return new XTwitterFeed(section);
  });
  sections.register('static-highlight-banner', function (section) {
    return new XHighlightsBanners(section);
  });
  sections.register('static-slideshow', function (section) {
    return new XSlideshow(section);
  });
  sections.register('live-market-mosaic', function (section) {
    return new XPromoBlocks(section);
  });
  sections.register('live-market-grid', function (section) {
    return new XPromoBlocks(section);
  });
  sections.register('live-menu-list', function (section) {
    return new XMenuList(section);
  });
  sections.register('live-twitter-feed', function (section) {
    return new XTwitterFeed$1(section);
  });
  sections.register('live-instagram-feed', function (section) {
    return new XInstagramFeed(section);
  });
  sections.register('live-featured-collection', function (section) {
    return new XFeaturedCollection(section);
  });
  sections.register('live-featured-product', function (section) {
    return new XProduct(section);
  });
  sections.register('live-rich-text', function (section) {
    return new XTwitterFeed$3(section);
  });
  sections.register('live-search', function (section) {
    return new XSearch(section);
  });
  sections.register('live-video', function (section) {
    return new XVideo(section);
  });
  sections.register('x-newsletter', function (section) {
    return new XNewsletter(section);
  });
  sections.register('x-map', function (section) {
    return new PxsMap(section);
  });
  new Account();
  new Contact();
  new Page();
})();
